"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5568],{

/***/ 27036:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(61268));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

exports.Z = _default;

/***/ }),

/***/ 46901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Alert_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(15463);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Alert/alertClasses.js


function getAlertUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiAlert', slot);
}
const alertClasses = (0,generateUtilityClasses/* default */.Z)('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
/* harmony default export */ var Alert_alertClasses = (alertClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/SuccessOutlined.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var SuccessOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ReportProblemOutlined.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var ReportProblemOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ErrorOutline.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var ErrorOutline = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/InfoOutlined.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var InfoOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined'));
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/svg-icons/Close.js
var Close = __webpack_require__(34484);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Alert/Alert.js
'use client';



const _excluded = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"];


















const useUtilityClasses = ownerState => {
  const {
    variant,
    color,
    severity,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${variant}${(0,capitalize/* default */.Z)(color || severity)}`, `${variant}`],
    icon: ['icon'],
    message: ['message'],
    action: ['action']
  };
  return (0,composeClasses/* default */.Z)(slots, getAlertUtilityClass, classes);
};
const AlertRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiAlert',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0,capitalize/* default */.Z)(ownerState.color || ownerState.severity)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const getColor = theme.palette.mode === 'light' ? colorManipulator/* darken */._j : colorManipulator/* lighten */.$n;
  const getBackgroundColor = theme.palette.mode === 'light' ? colorManipulator/* lighten */.$n : colorManipulator/* darken */._j;
  const color = ownerState.color || ownerState.severity;
  return (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
    backgroundColor: 'transparent',
    display: 'flex',
    padding: '6px 16px'
  }, color && ownerState.variant === 'standard' && {
    color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
    backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
    [`& .${Alert_alertClasses.icon}`]: theme.vars ? {
      color: theme.vars.palette.Alert[`${color}IconColor`]
    } : {
      color: theme.palette[color].main
    }
  }, color && ownerState.variant === 'outlined' && {
    color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
    border: `1px solid ${(theme.vars || theme).palette[color].light}`,
    [`& .${Alert_alertClasses.icon}`]: theme.vars ? {
      color: theme.vars.palette.Alert[`${color}IconColor`]
    } : {
      color: theme.palette[color].main
    }
  }, color && ownerState.variant === 'filled' && (0,esm_extends/* default */.Z)({
    fontWeight: theme.typography.fontWeightMedium
  }, theme.vars ? {
    color: theme.vars.palette.Alert[`${color}FilledColor`],
    backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
  } : {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
    color: theme.palette.getContrastText(theme.palette[color].main)
  }));
});
const AlertIcon = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})({
  marginRight: 12,
  padding: '7px 0',
  display: 'flex',
  fontSize: 22,
  opacity: 0.9
});
const AlertMessage = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0',
  minWidth: 0,
  overflow: 'auto'
});
const AlertAction = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '4px 0 0 16px',
  marginLeft: 'auto',
  marginRight: -8
});
const defaultIconMapping = {
  success: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessOutlined, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/(0,jsx_runtime.jsx)(ReportProblemOutlined, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorOutline, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoOutlined, {
    fontSize: "inherit"
  })
};
const Alert = /*#__PURE__*/react.forwardRef(function Alert(inProps, ref) {
  var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAlert'
  });
  const {
      action,
      children,
      className,
      closeText = 'Close',
      color,
      components = {},
      componentsProps = {},
      icon,
      iconMapping = defaultIconMapping,
      onClose,
      role = 'alert',
      severity = 'success',
      slotProps = {},
      slots = {},
      variant = 'standard'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    severity,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : IconButton/* default */.Z;
  const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : Close/* default */.Z;
  const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
  const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AlertRoot, (0,esm_extends/* default */.Z)({
    role: role,
    elevation: 0,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: [icon !== false ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertIcon, {
      ownerState: ownerState,
      className: classes.icon,
      children: icon || iconMapping[severity] || defaultIconMapping[severity]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(AlertMessage, {
      ownerState: ownerState,
      className: classes.message,
      children: children
    }), action != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: action
    }) : null, action == null && onClose ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AlertCloseButton, (0,esm_extends/* default */.Z)({
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
      }, closeButtonProps, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AlertCloseIcon, (0,esm_extends/* default */.Z)({
          fontSize: "small"
        }, closeIconProps))
      }))
    }) : null]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Alert_Alert = (Alert);

/***/ }),

/***/ 69368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(15463);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/SwitchBase.js + 1 modules
var SwitchBase = __webpack_require__(21964);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/CheckBoxOutlineBlank.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBoxOutlineBlank = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/CheckBox.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/IndeterminateCheckBox.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var IndeterminateCheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Checkbox/checkboxClasses.js


function getCheckboxUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCheckbox', slot);
}
const checkboxClasses = (0,generateUtilityClasses/* default */.Z)('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium']);
/* harmony default export */ var Checkbox_checkboxClasses = (checkboxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js
'use client';



const _excluded = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"];















const useUtilityClasses = ownerState => {
  const {
    classes,
    indeterminate,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${(0,capitalize/* default */.Z)(color)}`, `size${(0,capitalize/* default */.Z)(size)}`]
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getCheckboxUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const CheckboxRoot = (0,styled/* default */.ZP)(SwitchBase/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${Checkbox_checkboxClasses.checked}, &.${Checkbox_checkboxClasses.indeterminate}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${Checkbox_checkboxClasses.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
const defaultCheckedIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBox, {});
const defaultIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBoxOutlineBlank, {});
const defaultIndeterminateIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(IndeterminateCheckBox, {});
const Checkbox = /*#__PURE__*/react.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCheckbox'
  });
  const {
      checkedIcon = defaultCheckedIcon,
      color = 'primary',
      icon: iconProp = defaultIcon,
      indeterminate = false,
      indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
      inputProps,
      size = 'medium',
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    indeterminate,
    size
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxRoot, (0,esm_extends/* default */.Z)({
    type: "checkbox",
    inputProps: (0,esm_extends/* default */.Z)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/react.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx/* default */.Z)(classes.root, className)
  }, other, {
    classes: classes
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

/***/ }),

/***/ 54776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export setTranslateValue */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32793);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1048);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98885);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57144);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51705);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30577);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5340);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];










// Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.

function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(node);
  let transform;
  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }
  let offsetX = 0;
  let offsetY = 0;
  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }
  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }
    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }
  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }
    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }
  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }
    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  }

  // direction === 'down'
  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }
  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);
  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}

/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Slide = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Slide(props, ref) {
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      container: containerProp,
      direction = 'down',
      easing: easingProp = defaultEasing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);
  const childrenRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(children.ref, childrenRef, ref);
  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .reflow */ .n)(node);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';
    if (onExited) {
      onExited(node);
    }
  });
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };
  const updatePosition = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }
    const handleResize = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        ref: handleRef,
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Slide);

/***/ }),

/***/ 57820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Snackbar_Snackbar; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(15463);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/base/utils/useSlotProps.js + 3 modules
var useSlotProps = __webpack_require__(77632);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(90970);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js
var useEventCallback = __webpack_require__(88515);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/base/utils/extractEventHandlers.js
var extractEventHandlers = __webpack_require__(74098);
;// CONCATENATED MODULE: ./node_modules/@mui/material/node_modules/@mui/base/useSnackbar/useSnackbar.js
'use client';






/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */
function useSnackbar(parameters) {
  const {
    autoHideDuration = null,
    disableWindowBlurListener = false,
    onClose,
    open,
    resumeHideDuration
  } = parameters;
  const timerAutoHide = react.useRef();
  react.useEffect(() => {
    if (!open) {
      return undefined;
    }

    /**
     * @param {KeyboardEvent} nativeEvent
     */
    function handleKeyDown(nativeEvent) {
      if (!nativeEvent.defaultPrevented) {
        // IE11, Edge (prior to using Blink?) use 'Esc'
        if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
          // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
          onClose == null ? void 0 : onClose(nativeEvent, 'escapeKeyDown');
        }
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);
  const handleClose = (0,useEventCallback/* default */.Z)((event, reason) => {
    onClose == null ? void 0 : onClose(event, reason);
  });
  const setAutoHideTimer = (0,useEventCallback/* default */.Z)(autoHideDurationParam => {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }
    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(() => {
      handleClose(null, 'timeout');
    }, autoHideDurationParam);
  });
  react.useEffect(() => {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }
    return () => {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]);
  const handleClickAway = event => {
    onClose == null ? void 0 : onClose(event, 'clickaway');
  };

  // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.
  const handlePause = () => {
    clearTimeout(timerAutoHide.current);
  };

  // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.
  const handleResume = react.useCallback(() => {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
  const createHandleBlur = otherHandlers => event => {
    const onBlurCallback = otherHandlers.onBlur;
    onBlurCallback == null ? void 0 : onBlurCallback(event);
    handleResume();
  };
  const createHandleFocus = otherHandlers => event => {
    const onFocusCallback = otherHandlers.onFocus;
    onFocusCallback == null ? void 0 : onFocusCallback(event);
    handlePause();
  };
  const createMouseEnter = otherHandlers => event => {
    const onMouseEnterCallback = otherHandlers.onMouseEnter;
    onMouseEnterCallback == null ? void 0 : onMouseEnterCallback(event);
    handlePause();
  };
  const createMouseLeave = otherHandlers => event => {
    const onMouseLeaveCallback = otherHandlers.onMouseLeave;
    onMouseLeaveCallback == null ? void 0 : onMouseLeaveCallback(event);
    handleResume();
  };
  react.useEffect(() => {
    // TODO: window global should be refactored here
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return () => {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }
    return undefined;
  }, [disableWindowBlurListener, handleResume, open]);
  const getRootProps = (otherHandlers = {}) => {
    const propsEventHandlers = (0,extractEventHandlers/* extractEventHandlers */._)(parameters);
    const externalEventHandlers = (0,esm_extends/* default */.Z)({}, propsEventHandlers, otherHandlers);
    return (0,esm_extends/* default */.Z)({
      // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
      // See https://github.com/mui/material-ui/issues/29080
      role: 'presentation'
    }, externalEventHandlers, {
      onBlur: createHandleBlur(externalEventHandlers),
      onFocus: createHandleFocus(externalEventHandlers),
      onMouseEnter: createMouseEnter(externalEventHandlers),
      onMouseLeave: createMouseLeave(externalEventHandlers)
    });
  };
  return {
    getRootProps,
    onClickAway: handleClickAway
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(96514);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/SnackbarContent/snackbarContentClasses.js


function getSnackbarContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSnackbarContent', slot);
}
const snackbarContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiSnackbarContent', ['root', 'message', 'action']);
/* harmony default export */ var SnackbarContent_snackbarContentClasses = ((/* unused pure expression or super */ null && (snackbarContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/SnackbarContent/SnackbarContent.js
'use client';



const _excluded = ["action", "className", "message", "role"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    action: ['action'],
    message: ['message']
  };
  return (0,composeClasses/* default */.Z)(slots, getSnackbarContentUtilityClass, classes);
};
const SnackbarContentRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiSnackbarContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
  const backgroundColor = (0,colorManipulator/* emphasize */._4)(theme.palette.background.default, emphasis);
  return (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
    color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
    backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      flexGrow: 'initial',
      minWidth: 288
    }
  });
});
const SnackbarContentMessage = (0,styled/* default */.ZP)('div', {
  name: 'MuiSnackbarContent',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0'
});
const SnackbarContentAction = (0,styled/* default */.ZP)('div', {
  name: 'MuiSnackbarContent',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  paddingLeft: 16,
  marginRight: -8
});
const SnackbarContent = /*#__PURE__*/react.forwardRef(function SnackbarContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSnackbarContent'
  });
  const {
      action,
      className,
      message,
      role = 'alert'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SnackbarContentRoot, (0,esm_extends/* default */.Z)({
    role: role,
    square: true,
    elevation: 6,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SnackbarContentMessage, {
      className: classes.message,
      ownerState: ownerState,
      children: message
    }), action ? /*#__PURE__*/(0,jsx_runtime.jsx)(SnackbarContentAction, {
      className: classes.action,
      ownerState: ownerState,
      children: action
    }) : null]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var SnackbarContent_SnackbarContent = (SnackbarContent);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Snackbar/snackbarClasses.js


function getSnackbarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSnackbar', slot);
}
const snackbarClasses = (0,generateUtilityClasses/* default */.Z)('MuiSnackbar', ['root', 'anchorOriginTopCenter', 'anchorOriginBottomCenter', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft']);
/* harmony default export */ var Snackbar_snackbarClasses = ((/* unused pure expression or super */ null && (snackbarClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/Snackbar/Snackbar.js
'use client';



const Snackbar_excluded = ["onEnter", "onExited"],
  _excluded2 = ["action", "anchorOrigin", "autoHideDuration", "children", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onBlur", "onClose", "onFocus", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"];













const Snackbar_useUtilityClasses = ownerState => {
  const {
    classes,
    anchorOrigin
  } = ownerState;
  const slots = {
    root: ['root', `anchorOrigin${(0,capitalize/* default */.Z)(anchorOrigin.vertical)}${(0,capitalize/* default */.Z)(anchorOrigin.horizontal)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getSnackbarUtilityClass, classes);
};
const SnackbarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiSnackbar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`anchorOrigin${(0,capitalize/* default */.Z)(ownerState.anchorOrigin.vertical)}${(0,capitalize/* default */.Z)(ownerState.anchorOrigin.horizontal)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return (0,esm_extends/* default */.Z)({
    zIndex: (theme.vars || theme).zIndex.snackbar,
    position: 'fixed',
    display: 'flex',
    left: 8,
    right: 8,
    justifyContent: 'center',
    alignItems: 'center'
  }, ownerState.anchorOrigin.vertical === 'top' ? {
    top: 8
  } : {
    bottom: 8
  }, ownerState.anchorOrigin.horizontal === 'left' && {
    justifyContent: 'flex-start'
  }, ownerState.anchorOrigin.horizontal === 'right' && {
    justifyContent: 'flex-end'
  }, {
    [theme.breakpoints.up('sm')]: (0,esm_extends/* default */.Z)({}, ownerState.anchorOrigin.vertical === 'top' ? {
      top: 24
    } : {
      bottom: 24
    }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
      left: 24,
      right: 'auto'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
      right: 24,
      left: 'auto'
    })
  });
});
const Snackbar = /*#__PURE__*/react.forwardRef(function Snackbar(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSnackbar'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      action,
      anchorOrigin: {
        vertical,
        horizontal
      } = {
        vertical: 'bottom',
        horizontal: 'left'
      },
      autoHideDuration = null,
      children,
      className,
      ClickAwayListenerProps,
      ContentProps,
      disableWindowBlurListener = false,
      message,
      open,
      TransitionComponent = Grow/* default */.Z,
      transitionDuration = defaultTransitionDuration,
      TransitionProps: {
        onEnter,
        onExited
      } = {}
    } = props,
    TransitionProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.TransitionProps, Snackbar_excluded),
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchorOrigin: {
      vertical,
      horizontal
    },
    autoHideDuration,
    disableWindowBlurListener,
    TransitionComponent,
    transitionDuration
  });
  const classes = Snackbar_useUtilityClasses(ownerState);
  const {
    getRootProps,
    onClickAway
  } = useSnackbar((0,esm_extends/* default */.Z)({}, ownerState));
  const [exited, setExited] = react.useState(true);
  const rootProps = (0,useSlotProps/* useSlotProps */.y)({
    elementType: SnackbarRoot,
    getSlotProps: getRootProps,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    },
    className: [classes.root, className]
  });
  const handleExited = node => {
    setExited(true);
    if (onExited) {
      onExited(node);
    }
  };
  const handleEnter = (node, isAppearing) => {
    setExited(false);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  // So we only render active snackbars.
  if (!open && exited) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, (0,esm_extends/* default */.Z)({
    onClickAway: onClickAway
  }, ClickAwayListenerProps, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SnackbarRoot, (0,esm_extends/* default */.Z)({}, rootProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up',
        onEnter: handleEnter,
        onExited: handleExited
      }, TransitionProps, {
        children: children || /*#__PURE__*/(0,jsx_runtime.jsx)(SnackbarContent_SnackbarContent, (0,esm_extends/* default */.Z)({
          message: message,
          action: action
        }, ContentProps))
      }))
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Snackbar_Snackbar = (Snackbar);

/***/ }),

/***/ 45843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Switch_Switch; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(15463);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/SwitchBase.js + 1 modules
var SwitchBase = __webpack_require__(21964);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Switch/switchClasses.js


function getSwitchUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSwitch', slot);
}
const switchClasses = (0,generateUtilityClasses/* default */.Z)('MuiSwitch', ['root', 'edgeStart', 'edgeEnd', 'switchBase', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium', 'checked', 'disabled', 'input', 'thumb', 'track']);
/* harmony default export */ var Switch_switchClasses = (switchClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Switch/Switch.js
'use client';

// @inheritedComponent IconButton


const _excluded = ["className", "color", "edge", "size", "sx"];













const useUtilityClasses = ownerState => {
  const {
    classes,
    edge,
    size,
    color,
    checked,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', edge && `edge${(0,capitalize/* default */.Z)(edge)}`, `size${(0,capitalize/* default */.Z)(size)}`],
    switchBase: ['switchBase', `color${(0,capitalize/* default */.Z)(color)}`, checked && 'checked', disabled && 'disabled'],
    thumb: ['thumb'],
    track: ['track'],
    input: ['input']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getSwitchUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const SwitchRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiSwitch',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.edge && styles[`edge${(0,capitalize/* default */.Z)(ownerState.edge)}`], styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-flex',
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: 'hidden',
  padding: 12,
  boxSizing: 'border-box',
  position: 'relative',
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: 'middle',
  // For correct alignment with the text.
  '@media print': {
    colorAdjust: 'exact'
  }
}, ownerState.edge === 'start' && {
  marginLeft: -8
}, ownerState.edge === 'end' && {
  marginRight: -8
}, ownerState.size === 'small' && {
  width: 40,
  height: 24,
  padding: 7,
  [`& .${Switch_switchClasses.thumb}`]: {
    width: 16,
    height: 16
  },
  [`& .${Switch_switchClasses.switchBase}`]: {
    padding: 4,
    [`&.${Switch_switchClasses.checked}`]: {
      transform: 'translateX(16px)'
    }
  }
}));
const SwitchSwitchBase = (0,styled/* default */.ZP)(SwitchBase/* default */.Z, {
  name: 'MuiSwitch',
  slot: 'SwitchBase',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.switchBase, {
      [`& .${Switch_switchClasses.input}`]: styles.input
    }, ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
  transition: theme.transitions.create(['left', 'transform'], {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${Switch_switchClasses.checked}`]: {
    transform: 'translateX(20px)'
  },
  [`&.${Switch_switchClasses.disabled}`]: {
    color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
  },
  [`&.${Switch_switchClasses.checked} + .${Switch_switchClasses.track}`]: {
    opacity: 0.5
  },
  [`&.${Switch_switchClasses.disabled} + .${Switch_switchClasses.track}`]: {
    opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
  },
  [`& .${Switch_switchClasses.input}`]: {
    left: '-100%',
    width: '300%'
  }
}), ({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${Switch_switchClasses.checked}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main,
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    [`&.${Switch_switchClasses.disabled}`]: {
      color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0,colorManipulator/* lighten */.$n)(theme.palette[ownerState.color].main, 0.62) : (0,colorManipulator/* darken */._j)(theme.palette[ownerState.color].main, 0.55)}`
    }
  },
  [`&.${Switch_switchClasses.checked} + .${Switch_switchClasses.track}`]: {
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
  }
}));
const SwitchTrack = (0,styled/* default */.ZP)('span', {
  name: 'MuiSwitch',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme
}) => ({
  height: '100%',
  width: '100%',
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: theme.transitions.create(['opacity', 'background-color'], {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
  opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
}));
const SwitchThumb = (0,styled/* default */.ZP)('span', {
  name: 'MuiSwitch',
  slot: 'Thumb',
  overridesResolver: (props, styles) => styles.thumb
})(({
  theme
}) => ({
  boxShadow: (theme.vars || theme).shadows[1],
  backgroundColor: 'currentColor',
  width: 20,
  height: 20,
  borderRadius: '50%'
}));
const Switch = /*#__PURE__*/react.forwardRef(function Switch(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSwitch'
  });
  const {
      className,
      color = 'primary',
      edge = false,
      size = 'medium',
      sx
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    edge,
    size
  });
  const classes = useUtilityClasses(ownerState);
  const icon = /*#__PURE__*/(0,jsx_runtime.jsx)(SwitchThumb, {
    className: classes.thumb,
    ownerState: ownerState
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SwitchRoot, {
    className: (0,clsx/* default */.Z)(classes.root, className),
    sx: sx,
    ownerState: ownerState,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SwitchSwitchBase, (0,esm_extends/* default */.Z)({
      type: "checkbox",
      icon: icon,
      checkedIcon: icon,
      ref: ref,
      ownerState: ownerState
    }, other, {
      classes: (0,esm_extends/* default */.Z)({}, classes, {
        root: classes.switchBase
      })
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(SwitchTrack, {
      className: classes.track,
      ownerState: ownerState
    })]
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Switch_Switch = (Switch);

/***/ }),

/***/ 34484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';




/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */

/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close'));

/***/ }),

/***/ 71470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _react=_interopRequireWildcard(__webpack_require__(67294));var _excluded=["placeholder","separator","isLastChild","inputStyle","focus","isDisabled","hasErrored","errorStyle","focusStyle","disabledStyle","shouldAutoFocus","isInputNum","index","value","className","isInputSecure"];function _getRequireWildcardCache(nodeInterop){if(typeof WeakMap!=="function")return null;var cacheBabelInterop=new WeakMap();var cacheNodeInterop=new WeakMap();return(_getRequireWildcardCache=function _getRequireWildcardCache(nodeInterop){return nodeInterop?cacheNodeInterop:cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj,nodeInterop){if(!nodeInterop&&obj&&obj.__esModule){return obj;}if(obj===null||_typeof(obj)!=="object"&&typeof obj!=="function"){return{"default":obj};}var cache=_getRequireWildcardCache(nodeInterop);if(cache&&cache.has(obj)){return cache.get(obj);}var newObj={};var hasPropertyDescriptor=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var key in obj){if(key!=="default"&&Object.prototype.hasOwnProperty.call(obj,key)){var desc=hasPropertyDescriptor?Object.getOwnPropertyDescriptor(obj,key):null;if(desc&&(desc.get||desc.set)){Object.defineProperty(newObj,key,desc);}else{newObj[key]=obj[key];}}}newObj["default"]=obj;if(cache){cache.set(obj,newObj);}return newObj;}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}var BACKSPACE=8;var LEFT_ARROW=37;var RIGHT_ARROW=39;var DELETE=46;var SPACEBAR=32;var isStyleObject=function isStyleObject(obj){return _typeof(obj)==='object';};var SingleOtpInput=function(_PureComponent){_inherits(SingleOtpInput,_PureComponent);var _super=_createSuper(SingleOtpInput);function SingleOtpInput(props){var _this;_classCallCheck(this,SingleOtpInput);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getClasses",function(){for(var _len=arguments.length,classes=new Array(_len),_key=0;_key<_len;_key++){classes[_key]=arguments[_key];}return classes.filter(function(c){return!isStyleObject(c)&&c!==false;}).join(' ');});_defineProperty(_assertThisInitialized(_this),"getType",function(){var _this$props=_this.props,isInputSecure=_this$props.isInputSecure,isInputNum=_this$props.isInputNum;if(isInputSecure){return'password';}if(isInputNum){return'tel';}return'text';});_this.input=_react["default"].createRef();return _this;}_createClass(SingleOtpInput,[{key:"componentDidMount",value:function componentDidMount(){var _this$props2=this.props,focus=_this$props2.focus,shouldAutoFocus=_this$props2.shouldAutoFocus;var inputEl=this.input.current;if(inputEl&&focus&&shouldAutoFocus){inputEl.focus();}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var focus=this.props.focus;var inputEl=this.input.current;if(prevProps.focus!==focus&&inputEl&&focus){inputEl.focus();inputEl.select();}}},{key:"render",value:function render(){var _this$props3=this.props,placeholder=_this$props3.placeholder,separator=_this$props3.separator,isLastChild=_this$props3.isLastChild,inputStyle=_this$props3.inputStyle,focus=_this$props3.focus,isDisabled=_this$props3.isDisabled,hasErrored=_this$props3.hasErrored,errorStyle=_this$props3.errorStyle,focusStyle=_this$props3.focusStyle,disabledStyle=_this$props3.disabledStyle,shouldAutoFocus=_this$props3.shouldAutoFocus,isInputNum=_this$props3.isInputNum,index=_this$props3.index,value=_this$props3.value,className=_this$props3.className,isInputSecure=_this$props3.isInputSecure,rest=_objectWithoutProperties(_this$props3,_excluded);return _react["default"].createElement("div",{className:className,style:{display:'flex',alignItems:'center'}},_react["default"].createElement("input",_extends({"aria-label":"".concat(index===0?'Please enter verification code. ':'').concat(isInputNum?'Digit':'Character'," ").concat(index+1),autoComplete:"off",style:Object.assign({width:'1em',textAlign:'center'},isStyleObject(inputStyle)&&inputStyle,focus&&isStyleObject(focusStyle)&&focusStyle,isDisabled&&isStyleObject(disabledStyle)&&disabledStyle,hasErrored&&isStyleObject(errorStyle)&&errorStyle),placeholder:placeholder,className:this.getClasses(inputStyle,focus&&focusStyle,isDisabled&&disabledStyle,hasErrored&&errorStyle),type:this.getType(),maxLength:"1",ref:this.input,disabled:isDisabled,value:value?value:''},rest)),!isLastChild&&separator);}}]);return SingleOtpInput;}(_react.PureComponent);var OtpInput=function(_Component){_inherits(OtpInput,_Component);var _super2=_createSuper(OtpInput);function OtpInput(){var _this2;_classCallCheck(this,OtpInput);for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}_this2=_super2.call.apply(_super2,[this].concat(args));_defineProperty(_assertThisInitialized(_this2),"state",{activeInput:0});_defineProperty(_assertThisInitialized(_this2),"getOtpValue",function(){return _this2.props.value?_this2.props.value.toString().split(''):[];});_defineProperty(_assertThisInitialized(_this2),"getPlaceholderValue",function(){var _this2$props=_this2.props,placeholder=_this2$props.placeholder,numInputs=_this2$props.numInputs;if(typeof placeholder==='string'){if(placeholder.length===numInputs){return placeholder;}if(placeholder.length>0){console.error('Length of the placeholder should be equal to the number of inputs.');}}});_defineProperty(_assertThisInitialized(_this2),"handleOtpChange",function(otp){var onChange=_this2.props.onChange;var otpValue=otp.join('');onChange(otpValue);});_defineProperty(_assertThisInitialized(_this2),"isInputValueValid",function(value){var isTypeValid=_this2.props.isInputNum?!isNaN(parseInt(value,10)):typeof value==='string';return isTypeValid&&value.trim().length===1;});_defineProperty(_assertThisInitialized(_this2),"focusInput",function(input){var numInputs=_this2.props.numInputs;var activeInput=Math.max(Math.min(numInputs-1,input),0);_this2.setState({activeInput:activeInput});});_defineProperty(_assertThisInitialized(_this2),"focusNextInput",function(){var activeInput=_this2.state.activeInput;_this2.focusInput(activeInput+1);});_defineProperty(_assertThisInitialized(_this2),"focusPrevInput",function(){var activeInput=_this2.state.activeInput;_this2.focusInput(activeInput-1);});_defineProperty(_assertThisInitialized(_this2),"changeCodeAtFocus",function(value){var activeInput=_this2.state.activeInput;var otp=_this2.getOtpValue();otp[activeInput]=value[0];_this2.handleOtpChange(otp);});_defineProperty(_assertThisInitialized(_this2),"handleOnPaste",function(e){e.preventDefault();var activeInput=_this2.state.activeInput;var _this2$props2=_this2.props,numInputs=_this2$props2.numInputs,isDisabled=_this2$props2.isDisabled;if(isDisabled){return;}var otp=_this2.getOtpValue();var nextActiveInput=activeInput;var pastedData=e.clipboardData.getData('text/plain').slice(0,numInputs-activeInput).split('');for(var pos=0;pos<numInputs;++pos){if(pos>=activeInput&&pastedData.length>0){otp[pos]=pastedData.shift();nextActiveInput++;}}_this2.setState({activeInput:nextActiveInput},function(){_this2.focusInput(nextActiveInput);_this2.handleOtpChange(otp);});});_defineProperty(_assertThisInitialized(_this2),"handleOnChange",function(e){var value=e.target.value;if(_this2.isInputValueValid(value)){_this2.changeCodeAtFocus(value);}});_defineProperty(_assertThisInitialized(_this2),"handleOnKeyDown",function(e){if(e.keyCode===BACKSPACE||e.key==='Backspace'){e.preventDefault();_this2.changeCodeAtFocus('');_this2.focusPrevInput();}else if(e.keyCode===DELETE||e.key==='Delete'){e.preventDefault();_this2.changeCodeAtFocus('');}else if(e.keyCode===LEFT_ARROW||e.key==='ArrowLeft'){e.preventDefault();_this2.focusPrevInput();}else if(e.keyCode===RIGHT_ARROW||e.key==='ArrowRight'){e.preventDefault();_this2.focusNextInput();}else if(e.keyCode===SPACEBAR||e.key===' '||e.key==='Spacebar'||e.key==='Space'){e.preventDefault();}});_defineProperty(_assertThisInitialized(_this2),"handleOnInput",function(e){if(_this2.isInputValueValid(e.target.value)){_this2.focusNextInput();}else{if(!_this2.props.isInputNum){var nativeEvent=e.nativeEvent;if(nativeEvent.data===null&&nativeEvent.inputType==='deleteContentBackward'){e.preventDefault();_this2.changeCodeAtFocus('');_this2.focusPrevInput();}}}});_defineProperty(_assertThisInitialized(_this2),"renderInputs",function(){var activeInput=_this2.state.activeInput;var _this2$props3=_this2.props,numInputs=_this2$props3.numInputs,inputStyle=_this2$props3.inputStyle,focusStyle=_this2$props3.focusStyle,separator=_this2$props3.separator,isDisabled=_this2$props3.isDisabled,disabledStyle=_this2$props3.disabledStyle,hasErrored=_this2$props3.hasErrored,errorStyle=_this2$props3.errorStyle,shouldAutoFocus=_this2$props3.shouldAutoFocus,isInputNum=_this2$props3.isInputNum,isInputSecure=_this2$props3.isInputSecure,className=_this2$props3.className;var inputs=[];var otp=_this2.getOtpValue();var placeholder=_this2.getPlaceholderValue();var dataCy=_this2.props['data-cy'];var dataTestId=_this2.props['data-testid'];var _loop=function _loop(i){inputs.push(_react["default"].createElement(SingleOtpInput,{placeholder:placeholder&&placeholder[i],key:i,index:i,focus:activeInput===i,value:otp&&otp[i],onChange:_this2.handleOnChange,onKeyDown:_this2.handleOnKeyDown,onInput:_this2.handleOnInput,onPaste:_this2.handleOnPaste,onFocus:function onFocus(e){_this2.setState({activeInput:i});e.target.select();},onBlur:function onBlur(){return _this2.setState({activeInput:-1});},separator:separator,inputStyle:inputStyle,focusStyle:focusStyle,isLastChild:i===numInputs-1,isDisabled:isDisabled,disabledStyle:disabledStyle,hasErrored:hasErrored,errorStyle:errorStyle,shouldAutoFocus:shouldAutoFocus,isInputNum:isInputNum,isInputSecure:isInputSecure,className:className,"data-cy":dataCy&&"".concat(dataCy,"-").concat(i),"data-testid":dataTestId&&"".concat(dataTestId,"-").concat(i)}));};for(var i=0;i<numInputs;i++){_loop(i);}return inputs;});return _this2;}_createClass(OtpInput,[{key:"render",value:function render(){var containerStyle=this.props.containerStyle;return _react["default"].createElement("div",{style:Object.assign({display:'flex'},isStyleObject(containerStyle)&&containerStyle),className:!isStyleObject(containerStyle)?containerStyle:''},this.renderInputs());}}]);return OtpInput;}(_react.Component);_defineProperty(OtpInput,"defaultProps",{numInputs:4,onChange:function onChange(otp){return console.log(otp);},isDisabled:false,shouldAutoFocus:false,value:'',isInputSecure:false});var _default=OtpInput;exports.Z=_default;

/***/ }),

/***/ 12730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ d; },
/* harmony export */   "r": function() { return /* binding */ dr; }
/* harmony export */ });
const d = {
    CustomEvent: "ce",
    Pr: "p",
    fc: "pc",
    Ac: "ca",
    Cu: "i",
    bu: "ie",
    ss: "cci",
    os: "ccic",
    Mt: "ccc",
    Wt: "ccd",
    Bl: "ss",
    Dl: "se",
    Li: "si",
    Qi: "sc",
    Vi: "sbc",
    Mc: "sfe",
    Eo: "iec",
    mc: "lr",
    dc: "uae",
    ns: "ci",
    Ot: "cc",
    wc: "lcaa",
    bc: "lcar",
    Gn: "inc",
    Rn: "add",
    On: "rem",
    $n: "set",
    Bn: "ncam",
    kc: "sgu",
    yr: "ffi",
    ro: "bi",
    ct: "bc",
  },
  dr = { Fr: "feed_displayed", Sc: "content_cards_displayed" };



/***/ }),

/***/ 57070:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

const G = {
  ce: function () {
    const t = (t = !1) => {
      const n = (Math.random().toString(16) + "000000000").substr(2, 8);
      return t ? "-" + n.substr(0, 4) + "-" + n.substr(4, 4) : n;
    };
    return t() + t(!0) + t(!0) + t();
  },
};
/* harmony default export */ __webpack_exports__["Z"] = (G);


/***/ }),

/***/ 45522:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ tt; }
/* harmony export */ });
class tt {
  constructor(t, e) {
    (this.database = t),
      (this.vd = e),
      (this.parent = "undefined" == typeof window ? self : window),
      (this.database = t),
      (this.vd = e);
  }
  Dd() {
    if ("indexedDB" in this.parent) return this.parent.indexedDB;
  }
  isSupported() {
    var t;
    try {
      if (null == this.Dd()) return !1;
      {
        const e =
          null === (t = this.Dd()) || void 0 === t
            ? void 0
            : t.open("Braze IndexedDB Support Test");
        if (
          (e &&
            ((e.onupgradeneeded = () => e.result.close()),
            (e.onsuccess = () => e.result.close())),
          "undefined" != typeof window)
        ) {
          const t = window,
            e = t.chrome || t.browser || t.pd;
          if (e && e.runtime && e.runtime.id)
            return (
              this.vd.info(
                "Not using IndexedDB for storage because we are running inside an extension",
              ),
              !1
            );
        }
        return !0;
      }
    } catch (t) {
      return (
        this.vd.info(
          "Not using IndexedDB for storage due to following error: " + t,
        ),
        !1
      );
    }
  }
  Bd(t, e) {
    var n;
    const o =
      null === (n = this.Dd()) || void 0 === n
        ? void 0
        : n.open(this.database.Sd, this.database.VERSION);
    if (null == o) return "function" == typeof e && e(), !1;
    const i = this;
    return (
      (o.onupgradeneeded = (t) => {
        var e;
        i.vd.info(
          "Upgrading indexedDB " +
            i.database.Sd +
            " to v" +
            i.database.VERSION +
            "...",
        );
        const n = null === (e = t.target) || void 0 === e ? void 0 : e.result;
        for (const t in i.database.Ms) {
          const e = t;
          i.database.Ms.hasOwnProperty(t) &&
            !n.objectStoreNames.contains(i.database.Ms[e]) &&
            n.createObjectStore(i.database.Ms[e]);
        }
      }),
      (o.onsuccess = (n) => {
        var o;
        const r = null === (o = n.target) || void 0 === o ? void 0 : o.result;
        (r.onversionchange = () => {
          r.close(),
            "function" == typeof e && e(),
            i.vd.error(
              "Needed to close the database unexpectedly because of an upgrade in another tab",
            );
        }),
          t(r);
      }),
      (o.onerror = (t) => {
        var n;
        const o = t;
        return (
          i.vd.info(
            "Could not open indexedDB " +
              i.database.Sd +
              " v" +
              i.database.VERSION +
              ": " +
              (null === (n = o.target) || void 0 === n ? void 0 : n.errorCode),
          ),
          "function" == typeof e && e(),
          !0
        );
      }),
      !0
    );
  }
  setItem(t, e, n, o, i) {
    if (!this.isSupported()) return "function" == typeof i && i(), !1;
    const r = this;
    return this.Bd((d) => {
      if (!d.objectStoreNames.contains(t))
        return (
          r.vd.error(
            "Could not store object " +
              e +
              " in " +
              t +
              " on indexedDB " +
              r.database.Sd +
              " - " +
              t +
              " is not a valid objectStore",
          ),
          "function" == typeof i && i(),
          void d.close()
        );
      const s = d.transaction([t], "readwrite");
      s.oncomplete = () => d.close();
      const u = s.objectStore(t).put(n, e);
      (u.onerror = () => {
        r.vd.error(
          "Could not store object " +
            e +
            " in " +
            t +
            " on indexedDB " +
            r.database.Sd,
        ),
          "function" == typeof i && i();
      }),
        (u.onsuccess = () => {
          "function" == typeof o && o();
        });
    }, i);
  }
  getItem(t, e, n) {
    if (!this.isSupported()) return !1;
    const o = this;
    return this.Bd((i) => {
      if (!i.objectStoreNames.contains(t))
        return (
          o.vd.error(
            "Could not retrieve object " +
              e +
              " in " +
              t +
              " on indexedDB " +
              o.database.Sd +
              " - " +
              t +
              " is not a valid objectStore",
          ),
          void i.close()
        );
      const r = i.transaction([t], "readonly");
      r.oncomplete = () => i.close();
      const d = r.objectStore(t).get(e);
      (d.onerror = () => {
        o.vd.error(
          "Could not retrieve object " +
            e +
            " in " +
            t +
            " on indexedDB " +
            o.database.Sd,
        );
      }),
        (d.onsuccess = (t) => {
          var e;
          const o = null === (e = t.target) || void 0 === e ? void 0 : e.result;
          null != o && n(o);
        });
    });
  }
  cr(t, e, n) {
    if (!this.isSupported()) return "function" == typeof n && n(), !1;
    const o = this;
    return this.Bd((i) => {
      if (!i.objectStoreNames.contains(t))
        return (
          o.vd.error(
            "Could not retrieve last record from " +
              t +
              " on indexedDB " +
              o.database.Sd +
              " - " +
              t +
              " is not a valid objectStore",
          ),
          "function" == typeof n && n(),
          void i.close()
        );
      const r = i.transaction([t], "readonly");
      r.oncomplete = () => i.close();
      const d = r.objectStore(t).openCursor(null, "prev");
      (d.onerror = () => {
        o.vd.error(
          "Could not open cursor for " + t + " on indexedDB " + o.database.Sd,
        ),
          "function" == typeof n && n();
      }),
        (d.onsuccess = (t) => {
          var o;
          const i = null === (o = t.target) || void 0 === o ? void 0 : o.result;
          null != i && null != i.value && null != i.key
            ? e(i.key, i.value)
            : "function" == typeof n && n();
        });
    }, n);
  }
  ge(t, e) {
    if (!this.isSupported()) return !1;
    const n = this;
    return this.Bd((o) => {
      if (!o.objectStoreNames.contains(t))
        return (
          n.vd.error(
            "Could not delete record " +
              e +
              " from " +
              t +
              " on indexedDB " +
              n.database.Sd +
              " - " +
              t +
              " is not a valid objectStore",
          ),
          void o.close()
        );
      const i = o.transaction([t], "readwrite");
      i.oncomplete = () => o.close();
      i.objectStore(t).delete(e).onerror = () => {
        n.vd.error(
          "Could not delete record " +
            e +
            " from " +
            t +
            " on indexedDB " +
            n.database.Sd,
        );
      };
    });
  }
  Ns(t, e) {
    if (!this.isSupported()) return !1;
    const n = this;
    return this.Bd((o) => {
      if (!o.objectStoreNames.contains(t))
        return (
          n.vd.error(
            "Could not retrieve objects from " +
              t +
              " on indexedDB " +
              n.database.Sd +
              " - " +
              t +
              " is not a valid objectStore",
          ),
          void o.close()
        );
      const i = o.transaction([t], "readwrite");
      i.oncomplete = () => o.close();
      const r = i.objectStore(t),
        d = r.openCursor(),
        s = [];
      (d.onerror = () => {
        s.length > 0
          ? (n.vd.info(
              "Cursor closed midway through for " +
                t +
                " on indexedDB " +
                n.database.Sd,
            ),
            e(s))
          : n.vd.error(
              "Could not open cursor for " +
                t +
                " on indexedDB " +
                n.database.Sd,
            );
      }),
        (d.onsuccess = (t) => {
          var n;
          const o = null === (n = t.target) || void 0 === n ? void 0 : n.result;
          if (null != o) {
            if (null != o.value && null != o.key) {
              r.delete(o.key).onsuccess = () => {
                s.push(o.value);
              };
            }
            "function" == typeof o.continue && o.continue();
          } else s.length > 0 && e(s);
        });
    });
  }
  clearData() {
    if (!this.isSupported()) return !1;
    const t = [];
    for (const e in this.database.Ms) {
      const n = e;
      this.database.Ms.hasOwnProperty(e) &&
        this.database.Ms[n] !== this.database.Ms.pe &&
        t.push(this.database.Ms[n]);
    }
    const e = this;
    return this.Bd(function (n) {
      const o = n.transaction(t, "readwrite");
      o.oncomplete = () => n.close();
      for (let n = 0; n < t.length; n++) {
        const i = t[n];
        o.objectStore(i).clear().onerror = function () {
          e.vd.error(
            "Could not clear " +
              this.source.name +
              " on indexedDB " +
              e.database.Sd,
          );
        };
      }
      o.onerror = function () {
        e.vd.error(
          "Could not clear object stores on indexedDB " + e.database.Sd,
        );
      };
    });
  }
}
tt.Ls = {
  Fs: {
    Sd: "AppboyServiceWorkerAsyncStorage",
    VERSION: 6,
    Ms: {
      Nu: "data",
      jr: "pushClicks",
      cu: "pushSubscribed",
      Cd: "fallbackDevice",
      Js: "cardUpdates",
      pe: "optOut",
      kr: "pendingData",
      qh: "sdkAuthenticationSignature",
    },
    be: 1,
  },
};


/***/ }),

/***/ 20335:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

const N = {
  init: function (n) {
    (void 0 === n && void 0 !== N.zg) || (N.zg = !!n), N.l || (N.l = !0);
  },
  destroy: function () {
    (N.l = !1), (N.zg = void 0), (N.vd = void 0);
  },
  setLogger: function (n) {
    "function" == typeof n
      ? (N.init(), (N.vd = n))
      : N.info("Ignoring setLogger call since logger is not a function");
  },
  toggleLogging: function () {
    N.init(),
      N.zg
        ? (console.log("Disabling Braze logging"), (N.zg = !1))
        : (console.log("Enabled Braze logging"), (N.zg = !0));
  },
  info: function (n) {
    if (N.zg) {
      const o = "Braze: " + n;
      null != N.vd ? N.vd(o) : console.log(o);
    }
  },
  warn: function (n) {
    if (N.zg) {
      const o = "Braze SDK Warning: " + n + " (v5.8.1)";
      null != N.vd ? N.vd(o) : console.warn(o);
    }
  },
  error: function (n) {
    if (N.zg) {
      const o = "Braze SDK Error: " + n + " (v5.8.1)";
      null != N.vd ? N.vd(o) : console.error(o);
    }
  },
};
/* harmony default export */ __webpack_exports__["Z"] = (N);


/***/ }),

/***/ 85716:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ card_manager_factory; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/models/control-card.js
var control_card = __webpack_require__(85563);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/event-logger.js
var event_logger = __webpack_require__(39179);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/request-result.js
var request_result = __webpack_require__(24673);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/event-types.js
var event_types = __webpack_require__(12730);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Card/card-manager.js





class M {
  constructor(t) {
    (this.C = t), (this.C = t);
  }
  logClick(t, n) {
    const r = new request_result/* default */.Z();
    if ((t.$t(), null == t.url || "" === t.url))
      return (
        logger/* default.info */.Z.info(`Card ${t.id} has no url. Not logging click to Braze servers.`),
        r
      );
    if (n && t.id && this.C) {
      const n = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Kt */.I.gt.Kt) || {};
      (n[t.id] = !0), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Kt */.I.gt.Kt, n);
    }
    const i = this.Lt([t]);
    if (null == i) return r;
    const o = n ? event_types/* EventTypes.Mt */.G.Mt : event_types/* EventTypes.Ot */.G.Ot;
    return event_logger/* default.ut */.Z.ut(o, i);
  }
  Pt(t) {
    const n = new request_result/* default */.Z();
    if (!t.Qt())
      return (
        logger/* default.info */.Z.info(
          `Card ${t.id} refused this dismissal. Ignoring analytics event.`,
        ),
        n
      );
    if (t.id && this.C) {
      const n = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Vt */.I.gt.Vt) || {};
      (n[t.id] = !0), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Vt */.I.gt.Vt, n);
    }
    const r = this.Lt([t]);
    return null == r ? n : event_logger/* default.ut */.Z.ut(event_types/* EventTypes.Wt */.G.Wt, r);
  }
  Xt(t, n) {
    const r = new request_result/* default */.Z(!0),
      i = [],
      o = [];
    let e = {};
    this.C && (e = n ? this.C.ft(storage_manager/* STORAGE_KEYS.gt.Yt */.I.gt.Yt) || {} : this.C.ft(storage_manager/* STORAGE_KEYS.gt.Zt */.I.gt.Zt) || {});
    for (const s of t) {
      s.ts()
        ? (s instanceof control_card/* default */.Z ? o.push(s) : i.push(s),
          s.id && (e[s.id] = !0))
        : logger/* default.info */.Z.info(
            `Card ${s.id} logged an impression too recently. Ignoring analytics event.`,
          );
    }
    const l = this.Lt(i),
      a = this.Lt(o);
    if (null == l && null == a) return (r.tt = !1), r;
    if (
      (this.C && (n ? this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Yt */.I.gt.Yt, e) : this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Zt */.I.gt.Zt, e)), null != l)
    ) {
      const t = n ? event_types/* EventTypes.ss */.G.ss : event_types/* EventTypes.ns */.G.ns,
        s = event_logger/* default.ut */.Z.ut(t, l);
      r.rs(s);
    }
    if (null != a && n) {
      const t = event_logger/* default.ut */.Z.ut(event_types/* EventTypes.os */.G.os, a);
      r.rs(t);
    }
    return r;
  }
  Lt(t) {
    let s,
      n = null;
    for (let r = 0; r < t.length; r++)
      (s = t[r].id),
        null != s &&
          "" !== s &&
          ((n = n || {}), (n.ids = n.ids || []), n.ids.push(s));
    return n;
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Card/card-manager-factory.js


const _ = {
  l: !1,
  aa: null,
  ea: () => (_.p(), _.aa || (_.aa = new M(braze_instance/* default.j */.ZP.j())), _.aa),
  p: () => {
    _.l || (braze_instance/* default.h */.ZP.h(_), (_.l = !0));
  },
  destroy: () => {
    (_.aa = null), (_.l = !1);
  },
};
/* harmony default export */ var card_manager_factory = (_);


/***/ }),

/***/ 35608:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CG": function() { return /* binding */ setCardHeight; },
/* harmony export */   "Dj": function() { return /* binding */ cardToHtml; },
/* harmony export */   "pq": function() { return /* binding */ markCardAsRead; },
/* harmony export */   "sv": function() { return /* binding */ getCardId; }
/* harmony export */ });
/* unused harmony export _setImageAltText */
/* harmony import */ var _util_component_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5242);
/* harmony import */ var _util_dom_utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11507);
/* harmony import */ var _Core_handle_braze_action_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40420);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22080);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57070);





function markCardAsRead(t) {
  if (null != t) {
    const e = t.querySelectorAll(".ab-unread-indicator")[0];
    null != e && (e.className += " read");
  }
}
function getCardId(t) {
  return t.getAttribute("data-ab-card-id");
}
function _setImageAltText(t, e) {
  let o = "";
  t.title || t.description || (o = "Feed Image"), e.setAttribute("alt", o);
}
function setCardHeight(t, e) {
  const o = e.querySelectorAll(".ab-image-area");
  let a,
    i = 0;
  o.length > 0 && (i = o[0].offsetWidth);
  for (const e of t)
    if (((a = e.te), a && e.imageUrl && "number" == typeof e.aspectRatio)) {
      const t = i / e.aspectRatio;
      t && (a.style.height = `${t}px`);
    }
}
function cardToHtml(t, logCardClick, e, o = "ltr") {
  const a = document.createElement("div");
  (a.dir = o),
    (a.className = "ab-card ab-effect-card " + t.oe),
    t.id &&
      (a.setAttribute("data-ab-card-id", t.id), a.setAttribute("id", t.id)),
    a.setAttribute("role", "article"),
    a.setAttribute("tabindex", "0");
  let i = "",
    n = !1;
  t.url && "" !== t.url && ((i = t.url), (n = !0));
  const d = (o) => (markCardAsRead(a), n && (logCardClick(t), (0,_Core_handle_braze_action_js__WEBPACK_IMPORTED_MODULE_0__/* ._handleBrazeAction */ .S)(i, e, o)), !1);
  if (t.pinned) {
    const t = document.createElement("div");
    t.className = "ab-pinned-indicator";
    const e = document.createElement("i");
    (e.className = "fa fa-star"), t.appendChild(e), a.appendChild(t);
  }
  if (t.imageUrl && "" !== t.imageUrl) {
    const e = document.createElement("div");
    (e.dir = o), (e.className = "ab-image-area");
    const r = document.createElement("img");
    if (
      (r.setAttribute("src", t.imageUrl),
      (r.onload = () => {
        a.style.height = "auto";
      }),
      _setImageAltText(t, r),
      e.appendChild(r),
      (a.className += " with-image"),
      n && !t.ae)
    ) {
      const t = document.createElement("a");
      t.setAttribute("href", i),
        (t.onclick = d),
        t.appendChild(e),
        a.appendChild(t);
    } else a.appendChild(e);
  }
  const r = document.createElement("div");
  if (((r.className = "ab-card-body"), (r.dir = o), t.dismissible)) {
    t.logCardDismissal = () => (0,_index_js__WEBPACK_IMPORTED_MODULE_1__/* .logCardDismissal */ .K)(t);
    const e = (0,_util_component_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .createCloseButton */ .B)("Dismiss Card", void 0, t.dismissCard.bind(t), o);
    a.appendChild(e),
      (0,_util_dom_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .detectSwipe */ .FZ)(r, _util_dom_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTIONS.ie */ .mQ.ie, (t) => {
        (a.className += " ab-swiped-left"), e.onclick(t);
      }),
      (0,_util_dom_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .detectSwipe */ .FZ)(r, _util_dom_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTIONS.de */ .mQ.de, (t) => {
        (a.className += " ab-swiped-right"), e.onclick(t);
      });
  }
  let c = "",
    s = !1;
  if ((t.title && "" !== t.title && ((c = t.title), (s = !0)), s)) {
    const t = document.createElement("h1");
    if (
      ((t.className = "ab-title"),
      (t.id = _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ce */ .Z.ce()),
      a.setAttribute("aria-labelledby", t.id),
      n)
    ) {
      const e = document.createElement("a");
      e.setAttribute("href", i),
        (e.onclick = d),
        e.appendChild(document.createTextNode(c)),
        t.appendChild(e);
    } else t.appendChild(document.createTextNode(c));
    r.appendChild(t);
  }
  const m = document.createElement("div");
  if (
    ((m.className = s ? "ab-description" : "ab-description ab-no-title"),
    (m.id = _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ce */ .Z.ce()),
    a.setAttribute("aria-describedby", m.id),
    t.description && m.appendChild(document.createTextNode(t.description)),
    n)
  ) {
    const e = document.createElement("div");
    e.className = "ab-url-area";
    const o = document.createElement("a");
    o.setAttribute("href", i),
      t.linkText && o.appendChild(document.createTextNode(t.linkText)),
      (o.onclick = d),
      e.appendChild(o),
      m.appendChild(e);
  }
  r.appendChild(m), a.appendChild(r);
  const u = document.createElement("div");
  return (
    (u.className = "ab-unread-indicator"),
    t.viewed && (u.className += " read"),
    a.appendChild(u),
    (t.te = a),
    a
  );
}


/***/ }),

/***/ 1280:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ logCardClick; }
/* harmony export */ });
/* harmony import */ var _models_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72857);
/* harmony import */ var _card_manager_factory_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85716);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27671);
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20335);





function logCardClick(o, m) {
  return (
    !!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr() &&
    (o instanceof _models_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z ? _card_manager_factory_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ea */ .Z.ea().logClick(o, m).tt : (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error("card " + _common_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .MUST_BE_CARD_WARNING_SUFFIX */ .U4), !1))
  );
}


/***/ }),

/***/ 22080:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ logCardDismissal; }
/* harmony export */ });
/* harmony import */ var _models_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72857);
/* harmony import */ var _card_manager_factory_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85716);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27671);
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20335);





function logCardDismissal(o) {
  return (
    !!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr() &&
    (o instanceof _models_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z ? _card_manager_factory_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ea */ .Z.ea().Pt(o).tt : (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error("card " + _common_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .MUST_BE_CARD_WARNING_SUFFIX */ .U4), !1))
  );
}


/***/ }),

/***/ 11066:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ logCardImpressions; }
/* harmony export */ });
/* harmony import */ var _models_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72857);
/* harmony import */ var _card_manager_factory_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85716);
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _util_code_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72893);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27671);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20335);






function logCardImpressions(o, n) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return !1;
  if (!(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ)(o)) return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].error */ .Z.error("cards must be an array"), !1;
  for (const r of o)
    if (!(r instanceof _models_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)) return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].error */ .Z.error(`Each card in cards ${_common_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .MUST_BE_CARD_WARNING_SUFFIX */ .U4}`), !1;
  return _card_manager_factory_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].ea */ .Z.ea().Xt(o, n).tt;
}


/***/ }),

/***/ 5383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CaptionedImage; }
/* harmony export */ });
/* harmony import */ var _card_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72857);

class CaptionedImage extends _card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f) {
    super(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f),
      (this.oe = "ab-captioned-image"),
      (this.ae = !0),
      (this.test = !1);
  }
  bt() {
    const t = {};
    return (
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.hs */ .Z.es.hs] = _card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.cs */ .Z.ds.cs),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ps */ .Z.es.ps] = this.id),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.us */ .Z.es.us] = this.viewed),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ls */ .Z.es.ls] = this.title),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fs */ .Z.es.fs] = this.imageUrl),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.xs */ .Z.es.xs] = this.description),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.bs */ .Z.es.bs] = this.updated),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.gs */ .Z.es.gs] = this.created),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.js */ .Z.es.js] = this.categories),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.zs */ .Z.es.zs] = this.expiresAt),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.URL */ .Z.es.URL] = this.url),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ks */ .Z.es.ks] = this.linkText),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.qs */ .Z.es.qs] = this.aspectRatio),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs] = this.extras),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ws */ .Z.es.ws] = this.pinned),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ys */ .Z.es.ys] = this.dismissible),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.As */ .Z.es.As] = this.clicked),
      (t[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Bs */ .Z.es.Bs] = this.test),
      t
    );
  }
}


/***/ }),

/***/ 72857:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var _util_date_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57750);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27671);
/* harmony import */ var _managers_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74663);
/* harmony import */ var _shared_lib_logger_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20335);




class Card {
  constructor(t, i, s, h, n, l, e, r, u, E, o, T, I, a, c, N) {
    (this.id = t),
      (this.viewed = i),
      (this.title = s),
      (this.imageUrl = h),
      (this.description = n),
      (this.created = l),
      (this.updated = e),
      (this.categories = r),
      (this.expiresAt = u),
      (this.url = E),
      (this.linkText = o),
      (this.aspectRatio = T),
      (this.extras = I),
      (this.pinned = a),
      (this.dismissible = c),
      (this.clicked = N),
      (this.id = t),
      (this.viewed = i || !1),
      (this.title = s || ""),
      (this.imageUrl = h),
      (this.description = n || ""),
      (this.created = l || null),
      (this.updated = e || null),
      (this.categories = r || []),
      (this.expiresAt = u || null),
      (this.url = E),
      (this.linkText = o),
      null == T
        ? (this.aspectRatio = null)
        : ((T = parseFloat(T.toString())),
          (this.aspectRatio = isNaN(T) ? null : T)),
      (this.extras = I || {}),
      (this.pinned = a || !1),
      (this.dismissible = c || !1),
      (this.dismissed = !1),
      (this.clicked = N || !1),
      (this.isControl = !1),
      (this.test = !1),
      (this.ti = null),
      (this.ii = null),
      (this.si = null);
  }
  subscribeToClickedEvent(t) {
    return this.hi().Ft(t);
  }
  subscribeToDismissedEvent(t) {
    return this.ni().Ft(t);
  }
  removeSubscription(t) {
    this.hi().removeSubscription(t), this.ni().removeSubscription(t);
  }
  removeAllSubscriptions() {
    this.hi().removeAllSubscriptions(), this.ni().removeAllSubscriptions();
  }
  dismissCard() {
    if (!this.dismissible || this.dismissed) return;
    "function" == typeof this.logCardDismissal && this.logCardDismissal();
    let t = this.te;
    !t && this.id && (t = document.getElementById(this.id)),
      t &&
        ((t.style.height = t.offsetHeight + "px"),
        (t.className = t.className + " ab-hide"),
        setTimeout(function () {
          t &&
            t.parentNode &&
            ((t.style.height = "0"),
            (t.style.margin = "0"),
            setTimeout(function () {
              t && t.parentNode && t.parentNode.removeChild(t);
            }, Card.li));
        }, _common_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .FEED_ANIMATION_DURATION */ .rF));
  }
  hi() {
    return null == this.ti && (this.ti = new _managers_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z()), this.ti;
  }
  ni() {
    return null == this.ii && (this.ii = new _managers_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z()), this.ii;
  }
  ts() {
    const t = new Date().valueOf();
    return (
      !(null != this.si && t - this.si < Card.ei) &&
      ((this.si = t), (this.viewed = !0), !0)
    );
  }
  $t() {
    (this.viewed = !0), (this.clicked = !0), this.hi().X();
  }
  Qt() {
    return (
      !(!this.dismissible || this.dismissed) &&
      ((this.dismissed = !0), this.ni().X(), !0)
    );
  }
  ri(t) {
    if (null == t || t[Card.ui.ps] !== this.id) return !0;
    if (t[Card.ui.Ei]) return !1;
    if (
      null != t[Card.ui.bs] &&
      null != this.updated &&
      parseInt(t[Card.ui.bs]) < (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .convertMsToSeconds */ .FX)(this.updated.valueOf())
    )
      return !0;
    if (
      (t[Card.ui.us] && !this.viewed && (this.viewed = !0),
      t[Card.ui.As] && !this.clicked && (this.clicked = t[Card.ui.As]),
      null != t[Card.ui.ls] && (this.title = t[Card.ui.ls]),
      null != t[Card.ui.fs] && (this.imageUrl = t[Card.ui.fs]),
      null != t[Card.ui.xs] && (this.description = t[Card.ui.xs]),
      null != t[Card.ui.bs])
    ) {
      const i = (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .dateFromUnixTimestamp */ .X2)(t[Card.ui.bs]);
      null != i && (this.updated = i);
    }
    if (null != t[Card.ui.zs]) {
      let i;
      (i = t[Card.ui.zs] === Card.oi ? null : (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .dateFromUnixTimestamp */ .X2)(t[Card.ui.zs])),
        (this.expiresAt = i);
    }
    if (
      (null != t[Card.ui.URL] && (this.url = t[Card.ui.URL]),
      null != t[Card.ui.ks] && (this.linkText = t[Card.ui.ks]),
      null != t[Card.ui.qs])
    ) {
      const i = parseFloat(t[Card.ui.qs].toString());
      this.aspectRatio = isNaN(i) ? null : i;
    }
    return (
      null != t[Card.ui.vs] && (this.extras = t[Card.ui.vs]),
      null != t[Card.ui.ws] && (this.pinned = t[Card.ui.ws]),
      null != t[Card.ui.ys] && (this.dismissible = t[Card.ui.ys]),
      null != t[Card.ui.Bs] && (this.test = t[Card.ui.Bs]),
      !0
    );
  }
  bt() {
    _shared_lib_logger_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error("Must be implemented in a subclass");
  }
}
(Card.oi = -1),
  (Card.ui = {
    ps: "id",
    us: "v",
    ys: "db",
    Ei: "r",
    bs: "ca",
    ws: "p",
    zs: "ea",
    vs: "e",
    hs: "tp",
    fs: "i",
    ls: "tt",
    xs: "ds",
    URL: "u",
    ks: "dm",
    qs: "ar",
    As: "cl",
    Bs: "t",
  }),
  (Card.ds = {
    cs: "captioned_image",
    Ti: "text_announcement",
    Ii: "short_news",
    ai: "banner_image",
    ci: "control",
  }),
  (Card.es = {
    ps: "id",
    us: "v",
    ys: "db",
    gs: "cr",
    bs: "ca",
    ws: "p",
    js: "t",
    zs: "ea",
    vs: "e",
    hs: "tp",
    fs: "i",
    ls: "tt",
    xs: "ds",
    URL: "u",
    ks: "dm",
    qs: "ar",
    As: "cl",
    Bs: "s",
  }),
  (Card.Ni = {
    mi: "ADVERTISING",
    Si: "ANNOUNCEMENTS",
    Ai: "NEWS",
    Di: "SOCIAL",
  }),
  (Card.li = 400),
  (Card.ei = 1e4);


/***/ }),

/***/ 37653:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClassicCard; }
/* harmony export */ });
/* harmony import */ var _card_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72857);

class ClassicCard extends _card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m) {
    super(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m),
      (this.oe = "ab-classic-card"),
      (this.ae = !0);
  }
  bt() {
    const s = {};
    return (
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.hs */ .Z.es.hs] = _card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.Ii */ .Z.ds.Ii),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ps */ .Z.es.ps] = this.id),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.us */ .Z.es.us] = this.viewed),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ls */ .Z.es.ls] = this.title),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fs */ .Z.es.fs] = this.imageUrl),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.xs */ .Z.es.xs] = this.description),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.bs */ .Z.es.bs] = this.updated),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.gs */ .Z.es.gs] = this.created),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.js */ .Z.es.js] = this.categories),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.zs */ .Z.es.zs] = this.expiresAt),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.URL */ .Z.es.URL] = this.url),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ks */ .Z.es.ks] = this.linkText),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.qs */ .Z.es.qs] = this.aspectRatio),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs] = this.extras),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ws */ .Z.es.ws] = this.pinned),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ys */ .Z.es.ys] = this.dismissible),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.As */ .Z.es.As] = this.clicked),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Bs */ .Z.es.Bs] = this.test),
      s
    );
  }
}


/***/ }),

/***/ 85563:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ControlCard; }
/* harmony export */ });
/* harmony import */ var _card_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72857);

class ControlCard extends _card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(l, t, s, i, n, r) {
    super(l, t, null, null, null, null, s, null, i, null, null, null, n, r),
      (this.isControl = !0),
      (this.oe = "ab-control-card"),
      (this.ae = !1);
  }
  bt() {
    const l = {};
    return (
      (l[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.hs */ .Z.es.hs] = _card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.ci */ .Z.ds.ci),
      (l[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ps */ .Z.es.ps] = this.id),
      (l[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.us */ .Z.es.us] = this.viewed),
      (l[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.bs */ .Z.es.bs] = this.updated),
      (l[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.zs */ .Z.es.zs] = this.expiresAt),
      (l[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs] = this.extras),
      (l[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ws */ .Z.es.ws] = this.pinned),
      (l[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Bs */ .Z.es.Bs] = this.test),
      l
    );
  }
}


/***/ }),

/***/ 8378:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageOnly; }
/* harmony export */ });
/* harmony import */ var _card_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72857);

class ImageOnly extends _card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(s, t, i, h, r, e, l, n, o, a, u, c, d, m) {
    super(s, t, null, i, null, h, r, e, l, n, o, a, u, c, d, m),
      (this.oe = "ab-image-only"),
      (this.ae = !1),
      (this.test = !1);
  }
  bt() {
    const s = {};
    return (
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.hs */ .Z.es.hs] = _card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.ai */ .Z.ds.ai),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ps */ .Z.es.ps] = this.id),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.us */ .Z.es.us] = this.viewed),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fs */ .Z.es.fs] = this.imageUrl),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.bs */ .Z.es.bs] = this.updated),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.gs */ .Z.es.gs] = this.created),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.js */ .Z.es.js] = this.categories),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.zs */ .Z.es.zs] = this.expiresAt),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.URL */ .Z.es.URL] = this.url),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ks */ .Z.es.ks] = this.linkText),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.qs */ .Z.es.qs] = this.aspectRatio),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs] = this.extras),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ws */ .Z.es.ws] = this.pinned),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ys */ .Z.es.ys] = this.dismissible),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.As */ .Z.es.As] = this.clicked),
      (s[_card_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Bs */ .Z.es.Bs] = this.test),
      s
    );
  }
}


/***/ }),

/***/ 23756:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D5": function() { return /* binding */ newCardFromFeedJson; },
/* harmony export */   "rN": function() { return /* binding */ newCardFromSerializedValue; },
/* harmony export */   "xA": function() { return /* binding */ newCardFromContentCardsJson; }
/* harmony export */ });
/* unused harmony export newCard */
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72857);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37653);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5383);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8378);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85563);
/* harmony import */ var _util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57750);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20335);



function newCard(n, e, r, t, o, i, l, u, d, a, w, f, s, m, C, p, c, x) {
  let F;
  if (e === _index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.Ti */ .Z.ds.Ti || e === _index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.Ii */ .Z.ds.Ii)
    F = new _index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(n, r, t, o, i, l, u, d, a, w, f, s, m, C, p, c);
  else if (e === _index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.cs */ .Z.ds.cs)
    F = new _index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(n, r, t, o, i, l, u, d, a, w, f, s, m, C, p, c);
  else if (e === _index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.ai */ .Z.ds.ai)
    F = new _index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(n, r, o, l, u, d, a, w, f, s, m, C, p, c);
  else {
    if (e !== _index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ds.ci */ .Z.ds.ci)
      return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].error */ .Z.error("Ignoring card with unknown type " + e), null;
    F = new _index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z(n, r, u, a, m, C);
  }
  return x && (F.test = x), F;
}
function newCardFromContentCardsJson(n) {
  if (n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.Ei */ .Z.ui.Ei]) return null;
  const e = n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.ps */ .Z.ui.ps],
    r = n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.hs */ .Z.ui.hs],
    t = n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.us */ .Z.ui.us],
    o = n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.ls */ .Z.ui.ls],
    i = n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.fs */ .Z.ui.fs],
    l = n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.xs */ .Z.ui.xs],
    u = (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .dateFromUnixTimestamp */ .X2)(n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.bs */ .Z.ui.bs]),
    d = u;
  let a;
  a = n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.zs */ .Z.ui.zs] === _index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].oi */ .Z.oi ? null : (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .dateFromUnixTimestamp */ .X2)(n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.zs */ .Z.ui.zs]);
  return newCard(
    e,
    r,
    t,
    o,
    i,
    l,
    d,
    u,
    null,
    a,
    n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.URL */ .Z.ui.URL],
    n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.ks */ .Z.ui.ks],
    n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.qs */ .Z.ui.qs],
    n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.vs */ .Z.ui.vs],
    n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.ws */ .Z.ui.ws],
    n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.ys */ .Z.ui.ys],
    n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.As */ .Z.ui.As],
    n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ui.Bs */ .Z.ui.Bs] || !1,
  );
}
function newCardFromFeedJson(n) {
  return newCard(
    n.id,
    n.type,
    n.viewed,
    n.title,
    n.image,
    n.description,
    (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .dateFromUnixTimestamp */ .X2)(n.created),
    (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .dateFromUnixTimestamp */ .X2)(n.updated),
    n.categories,
    (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .dateFromUnixTimestamp */ .X2)(n.expires_at),
    n.url,
    n.domain,
    n.aspect_ratio,
    n.extras,
    !1,
    !1,
  );
}
function newCardFromSerializedValue(n) {
  return (
    newCard(
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ps */ .Z.es.ps],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.hs */ .Z.es.hs],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.us */ .Z.es.us],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ls */ .Z.es.ls],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fs */ .Z.es.fs],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.xs */ .Z.es.xs],
      (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .rehydrateDateAfterJsonization */ .Rd)(n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.gs */ .Z.es.gs]),
      (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .rehydrateDateAfterJsonization */ .Rd)(n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.bs */ .Z.es.bs]),
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.js */ .Z.es.js],
      (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .rehydrateDateAfterJsonization */ .Rd)(n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.zs */ .Z.es.zs]),
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.URL */ .Z.es.URL],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ks */ .Z.es.ks],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.qs */ .Z.es.qs],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ws */ .Z.es.ws],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ys */ .Z.es.ys],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.As */ .Z.es.As],
      n[_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Bs */ .Z.es.Bs] || !1,
    ) || void 0
  );
}


/***/ }),

/***/ 1627:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ content_cards_provider_factory; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/net.js
var net = __webpack_require__(41843);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/base-provider.js
var base_provider = __webpack_require__(40158);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/content-cards.js
var content_cards = __webpack_require__(82028);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/date-utils.js
var date_utils = __webpack_require__(57750);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/url-utils.js
var url_utils = __webpack_require__(1148);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/util/card-factory.js
var card_factory = __webpack_require__(23756);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/subscription-manager.js
var subscription_manager = __webpack_require__(74663);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/request-header-utils.js
var request_header_utils = __webpack_require__(76870);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/math.js
var math = __webpack_require__(96504);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/indexed-db-adapter.js
var indexed_db_adapter = __webpack_require__(45522);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/content-cards-provider.js












class Q extends base_provider/* default */.Z {
  constructor(t, s, i, e, h) {
    super(),
      (this.Cs = t),
      (this.C = s),
      (this.B = i),
      (this.Ss = e),
      (this.S = h),
      (this.Cs = t),
      (this.C = s),
      (this.B = i),
      (this.Ss = e),
      (this.S = h),
      (this.Ts = new subscription_manager/* default */.Z()),
      braze_instance/* default.N */.ZP.N(this.Ts),
      (this.Rs = 0),
      (this.Us = 0),
      (this.cards = []),
      this.Ds();
    const n = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs;
    new indexed_db_adapter/* default */.Z(n, logger/* default */.Z).Ns(n.Ms.Js, (t) => {
      this.$s(t);
    }),
      (this.Es = null),
      (this.k = null),
      (this.Ps = null),
      (this.Xs = null),
      (this._s = 10);
  }
  Gs() {
    return this.Es;
  }
  Hs(t) {
    this.Es = t;
  }
  Ct() {
    return this.k;
  }
  Tt(t) {
    this.k = t;
  }
  Ds() {
    if (!this.C) return;
    const t = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Is */.I.gt.Is) || [],
      i = [];
    for (let s = 0; s < t.length; s++) {
      const e = (0,card_factory/* newCardFromSerializedValue */.rN)(t[s]);
      null != e && i.push(e);
    }
    (this.cards = this.Ks(this.Os(i, !1))),
      (this.Rs = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Qs */.I.gt.Qs) || this.Rs),
      (this.Us = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Vs */.I.gt.Vs) || this.Us);
  }
  Ws(t, i = !1, e = 0, h = 0) {
    let r;
    if (i) {
      r = [];
      for (const t of this.cards) t.test && r.push(t);
    } else r = this.cards.slice();
    for (let s = 0; s < t.length; s++) {
      const e = t[s];
      let h = null;
      for (let t = 0; t < this.cards.length; t++)
        if (e.id === this.cards[t].id) {
          h = this.cards[t];
          break;
        }
      if (i) {
        const t = (0,card_factory/* newCardFromContentCardsJson */.xA)(e);
        null != h && h.viewed && t && (t.viewed = !0), null != t && r.push(t);
      } else if (null == h) {
        const t = (0,card_factory/* newCardFromContentCardsJson */.xA)(e);
        null != t && r.push(t);
      } else {
        if (!h.ri(e))
          for (let t = 0; t < r.length; t++)
            if (e.id === r[t].id) {
              r.splice(t, 1);
              break;
            }
      }
    }
    (this.cards = this.Ks(this.Os(r, i))),
      this.Ys(),
      (this.Rs = e),
      (this.Us = h),
      this.C && (this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Qs */.I.gt.Qs, this.Rs), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Vs */.I.gt.Vs, this.Us));
  }
  U(t) {
    if (this.Zs() && null != t && t.cards) {
      this.C && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.fi */.I.gt.fi, braze_instance/* default.di */.ZP.di());
      const i = t.full_sync;
      i || this.Ds(),
        this.Ws(t.cards, i, t.last_full_sync_at, t.last_card_updated_at),
        this.Ts.X(this.pi(!0));
    }
  }
  Ci(t) {
    this.bi(), (this.Ps = t);
  }
  $s(t) {
    var s;
    if (!this.Zs()) return;
    this.Ds();
    const i = this.cards.slice();
    let e = null;
    e = null === (s = this.Cs) || void 0 === s ? void 0 : s.getUserId();
    for (let s = 0; s < t.length; s++)
      if (e === t[s].userId || (null == e && null == t[s].userId)) {
        const e = t[s].card;
        let h = null;
        for (let t = 0; t < this.cards.length; t++)
          if (e.id === this.cards[t].id) {
            h = this.cards[t];
            break;
          }
        if (null == h) {
          const t = (0,card_factory/* newCardFromContentCardsJson */.xA)(e);
          null != t && i.push(t);
        } else {
          if (!h.ri(e))
            for (let t = 0; t < i.length; t++)
              if (e.id === i[t].id) {
                i.splice(t, 1);
                break;
              }
        }
      }
    (this.cards = this.Ks(this.Os(i, !1))), this.Ys(), this.Ts.X(this.pi(!0));
  }
  Os(t, i) {
    let e = {},
      h = {},
      r = {};
    this.C &&
      ((e = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Kt */.I.gt.Kt) || {}),
      (h = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Yt */.I.gt.Yt) || {}),
      (r = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Vt */.I.gt.Vt) || {}));
    const n = {},
      o = {},
      l = {};
    for (let s = 0; s < t.length; s++) {
      const i = t[s].id;
      i &&
        (e[i] && ((t[s].clicked = !0), (n[i] = !0)),
        h[i] && ((t[s].viewed = !0), (o[i] = !0)),
        r[i] && ((t[s].dismissed = !0), (l[i] = !0)));
    }
    return (
      i &&
        this.C &&
        (this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Kt */.I.gt.Kt, n), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Yt */.I.gt.Yt, o), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Vt */.I.gt.Vt, l)),
      t
    );
  }
  Ks(t) {
    const i = [],
      e = new Date();
    let h = {};
    this.C && (h = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Vt */.I.gt.Vt) || {});
    let r = !1;
    for (let s = 0; s < t.length; s++) {
      const n = t[s].url;
      if (!this.Ss && n && (0,url_utils/* isURIJavascriptOrData */.o)(n)) {
        logger/* default.error */.Z.error(
          `Card with url ${n} will not be displayed because Javascript URLs are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable this card.`,
        );
        continue;
      }
      const o = t[s].expiresAt;
      let l = !0;
      if ((null != o && (l = o >= e), (l = l && !t[s].dismissed), l))
        i.push(t[s]);
      else {
        const i = t[s].id;
        i && (h[i] = !0), (r = !0);
      }
    }
    return r && this.C && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Vt */.I.gt.Vt, h), i;
  }
  Ys() {
    var t;
    const i = [];
    for (let t = 0; t < this.cards.length; t++) i.push(this.cards[t].bt());
    null === (t = this.C) || void 0 === t || t.Bt(storage_manager/* STORAGE_KEYS.gt.Is */.I.gt.Is, i);
  }
  bi() {
    this.Ps && (clearTimeout(this.Ps), (this.Ps = null));
  }
  vi(t, i, e = !1) {
    var n;
    const o = this.S,
      u = this.C;
    if (!o || !u) return void ("function" == typeof i && i());
    if ((e && (request_header_utils/* default.wi */.Z.wi(u, request_header_utils/* default.O.gi */.Z.O.gi), this.bi()), !this.Zs()))
      return void (
        null === (n = this.B) ||
        void 0 === n ||
        n.ji(() => {
          this.vi(t, i, !0);
        })
      );
    const c = o.H({}, !0);
    u.ft(storage_manager/* STORAGE_KEYS.gt.fi */.I.gt.fi) !== braze_instance/* default.di */.ZP.di() && this.yi(),
      (c.last_full_sync_at = this.Rs),
      (c.last_card_updated_at = this.Us);
    const f = o.J(c, request_header_utils/* default.O.gi */.Z.O.gi, e);
    let d = !1;
    o.V(
      c,
      (s = -1) => {
        if (this.C) {
          const t = new Date().valueOf();
          request_header_utils/* default.W */.Z.W(this.C, request_header_utils/* default.O.gi */.Z.O.gi, t);
        }
        -1 !== s && f.push(["X-Braze-Req-Tokens-Remaining", s.toString()]),
          net/* default.Y */.Z.Y({
            url: `${o.Z()}/content_cards/sync`,
            data: c,
            headers: f,
            tt: (s) => {
              if (!o.st(c, s, f))
                return (d = !0), void ("function" == typeof i && i());
              o.it(), this.U(s), (d = !1), "function" == typeof t && t();
            },
            error: (t) => {
              o.et(t, "retrieving content cards"),
                (d = !0),
                "function" == typeof i && i();
            },
            nt: (s, e) => {
              let r;
              if (d) {
                let t = this.Xs;
                (null == t || t < 1e3 * this._s) && (t = 1e3 * this._s),
                  (r = Math.min(3e5, (0,math/* randomInclusive */.R)(1e3 * this._s, 3 * t)));
              }
              o.rt(
                e,
                () => {
                  this.vi(t, i, !1);
                },
                request_header_utils/* default.O.gi */.Z.O.gi,
                (t) => this.Ci(t),
                () => this.bi(),
                r,
              );
            },
          });
      },
      request_header_utils/* default.O.gi */.Z.O.gi,
      i,
    );
  }
  pi(t) {
    t || this.Ds();
    const i = this.Ks(this.cards);
    i.sort((t, s) =>
      t.pinned && !s.pinned
        ? -1
        : s.pinned && !t.pinned
        ? 1
        : t.updated && s.updated && t.updated > s.updated
        ? -1
        : t.updated && s.updated && s.updated > t.updated
        ? 1
        : 0,
    );
    let e = Math.max(this.Us || 0, this.Rs || 0);
    return (
      0 === e && (e = void 0),
      this.C && this.C.ft(storage_manager/* STORAGE_KEYS.gt.Vs */.I.gt.Vs) === this.Us && void 0 === e && (e = this.Us),
      new content_cards/* default */.Z(i, (0,date_utils/* dateFromUnixTimestamp */.X2)(e))
    );
  }
  qt(t) {
    return this.Ts.Ft(t);
  }
  yi() {
    (this.Rs = 0),
      (this.Us = 0),
      this.C && (this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Qs */.I.gt.Qs), this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Vs */.I.gt.Vs));
  }
  changeUser(t) {
    t ||
      ((this.cards = []),
      this.Ts.X(new content_cards/* default */.Z(this.cards.slice(), null)),
      this.C &&
        (this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Is */.I.gt.Is),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Kt */.I.gt.Kt),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Yt */.I.gt.Yt),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Vt */.I.gt.Vt))),
      this.yi();
  }
  clearData(t) {
    (this.Rs = 0),
      (this.Us = 0),
      (this.cards = []),
      this.Ts.X(new content_cards/* default */.Z(this.cards.slice(), null)),
      t &&
        this.C &&
        (this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Is */.I.gt.Is),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Kt */.I.gt.Kt),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Yt */.I.gt.Yt),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Vt */.I.gt.Vt),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Qs */.I.gt.Qs),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Vs */.I.gt.Vs));
  }
  Zs() {
    return !!this.B && (!!this.B.Ri() || (0 !== this.B.Et() && this.Ui(), !1));
  }
  Ui() {
    this.Ts.X(new content_cards/* default */.Z([], new Date())), this.C && this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Is */.I.gt.Is);
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/content-cards-provider-factory.js


const W = {
  l: !1,
  provider: null,
  m: () => (
    W.p(),
    W.provider ||
      ((W.provider = new Q(braze_instance/* default.ir */.ZP.ir(), braze_instance/* default.j */.ZP.j(), braze_instance/* default.v */.ZP.v(), braze_instance/* default.tr */.ZP.tr(), braze_instance/* default.g */.ZP.g())),
      braze_instance/* default._ */.ZP._(W.provider)),
    W.provider
  ),
  p: () => {
    W.l || (braze_instance/* default.h */.ZP.h(W), (W.l = !0));
  },
  destroy: () => {
    (W.provider = null), (W.l = !1);
  },
};
/* harmony default export */ var content_cards_provider_factory = (W);


/***/ }),

/***/ 82028:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentCards; }
/* harmony export */ });
/* harmony import */ var _common_base_feed_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67);
/* harmony import */ var _Card_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11066);
/* harmony import */ var _Card_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1280);
/* harmony import */ var _request_content_cards_refresh_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28863);



class ContentCards extends _common_base_feed_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(r, e) {
    super(r, e);
  }
  getUnviewedCardCount() {
    return super.getUnreadCardCount();
  }
  logCardImpressions(r) {
    (0,_Card_index_js__WEBPACK_IMPORTED_MODULE_1__/* .logCardImpressions */ .p)(r, !0);
  }
  logCardClick(r) {
    return (0,_Card_index_js__WEBPACK_IMPORTED_MODULE_2__/* .logCardClick */ .d)(r, !0);
  }
  sr() {
    (0,_request_content_cards_refresh_js__WEBPACK_IMPORTED_MODULE_3__/* .requestContentCardsRefresh */ .v)();
  }
  nr() {
    return !0;
  }
}
ContentCards.dr = 6e4;


/***/ }),

/***/ 28863:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ requestContentCardsRefresh; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _content_cards_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1627);


function requestContentCardsRefresh(e, t) {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return _content_cards_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].m */ .Z.m().vi(e, t, !0);
}


/***/ }),

/***/ 49954:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ subscribeToContentCardsUpdates; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _content_cards_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1627);


function subscribeToContentCardsUpdates(o) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return;
  const t = _content_cards_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].m */ .Z.m(),
    n = t.qt(o);
  if (!t.Ct()) {
    const o = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].nn */ .ZP.nn();
    if (o) {
      const r = o.rn(() => {
        t.vi(void 0, void 0, !0);
      });
      r && t.Tt(r);
    }
  }
  return n;
}


/***/ }),

/***/ 34790:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "changeUser": function() { return /* binding */ changeUser; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _util_string_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8548);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20335);
/* harmony import */ var _User_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17615);
/* harmony import */ var _util_validation_utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3905);





function changeUser(e, i) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return;
  if (null == e || 0 === e.length || e != e)
    return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error("changeUser requires a non-empty userId.");
  if ((0,_util_string_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .getByteLength */ .E)(e) > _User_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ur */ .Z.ur)
    return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(
      `Rejected user id "${e}" because it is longer than ${_User_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ur */ .Z.ur} bytes.`,
    );
  if (null != i && !(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_4__/* .validateStandardString */ .ro)(i, "set signature for new user", "signature")) return;
  const t = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].nn */ .ZP.nn();
  t && t.changeUser(e.toString(), _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ar */ .ZP.ar(), i);
}


/***/ }),

/***/ 12017:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
  BROWSER: "browser",
  BROWSER_VERSION: "browserVersion",
  OS: "os",
  RESOLUTION: "resolution",
  LANGUAGE: "language",
  TIME_ZONE: "timeZone",
  USER_AGENT: "userAgent",
});


/***/ }),

/***/ 46243:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getUser; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);

function getUser() {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mr */ .ZP.mr();
}


/***/ }),

/***/ 40420:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ _handleBrazeAction; },
/* harmony export */   "h": function() { return /* binding */ handleBrazeAction; }
/* harmony export */ });
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20335);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27671);
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73046);
/* harmony import */ var _util_browser_detector_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7169);
/* harmony import */ var _util_device_constants_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35806);
/* harmony import */ var _util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var _util_window_utils_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75319);
/* harmony import */ var _get_user_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46243);









function _handleBrazeAction(o, e, s) {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr())
    if (_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .BRAZE_ACTION_URI_REGEX.test */ .y9.test(o)) {
      const e = (0,_util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .getDecodedBrazeAction */ .OL)(o);
      if (!e) return;
      const s = (o) => {
        if (!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isValidBrazeActionJson */ .zR)(o))
          return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error(
            `Decoded Braze Action json is invalid: ${JSON.stringify(
              o,
              null,
              2,
            )}`,
          );
        const e = _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.properties.type */ .A9.properties.type,
          t = _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.properties.eo */ .A9.properties.eo,
          i = _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.properties.so */ .A9.properties.so,
          n = o[e];
        if (n === _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.io */ .A9.types.io) {
          const e = o[t];
          for (const o of e) s(o);
        } else {
          const e = o[i];
          let s, t;
          switch (n) {
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.logCustomEvent */ .A9.types.logCustomEvent:
              Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61454)).then(
                ({ logCustomEvent: logCustomEvent }) => {
                  _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"]._t */ .ZP._t()
                    ? ((t = Array.prototype.slice.call(e)),
                      logCustomEvent(...t))
                    : _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .BRAZE_MUST_BE_INITIALIZED_ERROR */ .Go);
                },
              );
              break;
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.requestPushPermission */ .A9.types.requestPushPermission:
              Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 12261)).then(
                ({ requestPushPermission: requestPushPermission }) => {
                  _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"]._t */ .ZP._t()
                    ? "Safari" === _util_browser_detector_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].browser */ .Z.browser && _util_browser_detector_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].OS */ .Z.OS === _util_device_constants_js__WEBPACK_IMPORTED_MODULE_6__/* .OperatingSystems.ao */ .T.ao
                      ? window.navigator.standalone && requestPushPermission()
                      : requestPushPermission()
                    : _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .BRAZE_MUST_BE_INITIALIZED_ERROR */ .Go);
                },
              );
              break;
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.setEmailNotificationSubscriptionType */ .A9.types.setEmailNotificationSubscriptionType:
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.setPushNotificationSubscriptionType */ .A9.types.setPushNotificationSubscriptionType:
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.setCustomUserAttribute */ .A9.types.setCustomUserAttribute:
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.addToSubscriptionGroup */ .A9.types.addToSubscriptionGroup:
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.removeFromSubscriptionGroup */ .A9.types.removeFromSubscriptionGroup:
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.addToCustomAttributeArray */ .A9.types.addToCustomAttributeArray:
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.removeFromCustomAttributeArray */ .A9.types.removeFromCustomAttributeArray:
              if (((s = (0,_get_user_js__WEBPACK_IMPORTED_MODULE_7__/* .getUser */ .P)()), s)) {
                s[n](...Array.prototype.slice.call(e));
              }
              break;
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.co */ .A9.types.co:
            case _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_ACTIONS.types.mo */ .A9.types.mo:
              (t = Array.prototype.slice.call(e)), _util_window_utils_js__WEBPACK_IMPORTED_MODULE_8__/* .WindowUtils.openUri */ .SD.openUri(...t);
              break;
            default:
              _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].info */ .Z.info(`Ignoring unknown Braze Action: ${n}`);
          }
        }
      };
      s(e);
    } else _util_window_utils_js__WEBPACK_IMPORTED_MODULE_8__/* .WindowUtils.openUri */ .SD.openUri(o, e, s);
}
function handleBrazeAction(o, e) {
  _handleBrazeAction(o, e);
}


/***/ }),

/***/ 69390:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ initialize; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);

function initialize(i, n) {
  return _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].initialize */ .ZP.initialize(i, n);
}


/***/ }),

/***/ 61454:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "logCustomEvent": function() { return /* binding */ logCustomEvent; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _common_event_logger_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39179);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20335);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12730);
/* harmony import */ var _triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24365);
/* harmony import */ var _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85346);
/* harmony import */ var _util_validation_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3905);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27671);







function logCustomEvent(t, e) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return !1;
  if (null == t || t.length <= 0)
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(
        `logCustomEvent requires a non-empty eventName, got "${t}". Ignoring event.`,
      ),
      !1
    );
  if (!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .validateCustomString */ .zM)(t, "log custom event", "the event name")) return !1;
  const [o, n] = (0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .validateCustomProperties */ .lg)(
    e,
    _common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .LOG_CUSTOM_EVENT_STRING */ ._P,
    "eventProperties",
    `log custom event "${t}"`,
    "event",
  );
  if (!o) return !1;
  const i = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].v */ .ZP.v();
  if (i && i.je(t))
    return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].info */ .Z.info(`Custom Event "${t}" is blocklisted, ignoring.`), !1;
  const s = _common_event_logger_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ut */ .Z.ut(_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__/* .EventTypes.CustomEvent */ .G.CustomEvent, { n: t, p: n });
  if (s.tt) {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].info */ .Z.info(`Logged custom event "${t}".`);
    for (const o of s.$e) _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_6__/* .TriggersProviderFactory.m */ .n.m().Ce(_triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Ee */ .Z.Ee, [t, e], o);
  }
  return s.tt;
}


/***/ }),

/***/ 61364:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "logPurchase": function() { return /* binding */ logPurchase; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27671);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20335);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12730);
/* harmony import */ var _triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24365);
/* harmony import */ var _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85346);
/* harmony import */ var _util_validation_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3905);
/* harmony import */ var _common_event_logger_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39179);







function logPurchase(e, o, i, n, t) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return !1;
  if (
    (null == i && (i = "USD"), null == n && (n = 1), null == e || e.length <= 0)
  )
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(
        `logPurchase requires a non-empty productId, got "${e}", ignoring.`,
      ),
      !1
    );
  if (!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .validateCustomString */ .zM)(e, "log purchase", "the purchase name")) return !1;
  if (null == o || isNaN(parseFloat(o.toString())))
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(`logPurchase requires a numeric price, got ${o}, ignoring.`), !1
    );
  const s = parseFloat(o.toString()).toFixed(2);
  if (null == n || isNaN(parseInt(n.toString())))
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(`logPurchase requires an integer quantity, got ${n}, ignoring.`),
      !1
    );
  const D = parseInt(n.toString());
  if (D < 1 || D > _common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .MAX_PURCHASE_QUANTITY */ .Fz)
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(
        `logPurchase requires a quantity >1 and <${_common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .MAX_PURCHASE_QUANTITY */ .Fz}, got ${D}, ignoring.`,
      ),
      !1
    );
  i = null != i ? i.toUpperCase() : i;
  if (
    -1 ===
    [
      "AED",
      "AFN",
      "ALL",
      "AMD",
      "ANG",
      "AOA",
      "ARS",
      "AUD",
      "AWG",
      "AZN",
      "BAM",
      "BBD",
      "BDT",
      "BGN",
      "BHD",
      "BIF",
      "BMD",
      "BND",
      "BOB",
      "BRL",
      "BSD",
      "BTC",
      "BTN",
      "BWP",
      "BYR",
      "BZD",
      "CAD",
      "CDF",
      "CHF",
      "CLF",
      "CLP",
      "CNY",
      "COP",
      "CRC",
      "CUC",
      "CUP",
      "CVE",
      "CZK",
      "DJF",
      "DKK",
      "DOP",
      "DZD",
      "EEK",
      "EGP",
      "ERN",
      "ETB",
      "EUR",
      "FJD",
      "FKP",
      "GBP",
      "GEL",
      "GGP",
      "GHS",
      "GIP",
      "GMD",
      "GNF",
      "GTQ",
      "GYD",
      "HKD",
      "HNL",
      "HRK",
      "HTG",
      "HUF",
      "IDR",
      "ILS",
      "IMP",
      "INR",
      "IQD",
      "IRR",
      "ISK",
      "JEP",
      "JMD",
      "JOD",
      "JPY",
      "KES",
      "KGS",
      "KHR",
      "KMF",
      "KPW",
      "KRW",
      "KWD",
      "KYD",
      "KZT",
      "LAK",
      "LBP",
      "LKR",
      "LRD",
      "LSL",
      "LTL",
      "LVL",
      "LYD",
      "MAD",
      "MDL",
      "MGA",
      "MKD",
      "MMK",
      "MNT",
      "MOP",
      "MRO",
      "MTL",
      "MUR",
      "MVR",
      "MWK",
      "MXN",
      "MYR",
      "MZN",
      "NAD",
      "NGN",
      "NIO",
      "NOK",
      "NPR",
      "NZD",
      "OMR",
      "PAB",
      "PEN",
      "PGK",
      "PHP",
      "PKR",
      "PLN",
      "PYG",
      "QAR",
      "RON",
      "RSD",
      "RUB",
      "RWF",
      "SAR",
      "SBD",
      "SCR",
      "SDG",
      "SEK",
      "SGD",
      "SHP",
      "SLL",
      "SOS",
      "SRD",
      "STD",
      "SVC",
      "SYP",
      "SZL",
      "THB",
      "TJS",
      "TMT",
      "TND",
      "TOP",
      "TRY",
      "TTD",
      "TWD",
      "TZS",
      "UAH",
      "UGX",
      "USD",
      "UYU",
      "UZS",
      "VEF",
      "VND",
      "VUV",
      "WST",
      "XAF",
      "XAG",
      "XAU",
      "XCD",
      "XDR",
      "XOF",
      "XPD",
      "XPF",
      "XPT",
      "YER",
      "ZAR",
      "ZMK",
      "ZMW",
      "ZWL",
    ].indexOf(i)
  )
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(`logPurchase requires a valid currencyCode, got ${i}, ignoring.`),
      !1
    );
  const [u, a] = (0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .validateCustomProperties */ .lg)(
    t,
    "logPurchase",
    "purchaseProperties",
    `log purchase "${e}"`,
    "purchase",
  );
  if (!u) return !1;
  const g = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].v */ .ZP.v();
  if (g && g.Dr(e))
    return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].info */ .Z.info(`Purchase "${e}" is blocklisted, ignoring.`), !1;
  const P = _common_event_logger_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ut */ .Z.ut(_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__/* .EventTypes.Pr */ .G.Pr, { pid: e, c: i, p: s, q: D, pr: a });
  if (P.tt) {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].info */ .Z.info(`Logged ${D} purchase${D > 1 ? "s" : ""} of "${e}" for ${i} ${s}.`);
    for (const r of P.$e) _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_6__/* .TriggersProviderFactory.m */ .n.m().Ce(_triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Rr */ .Z.Rr, [e, t], r);
  }
  return P.tt;
}


/***/ }),

/***/ 45430:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ openSession; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45522);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20335);
/* harmony import */ var _triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24365);
/* harmony import */ var _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85346);




function openSession() {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return;
  const i = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].nn */ .ZP.nn();
  if (!i) return;
  i.openSession();
  const t = _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Ls.Fs */ .Z.Ls.Fs,
    o = new _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(t, _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  o.cr(t.Ms.jr, (r, n) => {
    const e = n.lastClick,
      s = n.trackingString;
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].info */ .Z.info(`Firing push click trigger from ${s} push click at ${e}`);
    const c = i.lr(e, s),
      g = function () {
        _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_3__/* .TriggersProviderFactory.m */ .n.m().Ce(_triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].hr */ .Z.hr, [s], c);
      };
    i.br(g, g), o.ge(t.Ms.jr, r);
  }),
    o.Ns(t.Ms.kr, function (r) {
      i.vr(r);
    });
}


/***/ }),

/***/ 18503:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ removeSubscription; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);

function removeSubscription(e) {
  _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr() && _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].removeSubscription */ .ZP.removeSubscription(e);
}


/***/ }),

/***/ 64650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "requestImmediateDataFlush": function() { return /* binding */ requestImmediateDataFlush; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);

function requestImmediateDataFlush(e) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return;
  const t = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].nn */ .ZP.nn();
  t && t.requestImmediateDataFlush(e);
}


/***/ }),

/***/ 12962:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureFlag; }
/* harmony export */ });
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20335);

class FeatureFlag {
  constructor(t, e = !1, r = {}, i) {
    (this.id = t),
      (this.enabled = e),
      (this.properties = r),
      (this.trackingString = i),
      (this.id = t),
      (this.enabled = e),
      (this.properties = r),
      (this.trackingString = i);
  }
  he(t, e, r) {
    const i = this.properties[t];
    return null == i ? (this.ye(t), null) : e(i) ? i.value : (this.Pe(r), null);
  }
  getStringProperty(t) {
    return this.he(t, this.Ie, "string");
  }
  getNumberProperty(t) {
    return this.he(t, this.Te, "number");
  }
  getBooleanProperty(t) {
    return this.he(t, this.Ne, "boolean");
  }
  getImageProperty(t) {
    return this.he(t, this.Re, "image");
  }
  getJsonProperty(t) {
    return this.he(t, this.Se, "jsonobject");
  }
  getTimestampProperty(t) {
    return this.he(t, this.Ae, "datetime");
  }
  bt() {
    const t = {};
    return (
      (t[FeatureFlag.es.ps] = this.id),
      (t[FeatureFlag.es.Fe] = this.enabled),
      (t[FeatureFlag.es.we] = this.properties),
      (t[FeatureFlag.es.xe] = this.trackingString),
      t
    );
  }
  Pe(t) {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].info */ .Z.info(`Property is not of type ${t}.`);
  }
  ye(t) {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].info */ .Z.info(`${t} not found in feature flag properties.`);
  }
  Ie(t) {
    return "string" === t.type && "string" == typeof t.value;
  }
  Te(t) {
    return "number" === t.type && "number" == typeof t.value;
  }
  Ne(t) {
    return "boolean" === t.type && "boolean" == typeof t.value;
  }
  Re(t) {
    return "image" === t.type && "string" == typeof t.value;
  }
  Se(t) {
    return (
      "jsonobject" === t.type &&
      "object" == typeof t.value &&
      t.value.constructor == Object
    );
  }
  Ae(t) {
    return "datetime" === t.type && "number" == typeof t.value;
  }
}
(FeatureFlag.es = { ps: "id", Fe: "e", we: "pr", xe: "fts" }),
  (FeatureFlag.ui = { ps: "id", Fe: "enabled", we: "properties", xe: "fts" });


/***/ }),

/***/ 75219:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ feature_flags_provider_factory; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/base-provider.js
var base_provider = __webpack_require__(40158);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/subscription-manager.js
var subscription_manager = __webpack_require__(74663);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/math.js
var math = __webpack_require__(96504);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/net.js
var net = __webpack_require__(41843);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/feature-flag.js
var feature_flag = __webpack_require__(12962);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/feature-flag-factory.js


function newFeatureFlagFromJson(e) {
  if (e[feature_flag/* default.ui.ps */.Z.ui.ps] && "boolean" == typeof e[feature_flag/* default.ui.Fe */.Z.ui.Fe])
    return new feature_flag/* default */.Z(
      e[feature_flag/* default.ui.ps */.Z.ui.ps],
      e[feature_flag/* default.ui.Fe */.Z.ui.Fe],
      e[feature_flag/* default.ui.we */.Z.ui.we],
      e[feature_flag/* default.ui.xe */.Z.ui.xe],
    );
  logger/* default.info */.Z.info(`Unable to create feature flag from ${JSON.stringify(e, null, 2)}`);
}
function newFeatureFlagFromSerializedValue(e) {
  if (e[feature_flag/* default.es.ps */.Z.es.ps] && "boolean" == typeof e[feature_flag/* default.es.Fe */.Z.es.Fe])
    return new feature_flag/* default */.Z(
      e[feature_flag/* default.es.ps */.Z.es.ps],
      e[feature_flag/* default.es.Fe */.Z.es.Fe],
      e[feature_flag/* default.es.we */.Z.es.we],
      e[feature_flag/* default.es.xe */.Z.es.xe],
    );
  logger/* default.info */.Z.info(
    `Unable to deserialize feature flag from ${JSON.stringify(e, null, 2)}`,
  );
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/request-header-utils.js
var request_header_utils = __webpack_require__(76870);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/feature-flags-provider.js









class tr extends base_provider/* default */.Z {
  constructor(t, s, e, i) {
    super(),
      (this.B = t),
      (this.S = s),
      (this.C = e),
      (this.T = i),
      (this.De = []),
      (this.qe = 0),
      (this.B = t),
      (this.S = s),
      (this.C = e),
      (this.T = i),
      (this.ze = null),
      (this.ke = new subscription_manager/* default */.Z()),
      (this.R = 10),
      (this.I = null),
      (this.q = null),
      braze_instance/* default.N */.ZP.N(this.ke);
  }
  U(t) {
    var s;
    if (
      (null === (s = this.B) || void 0 === s ? void 0 : s.Be()) &&
      null != t &&
      t.feature_flags
    ) {
      this.De = [];
      for (const s of t.feature_flags) {
        const t = newFeatureFlagFromJson(s);
        t && this.De.push(t);
      }
      (this.qe = new Date().getTime()), this.Me(), this.ke.X(this.De);
    }
  }
  Ue() {
    let t = {};
    this.C && (t = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Xe */.I.gt.Xe));
    const e = {};
    for (const s in t) {
      const i = newFeatureFlagFromSerializedValue(t[s]);
      i && (e[i.id] = i);
    }
    return e;
  }
  _e() {
    var t;
    return (
      (null === (t = this.C) || void 0 === t ? void 0 : t.ft(storage_manager/* STORAGE_KEYS.gt.Ge */.I.gt.Ge)) || {}
    );
  }
  He(t) {
    this.C && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Ge */.I.gt.Ge, t);
  }
  qt(t) {
    return this.ke.Ft(t);
  }
  refreshFeatureFlags(t, s, e = !1, i = !0) {
    const r = () => {
      "function" == typeof s && s(), this.ke.X(this.De);
    };
    if (!this.Je(e))
      return (
        !this.ze &&
          this.B &&
          (this.ze = this.B.Ke(() => {
            this.refreshFeatureFlags(t, s);
          })),
        void r()
      );
    const o = this.S;
    if (!o) return void r();
    i && this.G();
    const n = o.H({}, !0),
      u = o.J(n, request_header_utils/* default.O.Le */.Z.O.Le);
    let f = !1;
    o.V(
      n,
      (i = -1) => {
        const o = this.S;
        if (!o) return void r();
        const c = new Date().valueOf();
        request_header_utils/* default.W */.Z.W(this.C, request_header_utils/* default.O.Le */.Z.O.Le, c),
          -1 !== i && u.push(["X-Braze-Req-Tokens-Remaining", i.toString()]),
          net/* default.Y */.Z.Y({
            url: `${o.Z()}/feature_flags/sync`,
            headers: u,
            data: n,
            tt: (s) => {
              if (!o.st(n, s, u)) return (f = !0), void r();
              o.it(), this.U(s), (f = !1), "function" == typeof t && t();
            },
            error: (t) => {
              o.et(t, "retrieving feature flags"), (f = !0), r();
            },
            nt: (i, r) => {
              let n;
              if (f) {
                let t = this.I;
                (null == t || t < 1e3 * this.R) && (t = 1e3 * this.R),
                  (n = Math.min(3e5, (0,math/* randomInclusive */.R)(1e3 * this.R, 3 * t)));
              }
              o.rt(
                r,
                () => {
                  this.refreshFeatureFlags(t, s, e, !0);
                },
                request_header_utils/* default.O.Le */.Z.O.Le,
                (t) => this.ot(t),
                () => this.G(),
                n,
              );
            },
          });
      },
      request_header_utils/* default.O.Le */.Z.O.Le,
      s,
    );
  }
  G() {
    null != this.q && (clearTimeout(this.q), (this.q = null));
  }
  ot(t) {
    this.G(), (this.q = t);
  }
  Je(t) {
    if (!this.B) return !1;
    if (!t) {
      const t = this.B.Oe();
      if (null == t) return !1;
      let s = !1;
      if (!isNaN(t)) {
        if (-1 === t) return logger/* default.info */.Z.info("Feature flag refreshes not allowed"), !1;
        s = new Date().getTime() >= (this.qe || 0) + 1e3 * t;
      }
      if (!s)
        return (
          logger/* default.info */.Z.info(`Feature flag refreshes were rate limited to ${t} seconds`), !1
        );
    }
    return this.B.Be();
  }
  Qe() {
    var t;
    return (
      (null === (t = this.C) || void 0 === t ? void 0 : t.ft(storage_manager/* STORAGE_KEYS.gt.Ve */.I.gt.Ve)) || null
    );
  }
  We() {
    var t, e;
    null === (t = this.C) ||
      void 0 === t ||
      t.Bt(storage_manager/* STORAGE_KEYS.gt.Ve */.I.gt.Ve, null === (e = this.T) || void 0 === e ? void 0 : e.St());
  }
  Ye() {
    var t;
    const s = null === (t = this.T) || void 0 === t ? void 0 : t.St(),
      e = this.Qe();
    return null == e || s === e;
  }
  Me() {
    if (!this.C) return;
    const t = {};
    for (const s of this.De) {
      const e = s.bt();
      t[s.id] = e;
    }
    this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Xe */.I.gt.Xe, t), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Ze */.I.gt.Ze, this.qe), this.We();
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/feature-flags-provider-factory.js


const nr = {
  l: !1,
  provider: null,
  m: () => (
    nr.p(),
    nr.provider ||
      ((nr.provider = new tr(braze_instance/* default.v */.ZP.v(), braze_instance/* default.g */.ZP.g(), braze_instance/* default.j */.ZP.j(), braze_instance/* default.P */.ZP.P())), braze_instance/* default._ */.ZP._(nr.provider)),
    nr.provider
  ),
  p: () => {
    nr.l || (braze_instance/* default.h */.ZP.h(nr), (nr.l = !0));
  },
  destroy: () => {
    (nr.provider = null), (nr.l = !1);
  },
};
/* harmony default export */ var feature_flags_provider_factory = (nr);


/***/ }),

/***/ 992:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "refreshFeatureFlags": function() { return /* binding */ refreshFeatureFlags; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _feature_flags_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75219);


function ar(e, t, a = !1) {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return _feature_flags_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].m */ .Z.m().refreshFeatureFlags(e, t, a);
}
function refreshFeatureFlags(r, e) {
  ar(r, e);
}
/* harmony default export */ __webpack_exports__["default"] = (ar);


/***/ }),

/***/ 32075:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ feed_provider_factory; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/base-provider.js
var base_provider = __webpack_require__(40158);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Feed/feed.js
var feed = __webpack_require__(83628);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/util/card-factory.js
var card_factory = __webpack_require__(23756);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/date-utils.js
var date_utils = __webpack_require__(57750);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/subscription-manager.js
var subscription_manager = __webpack_require__(74663);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Feed/feed-provider.js







class re extends base_provider/* default */.Z {
  constructor(t, s) {
    super(),
      (this.C = t),
      (this.Fi = s),
      (this.cards = []),
      (this.xi = null),
      (this.C = t),
      (this.Fi = s),
      (this.Ts = new subscription_manager/* default */.Z()),
      braze_instance/* default.N */.ZP.N(this.Ts),
      this.Ds();
  }
  Ds() {
    let t = [];
    this.C && (t = this.C.ft(storage_manager/* STORAGE_KEYS.gt.qi */.I.gt.qi) || []);
    const i = [];
    for (let s = 0; s < t.length; s++) {
      const e = (0,card_factory/* newCardFromSerializedValue */.rN)(t[s]);
      null != e && i.push(e);
    }
    (this.cards = i), this.C && (this.xi = (0,date_utils/* rehydrateDateAfterJsonization */.Rd)(this.C.ft(storage_manager/* STORAGE_KEYS.gt.zi */.I.gt.zi)));
  }
  ki(t) {
    const i = [];
    let e = null,
      r = {};
    this.C && (r = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Zt */.I.gt.Zt) || {});
    const h = {};
    for (let s = 0; s < t.length; s++) {
      e = t[s];
      const o = (0,card_factory/* newCardFromFeedJson */.D5)(e);
      if (null != o) {
        const t = o.id;
        t && r[t] && ((o.viewed = !0), (h[t] = !0)), i.push(o);
      }
    }
    (this.cards = i),
      this.Ys(),
      (this.xi = new Date()),
      this.C && (this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Zt */.I.gt.Zt, h), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.zi */.I.gt.zi, this.xi));
  }
  Ys() {
    var t;
    const i = [];
    for (let t = 0; t < this.cards.length; t++) i.push(this.cards[t].bt());
    null === (t = this.C) || void 0 === t || t.Bt(storage_manager/* STORAGE_KEYS.gt.qi */.I.gt.qi, i);
  }
  U(t) {
    null != t &&
      t.feed &&
      (this.Ds(),
      this.ki(t.feed),
      this.Ts.X(new feed/* default */.Z(this.cards.slice(), this.xi)));
  }
  Bi() {
    this.Ds();
    const t = [],
      s = new Date();
    for (let i = 0; i < this.cards.length; i++) {
      const e = this.cards[i].expiresAt;
      let r = !0;
      null != e && (r = e >= s), r && t.push(this.cards[i]);
    }
    return new feed/* default */.Z(t, this.xi);
  }
  vi() {
    this.Fi && this.Fi.requestFeedRefresh();
  }
  qt(t) {
    return this.Ts.Ft(t);
  }
  clearData(t) {
    null == t && (t = !1),
      (this.cards = []),
      (this.xi = null),
      t && this.C && (this.C.Ut(storage_manager/* STORAGE_KEYS.gt.qi */.I.gt.qi), this.C.Ut(storage_manager/* STORAGE_KEYS.gt.zi */.I.gt.zi)),
      this.Ts.X(new feed/* default */.Z(this.cards.slice(), this.xi));
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Feed/feed-provider-factory.js


const ie = {
  l: !1,
  provider: null,
  m: () => (
    ie.p(),
    ie.provider || ((ie.provider = new re(braze_instance/* default.j */.ZP.j(), braze_instance/* default.nn */.ZP.nn())), braze_instance/* default._ */.ZP._(ie.provider)),
    ie.provider
  ),
  p: () => {
    ie.l || (braze_instance/* default.h */.ZP.h(ie), (ie.l = !0));
  },
  destroy: () => {
    (ie.provider = null), (ie.l = !1);
  },
};
/* harmony default export */ var feed_provider_factory = (ie);


/***/ }),

/***/ 83628:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Feed; }
/* harmony export */ });
/* harmony import */ var _common_base_feed_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67);
/* harmony import */ var _Card_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11066);
/* harmony import */ var _Card_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1280);
/* harmony import */ var _request_feed_refresh_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83516);



class Feed extends _common_base_feed_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(r, e) {
    super(r, e);
  }
  logCardImpressions(r) {
    (0,_Card_index_js__WEBPACK_IMPORTED_MODULE_1__/* .logCardImpressions */ .p)(r, !1);
  }
  logCardClick(r) {
    return (0,_Card_index_js__WEBPACK_IMPORTED_MODULE_2__/* .logCardClick */ .d)(r, !1);
  }
  sr() {
    (0,_request_feed_refresh_js__WEBPACK_IMPORTED_MODULE_3__/* .requestFeedRefresh */ .a)();
  }
  nr() {
    return !1;
  }
}


/***/ }),

/***/ 46599:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ logFeedDisplayed; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12730);


function logFeedDisplayed() {
  var e;
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr())
    return null === (e = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].g */ .ZP.g()) || void 0 === e ? void 0 : e.zr(_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* .InternalEventTypes.Fr */ .r.Fr).tt;
}


/***/ }),

/***/ 83516:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ requestFeedRefresh; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _feed_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32075);


function requestFeedRefresh() {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return _feed_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].m */ .Z.m().vi();
}


/***/ }),

/***/ 96596:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ subscribeToFeedUpdates; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _feed_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32075);


function subscribeToFeedUpdates(e) {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return _feed_provider_factory_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].m */ .Z.m().qt(e);
}


/***/ }),

/***/ 33545:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "showFeed": function() { return /* binding */ showFeed; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10084);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83628);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96596);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46599);
/* harmony import */ var _feed_provider_factory_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32075);
/* harmony import */ var _util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72893);
/* harmony import */ var _Card_display_card_display_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35608);
/* harmony import */ var _ui_js_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46959);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20335);








function showFeed(e, t, n) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return;
  (0,_ui_js_index_js__WEBPACK_IMPORTED_MODULE_1__/* .setupFeedUI */ .B)();
  const o = (e, t) => {
      if (null == t) return e;
      const n = [];
      for (let e = 0; e < t.length; e++) n.push(t[e].toLowerCase());
      const o = [];
      for (let t = 0; t < e.length; t++) {
        const r = [],
          i = e[t].categories || [];
        for (let e = 0; e < i.length; e++) r.push(i[e].toLowerCase());
        (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .intersection */ .jV)(r, n).length > 0 && o.push(e[t]);
      }
      return o;
    },
    i = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ee */ .ZP.ee(_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* .OPTIONS.tn */ .JY.tn) || _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ee */ .ZP.ee(_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* .OPTIONS.en */ .JY.en) || !1;
  let s = !1;
  null == e && ((e = document.body), (s = !0));
  let l,
    f = !1;
  null == t
    ? ((l = _feed_provider_factory_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].m */ .Z.m().Bi()),
      (0,_common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__/* .updateFeedCards */ .Of)(l, o(l.cards, n), l.lastUpdated, null, i),
      (f = !0))
    : (l = new _index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z(o(t, n), new Date()));
  const a = (0,_common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__/* .feedToHtml */ .Yz)(l, i, s);
  if (f) {
    (null == l.lastUpdated ||
      new Date().valueOf() - l.lastUpdated.valueOf() > _index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dr */ .Z.dr) &&
      (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].info */ .Z.info(
        `Cached feed was older than max TTL of ${_index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dr */ .Z.dr} ms, requesting an update from the server.`,
      ),
      (0,_common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__/* .refreshFeed */ .cV)(l, a));
    const e = new Date().valueOf(),
      t = (0,_index_js__WEBPACK_IMPORTED_MODULE_7__/* .subscribeToFeedUpdates */ .n)(function (t) {
        const r = a.querySelectorAll(".ab-refresh-button")[0];
        if (null != r) {
          let t = 500;
          t -= new Date().valueOf() - e;
          const n = a.getAttribute(_common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__/* .LAST_REQUESTED_REFRESH_DATA_ATTRIBUTE */ .cP);
          if (n) {
            const e = parseInt(n);
            isNaN(e) || (t -= new Date().valueOf() - e);
          }
          setTimeout(
            function () {
              r.className = r.className.replace(/fa-spin/g, "");
            },
            Math.max(t, 0),
          );
        }
        (0,_common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__/* .updateFeedCards */ .Of)(l, o(t.cards, n), t.lastUpdated, a, i);
      });
    (0,_common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__/* .registerFeedSubscriptionId */ .GB)(t, a);
  }
  const u = (e) => {
    const t = e.querySelectorAll(".ab-feed");
    let n = null;
    for (let o = 0; o < t.length; o++) t[o].parentNode === e && (n = t[o]);
    null != n
      ? ((0,_common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__/* .destroyFeedHtml */ .tQ)(n), n.parentNode && n.parentNode.replaceChild(a, n))
      : e.appendChild(a),
      setTimeout(function () {
        a.className = a.className.replace("ab-hide", "ab-show");
      }, 0),
      s && a.focus(),
      (0,_index_js__WEBPACK_IMPORTED_MODULE_8__/* .logFeedDisplayed */ .j)(),
      (0,_common_feed_display_js__WEBPACK_IMPORTED_MODULE_4__/* .detectFeedImpressions */ .cz)(l, a),
      l && (0,_Card_display_card_display_js__WEBPACK_IMPORTED_MODULE_9__/* .setCardHeight */ .CG)(l.cards, e);
  };
  var d;
  null != e
    ? u(e)
    : (window.onload =
        ((d = window.onload),
        function () {
          "function" == typeof d && d(new Event("oldLoad")), u(document.body);
        }));
}


/***/ }),

/***/ 23340:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ buttonsFromSerializedInAppMessage; },
/* harmony export */   "q": function() { return /* binding */ newInAppMessageFromJson; }
/* harmony export */ });
/* harmony import */ var _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1792);
/* harmony import */ var _models_control_message_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98376);
/* harmony import */ var _models_full_screen_message_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4410);
/* harmony import */ var _models_html_message_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31090);
/* harmony import */ var _models_in_app_message_button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84072);
/* harmony import */ var _models_modal_message_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3811);
/* harmony import */ var _models_slide_up_message_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26616);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20335);








function newInAppMessageFromJson(e) {
  if (!e) return null;
  if (e.is_control) return _models_control_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].fromJson */ .Z.fromJson(e);
  let o = e.type;
  null != o && (o = o.toUpperCase());
  const s = e.message,
    n = e.text_align_message,
    r = e.slide_from,
    t = e.extras,
    m = e.trigger_id,
    l = e.click_action,
    i = e.uri,
    f = e.open_target,
    p = e.message_close,
    u = e.duration,
    a = e.icon,
    d = e.image_url,
    g = e.image_style,
    c = e.icon_color,
    j = e.icon_bg_color,
    w = e.bg_color,
    b = e.text_color,
    h = e.close_btn_color,
    v = e.header,
    x = e.text_align_header,
    I = e.header_text_color,
    A = e.frame_color,
    F = [];
  let M = e.btns;
  null == M && (M = []);
  for (let e = 0; e < M.length; e++) F.push(_models_in_app_message_button_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromJson */ .Z.fromJson(M[e]));
  const k = e.crop_type,
    y = e.orientation,
    z = e.animate_in,
    J = e.animate_out;
  let S = e.html_id,
    q = e.css;
  (null != S && "" !== S && null != q && "" !== q) ||
    ((S = void 0), (q = void 0));
  const B = e.message_extras;
  let C;
  if (o === _models_modal_message_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ds */ .Z.ds || o === _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].po.Ao */ .Z.po.Ao)
    C = new _models_modal_message_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(
      s,
      n,
      t,
      m,
      l,
      i,
      f,
      p,
      u,
      a,
      d,
      g,
      c,
      j,
      w,
      b,
      h,
      z,
      J,
      v,
      x,
      I,
      A,
      F,
      k,
      S,
      q,
      B,
    );
  else if (o === _models_full_screen_message_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ds */ .Z.ds)
    C = new _models_full_screen_message_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z(
      s,
      n,
      t,
      m,
      l,
      i,
      f,
      p,
      u,
      a,
      d,
      g,
      c,
      j,
      w,
      b,
      h,
      z,
      J,
      v,
      x,
      I,
      A,
      F,
      k,
      y,
      S,
      q,
      B,
    );
  else if (o === _models_slide_up_message_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].ds */ .Z.ds)
    C = new _models_slide_up_message_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z(
      s,
      n,
      r,
      t,
      m,
      l,
      i,
      f,
      p,
      u,
      a,
      d,
      c,
      j,
      w,
      b,
      h,
      z,
      J,
      S,
      q,
      B,
    );
  else {
    if (
      o !== _models_html_message_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].ds */ .Z.ds &&
      o !== _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].po.fo */ .Z.po.fo &&
      o !== _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].po.Fo */ .Z.po.Fo
    )
      return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .Z.error("Ignoring message with unknown type " + o);
    {
      const o = e.message_fields;
      (C = new _models_html_message_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z(s, t, m, p, u, z, J, A, S, q, o, B)),
        (C.trusted = e.trusted || !1);
    }
  }
  return (C.uo = o), C;
}
function buttonsFromSerializedInAppMessage(e) {
  const o = [];
  for (const s of e)
    o.push(
      new _models_in_app_message_button_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(
        s.text,
        s.backgroundColor,
        s.textColor,
        s.borderColor,
        s.clickAction,
        s.uri,
        s.id,
      ),
    );
  return o;
}


/***/ }),

/***/ 79602:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ in_app_message_manager_factory; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/net.js
var net = __webpack_require__(41843);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/control-message.js
var control_message = __webpack_require__(98376);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/html-message.js
var html_message = __webpack_require__(31090);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/in-app-message.js
var in_app_message = __webpack_require__(1792);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/in-app-message-button.js
var in_app_message_button = __webpack_require__(84072);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/event-logger.js
var event_logger = __webpack_require__(39179);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/in-app-message-factory.js
var in_app_message_factory = __webpack_require__(23340);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/math.js
var math = __webpack_require__(96504);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/request-result.js
var request_result = __webpack_require__(24673);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/event-types.js
var event_types = __webpack_require__(12730);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/subscription-manager.js
var subscription_manager = __webpack_require__(74663);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/trigger.js + 9 modules
var trigger = __webpack_require__(52134);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/validation-utils.js
var validation_utils = __webpack_require__(3905);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/braze-actions.js
var braze_actions = __webpack_require__(73046);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/utils/push-utils.js
var push_utils = __webpack_require__(74556);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/request-header-utils.js
var request_header_utils = __webpack_require__(76870);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/full-screen-message.js
var full_screen_message = __webpack_require__(4410);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/modal-message.js
var modal_message = __webpack_require__(3811);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/slide-up-message.js
var slide_up_message = __webpack_require__(26616);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/in-app-message-manager.js



















class ea {
  constructor(t, e, s, i) {
    (this.S = t),
      (this.T = e),
      (this.C = s),
      (this.Cs = i),
      (this.S = t),
      (this.T = e),
      (this.C = s),
      (this.Cs = i),
      (this.Mi = new subscription_manager/* default */.Z()),
      braze_instance/* default.N */.ZP.N(this.Mi),
      (this._i = 1e3),
      (this.Pi = 6e4),
      (this.Gi = null),
      (this.$i = null),
      (this.Oi = null);
  }
  Xi() {
    return this.Mi;
  }
  Hi(t) {
    return this.Mi.Ft(t);
  }
  Ji() {
    return this.Gi;
  }
  Ki(t) {
    this.Gi = t;
  }
  ut(t, e, s, i) {
    const r = new request_result/* default */.Z();
    let n;
    if (e === event_types/* EventTypes.Li */.G.Li || t instanceof control_message/* default */.Z) {
      if (!t.ts())
        return (
          logger/* default.info */.Z.info(
            "This in-app message has already received an impression. Ignoring analytics event.",
          ),
          r
        );
    } else if (e === event_types/* EventTypes.Qi */.G.Qi || (t instanceof html_message/* default */.Z && e === event_types/* EventTypes.Vi */.G.Vi)) {
      if (!t.$t(i))
        return (
          logger/* default.info */.Z.info(
            "This in-app message has already received a click. Ignoring analytics event.",
          ),
          r
        );
    }
    return (
      (n =
        t instanceof control_message/* default */.Z
          ? { trigger_ids: [t.triggerId] }
          : this.Wi(t)),
      null == n
        ? r
        : (t.messageExtras && (n.message_extras = t.messageExtras),
          null != s && (n.bid = s),
          event_logger/* default.ut */.Z.ut(e, n))
    );
  }
  Yi(t, e) {
    const s = new request_result/* default */.Z();
    if (!t.$t())
      return (
        logger/* default.info */.Z.info(
          "This in-app message button has already received a click. Ignoring analytics event.",
        ),
        s
      );
    const i = this.Wi(e);
    return null == i
      ? s
      : t.id === in_app_message_button/* default.Zi */.Z.Zi
      ? (logger/* default.info */.Z.info(
          "This in-app message button does not have a tracking id. Not logging event to Braze servers.",
        ),
        s)
      : (null != t.id && (i.bid = t.id), event_logger/* default.ut */.Z.ut(event_types/* EventTypes.Vi */.G.Vi, i));
  }
  Ir(t) {
    const e = t.messageFields;
    return (null != e && e.is_push_primer) || !1;
  }
  Mr(t) {
    if (!(t instanceof in_app_message/* default */.Z)) return;
    const e = (t) => {
      if (!t) return;
      const e = (0,braze_actions/* getDecodedBrazeAction */.OL)(t);
      return (0,braze_actions/* containsUnknownBrazeAction */.je)(e)
        ? (0,braze_actions/* ineligibleBrazeActionURLErrorMessage */.Tu)(braze_actions/* INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Tr */.yi.Tr, "In-App Message")
        : (0,braze_actions/* containsPushPrimerBrazeAction */.zA)(e) && !push_utils/* default.wr */.Z.wr()
        ? (0,braze_actions/* ineligibleBrazeActionURLErrorMessage */.Tu)(braze_actions/* INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Br */.yi.Br, "In-App Message")
        : void 0;
    };
    if (this.Ir(t) && !push_utils/* default.wr */.Z.wr())
      return "In-App Message contains a push prompt, but is not eligible for a push prompt. Ignoring.";
    const s = t.buttons || [];
    let i;
    for (const t of s)
      if (
        t.clickAction === in_app_message/* default.ClickAction.URI */.Z.ClickAction.URI &&
        t.uri &&
        validation_utils/* BRAZE_ACTION_URI_REGEX.test */.y9.test(t.uri) &&
        ((i = e(t.uri)), i)
      )
        return i;
    return t.clickAction === in_app_message/* default.ClickAction.URI */.Z.ClickAction.URI &&
      t.uri &&
      validation_utils/* BRAZE_ACTION_URI_REGEX.test */.y9.test(t.uri)
      ? e(t.uri)
      : void 0;
  }
  _r(t, e) {
    e !== this.Oi && this.qr(), (this.$i = t), (this.Oi = e);
  }
  qr() {
    null != this.$i &&
      (clearTimeout(this.$i), (this.$i = null), (this.Oi = null));
  }
  Er(t, e, s, i) {
    const r = this.S;
    if (!r) return;
    this.Oi && t.triggerId !== this.Oi && (this.qr(), request_header_utils/* default.wi */.Z.wi(this.C, request_header_utils/* default.O.Gr */.Z.O.Gr));
    const n = r.Nr(!1, !1),
      o = r.H(n);
    (o.template = { trigger_id: t.triggerId, trigger_event_type: e }),
      null != s && (o.template.data = s.$r());
    const u = r.J(o, request_header_utils/* default.O.Gr */.Z.O.Gr);
    r.V(
      o,
      (r = -1) => {
        const n = this.S;
        if (!n) return;
        const p = new Date().valueOf();
        request_header_utils/* default.W */.Z.W(this.C, request_header_utils/* default.O.Gr */.Z.O.Gr, p),
          -1 !== r && u.push(["X-Braze-Req-Tokens-Remaining", r.toString()]);
        let m,
          c,
          g = !1;
        net/* default.Y */.Z.Y({
          url: `${n.Z()}/template/`,
          data: o,
          headers: u,
          tt: (e) => {
            if (!n.st(o, e, u))
              return void ("function" == typeof t.Cr && t.Cr());
            if ((n.it(), null == e || null == e.templated_message)) return;
            const s = e.templated_message;
            if (s.type !== trigger/* default.Xr.Or */.Z.Xr.Or) return;
            const i = (0,in_app_message_factory/* newInAppMessageFromJson */.q)(s.data);
            if (null == i) return;
            const r = this.Mr(i);
            if (r)
              return logger/* default.error */.Z.error(r), void ("function" == typeof t.Cr && t.Cr());
            "function" == typeof t.Hr && t.Hr(i);
          },
          error: (e) => {
            (g = !0),
              (m = e),
              (c = `getting user personalization for message ${t.triggerId}.`);
          },
          nt: (r, o) => {
            if (new Date().valueOf() - t.Jr < t.Kr) {
              let r = 0;
              if (g) {
                const e = Math.min(t.Kr, this.Pi),
                  s = this._i;
                null == i && (i = s), (r = Math.min(e, (0,math/* randomInclusive */.R)(s, 3 * i)));
              }
              n.rt(
                o,
                () => {
                  this.Er(t, e, s, r);
                },
                request_header_utils/* default.O.Gr */.Z.O.Gr,
                (e) => this._r(e, t.triggerId),
                () => this.qr(),
                r,
              );
            }
            g && n.et(m, c);
          },
        });
      },
      request_header_utils/* default.O.Gr */.Z.O.Gr,
    );
  }
  Wi(t) {
    if (null == t.triggerId)
      return (
        logger/* default.info */.Z.info(
          "The in-app message has no analytics id. Not logging event to Braze servers.",
        ),
        null
      );
    const e = {};
    return null != t.triggerId && (e.trigger_ids = [t.triggerId]), e;
  }
  sn(t) {
    return (
      !!this.C &&
      !(
        !(t && t instanceof in_app_message/* default */.Z && t.constructor !== in_app_message/* default */.Z) ||
        t instanceof control_message/* default */.Z
      ) &&
      this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Lr */.I.gt.Lr, t.bt())
    );
  }
  Ar() {
    if (!this.C) return null;
    const t = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Lr */.I.gt.Lr);
    if (!t) return null;
    let e;
    switch (t.type) {
      case in_app_message/* default.po.Qr */.Z.po.Qr:
        e = full_screen_message/* default.Ur */.Z.Ur(t);
        break;
      case in_app_message/* default.po.Vr */.Z.po.Vr:
      case in_app_message/* default.po.fo */.Z.po.fo:
      case in_app_message/* default.po.Fo */.Z.po.Fo:
        e = html_message/* default.Ur */.Z.Ur(t);
        break;
      case in_app_message/* default.po.Wr */.Z.po.Wr:
      case in_app_message/* default.po.Ao */.Z.po.Ao:
        e = modal_message/* default.Ur */.Z.Ur(t);
        break;
      case in_app_message/* default.po.Yr */.Z.po.Yr:
        e = slide_up_message/* default.Ur */.Z.Ur(t);
    }
    return e && this.Zr(), e;
  }
  Zr() {
    this.C && this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Lr */.I.gt.Lr);
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/in-app-message-manager-factory.js


const se = {
  aa: null,
  l: !1,
  ea: () => (
    se.p(), se.aa || (se.aa = new ea(braze_instance/* default.g */.ZP.g(), braze_instance/* default.P */.ZP.P(), braze_instance/* default.j */.ZP.j(), braze_instance/* default.ir */.ZP.ir())), se.aa
  ),
  p: () => {
    se.l || (braze_instance/* default.h */.ZP.h(se), (se.l = !0));
  },
  destroy: () => {
    (se.aa = null), (se.l = !1);
  },
};
/* harmony default export */ var in_app_message_manager_factory = (se);


/***/ }),

/***/ 35896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ logInAppMessageButtonClick; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27671);
/* harmony import */ var _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1792);
/* harmony import */ var _models_in_app_message_button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84072);
/* harmony import */ var _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79602);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20335);
/* harmony import */ var _triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24365);
/* harmony import */ var _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85346);








function logInAppMessageButtonClick(o, t) {
  var e;
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return !1;
  if (!(o instanceof _models_in_app_message_button_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z))
    return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].error */ .Z.error("button must be an InAppMessageButton object"), !1;
  if (!(t instanceof _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)) return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .MUST_BE_IN_APP_MESSAGE_WARNING */ .De), !1;
  const s = _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].ea */ .Z.ea().Yi(o, t);
  if (s.tt)
    for (let r = 0; r < s.$e.length; r++)
      _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_6__/* .TriggersProviderFactory.m */ .n.m().Ce(
        _triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Bo */ .Z.Bo,
        [
          t.triggerId,
          null === (e = o.id) || void 0 === e ? void 0 : e.toString(),
        ],
        s.$e[r],
      );
  return s.tt;
}


/***/ }),

/***/ 94945:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ logInAppMessageClick; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1792);
/* harmony import */ var _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79602);
/* harmony import */ var _log_in_app_message_impression_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39517);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27671);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20335);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12730);
/* harmony import */ var _triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24365);
/* harmony import */ var _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85346);








function logInAppMessageClick(o) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return !1;
  if (!(o instanceof _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)) return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .MUST_BE_IN_APP_MESSAGE_WARNING */ .De), !1;
  const s = _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ea */ .Z.ea().ut(o, _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__/* .EventTypes.Qi */ .G.Qi);
  if (s) {
    o.Do() || (0,_log_in_app_message_impression_js__WEBPACK_IMPORTED_MODULE_6__/* .logInAppMessageImpression */ .v)(o);
    for (let r = 0; r < s.$e.length; r++)
      _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_7__/* .TriggersProviderFactory.m */ .n.m().Ce(_triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Bo */ .Z.Bo, [o.triggerId], s.$e[r]);
  }
  return s.tt;
}


/***/ }),

/***/ 35746:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ logInAppMessageHtmlClick; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _models_html_message_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31090);
/* harmony import */ var _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79602);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20335);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12730);
/* harmony import */ var _triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24365);
/* harmony import */ var _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85346);






function logInAppMessageHtmlClick(e, t, s) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return !1;
  if (!(e instanceof _models_html_message_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z))
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].error */ .Z.error(
        "inAppMessage argument to logInAppMessageHtmlClick must be an HtmlMessage object.",
      ),
      !1
    );
  let o = _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* .EventTypes.Qi */ .G.Qi;
  null != t && (o = _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* .EventTypes.Vi */ .G.Vi);
  const m = _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ea */ .Z.ea().ut(e, o, t, s);
  if (m.tt)
    for (let r = 0; r < m.$e.length; r++)
      _triggers_triggers_provider_factory_js__WEBPACK_IMPORTED_MODULE_5__/* .TriggersProviderFactory.m */ .n.m().Ce(_triggers_models_trigger_events_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Bo */ .Z.Bo, [e.triggerId, t], m.$e[r]);
  return m.tt;
}


/***/ }),

/***/ 39517:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ logInAppMessageImpression; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _models_control_message_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98376);
/* harmony import */ var _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1792);
/* harmony import */ var _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79602);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27671);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20335);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12730);






function logInAppMessageImpression(o) {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return !1;
  if (!(o instanceof _models_in_app_message_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z || o instanceof _models_control_message_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z))
    return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .MUST_BE_IN_APP_MESSAGE_WARNING */ .De), !1;
  const s = o instanceof _models_control_message_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z ? _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__/* .EventTypes.Eo */ .G.Eo : _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_5__/* .EventTypes.Li */ .G.Li;
  return _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].ea */ .Z.ea().ut(o, s).tt;
}


/***/ }),

/***/ 98376:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ControlMessage; }
/* harmony export */ });
class ControlMessage {
  constructor(s, t) {
    (this.triggerId = s),
      (this.messageExtras = t),
      (this.triggerId = s),
      (this.messageExtras = t),
      (this.extras = {}),
      (this.isControl = !0),
      (this.Ht = !1);
  }
  static fromJson(s) {
    return new ControlMessage(s.trigger_id, s.message_extras);
  }
  ts() {
    return !this.Ht && ((this.Ht = !0), !0);
  }
  Do() {
    return this.Ht;
  }
}


/***/ }),

/***/ 4410:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FullScreenMessage; }
/* harmony export */ });
/* harmony import */ var _in_app_message_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23340);
/* harmony import */ var _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1792);


class FullScreenMessage extends _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(
    e,
    r,
    s,
    t,
    i,
    a,
    o,
    p,
    m,
    n,
    u,
    c,
    f,
    d,
    l,
    g,
    j,
    x,
    z,
    h,
    v,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
    B,
  ) {
    (p = p || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DismissType.MANUAL */ .Z.DismissType.MANUAL),
      (k = k || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Orientation.PORTRAIT */ .Z.Orientation.PORTRAIT),
      super(
        e,
        r,
        void 0,
        s,
        t,
        i,
        a,
        o,
        p,
        m,
        n,
        u,
        c,
        f,
        d,
        l,
        g,
        j,
        x,
        z,
        h,
        v,
        w,
        y,
        S,
        (b = b || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CropType.CENTER_CROP */ .Z.CropType.CENTER_CROP),
        k,
        q,
        A,
        B,
      ),
      (this.Co = _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TextAlignment.CENTER */ .Z.TextAlignment.CENTER);
  }
  bt() {
    return super.bt(FullScreenMessage.ds);
  }
  static Ur(e) {
    return new FullScreenMessage(
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ra */ .Z.es.ra],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.sa */ .Z.es.sa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ta */ .Z.es.ta],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ia */ .Z.es.ia],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.URI */ .Z.es.URI],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.oa */ .Z.es.oa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.pa */ .Z.es.pa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ma */ .Z.es.ma],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.na */ .Z.es.na],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fs */ .Z.es.fs],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ua */ .Z.es.ua],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ca */ .Z.es.ca],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fa */ .Z.es.fa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.da */ .Z.es.da],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.la */ .Z.es.la],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ga */ .Z.es.ga],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ja */ .Z.es.ja],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.xa */ .Z.es.xa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.za */ .Z.es.za],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ha */ .Z.es.ha],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.va */ .Z.es.va],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.wa */ .Z.es.wa],
      (0,_in_app_message_factory_js__WEBPACK_IMPORTED_MODULE_1__/* .buttonsFromSerializedInAppMessage */ .V)(e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ya */ .Z.es.ya]),
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Sa */ .Z.es.Sa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ba */ .Z.es.ba],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ka */ .Z.es.ka],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.CSS */ .Z.es.CSS],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.qa */ .Z.es.qa],
    );
  }
}
FullScreenMessage.ds = _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].po.Qr */ .Z.po.Qr;


/***/ }),

/***/ 31090:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HtmlMessage; }
/* harmony export */ });
/* harmony import */ var _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1792);

class HtmlMessage extends _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(i, o, e, r, d, t, s, v, n, u, a, c) {
    super(
      i,
      void 0,
      void 0,
      o,
      e,
      void 0,
      void 0,
      void 0,
      (r = r || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DismissType.MANUAL */ .Z.DismissType.MANUAL),
      d,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      t,
      s,
      void 0,
      void 0,
      void 0,
      v,
      void 0,
      void 0,
      void 0,
      n,
      u,
      c,
    ),
      (this.messageFields = a),
      (this.messageFields = a);
  }
  Po() {
    return !1;
  }
  $t(i) {
    if (this.uo === _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].po.Vr */ .Z.po.Vr) {
      if (this.So) return !1;
      this.So = !0;
    }
    return this.ti.X(i), !0;
  }
  bt() {
    const i = super.bt(HtmlMessage.ds);
    return (i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Go */ .Z.es.Go] = this.messageFields), i;
  }
  static Ur(i) {
    return new HtmlMessage(
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ra */ .Z.es.ra],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ta */ .Z.es.ta],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.pa */ .Z.es.pa],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ma */ .Z.es.ma],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ja */ .Z.es.ja],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.xa */ .Z.es.xa],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.wa */ .Z.es.wa],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ka */ .Z.es.ka],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.CSS */ .Z.es.CSS],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Go */ .Z.es.Go],
      i[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.qa */ .Z.es.qa],
    );
  }
}
HtmlMessage.ds = _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].po.Vr */ .Z.po.Vr;


/***/ }),

/***/ 84072:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InAppMessageButton; }
/* harmony export */ });
/* harmony import */ var _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1792);
/* harmony import */ var _managers_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74663);


class InAppMessageButton {
  constructor(s, t, i, r, h, e, n) {
    (this.text = s),
      (this.backgroundColor = t),
      (this.textColor = i),
      (this.borderColor = r),
      (this.clickAction = h),
      (this.uri = e),
      (this.id = n),
      (this.text = s || ""),
      (this.backgroundColor = t || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].th.sh */ .Z.th.sh),
      (this.textColor = i || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].th.ih */ .Z.th.ih),
      (this.borderColor = r || this.backgroundColor),
      (this.clickAction = h || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ClickAction.NONE */ .Z.ClickAction.NONE),
      (this.uri = e),
      null == n && (n = InAppMessageButton.Zi),
      (this.id = n),
      (this.So = !1),
      (this.ti = new _managers_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z());
  }
  subscribeToClickedEvent(s) {
    return this.ti.Ft(s);
  }
  removeSubscription(s) {
    this.ti.removeSubscription(s);
  }
  removeAllSubscriptions() {
    this.ti.removeAllSubscriptions();
  }
  $t() {
    return !this.So && ((this.So = !0), this.ti.X(), !0);
  }
  static fromJson(s) {
    return new InAppMessageButton(
      s.text,
      s.bg_color,
      s.text_color,
      s.border_color,
      s.click_action,
      s.uri,
      s.id,
    );
  }
}
InAppMessageButton.Zi = -1;


/***/ }),

/***/ 1792:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InAppMessage; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88468);
/* harmony import */ var _util_browser_detector_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7169);
/* harmony import */ var _util_dom_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11507);
/* harmony import */ var _util_key_codes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7429);
/* harmony import */ var _managers_subscription_manager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74663);
/* harmony import */ var _utils_in_app_message_utils_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7048);






class InAppMessage {
  constructor(
    t,
    s,
    i,
    h,
    e,
    E,
    n,
    T,
    o,
    r,
    l,
    a,
    I,
    c,
    A,
    O,
    _,
    m,
    L,
    N,
    S,
    R,
    M,
    D,
    C,
    d,
    U,
    b,
    P,
    p,
  ) {
    (this.message = t),
      (this.messageAlignment = s),
      (this.slideFrom = i),
      (this.extras = h),
      (this.triggerId = e),
      (this.clickAction = E),
      (this.uri = n),
      (this.openTarget = T),
      (this.dismissType = o),
      (this.duration = r),
      (this.icon = l),
      (this.imageUrl = a),
      (this.imageStyle = I),
      (this.iconColor = c),
      (this.iconBackgroundColor = A),
      (this.backgroundColor = O),
      (this.textColor = _),
      (this.closeButtonColor = m),
      (this.animateIn = L),
      (this.animateOut = N),
      (this.header = S),
      (this.headerAlignment = R),
      (this.headerTextColor = M),
      (this.frameColor = D),
      (this.buttons = C),
      (this.cropType = d),
      (this.orientation = U),
      (this.htmlId = b),
      (this.css = P),
      (this.messageExtras = p),
      (this.message = t),
      (this.messageAlignment = s || InAppMessage.TextAlignment.CENTER),
      (this.duration = r || 5e3),
      (this.slideFrom = i || InAppMessage.SlideFrom.BOTTOM),
      (this.extras = h || {}),
      (this.triggerId = e),
      (this.clickAction = E || InAppMessage.ClickAction.NONE),
      (this.uri = n),
      (this.openTarget = T || InAppMessage.OpenTarget.NONE),
      (this.dismissType = o || InAppMessage.DismissType.AUTO_DISMISS),
      (this.icon = l),
      (this.imageUrl = a),
      (this.imageStyle = I || InAppMessage.ImageStyle.TOP),
      (this.iconColor = c || InAppMessage.th.ih),
      (this.iconBackgroundColor = A || InAppMessage.th.sh),
      (this.backgroundColor = O || InAppMessage.th.ih),
      (this.textColor = _ || InAppMessage.th.hh),
      (this.closeButtonColor = m || InAppMessage.th.eh),
      (this.animateIn = L),
      null == this.animateIn && (this.animateIn = !0),
      (this.animateOut = N),
      null == this.animateOut && (this.animateOut = !0),
      (this.header = S),
      (this.headerAlignment = R || InAppMessage.TextAlignment.CENTER),
      (this.headerTextColor = M || InAppMessage.th.hh),
      (this.frameColor = D || InAppMessage.th.Eh),
      (this.buttons = C || []),
      (this.cropType = d || InAppMessage.CropType.FIT_CENTER),
      (this.orientation = U),
      (this.htmlId = b),
      (this.css = P),
      (this.isControl = !1),
      (this.messageExtras = p),
      (this.nh = !1),
      (this.Ht = !1),
      (this.So = !1),
      (this.Th = !1),
      (this.ho = null),
      (this.jo = null),
      (this.ti = new _managers_subscription_manager_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z()),
      (this.oh = new _managers_subscription_manager_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z()),
      (this.Co = InAppMessage.TextAlignment.CENTER);
  }
  subscribeToClickedEvent(t) {
    return this.ti.Ft(t);
  }
  subscribeToDismissedEvent(t) {
    return this.oh.Ft(t);
  }
  removeSubscription(t) {
    this.ti.removeSubscription(t), this.oh.removeSubscription(t);
  }
  removeAllSubscriptions() {
    this.ti.removeAllSubscriptions(), this.oh.removeAllSubscriptions();
  }
  closeMessage() {
    this.ll(this.ho);
  }
  wo() {
    return !0;
  }
  Po() {
    return this.wo();
  }
  bo() {
    return null != this.htmlId && this.htmlId.length > 4;
  }
  lo() {
    return this.bo() && null != this.css && this.css.length > 0;
  }
  do() {
    if (this.bo() && this.lo()) return this.htmlId + "-css";
  }
  ts() {
    return !this.Ht && ((this.Ht = !0), !0);
  }
  Do() {
    return this.Ht;
  }
  $t(t) {
    return !this.So && ((this.So = !0), this.ti.X(), !0);
  }
  Qt() {
    return !this.Th && ((this.Th = !0), this.oh.X(), !0);
  }
  hide(t) {
    if (t && t.parentNode) {
      let s = t.closest(".ab-iam-root");
      if ((null == s && (s = t), this.wo() && null != s.parentNode)) {
        const t = s.parentNode.classList;
        t && t.contains(InAppMessage.rh) && t.remove(InAppMessage.rh),
          document.body.removeEventListener("touchmove", InAppMessage.lh);
      }
      s.className = s.className.replace(InAppMessage.uh, InAppMessage.ah);
    }
    return this.animateOut || !1;
  }
  ll(t, s) {
    if (null == t) return;
    let i;
    (this.ho = null),
      (i =
        -1 === t.className.indexOf("ab-in-app-message")
          ? t.getElementsByClassName("ab-in-app-message")[0]
          : t);
    let h = !1;
    i && (h = this.hide(i));
    const e = document.body;
    let E;
    null != e && (E = e.scrollTop);
    const n = () => {
      if (t && t.parentNode) {
        let s = t.closest(".ab-iam-root");
        null == s && (s = t), s.parentNode && s.parentNode.removeChild(s);
      }
      const i = this.do();
      if (null != i) {
        const t = document.getElementById(i);
        t && t.parentNode && t.parentNode.removeChild(t);
      }
      null != e && "Safari" === _util_browser_detector_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].browser */ .Z.browser && (e.scrollTop = E),
        s ? s() : this.Qt();
    };
    h ? setTimeout(n, InAppMessage.Ih) : n(), this.jo && this.jo.focus();
  }
  Mo() {
    return document.createTextNode(this.message || "");
  }
  $o(t) {
    let s = "";
    this.message || this.header || !this.wo() || (s = "Modal Image"),
      t.setAttribute("alt", s);
  }
  static lh(t) {
    if (t.targetTouches && t.targetTouches.length > 1) return;
    const s = t.target;
    (s &&
      s.classList &&
      s.classList.contains("ab-message-text") &&
      s.scrollHeight > s.clientHeight) ||
      (document.querySelector(`.${InAppMessage.rh}`) &&
        t.cancelable &&
        t.preventDefault());
  }
  Ah(t) {
    const s = t.parentNode;
    this.wo() &&
      null != s &&
      this.orientation !== InAppMessage.Orientation.LANDSCAPE &&
      (null != s.classList && s.classList.add(InAppMessage.rh),
      document.body.addEventListener(
        "touchmove",
        InAppMessage.lh,
        !!(0,_util_dom_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .supportsPassive */ .QZ)() && { passive: !1 },
      )),
      (t.className += " " + InAppMessage.uh);
  }
  static Oh(t) {
    if (
      t.keyCode === _util_key_codes_js__WEBPACK_IMPORTED_MODULE_3__/* .KeyCodes._h */ .m._h &&
      !_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ee */ .ZP.ee(_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_4__/* .OPTIONS.mh */ .JY.mh) &&
      document.querySelectorAll(".ab-modal-interactions").length > 0
    ) {
      const t = document.getElementsByClassName("ab-html-message");
      let s = !1;
      for (const i of t) {
        let t = null;
        (0,_utils_in_app_message_utils_js__WEBPACK_IMPORTED_MODULE_5__/* .isIFrame */ .f)(i) &&
          i.contentWindow &&
          (t = i.contentWindow.document.getElementsByClassName(
            "ab-programmatic-close-button",
          )[0]),
          null != t && ((0,_util_dom_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .clickElement */ .$j)(t), (s = !0));
      }
      if (!s) {
        const t = document.querySelectorAll(
          ".ab-modal-interactions > .ab-close-button",
        )[0];
        null != t && (0,_util_dom_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .clickElement */ .$j)(t);
      }
    }
  }
  Lh() {
    this.nh ||
      _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ee */ .ZP.ee(_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_4__/* .OPTIONS.mh */ .JY.mh) ||
      (document.addEventListener("keydown", InAppMessage.Oh, !1),
      _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Nh */ .ZP.Nh(() => {
        document.removeEventListener("keydown", InAppMessage.Oh);
      }),
      (this.nh = !0));
  }
  bt(t) {
    const s = {};
    return t
      ? ((s[InAppMessage.es.ra] = this.message),
        (s[InAppMessage.es.sa] = this.messageAlignment),
        (s[InAppMessage.es.Sh] = this.slideFrom),
        (s[InAppMessage.es.vs] = this.extras),
        (s[InAppMessage.es.ta] = this.triggerId),
        (s[InAppMessage.es.ia] = this.clickAction),
        (s[InAppMessage.es.URI] = this.uri),
        (s[InAppMessage.es.oa] = this.openTarget),
        (s[InAppMessage.es.pa] = this.dismissType),
        (s[InAppMessage.es.ma] = this.duration),
        (s[InAppMessage.es.na] = this.icon),
        (s[InAppMessage.es.fs] = this.imageUrl),
        (s[InAppMessage.es.ua] = this.imageStyle),
        (s[InAppMessage.es.ca] = this.iconColor),
        (s[InAppMessage.es.fa] = this.iconBackgroundColor),
        (s[InAppMessage.es.da] = this.backgroundColor),
        (s[InAppMessage.es.la] = this.textColor),
        (s[InAppMessage.es.ga] = this.closeButtonColor),
        (s[InAppMessage.es.ja] = this.animateIn),
        (s[InAppMessage.es.xa] = this.animateOut),
        (s[InAppMessage.es.za] = this.header),
        (s[InAppMessage.es.ha] = this.headerAlignment),
        (s[InAppMessage.es.va] = this.headerTextColor),
        (s[InAppMessage.es.wa] = this.frameColor),
        (s[InAppMessage.es.ya] = this.buttons),
        (s[InAppMessage.es.Sa] = this.cropType),
        (s[InAppMessage.es.ba] = this.orientation),
        (s[InAppMessage.es.ka] = this.htmlId),
        (s[InAppMessage.es.CSS] = this.css),
        (s[InAppMessage.es.hs] = t),
        (s[InAppMessage.es.qa] = this.messageExtras),
        s)
      : s;
  }
}
(InAppMessage.th = {
  hh: 4281545523,
  ih: 4294967295,
  sh: 4278219733,
  Rh: 4293914607,
  Mh: 4283782485,
  Eh: 3224580915,
  eh: 4288387995,
}),
  (InAppMessage.xo = {
    Dh: "hd",
    vo: "ias",
    Ch: "of",
    dh: "do",
    Uh: "umt",
    bh: "tf",
    Ph: "te",
  }),
  (InAppMessage.SlideFrom = { TOP: "TOP", BOTTOM: "BOTTOM" }),
  (InAppMessage.ClickAction = {
    NEWS_FEED: "NEWS_FEED",
    URI: "URI",
    NONE: "NONE",
  }),
  (InAppMessage.DismissType = {
    AUTO_DISMISS: "AUTO_DISMISS",
    MANUAL: "SWIPE",
  }),
  (InAppMessage.OpenTarget = { NONE: "NONE", BLANK: "BLANK" }),
  (InAppMessage.ImageStyle = { TOP: "TOP", GRAPHIC: "GRAPHIC" }),
  (InAppMessage.Orientation = { PORTRAIT: "PORTRAIT", LANDSCAPE: "LANDSCAPE" }),
  (InAppMessage.TextAlignment = {
    START: "START",
    CENTER: "CENTER",
    END: "END",
  }),
  (InAppMessage.CropType = {
    CENTER_CROP: "CENTER_CROP",
    FIT_CENTER: "FIT_CENTER",
  }),
  (InAppMessage.po = {
    Yr: "SLIDEUP",
    Wr: "MODAL",
    Ao: "MODAL_STYLED",
    Qr: "FULL",
    Vr: "WEB_HTML",
    fo: "HTML",
    Fo: "HTML_FULL",
  }),
  (InAppMessage.Ih = 500),
  (InAppMessage.ph = 200),
  (InAppMessage.uh = "ab-show"),
  (InAppMessage.ah = "ab-hide"),
  (InAppMessage.rh = "ab-pause-scrolling"),
  (InAppMessage.es = {
    ra: "m",
    sa: "ma",
    Sh: "sf",
    vs: "e",
    ta: "ti",
    ia: "ca",
    URI: "u",
    oa: "oa",
    pa: "dt",
    ma: "d",
    na: "i",
    fs: "iu",
    ua: "is",
    ca: "ic",
    fa: "ibc",
    da: "bc",
    la: "tc",
    ga: "cbc",
    ja: "ai",
    xa: "ao",
    za: "h",
    ha: "ha",
    va: "htc",
    wa: "fc",
    ya: "b",
    Sa: "ct",
    ba: "o",
    ka: "hi",
    CSS: "css",
    hs: "type",
    Go: "messageFields",
    qa: "me",
  });


/***/ }),

/***/ 3811:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModalMessage; }
/* harmony export */ });
/* harmony import */ var _in_app_message_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23340);
/* harmony import */ var _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1792);


class ModalMessage extends _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(
    e,
    r,
    s,
    t,
    i,
    o,
    a,
    p,
    m,
    n,
    u,
    c,
    d,
    f,
    l,
    g,
    j,
    v,
    x,
    z,
    h,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
  ) {
    super(
      e,
      r,
      void 0,
      s,
      t,
      i,
      o,
      a,
      (p = p || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DismissType.MANUAL */ .Z.DismissType.MANUAL),
      m,
      n,
      u,
      c,
      d,
      f,
      l,
      g,
      j,
      v,
      x,
      z,
      h,
      w,
      y,
      S,
      (b = b || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CropType.FIT_CENTER */ .Z.CropType.FIT_CENTER),
      void 0,
      k,
      q,
      A,
    ),
      (this.Co = _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TextAlignment.CENTER */ .Z.TextAlignment.CENTER);
  }
  bt() {
    return super.bt(ModalMessage.ds);
  }
  static Ur(e) {
    return new ModalMessage(
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ra */ .Z.es.ra],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.sa */ .Z.es.sa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ta */ .Z.es.ta],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ia */ .Z.es.ia],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.URI */ .Z.es.URI],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.oa */ .Z.es.oa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.pa */ .Z.es.pa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ma */ .Z.es.ma],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.na */ .Z.es.na],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fs */ .Z.es.fs],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ua */ .Z.es.ua],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ca */ .Z.es.ca],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fa */ .Z.es.fa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.da */ .Z.es.da],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.la */ .Z.es.la],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ga */ .Z.es.ga],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ja */ .Z.es.ja],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.xa */ .Z.es.xa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.za */ .Z.es.za],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ha */ .Z.es.ha],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.va */ .Z.es.va],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.wa */ .Z.es.wa],
      (0,_in_app_message_factory_js__WEBPACK_IMPORTED_MODULE_1__/* .buttonsFromSerializedInAppMessage */ .V)(e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ya */ .Z.es.ya]),
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Sa */ .Z.es.Sa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ka */ .Z.es.ka],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.CSS */ .Z.es.CSS],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.qa */ .Z.es.qa],
    );
  }
}
ModalMessage.ds = _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].po.Wr */ .Z.po.Wr;


/***/ }),

/***/ 26616:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SlideUpMessage; }
/* harmony export */ });
/* harmony import */ var _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1792);
/* harmony import */ var _util_dom_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11507);


class SlideUpMessage extends _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
  constructor(
    e,
    t,
    s,
    o,
    i,
    r,
    n,
    d,
    a,
    u,
    p,
    m,
    c,
    l,
    v,
    x,
    f,
    h,
    g,
    I,
    M,
    b,
  ) {
    (x = x || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].th.Mh */ .Z.th.Mh),
      (v = v || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].th.Rh */ .Z.th.Rh),
      super(
        e,
        (t = t || _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TextAlignment.START */ .Z.TextAlignment.START),
        s,
        o,
        i,
        r,
        n,
        d,
        a,
        u,
        p,
        m,
        void 0,
        c,
        l,
        v,
        x,
        f,
        h,
        g,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        I,
        M,
        b,
      ),
      (this.Co = _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TextAlignment.START */ .Z.TextAlignment.START);
  }
  wo() {
    return !1;
  }
  Mo() {
    const e = document.createElement("span");
    return e.appendChild(document.createTextNode(this.message || "")), e;
  }
  Ah(e) {
    const t = e.getElementsByClassName("ab-in-app-message")[0];
    _util_dom_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .DOMUtils.Ho */ .lP.Ho(t, !0, !0) ||
      (this.slideFrom === _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SlideFrom.TOP */ .Z.SlideFrom.TOP
        ? (t.style.top = "0px")
        : (t.style.bottom = "0px")),
      super.Ah(e);
  }
  bt() {
    return super.bt(SlideUpMessage.ds);
  }
  static Ur(e) {
    return new SlideUpMessage(
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ra */ .Z.es.ra],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.sa */ .Z.es.sa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.Sh */ .Z.es.Sh],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.vs */ .Z.es.vs],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ta */ .Z.es.ta],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ia */ .Z.es.ia],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.URI */ .Z.es.URI],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.oa */ .Z.es.oa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.pa */ .Z.es.pa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ma */ .Z.es.ma],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.na */ .Z.es.na],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fs */ .Z.es.fs],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ca */ .Z.es.ca],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.fa */ .Z.es.fa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.da */ .Z.es.da],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.la */ .Z.es.la],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ga */ .Z.es.ga],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ja */ .Z.es.ja],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.xa */ .Z.es.xa],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.ka */ .Z.es.ka],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.CSS */ .Z.es.CSS],
      e[_in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].es.qa */ .Z.es.qa],
    );
  }
}
SlideUpMessage.ds = _in_app_message_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].po.Yr */ .Z.po.Yr;


/***/ }),

/***/ 30174:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ subscribeToInAppMessage; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79602);


function subscribeToInAppMessage(n) {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr())
    return "function" != typeof n
      ? null
      : _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ea */ .Z.ea().Hi(function (r) {
          return n(r[0]), r.slice(1);
        });
}


/***/ }),

/***/ 73659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ automaticallyShowInAppMessages; }
/* harmony export */ });
/* harmony import */ var _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79602);
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _ui_js_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9135);
/* harmony import */ var _show_in_app_message_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78914);
/* harmony import */ var _subscribe_to_in_app_message_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30174);





function automaticallyShowInAppMessages() {
  if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return;
  (0,_ui_js_index_js__WEBPACK_IMPORTED_MODULE_1__/* .setupInAppMessageUI */ .R)();
  const s = _in_app_message_manager_factory_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ea */ .Z.ea();
  if (null == s.Ji()) {
    const r = (0,_subscribe_to_in_app_message_js__WEBPACK_IMPORTED_MODULE_3__/* .subscribeToInAppMessage */ .u)((s) => (0,_show_in_app_message_js__WEBPACK_IMPORTED_MODULE_4__/* .showInAppMessage */ .g)(s));
    s.Ki(r);
  }
  return s.Ji();
}


/***/ }),

/***/ 78914:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ showInAppMessage; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/control-message.js
var control_message = __webpack_require__(98376);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/html-message.js
var html_message = __webpack_require__(31090);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/in-app-message.js
var in_app_message = __webpack_require__(1792);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/slide-up-message.js
var slide_up_message = __webpack_require__(26616);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/full-screen-message.js
var full_screen_message = __webpack_require__(4410);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/modal-message.js
var modal_message = __webpack_require__(3811);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/display/get-animation-effect.js




function me(e) {
  let s = "";
  return (
    e.animateIn && (s += " ab-animate-in"),
    e.animateOut && (s += " ab-animate-out"),
    e instanceof full_screen_message/* default */.Z
      ? (s += " ab-effect-fullscreen")
      : e instanceof html_message/* default */.Z
      ? (s += " ab-effect-html")
      : e instanceof modal_message/* default */.Z
      ? (s += " ab-effect-modal")
      : e instanceof slide_up_message/* default */.Z && (s += " ab-effect-slide"),
    s
  );
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/dom-utils.js
var dom_utils = __webpack_require__(11507);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/component-utils.js
var component_utils = __webpack_require__(5242);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/util/color-utils.js
function isTransparent(r) {
  return (
    null != r &&
    ((r = parseInt(r.toString())), !isNaN(r) && (4278190080 & r) >>> 24 == 0)
  );
}
function toRgba(r, n) {
  if (null == r) return "";
  if (((r = parseInt(r.toString())), isNaN(r))) return "";
  (n && !isNaN(parseFloat(n.toString()))) || (n = 1);
  return (
    "rgba(" +
    [
      (16711680 & (r >>>= 0)) >>> 16,
      (65280 & r) >>> 8,
      255 & r,
      (((4278190080 & r) >>> 24) / 255) * n,
    ].join(",") +
    ")"
  );
}
function toRgb(r) {
  if (null == r || isNaN(parseInt(r.toString()))) return "";
  return (
    "rgb(" +
    [(16711680 & (r >>>= 0)) >>> 16, (65280 & r) >>> 8, 255 & r].join(",") +
    ")"
  );
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/log-in-app-message-click.js
var log_in_app_message_click = __webpack_require__(94945);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/handle-braze-action.js
var handle_braze_action = __webpack_require__(40420);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/browser-detector.js + 3 modules
var browser_detector = __webpack_require__(7169);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/log-in-app-message-html-click.js
var log_in_app_message_html_click = __webpack_require__(35746);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/device-constants.js
var device_constants = __webpack_require__(35806);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/url-utils.js
var url_utils = __webpack_require__(1148);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/window-utils.js
var window_utils = __webpack_require__(75319);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/display/html-message-display-utils.js




const buildHtmlClickHandler = (l, t, i, o) => {
  const r = i.getAttribute("href"),
    e = i.onclick;
  return (n) => {
    if (null != e && "function" == typeof e && !1 === e.bind(i)(n)) return;
    let s = (0,url_utils/* parseQueryStringKeyValues */.L)(r).abButtonId;
    if (
      ((null != s && "" !== s) || (s = i.getAttribute("id") || void 0),
      null != r && "" !== r && 0 !== r.indexOf("#"))
    ) {
      const e =
          "blank" ===
          (i.getAttribute("target") || "").toLowerCase().replace("_", ""),
        m = o || l.openTarget === in_app_message/* default.OpenTarget.BLANK */.Z.OpenTarget.BLANK || e,
        u = () => {
          (0,log_in_app_message_html_click/* logInAppMessageHtmlClick */.U)(l, s, r), window_utils/* WindowUtils.openUri */.SD.openUri(r, m, n);
        };
      m ? u() : l.ll(t, u);
    } else (0,log_in_app_message_html_click/* logInAppMessageHtmlClick */.U)(l, s, r || void 0);
    return n.stopPropagation(), !1;
  };
};

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/html-display-utils.js
var html_display_utils = __webpack_require__(71177);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/display/html-message-to-html.js






function ct(t, e, o, s, n, i) {
  const l = document.createElement("iframe");
  l.setAttribute("title", "Modal Message"),
    n && (l.style.zIndex = (n + 1).toString());
  if (
    ((0,html_display_utils/* attachHtmlToIframeWithNonce */.Bl)(l, t.message, i),
    (l.onload = () => {
      const n = l.contentWindow;
      n.focus();
      const a = n.document.getElementsByTagName("head")[0];
      if (null != a) {
        if (t.lo()) {
          const e = document.createElement("style");
          (e.innerHTML = t.css || ""),
            (e.id = t.do() || ""),
            null != i && e.setAttribute("nonce", i),
            a.appendChild(e);
        }
        const e = n.document.createElement("base");
        null != e && (e.setAttribute("target", "_parent"), a.appendChild(e));
      }
      const r = n.document.getElementsByTagName("title");
      r && r.length > 0 && l.setAttribute("title", r[0].textContent || "");
      const c = Object.assign(
        Object.assign(
          {},
          (0,html_display_utils/* buildBrazeBridge */.NK)(l, e, (e, o) => t.ll(e, o)),
        ),
        {
          closeMessage: function () {
            t.ll(l);
          },
          logClick: function () {
            (0,log_in_app_message_html_click/* logInAppMessageHtmlClick */.U)(t, ...arguments);
          },
        },
      );
      if (
        ((n.appboyBridge = c), (n.brazeBridge = c), t.uo !== in_app_message/* default.po.fo */.Z.po.fo)
      ) {
        const e = n.document.getElementsByTagName("a");
        for (let o = 0; o < e.length; o++) e[o].onclick = buildHtmlClickHandler(t, l, e[o], s);
        const o = n.document.getElementsByTagName("button");
        for (let e = 0; e < o.length; e++) o[e].onclick = buildHtmlClickHandler(t, l, o[e], s);
      }
      const m = n.document.body;
      if (null != m) {
        t.bo() && (m.id = t.htmlId || "");
        const e = document.createElement("hidden");
        (e.onclick = c.closeMessage),
          (e.className = "ab-programmatic-close-button"),
          m.appendChild(e);
      }
      n.dispatchEvent(new CustomEvent("ab.BridgeReady")),
        -1 !== l.className.indexOf("ab-start-hidden") &&
          ((l.className = l.className.replace("ab-start-hidden", "")), o(l));
    }),
    (l.className =
      "ab-in-app-message ab-start-hidden ab-html-message ab-modal-interactions"),
    browser_detector/* default.OS */.Z.OS === device_constants/* OperatingSystems.ao */.T.ao)
  ) {
    const e = document.createElement("div");
    return (
      (e.className = "ab-ios-scroll-wrapper"), e.appendChild(l), (t.ho = e), e
    );
  }
  return (t.ho = l), l;
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/log-in-app-message-button-click.js
var log_in_app_message_button_click = __webpack_require__(35896);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/key-codes.js
var key_codes = __webpack_require__(7429);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/display/modal-utils.js






const ce = {
  Lo: (t) => {
    const o = t.querySelectorAll(
      ".ab-close-button, .ab-message-text, .ab-message-button",
    );
    let e;
    for (let t = 0; t < o.length; t++) (e = o[t]), (e.tabIndex = 0);
    if (o.length > 0) {
      const e = o[0],
        s = o[o.length - 1];
      t.addEventListener("keydown", (o) => {
        const a = document.activeElement;
        o.keyCode === key_codes/* KeyCodes.yo */.m.yo &&
          (o.shiftKey || (a !== s && a !== t)
            ? !o.shiftKey ||
              (a !== e && a !== t) ||
              (o.preventDefault(), s.focus())
            : (o.preventDefault(), e.focus()));
      });
    }
  },
  Io: (t, o) => {
    o.setAttribute("role", "dialog"),
      o.setAttribute("aria-modal", "true"),
      o.setAttribute("aria-label", "Modal Message"),
      t && o.setAttribute("aria-labelledby", t);
  },
  zo: (t, o, e, s) => {
    if (t.buttons && t.buttons.length > 0) {
      const a = document.createElement("div");
      (a.className = "ab-message-buttons"), e.appendChild(a);
      const l = e.getElementsByClassName("ab-message-text")[0];
      null != l && (l.className += " ab-with-buttons");
      const n = (a) => (l) => (
        t.ll(e, () => {
          (0,log_in_app_message_button_click/* logInAppMessageButtonClick */.S)(a, t),
            a.clickAction === in_app_message/* default.ClickAction.URI */.Z.ClickAction.URI
              ? (0,handle_braze_action/* _handleBrazeAction */.S)(
                  a.uri || "",
                  s || t.openTarget === in_app_message/* default.OpenTarget.BLANK */.Z.OpenTarget.BLANK,
                  l,
                )
              : a.clickAction === in_app_message/* default.ClickAction.NEWS_FEED */.Z.ClickAction.NEWS_FEED && o();
        }),
        l.stopPropagation(),
        !1
      );
      for (let o = 0; o < t.buttons.length; o++) {
        const e = t.buttons[o],
          s = document.createElement("button");
        (s.className = "ab-message-button"),
          s.setAttribute("type", "button"),
          (0,dom_utils/* addPassiveEventListener */.lj)(s, "touchstart");
        let l = e.text;
        "" === e.text && (l = " "),
          s.appendChild(document.createTextNode(l)),
          t.lo() ||
            ((s.style.backgroundColor = toRgba(e.backgroundColor)),
            (s.style.color = toRgba(e.textColor)),
            (s.style.borderColor = toRgba(e.borderColor))),
          (s.onclick = n(e)),
          a.appendChild(s);
      }
    }
  },
};
/* harmony default export */ var modal_utils = (ce);

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/guid.js
var guid = __webpack_require__(57070);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/display/in-app-message-to-html.js













function de(e, o, a, t, n, s, i, m = document.body, l = "ltr") {
  if (((e.jo = document.activeElement), e instanceof html_message/* default */.Z))
    return ct(e, o, a, n, s, i);
  const c = (function (e, o, a, t, n, s, i = document.body, m = "ltr") {
    let l = null;
    const c = document.createElement("div");
    (c.dir = m),
      (c.className = "ab-in-app-message ab-start-hidden ab-background"),
      s && (c.style.zIndex = (s + 1).toString()),
      e.wo() &&
        ((c.className += " ab-modal-interactions"),
        c.setAttribute("tabindex", "-1")),
      e.lo() ||
        ((c.style.color = toRgba(e.textColor)),
        (c.style.backgroundColor = toRgba(e.backgroundColor)),
        isTransparent(e.backgroundColor) && (c.className += " ab-no-shadow"));
    const d = () => {
        -1 !== c.className.indexOf("ab-start-hidden") &&
          ((c.className = c.className.replace("ab-start-hidden", "")),
          document.querySelectorAll(".ab-iam-img-loading").length > 0
            ? t(
                `Cannot show in-app message ${e.message} because another message is being shown.`,
                in_app_message/* default.xo.vo */.Z.xo.vo,
              )
            : a(c));
      },
      r = (o = !0) => {
        let a = document.querySelectorAll(".ab-iam-root");
        (a && 0 !== a.length) || (a = i.querySelectorAll(".ab-iam-root")),
          a &&
            a.length > 0 &&
            (a[0].classList.remove("ab-iam-img-loading"),
            l && (clearTimeout(l), (l = null)),
            o
              ? d()
              : logger/* default.error */.Z.error(
                  `Cannot show in-app message ${e.message} because the image failed to load.`,
                ));
      };
    e.imageStyle === in_app_message/* default.ImageStyle.GRAPHIC */.Z.ImageStyle.GRAPHIC &&
      (c.className += " graphic"),
      e.orientation === in_app_message/* default.Orientation.LANDSCAPE */.Z.Orientation.LANDSCAPE &&
        (c.className += " landscape"),
      null != e.buttons &&
        0 === e.buttons.length &&
        (e.clickAction !== in_app_message/* default.ClickAction.NONE */.Z.ClickAction.NONE &&
          (c.className += " ab-clickable"),
        (c.onclick = (a) => (
          e.ll(c, () => {
            (0,log_in_app_message_click/* logInAppMessageClick */.W)(e),
              e.clickAction === in_app_message/* default.ClickAction.URI */.Z.ClickAction.URI
                ? (0,handle_braze_action/* _handleBrazeAction */.S)(
                    e.uri || "",
                    n || e.openTarget === in_app_message/* default.OpenTarget.BLANK */.Z.OpenTarget.BLANK,
                    a,
                  )
                : e.clickAction === in_app_message/* default.ClickAction.NEWS_FEED */.Z.ClickAction.NEWS_FEED && o();
          }),
          a.stopPropagation(),
          !1
        )));
    const u = (0,component_utils/* createCloseButton */.B)(
      "Close Message",
      e.lo() ? void 0 : toRgba(e.closeButtonColor),
      () => {
        e.ll(c);
      },
      m,
    );
    c.appendChild(u), s && (u.style.zIndex = (s + 2).toString());
    const b = document.createElement("div");
    (b.className = "ab-message-text"), (b.dir = m);
    const p = (e.messageAlignment || e.Co).toLowerCase();
    b.className += " " + p + "-aligned";
    let g = !1;
    const f = document.createElement("div");
    if (((f.className = "ab-image-area"), e.imageUrl)) {
      if (e.cropType === in_app_message/* default.CropType.CENTER_CROP */.Z.CropType.CENTER_CROP) {
        const o = document.createElement("span");
        (o.className = "ab-center-cropped-img"),
          (o.style.backgroundImage = "url(" + e.imageUrl + ")"),
          o.setAttribute("role", "img"),
          o.setAttribute("aria-label", "Modal Image"),
          e.$o(o),
          f.appendChild(o);
      } else {
        const o = document.createElement("img");
        if (
          (o.setAttribute("src", e.imageUrl),
          e.$o(o),
          0 === document.querySelectorAll(".ab-iam-img-loading").length)
        ) {
          g = !0;
          const e = document.querySelectorAll(".ab-iam-root");
          e && e.length > 0 && e[0].classList.add("ab-iam-img-loading"),
            (l = window.setTimeout(() => {
              r(!1);
            }, 6e4)),
            (o.onload = () => {
              r();
            }),
            (o.onerror = () => {
              r(!1);
            });
        }
        f.appendChild(o);
      }
      c.appendChild(f), (b.className += " ab-with-image");
    } else if (e.icon) {
      f.className += " ab-icon-area";
      const o = document.createElement("span");
      (o.className = "ab-icon"),
        e.lo() ||
          ((o.style.backgroundColor = toRgba(e.iconBackgroundColor)),
          (o.style.color = toRgba(e.iconColor)));
      const a = document.createElement("i");
      (a.className = "fa"),
        a.appendChild(document.createTextNode(e.icon)),
        a.setAttribute("aria-hidden", "true"),
        o.appendChild(a),
        f.appendChild(o),
        c.appendChild(f),
        (b.className += " ab-with-icon");
    }
    if (((0,dom_utils/* addPassiveEventListener */.lj)(b, "touchstart"), e.header && e.header.length > 0)) {
      const o = document.createElement("h1");
      (o.className = "ab-message-header"), (e.ko = guid/* default.ce */.Z.ce()), (o.id = e.ko);
      const a = (
        e.headerAlignment || in_app_message/* default.TextAlignment.CENTER */.Z.TextAlignment.CENTER
      ).toLowerCase();
      (o.className += " " + a + "-aligned"),
        e.lo() || (o.style.color = toRgba(e.headerTextColor)),
        o.appendChild(document.createTextNode(e.header)),
        b.appendChild(o);
    }
    return b.appendChild(e.Mo()), c.appendChild(b), g || d(), (e.ho = c), c;
  })(e, o, a, t, n, s, m, l);
  if (e instanceof full_screen_message/* default */.Z || e instanceof modal_message/* default */.Z) {
    const a = e instanceof full_screen_message/* default */.Z ? "ab-fullscreen" : "ab-modal";
    (c.className += ` ${a} ab-centered`),
      modal_utils.zo(e, o, c, n),
      modal_utils.Lo(c),
      modal_utils.Io(e.ko, c);
  } else if (e instanceof slide_up_message/* default */.Z) {
    c.className += " ab-slideup";
    const o = c.getElementsByClassName("ab-close-button")[0];
    if (null != o) {
      const a = (0,dom_utils/* buildSvg */.MK)(
        "0 0 11.38 19.44",
        "M11.38 9.72l-9.33 9.72L0 17.3l7.27-7.58L0 2.14 2.05 0l9.33 9.72z",
        e.lo() ? void 0 : toRgba(e.closeButtonColor),
      );
      a.setAttribute("class", `ab-chevron ${l}`), o.appendChild(a);
    }
    let a, t;
    (0,dom_utils/* detectSwipe */.FZ)(c, dom_utils/* DIRECTIONS.ie */.mQ.ie, (e) => {
      (c.className += " ab-swiped-left"),
        null != o && null != o.onclick && o.onclick(e);
    }),
      (0,dom_utils/* detectSwipe */.FZ)(c, dom_utils/* DIRECTIONS.de */.mQ.de, (e) => {
        (c.className += " ab-swiped-right"),
          null != o && null != o.onclick && o.onclick(e);
      }),
      e.slideFrom === in_app_message/* default.SlideFrom.TOP */.Z.SlideFrom.TOP
        ? ((a = dom_utils/* DIRECTIONS.To */.mQ.To), (t = " ab-swiped-up"))
        : ((a = dom_utils/* DIRECTIONS.qo */.mQ.qo), (t = " ab-swiped-down")),
      (0,dom_utils/* detectSwipe */.FZ)(c, a, (e) => {
        (c.className += t), null != o && null != o.onclick && o.onclick(e);
      });
  }
  return c;
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/log-in-app-message-impression.js
var log_in_app_message_impression = __webpack_require__(39517);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ui/js/iam-css.js
var iam_css = __webpack_require__(9135);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/constants.js
var constants = __webpack_require__(27671);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/utils/in-app-message-utils.js
var in_app_message_utils = __webpack_require__(7048);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/l10n/l10n-manager-factory.js + 2 modules
var l10n_manager_factory = __webpack_require__(8731);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/ui/show-in-app-message.js

















function showInAppMessage(e, t, o) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  if (((0,iam_css/* setupInAppMessageUI */.R)(), null == e)) return !1;
  if (e instanceof control_message/* default */.Z)
    return (
      logger/* default.info */.Z.info(
        "User received control for a multivariate test, logging to Braze servers.",
      ),
      (0,log_in_app_message_impression/* logInAppMessageImpression */.v)(e),
      !0
    );
  if (!(e instanceof in_app_message/* default */.Z)) return !1;
  if (e.constructor === in_app_message/* default */.Z) return !1;
  e.Lh();
  const s = e instanceof html_message/* default */.Z;
  if (s && !e.trusted && !braze_instance/* default.tr */.ZP.tr())
    return (
      logger/* default.error */.Z.error(
        'HTML in-app messages are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these messages.',
      ),
      !1
    );
  if ((null == t && (t = document.body), e.wo())) {
    if (t.querySelectorAll(".ab-modal-interactions").length > 0)
      return (
        logger/* default.info */.Z.info(
          `Cannot show in-app message ${e.message} because another message is being shown.`,
        ),
        !1
      );
  }
  if (window_utils/* WindowUtils.Uo */.SD.Uo()) {
    const t = window_utils/* WindowUtils.Jo */.SD.Jo();
    if (
      (t === window_utils/* ORIENTATION.PORTRAIT */.eh.PORTRAIT &&
        e.orientation === in_app_message/* default.Orientation.LANDSCAPE */.Z.Orientation.LANDSCAPE) ||
      (t === window_utils/* ORIENTATION.LANDSCAPE */.eh.LANDSCAPE &&
        e.orientation === in_app_message/* default.Orientation.PORTRAIT */.Z.Orientation.PORTRAIT)
    ) {
      const o = t === window_utils/* ORIENTATION.PORTRAIT */.eh.PORTRAIT ? "portrait" : "landscape",
        s =
          e.orientation === in_app_message/* default.Orientation.PORTRAIT */.Z.Orientation.PORTRAIT
            ? "portrait"
            : "landscape";
      return (
        logger/* default.info */.Z.info(
          `Not showing ${s} in-app message ${e.message} because the screen is currently ${o}`,
        ),
        !1
      );
    }
  }
  if (!braze_instance/* default.tr */.ZP.tr()) {
    let t = !1;
    if (e.buttons && e.buttons.length > 0) {
      const o = e.buttons;
      for (let e = 0; e < o.length; e++)
        if (o[e].clickAction === in_app_message/* default.ClickAction.URI */.Z.ClickAction.URI) {
          const s = o[e].uri;
          t = (0,url_utils/* isURIJavascriptOrData */.o)(s);
        }
    } else e.clickAction === in_app_message/* default.ClickAction.URI */.Z.ClickAction.URI && (t = (0,url_utils/* isURIJavascriptOrData */.o)(e.uri));
    if (t)
      return (
        logger/* default.error */.Z.error(
          'Javascript click actions are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these actions.',
        ),
        !1
      );
  }
  const i = document.createElement("div");
  if (
    ((i.className = "ab-iam-root v3"),
    (i.className += me(e)),
    i.setAttribute("role", "complementary"),
    e.bo() && (i.id = e.htmlId),
    braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.No */.JY.No) && (i.style.zIndex = (braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.No */.JY.No) + 1).toString()),
    t.appendChild(i),
    e.lo())
  ) {
    const t = document.createElement("style");
    (t.innerHTML = e.css),
      (t.id = e.do()),
      null != braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.er */.JY.er) && t.setAttribute("nonce", braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.er */.JY.er)),
      document.getElementsByTagName("head")[0].appendChild(t);
  }
  const n = e instanceof slide_up_message/* default */.Z,
    a = de(
      e,
      () => {
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 33545)).then((e) => {
          braze_instance/* default._t */.ZP._t() ? e.showFeed() : logger/* default.error */.Z.error(constants/* BRAZE_MUST_BE_INITIALIZED_ERROR */.Go);
        });
      },
      (t) => {
        if (e.wo() && e.Po()) {
          const o = document.createElement("div");
          if (
            ((o.className = "ab-page-blocker"),
            e.lo() || (o.style.backgroundColor = toRgba(e.frameColor)),
            braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.No */.JY.No) && (o.style.zIndex = braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.No */.JY.No).toString()),
            i.appendChild(o),
            !braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.mh */.JY.mh))
          ) {
            const s = new Date().valueOf();
            o.onclick = (o) => {
              new Date().valueOf() - s > in_app_message/* default.ph */.Z.ph &&
                (e.ll(t), o.stopPropagation());
            };
          }
          i.appendChild(t), t.focus(), e.Ah(i);
        } else if (n) {
          const o = document.querySelectorAll(".ab-slideup");
          let s = null;
          for (let e = o.length - 1; e >= 0; e--)
            if (o[e] !== t) {
              s = o[e];
              break;
            }
          if (e.slideFrom === in_app_message/* default.SlideFrom.TOP */.Z.SlideFrom.TOP) {
            let e = 0;
            null != s && (e = s.offsetTop + s.offsetHeight),
              (t.style.top = Math.max(e, 0) + "px");
          } else {
            let e = 0;
            null != s &&
              (e =
                (window.innerHeight || document.documentElement.clientHeight) -
                s.offsetTop),
              (t.style.bottom = Math.max(e, 0) + "px");
          }
        } else if (s && !braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.mh */.JY.mh)) {
          const o = e;
          (0,in_app_message_utils/* isIFrame */.f)(t) &&
            t.contentWindow &&
            t.contentWindow.addEventListener("keydown", function (e) {
              e.keyCode === key_codes/* KeyCodes._h */.m._h && o.closeMessage();
            });
        }
        (0,log_in_app_message_impression/* logInAppMessageImpression */.v)(e),
          e.dismissType === in_app_message/* default.DismissType.AUTO_DISMISS */.Z.DismissType.AUTO_DISMISS &&
            setTimeout(() => {
              i.contains(t) && e.ll(t);
            }, e.duration),
          "function" == typeof o && o();
      },
      (e) => {
        logger/* default.info */.Z.info(e);
      },
      braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.Ko */.JY.Ko),
      braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.No */.JY.No),
      braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.er */.JY.er),
      t,
      l10n_manager_factory/* default.ea */.Z.ea().Oo(),
    );
  return (s || n) && (i.appendChild(a), e.Ah(i)), !0;
}


/***/ }),

/***/ 7048:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ isIFrame; }
/* harmony export */ });
const isIFrame = (e) => null !== e && "IFRAME" === e.tagName;


/***/ }),

/***/ 47733:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ isPushSupported; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _utils_push_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74556);


function isPushSupported() {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return _utils_push_utils_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isPushSupported */ .Z.isPushSupported();
}


/***/ }),

/***/ 23966:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ push_manager_factory; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/code-utils.js
var code_utils = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/push-token.js
var push_token = __webpack_require__(63552);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/shared-lib/encoding-utils.js
const ei = {
  Vn: function (t) {
    const r = (t + "=".repeat((4 - (t.length % 4)) % 4))
        .replace(/\-/g, "+")
        .replace(/_/g, "/"),
      n = atob(r),
      o = new Uint8Array(n.length);
    for (let t = 0; t < n.length; ++t) o[t] = n.charCodeAt(t);
    return o;
  },
};
/* harmony default export */ var encoding_utils = (ei);

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/User/user.js
var user = __webpack_require__(17615);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/utils/push-utils.js
var push_utils = __webpack_require__(74556);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/error-utils.js
var error_utils = __webpack_require__(8031);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Push/push-manager.js







class na {
  constructor(i, t, e, s, r, n, o, u, a, h, c) {
    (this.on = i),
      (this.un = t),
      (this.an = e),
      (this.hn = r),
      (this.cn = n),
      (this.fn = o),
      (this.B = u),
      (this.ln = a),
      (this.dn = h),
      (this.C = c),
      (this.on = i),
      (this.un = t),
      (this.an = e),
      (this.pn = s + "/safari/" + t),
      (this.hn = r || "/service-worker.js"),
      (this.fn = o),
      (this.B = u),
      (this.ln = a || !1),
      (this.dn = h || !1),
      (this.C = c),
      (this.bn = push_utils/* default.yn */.Z.yn()),
      (this.mn = push_utils/* default.gn */.Z.gn());
  }
  vn() {
    return this.dn;
  }
  wn(i, t, e, s, r) {
    i.unsubscribe()
      .then((i) => {
        i
          ? this.kn(t, e, s, r)
          : (logger/* default.error */.Z.error("Failed to unsubscribe device from push."),
            "function" == typeof r && r(!1));
      })
      .catch((i) => {
        logger/* default.error */.Z.error("Push unsubscription error: " + i),
          "function" == typeof r && r(!1);
      });
  }
  Pn(i, t, e) {
    var s;
    const r = ((i) => {
      if ("string" == typeof i) return i;
      if (0 !== i.endpoint.indexOf("https://android.googleapis.com/gcm/send"))
        return i.endpoint;
      let t = i.endpoint;
      const e = i;
      return (
        e.Dn &&
          -1 === i.endpoint.indexOf(e.Dn) &&
          (t = i.endpoint + "/" + e.Dn),
        t
      );
    })(i);
    let n = null,
      o = null;
    const u = i;
    if (null != u.getKey)
      try {
        const i = Array.from(new Uint8Array(u.getKey("p256dh"))),
          t = Array.from(new Uint8Array(u.getKey("auth")));
        (n = btoa(String.fromCharCode.apply(null, i))),
          (o = btoa(String.fromCharCode.apply(null, t)));
      } catch (i) {
        logger/* default.error */.Z.error((0,error_utils/* getErrorMessage */.e)(i));
      }
    const a = ((i) => {
      let t;
      return i.options &&
        (t = i.options.applicationServerKey) &&
        t.byteLength &&
        t.byteLength > 0
        ? btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(t))))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
        : null;
    })(u);
    null === (s = this.on) || void 0 === s || s.Sn(r, t, n, o, a),
      r && "function" == typeof e && e(r, n, o);
  }
  An() {
    var i;
    null === (i = this.on) || void 0 === i || i.jn(!0);
  }
  xn(i, t) {
    var e;
    null === (e = this.on) || void 0 === e || e.jn(!1),
      logger/* default.info */.Z.info(i),
      "function" == typeof t && t(!1);
  }
  Nn(i, t, e, s) {
    var r;
    if ("default" === t.permission)
      try {
        window.safari.pushNotification.requestPermission(
          this.pn,
          i,
          {
            api_key: this.un,
            device_id:
              (null === (r = this.an) || void 0 === r ? void 0 : r.ve().id) ||
              "",
          },
          (t) => {
            "granted" === t.permission &&
              this.on &&
              this.on.setPushNotificationSubscriptionType(
                user/* default.NotificationSubscriptionTypes.OPTED_IN */.Z.NotificationSubscriptionTypes.OPTED_IN,
              ),
              this.Nn(i, t, e, s);
          },
        );
      } catch (i) {
        this.xn("Could not request permission for push: " + i, s);
      }
    else
      "denied" === t.permission
        ? this.xn(
            "The user has blocked notifications from this site, or Safari push is not configured in the Braze dashboard.",
            s,
          )
        : "granted" === t.permission &&
          (logger/* default.info */.Z.info("Device successfully subscribed to push."),
          this.Pn(t.deviceToken, new Date(), e));
  }
  requestPermission(i, t, e) {
    const s = (s) => {
      switch (s) {
        case "granted":
          return void ("function" == typeof i && i());
        case "default":
          return void ("function" == typeof t && t());
        case "denied":
          return void ("function" == typeof e && e());
        default:
          logger/* default.error */.Z.error("Received unexpected permission result " + s);
      }
    };
    let r = !1;
    if ("default" !== window.Notification.permission)
      s(Notification.permission);
    else {
      const i = window.Notification.requestPermission((i) => {
        r && s(i);
      });
      i
        ? i.then((i) => {
            s(i);
          })
        : (r = !0);
    }
  }
  kn(i, t, e, s) {
    const r = { userVisibleOnly: !0 };
    null != t && (r.applicationServerKey = t),
      i.pushManager
        .subscribe(r)
        .then((i) => {
          logger/* default.info */.Z.info("Device successfully subscribed to push."),
            this.Pn(i, new Date(), e);
        })
        .catch((i) => {
          push_utils/* default.isPushBlocked */.Z.isPushBlocked()
            ? (logger/* default.info */.Z.info("Permission for push notifications was denied."),
              "function" == typeof s && s(!1))
            : (logger/* default.error */.Z.error("Push subscription failed: " + i),
              "function" == typeof s && s(!0));
        });
  }
  Un() {
    if (this.ln) return navigator.serviceWorker.getRegistration(this.hn);
    const i = this.cn ? { scope: this.cn } : void 0;
    return navigator.serviceWorker.register(this.hn, i).then(() =>
      navigator.serviceWorker.ready.then(
        (i) => (
          i &&
            "function" == typeof i.update &&
            i.update().catch((i) => {
              logger/* default.info */.Z.info("ServiceWorker update failed: " + i);
            }),
          i
        ),
      ),
    );
  }
  Wn(i) {
    this.ln ||
      (i.unregister(), logger/* default.info */.Z.info("Service worker successfully unregistered."));
  }
  subscribe(i, t) {
    if (!push_utils/* default.isPushSupported */.Z.isPushSupported())
      return logger/* default.info */.Z.info(na._n), void ("function" == typeof t && t(!1));
    if (this.bn) {
      if (!this.ln && null != window.location) {
        let i = this.hn;
        -1 === i.indexOf(window.location.host) &&
          (i = window.location.host + i),
          -1 === i.indexOf(window.location.protocol) &&
            (i = window.location.protocol + "//" + i);
      }
      if (push_utils/* default.isPushBlocked */.Z.isPushBlocked())
        return void this.xn(
          "Notifications from this site are blocked. This may be a temporary embargo or a permanent denial.",
          t,
        );
      if (this.B && !this.B.Tn() && 0 === this.B.Et())
        return (
          logger/* default.info */.Z.info(
            "Waiting for VAPID key from server config before subscribing to push.",
          ),
          void this.B.In(() => {
            this.subscribe(i, t);
          })
        );
      const e = () => {
          logger/* default.info */.Z.info("Permission for push notifications was denied."),
            "function" == typeof t && t(!1);
        },
        r = () => {
          let i = "Permission for push notifications was ignored.";
          push_utils/* default.isPushBlocked */.Z.isPushBlocked() &&
            (i +=
              " The browser has automatically blocked further permission requests for a period (probably 1 week)."),
            logger/* default.info */.Z.info(i),
            "function" == typeof t && t(!0);
        },
        n = push_utils/* default.isPushPermissionGranted */.Z.isPushPermissionGranted(),
        o = () => {
          !n &&
            this.on &&
            this.on.setPushNotificationSubscriptionType(
              user/* default.NotificationSubscriptionTypes.OPTED_IN */.Z.NotificationSubscriptionTypes.OPTED_IN,
            ),
            this.Un()
              .then((e) => {
                if (null == e)
                  return (
                    logger/* default.error */.Z.error(
                      "No service worker registration. Set the `manageServiceWorkerExternally` initialization option to false or ensure that your service worker is registered before calling registerPush.",
                    ),
                    void ("function" == typeof t && t(!0))
                  );
                e.pushManager
                  .getSubscription()
                  .then((r) => {
                    var n;
                    let o = null;
                    if (
                      (null !=
                        (null === (n = this.B) || void 0 === n
                          ? void 0
                          : n.Tn()) && (o = encoding_utils.Vn(this.B.Tn())),
                      r)
                    ) {
                      let n,
                        u = null,
                        a = null;
                      if ((this.C && (n = this.C.ft(storage_manager/* STORAGE_KEYS.gt.qn */.I.gt.qn)), n && !(0,code_utils/* isArray */.kJ)(n))) {
                        let i;
                        try {
                          i = push_token/* default.En */.Z.En(n).zn;
                        } catch (t) {
                          i = null;
                        }
                        null == i ||
                          isNaN(i.getTime()) ||
                          0 === i.getTime() ||
                          ((u = i),
                          (a = new Date(u)),
                          a.setMonth(u.getMonth() + 6));
                      }
                      null != o &&
                      r.options &&
                      r.options.applicationServerKey &&
                      r.options.applicationServerKey.byteLength &&
                      r.options.applicationServerKey.byteLength > 0 &&
                      !(0,code_utils/* isEqual */.Xy)(o, new Uint8Array(r.options.applicationServerKey))
                        ? (r.options.applicationServerKey.byteLength > 12
                            ? logger/* default.info */.Z.info(
                                "Device was already subscribed to push using a different VAPID provider, creating new subscription.",
                              )
                            : logger/* default.info */.Z.info(
                                "Attempting to upgrade a gcm_sender_id-based push registration to VAPID - depending on the browser this may or may not result in the same gcm_sender_id-based subscription.",
                              ),
                          this.wn(r, e, o, i, t))
                        : r.expirationTime &&
                          new Date(r.expirationTime).valueOf() <=
                            new Date().valueOf()
                        ? (logger/* default.info */.Z.info(
                            "Push subscription is expired, creating new subscription.",
                          ),
                          this.wn(r, e, o, i, t))
                        : n && (0,code_utils/* isArray */.kJ)(n)
                        ? this.wn(r, e, o, i, t)
                        : null == a
                        ? (logger/* default.info */.Z.info(
                            "No push subscription creation date found, creating new subscription.",
                          ),
                          this.wn(r, e, o, i, t))
                        : a.valueOf() <= new Date().valueOf()
                        ? (logger/* default.info */.Z.info(
                            "Push subscription older than 6 months, creating new subscription.",
                          ),
                          this.wn(r, e, o, i, t))
                        : (logger/* default.info */.Z.info(
                            "Device already subscribed to push, sending existing subscription to backend.",
                          ),
                          this.Pn(r, u, i));
                    } else this.kn(e, o, i, t);
                  })
                  .catch((i) => {
                    logger/* default.error */.Z.error("Error checking current push subscriptions: " + i);
                  });
              })
              .catch((i) => {
                logger/* default.error */.Z.error("ServiceWorker registration failed: " + i);
              });
        };
      this.requestPermission(o, r, e);
    } else if (this.mn) {
      if (null == this.fn || "" === this.fn)
        return (
          logger/* default.error */.Z.error(
            "You must supply the safariWebsitePushId initialization option in order to use registerPush on Safari",
          ),
          void ("function" == typeof t && t(!0))
        );
      const e = window.safari.pushNotification.permission(this.fn);
      this.Nn(this.fn, e, i, t);
    }
  }
  unsubscribe(i, t) {
    if (!push_utils/* default.isPushSupported */.Z.isPushSupported())
      return logger/* default.info */.Z.info(na._n), void ("function" == typeof t && t());
    this.bn
      ? navigator.serviceWorker.getRegistration(this.hn).then((e) => {
          e
            ? e.pushManager
                .getSubscription()
                .then((s) => {
                  s
                    ? (this.An(),
                      s
                        .unsubscribe()
                        .then((s) => {
                          s
                            ? (logger/* default.info */.Z.info(
                                "Device successfully unsubscribed from push.",
                              ),
                              "function" == typeof i && i())
                            : (logger/* default.error */.Z.error(
                                "Failed to unsubscribe device from push.",
                              ),
                              "function" == typeof t && t()),
                            this.Wn(e);
                        })
                        .catch((i) => {
                          logger/* default.error */.Z.error("Push unsubscription error: " + i),
                            "function" == typeof t && t();
                        }))
                    : (logger/* default.info */.Z.info("Device already unsubscribed from push."),
                      "function" == typeof i && i());
                })
                .catch((i) => {
                  logger/* default.error */.Z.error("Error unsubscribing from push: " + i),
                    "function" == typeof t && t();
                })
            : (logger/* default.info */.Z.info("Device already unsubscribed from push."),
              "function" == typeof i && i());
        })
      : this.mn &&
        (this.An(),
        logger/* default.info */.Z.info("Device unsubscribed from push."),
        "function" == typeof i && i());
  }
}
na._n = "Push notifications are not supported in this browser.";

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Push/push-manager-factory.js


const ra = {
  l: !1,
  aa: null,
  ea: () => (
    ra.p(),
    ra.aa ||
      (ra.aa = new na(
        braze_instance/* default.mr */.ZP.mr(),
        braze_instance/* default.Ma */.ZP.Ma(),
        braze_instance/* default.ue */.ZP.ue(),
        braze_instance/* default.Z */.ZP.Z(),
        braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS._a */.JY._a),
        braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.Aa */.JY.Aa),
        braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.Ba */.JY.Ba),
        braze_instance/* default.v */.ZP.v(),
        braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.Ca */.JY.Ca),
        braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.Da */.JY.Da),
        braze_instance/* default.j */.ZP.j(),
      )),
    ra.aa
  ),
  p: () => {
    ra.l || (braze_instance/* default.h */.ZP.h(ra), (ra.l = !0));
  },
  destroy: () => {
    (ra.aa = null), (ra.l = !1);
  },
};
/* harmony default export */ var push_manager_factory = (ra);


/***/ }),

/***/ 12261:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "requestPushPermission": function() { return /* binding */ requestPushPermission; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _push_manager_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23966);


function requestPushPermission(n, o) {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr())
    return _push_manager_factory_js__WEBPACK_IMPORTED_MODULE_1__["default"].ea().subscribe((o, t, e) => {
      const s = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].nn */ .ZP.nn();
      s && s.requestImmediateDataFlush(), "function" == typeof n && n(o, t, e);
    }, o);
}


/***/ }),

/***/ 77824:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "unregisterPush": function() { return /* binding */ unregisterPush; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _push_manager_factory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23966);


function unregisterPush(e, n) {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rr */ .ZP.rr()) return _push_manager_factory_js__WEBPACK_IMPORTED_MODULE_1__["default"].ea().unsubscribe(e, n);
}


/***/ }),

/***/ 74556:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

const vt = {
  yn: () =>
    "serviceWorker" in navigator &&
    "undefined" != typeof ServiceWorkerRegistration &&
    "showNotification" in ServiceWorkerRegistration.prototype &&
    "PushManager" in window,
  gn: () =>
    "safari" in window &&
    "pushNotification" in window.safari &&
    "function" == typeof window.safari.pushNotification.permission &&
    "function" == typeof window.safari.pushNotification.requestPermission,
  isPushSupported: () => vt.yn() || vt.gn(),
  isPushBlocked: () => {
    const i =
        vt.isPushSupported() &&
        "Notification" in window &&
        null != window.Notification &&
        null != window.Notification.permission &&
        "denied" === window.Notification.permission,
      n =
        vt.isPushSupported() &&
        (!("Notification" in window) || null == window.Notification);
    return i || n;
  },
  isPushPermissionGranted: () =>
    vt.isPushSupported() &&
    "Notification" in window &&
    null != window.Notification &&
    null != window.Notification.permission &&
    "granted" === window.Notification.permission,
  wr: () =>
    !vt.isPushBlocked() &&
    vt.isPushSupported() &&
    !vt.isPushPermissionGranted(),
};
/* harmony default export */ __webpack_exports__["Z"] = (vt);


/***/ }),

/***/ 17615:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ User; }
/* harmony export */ });
/* harmony import */ var _util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72893);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20335);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12730);
/* harmony import */ var _util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27671);
/* harmony import */ var _util_date_utils_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57750);





class User {
  constructor(t, e) {
    (this.Cs = t), (this.Fi = e), (this.Cs = t), (this.Fi = e);
  }
  getUserId(t) {
    const e = this.Cs.getUserId();
    if ("function" != typeof t) return e;
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].warn */ .Z.warn(
      "The callback for getUserId is deprecated. You can access its return value directly instead (e.g. `const id = braze.getUser().getUserId()`)",
    ),
      t(e);
  }
  addAlias(t, e) {
    return !(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(t, "add alias", "the alias", !1) || t.length <= 0
      ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error("addAlias requires a non-empty alias"), !1)
      : !(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(e, "add alias", "the label", !1) || e.length <= 0
      ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error("addAlias requires a non-empty label"), !1)
      : this.Fi.Cn(t, e).tt;
  }
  setFirstName(t) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(t, "set first name", "the firstName", !0) &&
      this.Cs.nu("first_name", t)
    );
  }
  setLastName(t) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(t, "set last name", "the lastName", !0) && this.Cs.nu("last_name", t)
    );
  }
  setEmail(t) {
    return null === t || (0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isValidEmail */ .vV)(t)
      ? this.Cs.nu("email", t)
      : (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
          `Cannot set email address - "${t}" did not pass RFC-5322 validation.`,
        ),
        !1);
  }
  setGender(t) {
    return (
      "string" == typeof t && (t = t.toLowerCase()),
      !(
        null !== t &&
        !(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .validateValueIsFromEnum */ .fk)(
          User.Genders,
          t,
          `Gender "${t}" is not a valid gender.`,
          "User.Genders",
        )
      ) && this.Cs.nu("gender", t)
    );
  }
  setDateOfBirth(t, e, r) {
    return null === t && null === e && null === r
      ? this.Cs.nu("dob", null)
      : ((t = null != t ? parseInt(t.toString()) : null),
        (e = null != e ? parseInt(e.toString()) : null),
        (r = null != r ? parseInt(r.toString()) : null),
        null == t ||
        null == e ||
        null == r ||
        isNaN(t) ||
        isNaN(e) ||
        isNaN(r) ||
        e > 12 ||
        e < 1 ||
        r > 31 ||
        r < 1
          ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
              "Cannot set date of birth - parameters should comprise a valid date e.g. setDateOfBirth(1776, 7, 4);",
            ),
            !1)
          : this.Cs.nu("dob", `${t}-${e}-${r}`));
  }
  setCountry(t) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(t, "set country", "the country", !0) && this.Cs.nu("country", t)
    );
  }
  setHomeCity(t) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(t, "set home city", "the homeCity", !0) && this.Cs.nu("home_city", t)
    );
  }
  setLanguage(t) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(t, "set language", "the language", !0) && this.Cs.nu("language", t)
    );
  }
  setEmailNotificationSubscriptionType(t) {
    return (
      !!(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .validateValueIsFromEnum */ .fk)(
        User.NotificationSubscriptionTypes,
        t,
        `Email notification setting "${t}" is not a valid subscription type.`,
        "User.NotificationSubscriptionTypes",
      ) && this.Cs.nu("email_subscribe", t)
    );
  }
  setPushNotificationSubscriptionType(t) {
    return (
      !!(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .validateValueIsFromEnum */ .fk)(
        User.NotificationSubscriptionTypes,
        t,
        `Push notification setting "${t}" is not a valid subscription type.`,
        "User.NotificationSubscriptionTypes",
      ) && this.Cs.nu("push_subscribe", t)
    );
  }
  setPhoneNumber(t) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(t, "set phone number", "the phoneNumber", !0) &&
      (null === t || t.match(User.Fn)
        ? this.Cs.nu("phone", t)
        : (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(`Cannot set phone number - "${t}" did not pass validation.`),
          !1))
    );
  }
  setLastKnownLocation(t, e, r, s, n) {
    return null == t || null == e
      ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
          "Cannot set last-known location - latitude and longitude are required.",
        ),
        !1)
      : ((t = parseFloat(t.toString())),
        (e = parseFloat(e.toString())),
        null != r && (r = parseFloat(r.toString())),
        null != s && (s = parseFloat(s.toString())),
        null != n && (n = parseFloat(n.toString())),
        isNaN(t) ||
        isNaN(e) ||
        (null != r && isNaN(r)) ||
        (null != s && isNaN(s)) ||
        (null != n && isNaN(n))
          ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
              "Cannot set last-known location - all supplied parameters must be numeric.",
            ),
            !1)
          : t > 90 || t < -90 || e > 180 || e < -180
          ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
              "Cannot set last-known location - latitude and longitude are bounded by ±90 and ±180 respectively.",
            ),
            !1)
          : (null != r && r < 0) || (null != n && n < 0)
          ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
              "Cannot set last-known location - accuracy and altitudeAccuracy may not be negative.",
            ),
            !1)
          : this.Fi.setLastKnownLocation(this.Cs.getUserId(), t, e, s, r, n)
              .tt);
  }
  setCustomUserAttribute(t, e, r) {
    if (!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomAttributeKey */ .bj)(t)) return !1;
    const s = (e) => {
      const [r] = (0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomProperties */ .lg)(
        e,
        _common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .SET_CUSTOM_USER_ATTRIBUTE_STRING */ .db,
        "attribute value",
        `set custom user attribute "${t}"`,
        "custom user attribute",
      );
      return r;
    };
    if ((0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .kJ)(e)) {
      const [r, n] = (0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomAttributeArrayType */ .$g)(t, e);
      if (!r && !n && 0 !== e.length) return !1;
      if (r || 0 === e.length) return this.Fi.Ln(_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* .EventTypes.$n */ .G.$n, t, e).tt;
      for (const t of e) if (!s(t)) return !1;
    } else if ((0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .isObject */ .Kn)(e)) {
      if (!s(e)) return !1;
      if (r) return this.Fi.Ln(_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* .EventTypes.Bn */ .G.Bn, t, e).tt;
    } else {
      if (!(void 0 !== e && (0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validatePropertyType */ .UO)(e))) return !1;
      if (
        ((0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .isDate */ .J_)(e) && (e = (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_5__/* .toValidBackendTimeString */ .BT)(e)),
        "string" == typeof e &&
          !(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomString */ .zM)(
            e,
            `set custom user attribute "${t}"`,
            "the element in the given array",
          ))
      )
        return !1;
    }
    return this.Cs.setCustomUserAttribute(t, e);
  }
  addToCustomAttributeArray(t, e) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomString */ .zM)(t, "add to custom user attribute array", "the given key") &&
      !(
        null != e &&
        !(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomString */ .zM)(e, "add to custom user attribute array", "the given value")
      ) &&
      this.Fi.Ln(_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* .EventTypes.Rn */ .G.Rn, t, e).tt
    );
  }
  removeFromCustomAttributeArray(t, e) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomString */ .zM)(t, "remove from custom user attribute array", "the given key") &&
      !(
        null != e &&
        !(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomString */ .zM)(e, "remove from custom user attribute array", "the given value")
      ) &&
      this.Fi.Ln(_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* .EventTypes.On */ .G.On, t, e).tt
    );
  }
  incrementCustomUserAttribute(t, e) {
    if (!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomString */ .zM)(t, "increment custom user attribute", "the given key")) return !1;
    null == e && (e = 1);
    const r = parseInt(e.toString());
    return isNaN(r) || r !== parseFloat(e.toString())
      ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
          `Cannot increment custom user attribute because the given incrementValue "${e}" is not an integer.`,
        ),
        !1)
      : this.Fi.Ln(_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* .EventTypes.Gn */ .G.Gn, t, r).tt;
  }
  setCustomLocationAttribute(t, e, r) {
    return (
      !!(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateCustomString */ .zM)(t, "set custom location attribute", "the given key") &&
      ((null !== e || null !== r) &&
      ((e = null != e ? parseFloat(e.toString()) : null),
      (r = null != r ? parseFloat(r.toString()) : null),
      (null == e && null != r) ||
        (null != e && null == r) ||
        (null != e && (isNaN(e) || e > 90 || e < -90)) ||
        (null != r && (isNaN(r) || r > 180 || r < -180)))
        ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
            "Received invalid values for latitude and/or longitude. Latitude and longitude are bounded by ±90 and ±180 respectively, or must both be null for removal.",
          ),
          !1)
        : this.Fi.Hn(t, e, r).tt)
    );
  }
  addToSubscriptionGroup(t) {
    return !(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(
      t,
      "add user to subscription group",
      "subscription group ID",
      !1,
    ) || t.length <= 0
      ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
          "addToSubscriptionGroup requires a non-empty subscription group ID",
        ),
        !1)
      : this.Fi.Kn(t, User.Mn.SUBSCRIBED).tt;
  }
  removeFromSubscriptionGroup(t) {
    return !(0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(
      t,
      "remove user from subscription group",
      "subscription group ID",
      !1,
    ) || t.length <= 0
      ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
          "removeFromSubscriptionGroup requires a non-empty subscription group ID",
        ),
        !1)
      : this.Fi.Kn(t, User.Mn.UNSUBSCRIBED).tt;
  }
  setLineId(t) {
    return (0,_util_validation_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .validateStandardString */ .ro)(t, "set LINE user ID", "the ID", !0) &&
      0 !== (null == t ? void 0 : t.length)
      ? t && t.length > User.Yn
        ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
            `Rejected LINE user ID ${t} because it is longer than ${User.Yn} characters.`,
          ),
          !1)
        : this.Cs.nu("native_line_id", t)
      : (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error("setLineId requires a non-empty ID"), !1);
  }
  Sn(t, e, r, s, n) {
    this.Cs.Sn(t, e, r, s, n), this.Fi.Jn();
  }
  jn(t) {
    this.Cs.jn(t);
  }
}
(User.Genders = {
  MALE: "m",
  FEMALE: "f",
  OTHER: "o",
  UNKNOWN: "u",
  NOT_APPLICABLE: "n",
  PREFER_NOT_TO_SAY: "p",
}),
  (User.NotificationSubscriptionTypes = {
    OPTED_IN: "opted_in",
    SUBSCRIBED: "subscribed",
    UNSUBSCRIBED: "unsubscribed",
  }),
  (User.Fn = /^[0-9 .\\(\\)\\+\\-]+$/),
  (User.Mn = { SUBSCRIBED: "subscribed", UNSUBSCRIBED: "unsubscribed" }),
  (User.Qn = "user_id"),
  (User.lu = "custom"),
  (User.ur = 997),
  (User.Yn = 33);


/***/ }),

/***/ 67:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ rr; }
/* harmony export */ });
/* unused harmony export FEED_ANIMATION_DURATION */
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20335);
/* harmony import */ var _Card_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85563);


const FEED_ANIMATION_DURATION = 500;
class rr {
  constructor(s, e) {
    (this.cards = s),
      (this.lastUpdated = e),
      (this.cards = s),
      (this.lastUpdated = e);
  }
  getUnreadCardCount() {
    let s = 0;
    for (const e of this.cards) e.viewed || e instanceof _Card_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z || s++;
    return s;
  }
  nr() {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error("Must be implemented in a subclass");
  }
  logCardImpressions(s) {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error("Must be implemented in a subclass");
  }
  logCardClick(s) {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error("Must be implemented in a subclass");
  }
  sr() {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error("Must be implemented in a subclass");
  }
}
(rr.dr = 6e4), (rr.Ih = 500), (rr.Ro = 1e4);


/***/ }),

/***/ 40158:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ t; }
/* harmony export */ });
class t {
  constructor() {}
  U(a) {}
  changeUser(a = !1) {}
  clearData(a = !1) {}
}


/***/ }),

/***/ 27671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ MUST_BE_IN_APP_MESSAGE_WARNING; },
/* harmony export */   "Fz": function() { return /* binding */ MAX_PURCHASE_QUANTITY; },
/* harmony export */   "Go": function() { return /* binding */ BRAZE_MUST_BE_INITIALIZED_ERROR; },
/* harmony export */   "S6": function() { return /* binding */ REQUEST_ATTEMPT_DEFAULT; },
/* harmony export */   "U4": function() { return /* binding */ MUST_BE_CARD_WARNING_SUFFIX; },
/* harmony export */   "Up": function() { return /* binding */ GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT; },
/* harmony export */   "Y$": function() { return /* binding */ GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT; },
/* harmony export */   "_P": function() { return /* binding */ LOG_CUSTOM_EVENT_STRING; },
/* harmony export */   "dH": function() { return /* binding */ LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT; },
/* harmony export */   "db": function() { return /* binding */ SET_CUSTOM_USER_ATTRIBUTE_STRING; },
/* harmony export */   "k6": function() { return /* binding */ SUBSCRIPTION_ID_DATA_ATTRIBUTE; },
/* harmony export */   "mM": function() { return /* binding */ MAX_RETRY_COUNT_PER_REQUEST; },
/* harmony export */   "rF": function() { return /* binding */ FEED_ANIMATION_DURATION; }
/* harmony export */ });
const MAX_PURCHASE_QUANTITY = 100;
const MUST_BE_IN_APP_MESSAGE_WARNING =
  "inAppMessage must be an InAppMessage object";
const MUST_BE_CARD_WARNING_SUFFIX = "must be a Card object";
const FEED_ANIMATION_DURATION = 500;
const LOG_CUSTOM_EVENT_STRING = "logCustomEvent";
const SET_CUSTOM_USER_ATTRIBUTE_STRING = "setCustomUserAttribute";
const BRAZE_MUST_BE_INITIALIZED_ERROR =
  "Braze must be initialized before calling methods.";
const GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT = 30;
const GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT = 30;
const LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT = 72e5;
const MAX_RETRY_COUNT_PER_REQUEST = 15;
const REQUEST_ATTEMPT_DEFAULT = 1;
const SUBSCRIPTION_ID_DATA_ATTRIBUTE = "data-update-subscription-id";


/***/ }),

/***/ 38430:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ impressOnTop; },
/* harmony export */   "Zw": function() { return /* binding */ impressOnBottom; },
/* harmony export */   "mP": function() { return /* binding */ detectImpression; },
/* harmony export */   "ql": function() { return /* binding */ topHadImpression; },
/* harmony export */   "rW": function() { return /* binding */ bottomHadImpression; }
/* harmony export */ });
/* unused harmony exports TOP_IMPRESSION_DATA_ATTRIBUTE, BOTTOM_IMPRESSION_DATA_ATTRIBUTE */
const TOP_IMPRESSION_DATA_ATTRIBUTE = "data-ab-had-top-impression";
const BOTTOM_IMPRESSION_DATA_ATTRIBUTE = "data-ab-had-bottom-impression";
function topHadImpression(o) {
  return null != o && !!o.getAttribute("data-ab-had-top-impression");
}
function impressOnTop(o) {
  null != o && o.setAttribute("data-ab-had-top-impression", "true");
}
function bottomHadImpression(o) {
  return null != o && !!o.getAttribute("data-ab-had-bottom-impression");
}
function impressOnBottom(o) {
  null != o && o.setAttribute("data-ab-had-bottom-impression", "true");
}
const detectImpression = {
  oo: topHadImpression,
  no: bottomHadImpression,
};


/***/ }),

/***/ 39179:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20335);
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88468);
/* harmony import */ var _models_braze_event_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57559);
/* harmony import */ var _models_request_result_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24673);




const c = {
  ut: (e, o, t) => {
    var n, s;
    const i = new _models_request_result_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(),
      l = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].P */ .ZP.P();
    if (!l)
      return (
        _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].info */ .Z.info(
          `Not logging event with type "${e}" because the current session ID could not be found.`,
        ),
        i
      );
    const d = l.Qo();
    return (
      i.$e.push(
        new _models_braze_event_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(
          t || (null === (n = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ir */ .ZP.ir()) || void 0 === n ? void 0 : n.getUserId()),
          e,
          new Date().valueOf(),
          d,
          o,
        ),
      ),
      (i.tt =
        (null === (s = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].j */ .ZP.j()) || void 0 === s ? void 0 : s.Vo(i.$e)) || !1),
      i
    );
  },
};
/* harmony default export */ __webpack_exports__["Z"] = (c);


/***/ }),

/***/ 10084:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GB": function() { return /* binding */ registerFeedSubscriptionId; },
/* harmony export */   "Of": function() { return /* binding */ updateFeedCards; },
/* harmony export */   "Yz": function() { return /* binding */ feedToHtml; },
/* harmony export */   "cP": function() { return /* binding */ LAST_REQUESTED_REFRESH_DATA_ATTRIBUTE; },
/* harmony export */   "cV": function() { return /* binding */ refreshFeed; },
/* harmony export */   "cz": function() { return /* binding */ detectFeedImpressions; },
/* harmony export */   "tQ": function() { return /* binding */ destroyFeedHtml; }
/* harmony export */ });
/* unused harmony exports SCROLL_LISTENER_ID, scrollListeners, generateFeedBody */
/* harmony import */ var _base_feed_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67);
/* harmony import */ var _Card_display_card_display_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35608);
/* harmony import */ var _util_dom_utils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11507);
/* harmony import */ var _Card_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85563);
/* harmony import */ var _Card_index_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72857);
/* harmony import */ var _util_code_utils_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72893);
/* harmony import */ var _util_key_codes_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7429);
/* harmony import */ var _l10n_l10n_manager_factory_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8731);
/* harmony import */ var _Core_remove_subscription_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18503);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20335);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57070);
/* harmony import */ var _util_validation_utils_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3905);
/* harmony import */ var _util_braze_actions_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73046);
/* harmony import */ var _detect_impression_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38430);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27671);














const LAST_REQUESTED_REFRESH_DATA_ATTRIBUTE =
  "data-last-requested-refresh";
const SCROLL_LISTENER_ID = "data-listener-id";
const scrollListeners = {};
function destroyFeedHtml(e) {
  e &&
    ((e.className = e.className.replace("ab-show", "ab-hide")),
    setTimeout(() => {
      e && e.parentNode && e.parentNode.removeChild(e);
    }, _base_feed_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Ih */ .Z.Ih));
  const t = e.getAttribute(_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SUBSCRIPTION_ID_DATA_ATTRIBUTE */ .k6);
  null != t && (0,_Core_remove_subscription_js__WEBPACK_IMPORTED_MODULE_2__/* .removeSubscription */ .A)(t);
  const o = e.getAttribute("data-listener-id");
  null != o &&
    (window.removeEventListener("scroll", scrollListeners[o]),
    delete scrollListeners[o]);
}
function generateFeedBody(e, t) {
  const o = _l10n_l10n_manager_factory_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ea */ .Z.ea(),
    s = document.createElement("div");
  if (
    ((s.className = "ab-feed-body"),
    s.setAttribute("aria-label", "Feed"),
    s.setAttribute("role", "feed"),
    null == e.lastUpdated)
  ) {
    const e = document.createElement("div");
    e.className = "ab-no-cards-message";
    const t = document.createElement("i");
    (t.className = "fa fa-spinner fa-spin fa-4x ab-initial-spinner"),
      e.appendChild(t),
      s.appendChild(e);
  } else {
    let n = !1;
    const logCardClick = (t) => e.logCardClick(t);
    for (const r of e.cards) {
      const i = r instanceof _Card_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
      !i || e.nr()
        ? (s.appendChild((0,_Card_display_card_display_js__WEBPACK_IMPORTED_MODULE_5__/* .cardToHtml */ .Dj)(r, logCardClick, t, o.Oo())), (n = n || !i))
        : _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].error */ .Z.error(
            "Received a control card for a legacy news feed. Control cards are only supported with content cards.",
          );
    }
    if (!n) {
      const e = document.createElement("div");
      (e.className = "ab-no-cards-message"),
        (e.innerHTML = o.get("NO_CARDS_MESSAGE") || ""),
        e.setAttribute("role", "article"),
        s.appendChild(e);
    }
  }
  return s;
}
function detectFeedImpressions(e, t) {
  if (null != e && null != t) {
    const o = [],
      s = t.querySelectorAll(".ab-card");
    e._o || (e._o = {});
    for (let t = 0; t < s.length; t++) {
      const n = (0,_Card_display_card_display_js__WEBPACK_IMPORTED_MODULE_5__/* .getCardId */ .sv)(s[t]),
        r = (0,_util_dom_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .topIsInView */ .rJ)(s[t]),
        i = (0,_util_dom_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .bottomIsInView */ .Fr)(s[t]);
      if (e._o[n]) {
        r || i || (0,_Card_display_card_display_js__WEBPACK_IMPORTED_MODULE_5__/* .markCardAsRead */ .pq)(s[t]);
        continue;
      }
      let a = (0,_detect_impression_js__WEBPACK_IMPORTED_MODULE_8__/* .topHadImpression */ .ql)(s[t]),
        d = (0,_detect_impression_js__WEBPACK_IMPORTED_MODULE_8__/* .bottomHadImpression */ .rW)(s[t]);
      const l = a,
        c = d;
      if (
        (!a && r && ((a = !0), (0,_detect_impression_js__WEBPACK_IMPORTED_MODULE_8__/* .impressOnTop */ .Ji)(s[t])), !d && i && ((d = !0), (0,_detect_impression_js__WEBPACK_IMPORTED_MODULE_8__/* .impressOnBottom */ .Zw)(s[t])), a && d)
      ) {
        if (l && c) continue;
        for (const t of e.cards)
          if (t.id === n) {
            (e._o[t.id] = !0), o.push(t);
            break;
          }
      }
    }
    o.length > 0 && e.logCardImpressions(o);
  }
}
function refreshFeed(e, t) {
  if (null == e || null == t) return;
  t.setAttribute("aria-busy", "true");
  const o = t.querySelectorAll(".ab-refresh-button")[0];
  null != o && (o.className += " fa-spin");
  const s = new Date().valueOf().toString();
  t.setAttribute("data-last-requested-refresh", s),
    setTimeout(() => {
      if (t.getAttribute("data-last-requested-refresh") === s) {
        const e = t.querySelectorAll(".fa-spin");
        for (let t = 0; t < e.length; t++)
          e[t].className = e[t].className.replace(/fa-spin/g, "");
        const o = t.querySelectorAll(".ab-initial-spinner")[0];
        if (null != o) {
          const e = document.createElement("span");
          (e.innerHTML = _l10n_l10n_manager_factory_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ea */ .Z.ea().get("FEED_TIMEOUT_MESSAGE") || ""),
            null != o.parentNode &&
              (o.parentNode.appendChild(e), o.parentNode.removeChild(o));
        }
        "true" === t.getAttribute("aria-busy") &&
          t.setAttribute("aria-busy", "false");
      }
    }, _base_feed_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Ro */ .Z.Ro),
    e.sr();
}
function feedToHtml(e, t, o) {
  const s = document.createElement("div");
  (s.className = "ab-feed ab-hide ab-effect-slide"),
    s.setAttribute("role", "dialog"),
    s.setAttribute("aria-label", "Feed"),
    s.setAttribute("tabindex", "-1");
  const n = document.createElement("div");
  (n.className = "ab-feed-buttons-wrapper"),
    n.setAttribute("role", "group"),
    s.appendChild(n);
  const r = document.createElement("i");
  (r.className = "fa fa-times ab-close-button"),
    r.setAttribute("aria-label", "Close Feed"),
    r.setAttribute("tabindex", "0"),
    r.setAttribute("role", "button");
  const i = (e) => {
    destroyFeedHtml(s), e.stopPropagation();
  };
  r.addEventListener("keydown", (e) => {
    (e.keyCode !== _util_key_codes_js__WEBPACK_IMPORTED_MODULE_9__/* .KeyCodes.Wo */ .m.Wo && e.keyCode !== _util_key_codes_js__WEBPACK_IMPORTED_MODULE_9__/* .KeyCodes.Xo */ .m.Xo) || i(e);
  }),
    (r.onclick = i);
  const a = document.createElement("i");
  (a.className = "fa fa-refresh ab-refresh-button"),
    e && null == e.lastUpdated && (a.className += " fa-spin"),
    a.setAttribute("aria-label", "Refresh Feed"),
    a.setAttribute("tabindex", "0"),
    a.setAttribute("role", "button");
  const d = (t) => {
    refreshFeed(e, s), t.stopPropagation();
  };
  a.addEventListener("keydown", (e) => {
    (e.keyCode !== _util_key_codes_js__WEBPACK_IMPORTED_MODULE_9__/* .KeyCodes.Wo */ .m.Wo && e.keyCode !== _util_key_codes_js__WEBPACK_IMPORTED_MODULE_9__/* .KeyCodes.Xo */ .m.Xo) || d(e);
  }),
    (a.onclick = d),
    n.appendChild(a),
    n.appendChild(r),
    s.appendChild(generateFeedBody(e, t));
  const l = () => detectFeedImpressions(e, s);
  if ((s.addEventListener("scroll", l), !o)) {
    window.addEventListener("scroll", l);
    const e = _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"].ce */ .Z.ce();
    (scrollListeners[e] = l), s.setAttribute("data-listener-id", e);
  }
  return s;
}
function updateFeedCards(e, t, o, s, n) {
  if (!(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_11__/* .isArray */ .kJ)(t)) return;
  const r = [];
  for (const e of t)
    if (e instanceof _Card_index_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z) {
      if (e.url && _util_validation_utils_js__WEBPACK_IMPORTED_MODULE_13__/* .BRAZE_ACTION_URI_REGEX.test */ .y9.test(e.url)) {
        const t = (0,_util_braze_actions_js__WEBPACK_IMPORTED_MODULE_14__/* .getDecodedBrazeAction */ .OL)(e.url);
        if ((0,_util_braze_actions_js__WEBPACK_IMPORTED_MODULE_14__/* .containsUnknownBrazeAction */ .je)(t)) {
          _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].error */ .Z.error((0,_util_braze_actions_js__WEBPACK_IMPORTED_MODULE_14__/* .ineligibleBrazeActionURLErrorMessage */ .Tu)(_util_braze_actions_js__WEBPACK_IMPORTED_MODULE_14__/* .INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Tr */ .yi.Tr, "Content Card"));
          continue;
        }
      }
      r.push(e);
    }
  if (((e.cards = r), (e.lastUpdated = o), null != s))
    if ((s.setAttribute("aria-busy", "false"), null == e.lastUpdated))
      destroyFeedHtml(s);
    else {
      const t = s.querySelectorAll(".ab-feed-body")[0];
      if (null != t) {
        const o = generateFeedBody(e, n);
        t.parentNode && t.parentNode.replaceChild(o, t),
          detectFeedImpressions(e, o.parentNode);
      }
    }
}
function registerFeedSubscriptionId(e, t) {
  e && t.setAttribute(_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SUBSCRIPTION_ID_DATA_ATTRIBUTE */ .k6, e);
}


/***/ }),

/***/ 65943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Banner": function() { return /* reexport */ Banner; },
  "BrazeSdkMetadata": function() { return /* reexport */ braze_sdk_metadata; },
  "CaptionedImage": function() { return /* reexport */ captioned_image/* default */.Z; },
  "Card": function() { return /* reexport */ card/* default */.Z; },
  "ClassicCard": function() { return /* reexport */ classic_card/* default */.Z; },
  "ContentCards": function() { return /* reexport */ content_cards/* default */.Z; },
  "ControlCard": function() { return /* reexport */ control_card/* default */.Z; },
  "ControlMessage": function() { return /* reexport */ control_message/* default */.Z; },
  "DeviceProperties": function() { return /* reexport */ device_properties/* default */.Z; },
  "FeatureFlag": function() { return /* reexport */ feature_flag/* default */.Z; },
  "Feed": function() { return /* reexport */ feed/* default */.Z; },
  "FullScreenMessage": function() { return /* reexport */ full_screen_message/* default */.Z; },
  "HtmlMessage": function() { return /* reexport */ html_message/* default */.Z; },
  "ImageOnly": function() { return /* reexport */ image_only/* default */.Z; },
  "InAppMessage": function() { return /* reexport */ in_app_message/* default */.Z; },
  "InAppMessageButton": function() { return /* reexport */ in_app_message_button/* default */.Z; },
  "ModalMessage": function() { return /* reexport */ modal_message/* default */.Z; },
  "SlideUpMessage": function() { return /* reexport */ slide_up_message/* default */.Z; },
  "User": function() { return /* reexport */ user/* default */.Z; },
  "WindowUtils": function() { return /* reexport */ window_utils/* WindowUtils */.SD; },
  "addSdkMetadata": function() { return /* reexport */ addSdkMetadata; },
  "automaticallyShowInAppMessages": function() { return /* reexport */ automatically_show_in_app_messages/* automaticallyShowInAppMessages */.f; },
  "changeUser": function() { return /* reexport */ change_user.changeUser; },
  "deferInAppMessage": function() { return /* reexport */ deferInAppMessage; },
  "destroy": function() { return /* reexport */ destroy; },
  "destroyFeed": function() { return /* reexport */ destroyFeed; },
  "disableSDK": function() { return /* reexport */ disableSDK; },
  "enableSDK": function() { return /* reexport */ enableSDK; },
  "getAllBanners": function() { return /* reexport */ getAllBanners; },
  "getAllFeatureFlags": function() { return /* reexport */ getAllFeatureFlags; },
  "getBanner": function() { return /* reexport */ getBanner; },
  "getCachedContentCards": function() { return /* reexport */ getCachedContentCards; },
  "getCachedFeed": function() { return /* reexport */ getCachedFeed; },
  "getDeferredInAppMessage": function() { return /* reexport */ getDeferredInAppMessage; },
  "getDeviceId": function() { return /* reexport */ getDeviceId; },
  "getFeatureFlag": function() { return /* reexport */ getFeatureFlag; },
  "getUser": function() { return /* reexport */ get_user/* getUser */.P; },
  "handleBrazeAction": function() { return /* reexport */ handle_braze_action/* handleBrazeAction */.h; },
  "hideContentCards": function() { return /* reexport */ hideContentCards; },
  "initialize": function() { return /* reexport */ initialize/* initialize */.j; },
  "insertBanner": function() { return /* reexport */ insertBanner; },
  "isDisabled": function() { return /* reexport */ isDisabled; },
  "isInitialized": function() { return /* reexport */ isInitialized; },
  "isPushBlocked": function() { return /* reexport */ isPushBlocked; },
  "isPushPermissionGranted": function() { return /* reexport */ isPushPermissionGranted; },
  "isPushSupported": function() { return /* reexport */ is_push_supported/* isPushSupported */.H; },
  "logBannerImpressions": function() { return /* reexport */ logBannerImpressions; },
  "logCardClick": function() { return /* reexport */ log_card_click/* logCardClick */.d; },
  "logCardDismissal": function() { return /* reexport */ log_card_dismissal/* logCardDismissal */.K; },
  "logCardImpressions": function() { return /* reexport */ log_card_impressions/* logCardImpressions */.p; },
  "logContentCardClick": function() { return /* reexport */ logContentCardClick; },
  "logContentCardImpressions": function() { return /* reexport */ logContentCardImpressions; },
  "logCustomEvent": function() { return /* reexport */ log_custom_event.logCustomEvent; },
  "logFeatureFlagImpression": function() { return /* reexport */ logFeatureFlagImpression; },
  "logFeedDisplayed": function() { return /* reexport */ log_feed_displayed/* logFeedDisplayed */.j; },
  "logInAppMessageButtonClick": function() { return /* reexport */ log_in_app_message_button_click/* logInAppMessageButtonClick */.S; },
  "logInAppMessageClick": function() { return /* reexport */ log_in_app_message_click/* logInAppMessageClick */.W; },
  "logInAppMessageHtmlClick": function() { return /* reexport */ log_in_app_message_html_click/* logInAppMessageHtmlClick */.U; },
  "logInAppMessageImpression": function() { return /* reexport */ log_in_app_message_impression/* logInAppMessageImpression */.v; },
  "logPurchase": function() { return /* reexport */ log_purchase.logPurchase; },
  "openSession": function() { return /* reexport */ open_session/* openSession */.U; },
  "refreshFeatureFlags": function() { return /* reexport */ refresh_feature_flags.refreshFeatureFlags; },
  "removeAllSubscriptions": function() { return /* reexport */ removeAllSubscriptions; },
  "removeSubscription": function() { return /* reexport */ remove_subscription/* removeSubscription */.A; },
  "requestBannersRefresh": function() { return /* reexport */ requestBannersRefresh; },
  "requestContentCardsRefresh": function() { return /* reexport */ request_content_cards_refresh/* requestContentCardsRefresh */.v; },
  "requestFeedRefresh": function() { return /* reexport */ request_feed_refresh/* requestFeedRefresh */.a; },
  "requestImmediateDataFlush": function() { return /* reexport */ request_immediate_data_flush.requestImmediateDataFlush; },
  "requestPushPermission": function() { return /* reexport */ request_push_permission.requestPushPermission; },
  "setLogger": function() { return /* reexport */ setLogger; },
  "setSdkAuthenticationSignature": function() { return /* reexport */ setSdkAuthenticationSignature; },
  "showContentCards": function() { return /* reexport */ showContentCards; },
  "showFeed": function() { return /* reexport */ show_feed.showFeed; },
  "showInAppMessage": function() { return /* reexport */ show_in_app_message/* showInAppMessage */.g; },
  "subscribeToBannersUpdates": function() { return /* reexport */ subscribeToBannersUpdates; },
  "subscribeToContentCardsUpdates": function() { return /* reexport */ subscribe_to_content_cards_updates/* subscribeToContentCardsUpdates */.x; },
  "subscribeToFeatureFlagsUpdates": function() { return /* reexport */ subscribeToFeatureFlagsUpdates; },
  "subscribeToFeedUpdates": function() { return /* reexport */ subscribe_to_feed_updates/* subscribeToFeedUpdates */.n; },
  "subscribeToInAppMessage": function() { return /* reexport */ subscribe_to_in_app_message/* subscribeToInAppMessage */.u; },
  "subscribeToSdkAuthenticationFailures": function() { return /* reexport */ subscribeToSdkAuthenticationFailures; },
  "toggleContentCards": function() { return /* reexport */ toggleContentCards; },
  "toggleFeed": function() { return /* reexport */ toggleFeed; },
  "toggleLogging": function() { return /* reexport */ toggleLogging; },
  "unregisterPush": function() { return /* reexport */ unregister_push.unregisterPush; },
  "wipeData": function() { return /* reexport */ wipeData; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/models/card.js
var card = __webpack_require__(72857);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/models/image-only.js
var image_only = __webpack_require__(8378);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/models/captioned-image.js
var captioned_image = __webpack_require__(5383);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/models/classic-card.js
var classic_card = __webpack_require__(37653);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/models/control-card.js
var control_card = __webpack_require__(85563);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Card/models/index.js






// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/log-card-click.js
var log_card_click = __webpack_require__(1280);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/log-card-dismissal.js
var log_card_dismissal = __webpack_require__(22080);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/log-card-impressions.js
var log_card_impressions = __webpack_require__(11066);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Card/log-content-card-impressions.js

function logContentCardImpressions(o) {
  return (0,log_card_impressions/* logCardImpressions */.p)(o, !0);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Card/log-content-card-click.js

function logContentCardClick(o) {
  return (0,log_card_click/* logCardClick */.d)(o, !0);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Card/index.js







// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/content-cards.js
var content_cards = __webpack_require__(82028);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/content-cards-provider-factory.js + 1 modules
var content_cards_provider_factory = __webpack_require__(1627);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/get-cached-content-cards.js


function getCachedContentCards() {
  if (braze_instance/* default.rr */.ZP.rr()) return content_cards_provider_factory/* default.m */.Z.m().pi(!1);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/feed-display.js
var feed_display = __webpack_require__(10084);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/ui/hide-content-cards.js


function hideContentCards(e) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const n = document.querySelectorAll(".ab-feed");
  for (let o = 0; o < n.length; o++)
    (null == e || (null != e && n[o].parentNode === e)) && (0,feed_display/* destroyFeedHtml */.tQ)(n[o]);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/request-content-cards-refresh.js
var request_content_cards_refresh = __webpack_require__(28863);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/subscribe-to-content-cards-updates.js
var subscribe_to_content_cards_updates = __webpack_require__(49954);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Card/display/card-display.js
var card_display = __webpack_require__(35608);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ui/js/feed-css.js
var feed_css = __webpack_require__(46959);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/ui/show-content-cards.js







function showContentCards(n, t) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  (0,feed_css/* setupFeedUI */.B)();
  let e = !1;
  null == n && ((n = document.body), (e = !0));
  const o = braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.tn */.JY.tn) || braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.en */.JY.en) || !1,
    i = content_cards_provider_factory/* default.m */.Z.m().pi(!1);
  "function" == typeof t && (0,feed_display/* updateFeedCards */.Of)(i, t(i.cards.slice()), i.lastUpdated, null, o);
  const a = (0,feed_display/* feedToHtml */.Yz)(i, o, e),
    s = content_cards_provider_factory/* default.m */.Z.m(),
    f = s.Gs();
  (null == i.lastUpdated ||
    new Date().valueOf() - i.lastUpdated.valueOf() > content_cards/* default.dr */.Z.dr) &&
    (null == f || new Date().valueOf() - f > content_cards/* default.dr */.Z.dr) &&
    (logger/* default.info */.Z.info(
      `Cached content cards were older than max TTL of ${content_cards/* default.dr */.Z.dr} ms, requesting an update from the server.`,
    ),
    (0,feed_display/* refreshFeed */.cV)(i, a),
    s.Hs(new Date().valueOf()));
  const l = new Date().valueOf(),
    c = (0,subscribe_to_content_cards_updates/* subscribeToContentCardsUpdates */.x)(function (n) {
      const e = a.querySelectorAll(".ab-refresh-button")[0];
      if (null != e) {
        let n = 500,
          t = (n -= new Date().valueOf() - l);
        const o = a.getAttribute(feed_display/* LAST_REQUESTED_REFRESH_DATA_ATTRIBUTE */.cP);
        o && ((t = parseInt(o)), isNaN(t) || (n -= new Date().valueOf() - t)),
          setTimeout(
            function () {
              e.className = e.className.replace(/fa-spin/g, "");
            },
            Math.max(n, 0),
          );
      }
      let r = n.cards;
      "function" == typeof t && (r = t(r.slice())),
        (0,feed_display/* updateFeedCards */.Of)(i, r, n.lastUpdated, a, o);
    });
  (0,feed_display/* registerFeedSubscriptionId */.GB)(c, a);
  const u = function (n) {
    const t = n.querySelectorAll(".ab-feed");
    let o = null;
    for (let e = 0; e < t.length; e++) t[e].parentNode === n && (o = t[e]);
    null != o
      ? ((0,feed_display/* destroyFeedHtml */.tQ)(o), null != o.parentNode && o.parentNode.replaceChild(a, o))
      : n.appendChild(a),
      setTimeout(function () {
        a.className = a.className.replace("ab-hide", "ab-show");
      }, 0),
      e && a.focus(),
      (0,feed_display/* detectFeedImpressions */.cz)(i, a),
      (0,card_display/* setCardHeight */.CG)(i.cards, n);
  };
  var d;
  null != n
    ? u(n)
    : (window.onload =
        ((d = window.onload),
        function () {
          "function" == typeof d && d(new Event("oldLoad")), u(document.body);
        }));
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/ui/toggle-content-cards.js


function toggleContentCards(e, n) {
  braze_instance/* default.rr */.ZP.rr() &&
    (document.querySelectorAll(".ab-feed").length > 0
      ? hideContentCards()
      : showContentCards(e, n));
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/index.js








;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/braze-sdk-metadata.js
/* harmony default export */ var braze_sdk_metadata = ({
  GOOGLE_TAG_MANAGER: "gg",
  MPARTICLE: "mp",
  SEGMENT: "sg",
  TEALIUM: "tl",
  MANUAL: "manu",
  NPM: "npm",
  CDN: "wcd",
  SHOPIFY: "shp",
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/code-utils.js
var code_utils = __webpack_require__(72893);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/add-sdk-metadata.js




function addSdkMetadata(a) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const t = braze_instance/* default.g */.ZP.g();
  if (t) {
    if (!(0,code_utils/* isArray */.kJ)(a))
      return (
        logger/* default.error */.Z.error("Cannot set SDK metadata because metadata is not an array."), !1
      );
    for (const t of a)
      if (
        !(0,code_utils/* validateValueIsFromEnum */.fk)(
          braze_sdk_metadata,
          t,
          "sdkMetadata contained an invalid value.",
          "BrazeSdkMetadata",
        )
      )
        return !1;
    return t.addSdkMetadata(a), !0;
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/change-user.js
var change_user = __webpack_require__(34790);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/destroy.js


function destroy() {
  logger/* default.info */.Z.info("Destroying Braze instance"), braze_instance/* default.destroy */.ZP.destroy(!0);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/device-properties.js
var device_properties = __webpack_require__(12017);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/indexed-db-adapter.js
var indexed_db_adapter = __webpack_require__(45522);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/disable-sdk.js



function disableSDK() {
  const e = braze_instance/* default.nn */.ZP.nn();
  e && e.requestImmediateDataFlush();
  const n = new storage_manager/* default.se */.Z.se(null, !0),
    a = "This-cookie-will-expire-in-" + n.le();
  n.store(storage_manager/* STORAGE_KEYS.me */.I.me, a);
  const i = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs;
  new indexed_db_adapter/* default */.Z(i, logger/* default */.Z).setItem(i.Ms.pe, i.be, !0),
    logger/* default.info */.Z.info("disableSDK was called"),
    braze_instance/* default.destroy */.ZP.destroy(!1),
    braze_instance/* default.fe */.ZP.fe(!0);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/enable-sdk.js



function enableSDK() {
  new storage_manager/* default.se */.Z.se(null, !0).remove(storage_manager/* STORAGE_KEYS.me */.I.me);
  const e = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs;
  new indexed_db_adapter/* default */.Z(e, logger/* default */.Z).ge(e.Ms.pe, e.be),
    logger/* default.info */.Z.info("enableSDK was called"),
    braze_instance/* default.destroy */.ZP.destroy(!1),
    braze_instance/* default.fe */.ZP.fe(!1);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/get-device-id.js


function getDeviceId(e) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const t = braze_instance/* default.ue */.ZP.ue();
  if (!t) return;
  const i = t.ve().id;
  if ("function" != typeof e) return i;
  logger/* default.warn */.Z.warn(
    "The callback for getDeviceId is deprecated. You can access its return value directly instead (e.g. `const id = braze.getDeviceId()`)",
  ),
    e(i);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/get-user.js
var get_user = __webpack_require__(46243);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/initialize.js
var initialize = __webpack_require__(69390);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/is-disabled.js

function isDisabled() {
  return !!new storage_manager/* default.se */.Z.se(null, !0).gr(storage_manager/* STORAGE_KEYS.me */.I.me);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/is-initialized.js

function isInitialized() {
  return braze_instance/* default._t */.ZP._t();
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/log-custom-event.js
var log_custom_event = __webpack_require__(61454);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/log-purchase.js
var log_purchase = __webpack_require__(61364);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/open-session.js
var open_session = __webpack_require__(45430);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/remove-all-subscriptions.js

function removeAllSubscriptions() {
  braze_instance/* default.rr */.ZP.rr() && braze_instance/* default.removeAllSubscriptions */.ZP.removeAllSubscriptions();
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/remove-subscription.js
var remove_subscription = __webpack_require__(18503);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/request-immediate-data-flush.js
var request_immediate_data_flush = __webpack_require__(64650);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/set-logger.js

function setLogger(e) {
  logger/* default.setLogger */.Z.setLogger(e);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/validation-utils.js
var validation_utils = __webpack_require__(3905);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/set-sdk-authentication-signature.js


function setSdkAuthenticationSignature(t) {
  if (!braze_instance/* default.rr */.ZP.rr()) return !1;
  if ("" === t || !(0,validation_utils/* validateStandardString */.ro)(t, "set signature", "signature", !1)) return !1;
  const i = braze_instance/* default.Sr */.ZP.Sr();
  return !!i && (i.setSdkAuthenticationSignature(t), !0);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/subscribe-to-sdk-authentication-failures.js

function subscribeToSdkAuthenticationFailures(i) {
  var n;
  if (braze_instance/* default.rr */.ZP.rr())
    return null === (n = braze_instance/* default.Sr */.ZP.Sr()) || void 0 === n
      ? void 0
      : n.subscribeToSdkAuthenticationFailures(i);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/toggle-logging.js

function toggleLogging() {
  logger/* default.toggleLogging */.Z.toggleLogging();
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/constants.js
var constants = __webpack_require__(27671);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/wipe-data.js




function wipeData() {
  const o = braze_instance/* default.j */.ZP.j();
  if (null == o) return void logger/* default.warn */.Z.warn(constants/* BRAZE_MUST_BE_INITIALIZED_ERROR */.Go);
  o.clearData();
  const t = (0,code_utils/* keys */.XP)(indexed_db_adapter/* default.Ls */.Z.Ls);
  for (let o = 0; o < t.length; o++) {
    const n = t[o],
      r = indexed_db_adapter/* default.Ls */.Z.Ls[n];
    new indexed_db_adapter/* default */.Z(r, logger/* default */.Z).clearData();
  }
  if (braze_instance/* default.rr */.ZP.rr()) for (const o of braze_instance/* default.ar */.ZP.ar()) o.clearData(!0);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/handle-braze-action.js
var handle_braze_action = __webpack_require__(40420);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Core/index.js

























// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Feed/feed.js
var feed = __webpack_require__(83628);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Feed/feed-provider-factory.js + 1 modules
var feed_provider_factory = __webpack_require__(32075);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Feed/get-cached-feed.js


function getCachedFeed() {
  if (braze_instance/* default.rr */.ZP.rr()) return feed_provider_factory/* default.m */.Z.m().Bi();
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Feed/ui/hide-feed.js


function destroyFeed() {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const e = document.querySelectorAll(".ab-feed");
  for (let o = 0; o < e.length; o++) (0,feed_display/* destroyFeedHtml */.tQ)(e[o]);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Feed/log-feed-displayed.js
var log_feed_displayed = __webpack_require__(46599);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Feed/request-feed-refresh.js
var request_feed_refresh = __webpack_require__(83516);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Feed/ui/show-feed.js
var show_feed = __webpack_require__(33545);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Feed/subscribe-to-feed-updates.js
var subscribe_to_feed_updates = __webpack_require__(96596);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Feed/ui/toggle-feed.js


function toggleFeed(e, o, n) {
  braze_instance/* default.rr */.ZP.rr() &&
    (document.querySelectorAll(".ab-feed").length > 0
      ? destroyFeed()
      : (0,show_feed.showFeed)(e, o, n));
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Feed/index.js









// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/in-app-message.js
var in_app_message = __webpack_require__(1792);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/in-app-message-button.js
var in_app_message_button = __webpack_require__(84072);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/control-message.js
var control_message = __webpack_require__(98376);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/full-screen-message.js
var full_screen_message = __webpack_require__(4410);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/html-message.js
var html_message = __webpack_require__(31090);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/modal-message.js
var modal_message = __webpack_require__(3811);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/slide-up-message.js
var slide_up_message = __webpack_require__(26616);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/ui/automatically-show-in-app-messages.js
var automatically_show_in_app_messages = __webpack_require__(73659);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/log-in-app-message-button-click.js
var log_in_app_message_button_click = __webpack_require__(35896);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/log-in-app-message-click.js
var log_in_app_message_click = __webpack_require__(94945);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/log-in-app-message-html-click.js
var log_in_app_message_html_click = __webpack_require__(35746);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/log-in-app-message-impression.js
var log_in_app_message_impression = __webpack_require__(39517);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/ui/show-in-app-message.js + 6 modules
var show_in_app_message = __webpack_require__(78914);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/subscribe-to-in-app-message.js
var subscribe_to_in_app_message = __webpack_require__(30174);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/in-app-message-manager-factory.js + 1 modules
var in_app_message_manager_factory = __webpack_require__(79602);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/defer-in-app-message.js





function deferInAppMessage(e) {
  if (braze_instance/* default.rr */.ZP.rr())
    return e instanceof control_message/* default */.Z
      ? (logger/* default.info */.Z.info("Not deferring since this is a ControlMessage."), !1)
      : e instanceof in_app_message/* default */.Z
      ? in_app_message_manager_factory/* default.ea */.Z.ea().sn(e)
      : (logger/* default.info */.Z.info("Not an instance of InAppMessage, ignoring."), !1);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/get-deferred-in-app-message.js


function getDeferredInAppMessage() {
  if (braze_instance/* default.rr */.ZP.rr()) return in_app_message_manager_factory/* default.ea */.Z.ea().Ar();
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/index.js

















// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/utils/push-utils.js
var push_utils = __webpack_require__(74556);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Push/is-push-blocked.js


function isPushBlocked() {
  if (braze_instance/* default.rr */.ZP.rr()) return push_utils/* default.isPushBlocked */.Z.isPushBlocked();
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Push/is-push-permission-granted.js


function isPushPermissionGranted() {
  if (braze_instance/* default.rr */.ZP.rr()) return push_utils/* default.isPushPermissionGranted */.Z.isPushPermissionGranted();
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/is-push-supported.js
var is_push_supported = __webpack_require__(47733);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/request-push-permission.js
var request_push_permission = __webpack_require__(12261);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/unregister-push.js
var unregister_push = __webpack_require__(77824);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Push/index.js






// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/User/user.js
var user = __webpack_require__(17615);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/User/index.js


// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/feature-flag.js
var feature_flag = __webpack_require__(12962);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/refresh-feature-flags.js
var refresh_feature_flags = __webpack_require__(992);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/feature-flags-provider-factory.js + 2 modules
var feature_flags_provider_factory = __webpack_require__(75219);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/get-feature-flag.js


function getFeatureFlag(t) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const e = braze_instance/* default.v */.ZP.v();
  if (e && !e.Be()) return null;
  const n = feature_flags_provider_factory/* default.m */.Z.m().Ue();
  return n[t] ? n[t] : null;
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/get-all-feature-flags.js


function getAllFeatureFlags() {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const t = [],
    e = braze_instance/* default.v */.ZP.v();
  if (e && !e.Be()) return t;
  const n = feature_flags_provider_factory/* default.m */.Z.m().Ue();
  for (const r in n) t.push(n[r]);
  return t;
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/subscribe-to-feature-flags-updates.js



function subscribeToFeatureFlagsUpdates(t) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const e = feature_flags_provider_factory/* default.m */.Z.m();
  if (e.Ye()) {
    const r = getAllFeatureFlags();
    r && "function" == typeof t && t(r);
  }
  return e.qt(t);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/event-types.js
var event_types = __webpack_require__(12730);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/event-logger.js
var event_logger = __webpack_require__(39179);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/log-feature-flag-impression.js




function logFeatureFlagImpression(e) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  if (!e) return !1;
  const t =
      "Not logging a feature flag impression. The feature flag was not part of any matching experiment.",
    o = feature_flags_provider_factory/* default.m */.Z.m().Ue();
  if (!o[e]) return logger/* default.info */.Z.info(t), !1;
  const n = o[e].trackingString;
  if (!n) return logger/* default.info */.Z.info(t), !1;
  const i = feature_flags_provider_factory/* default.m */.Z.m()._e();
  if (i[n])
    return (
      logger/* default.info */.Z.info(
        "Not logging another feature flag impression. This ID was already logged this session.",
      ),
      !1
    );
  (i[n] = !0), feature_flags_provider_factory/* default.m */.Z.m().He(i);
  const s = { fid: e, fts: n };
  return event_logger/* default.ut */.Z.ut(event_types/* EventTypes.yr */.G.yr, s).tt;
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/FeatureFlags/index.js







;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/banner.js
class Banner {
  constructor(t, i, s, h = !1, r = !1, e = -1) {
    (this.id = t),
      (this.placementId = i),
      (this.html = s),
      (this.At = h),
      (this.isControl = r),
      (this.Gt = e),
      (this.id = t),
      (this.placementId = i),
      (this.html = s),
      (this.At = h),
      (this.isControl = r),
      (this.Gt = e),
      (this.Ht = !1);
  }
  Jt() {
    return this.isControl;
  }
  bt() {
    return {
      id: this.id,
      o: this.placementId,
      html: this.html,
      t: this.At,
      i: this.isControl,
      u: this.Gt,
    };
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/base-provider.js
var base_provider = __webpack_require__(40158);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/banner-factory.js

function newBannerFromSerializedValue(n) {
  return new Banner(n.id, n.o, n.html, n.t, n.i, n.u);
}
function newBannerFromJson(n) {
  return new Banner(
    n.id,
    n.placement_id,
    n.html,
    n.is_test_send,
    n.is_control,
    n.expires_at,
  );
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/request-header-utils.js
var request_header_utils = __webpack_require__(76870);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/net.js
var net = __webpack_require__(41843);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/math.js
var math = __webpack_require__(96504);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/subscription-manager.js
var subscription_manager = __webpack_require__(74663);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/banner-provider.js










class e extends base_provider/* default */.Z {
  constructor(t, s, i, e) {
    super(),
      (this.B = t),
      (this.S = s),
      (this.C = i),
      (this.T = e),
      (this.banners = {}),
      (this.B = t),
      (this.S = s),
      (this.C = i),
      (this.T = e),
      (this.R = 10),
      (this.I = null),
      (this.q = null),
      (this.F = new subscription_manager/* default */.Z()),
      braze_instance/* default.N */.ZP.N(this.F),
      (this.k = null),
      (this.D = null);
  }
  U(t) {
    if (this.L() && null != t && t.banners) {
      this.banners = {};
      const s = t.banners;
      for (const t in s) {
        const i = s[t];
        let e = null;
        null != i && null != i.banner && (e = newBannerFromJson(i.banner)),
          e && (this.banners[t] = e);
      }
      this.M(), this.F.X(this.banners);
    }
  }
  $(t, s, i, e = !0) {
    var n;
    const r = () => {
      "function" == typeof i && i();
    };
    if (!this.L())
      return void (
        null === (n = this.B) ||
        void 0 === n ||
        n.A(() => {
          this.$(t, s, i);
        })
      );
    const o = this.S;
    if (!o) return void r();
    e && this.G();
    const u = o.H({}, !0),
      c = [];
    for (const s of t) c.push({ id: s });
    u.placements = c;
    const d = o.J(u, request_header_utils/* default.O.K */.Z.O.K);
    let m = !1;
    o.V(
      u,
      (e = -1) => {
        const n = this.S;
        if (!n) return void r();
        const o = new Date().valueOf();
        request_header_utils/* default.W */.Z.W(this.C, request_header_utils/* default.O.K */.Z.O.K, o),
          -1 !== e && d.push(["X-Braze-Req-Tokens-Remaining", e.toString()]),
          net/* default.Y */.Z.Y({
            url: `${n.Z()}/banners/sync`,
            headers: d,
            data: u,
            tt: (t) => {
              if (!n.st(u, t, d)) return (m = !0), void r();
              n.it(), this.U(t), (m = !1), "function" == typeof s && s();
            },
            error: (t) => {
              n.et(t, "retrieving banners"), (m = !0), r();
            },
            nt: (e, r) => {
              let o;
              if (((this.D = t), m)) {
                let t = this.I;
                (null == t || t < 1e3 * this.R) && (t = 1e3 * this.R),
                  (o = Math.min(3e5, (0,math/* randomInclusive */.R)(1e3 * this.R, 3 * t)));
              }
              n.rt(
                r,
                () => {
                  this.$(t, s, i, !1);
                },
                request_header_utils/* default.O.K */.Z.O.K,
                (t) => this.ot(t),
                () => this.G(),
                o,
              );
            },
          });
      },
      request_header_utils/* default.O.K */.Z.O.K,
      i,
    );
  }
  ht() {
    return this.D;
  }
  lt(t, s) {
    const i = { id: t.id };
    s && (i.bid = s);
    return event_logger/* default.ut */.Z.ut(event_types/* EventTypes.ct */.G.ct, i).tt;
  }
  G() {
    null != this.q && (clearTimeout(this.q), (this.q = null));
  }
  ot(t) {
    this.G(), (this.q = t);
  }
  dt() {
    let t = {};
    this.C && (t = this.C.ft(storage_manager/* STORAGE_KEYS.gt.vt */.I.gt.vt));
    const i = {};
    for (const s in t) {
      let e = null;
      null != t[s] && (e = newBannerFromSerializedValue(t[s])), e && (i[e.placementId] = e);
    }
    return i;
  }
  M() {
    var t;
    if (!this.C) return;
    const i = {};
    for (const s in this.banners) {
      const e =
        (null === (t = this.banners[s]) || void 0 === t ? void 0 : t.bt()) ||
        null;
      i[s] = e;
    }
    this.C.Bt(storage_manager/* STORAGE_KEYS.gt.vt */.I.gt.vt, i), this.jt();
  }
  jt() {
    var t, i;
    null === (t = this.C) ||
      void 0 === t ||
      t.Bt(storage_manager/* STORAGE_KEYS.gt.yt */.I.gt.yt, null === (i = this.T) || void 0 === i ? void 0 : i.St());
  }
  wt() {
    var t;
    return (
      (null === (t = this.C) || void 0 === t ? void 0 : t.ft(storage_manager/* STORAGE_KEYS.gt.yt */.I.gt.yt)) || null
    );
  }
  Ct() {
    return this.k;
  }
  Tt(t) {
    this.k = t;
  }
  Rt() {
    var t;
    const s = null === (t = this.T) || void 0 === t ? void 0 : t.St(),
      i = this.wt();
    return null != i && s === i;
  }
  It() {
    var t;
    const s = null === (t = this.T) || void 0 === t ? void 0 : t.St(),
      i = this.wt();
    return null == i || s === i;
  }
  qt(t) {
    return this.F.Ft(t);
  }
  Nt() {
    var t;
    return (
      (null === (t = this.C) || void 0 === t ? void 0 : t.ft(storage_manager/* STORAGE_KEYS.gt.kt */.I.gt.kt)) || {}
    );
  }
  xt(t) {
    this.C && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.kt */.I.gt.kt, t);
  }
  changeUser() {
    this.zt();
  }
  L() {
    return !!this.B && (!!this.B.Dt() || (0 !== this.B.Et() && this.zt(), !1));
  }
  zt() {
    (this.banners = {}),
      this.C && (this.C.Ut(storage_manager/* STORAGE_KEYS.gt.vt */.I.gt.vt), this.C.Ut(storage_manager/* STORAGE_KEYS.gt.kt */.I.gt.kt)),
      this.F.X({});
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/banner-provider-factory.js


const i = {
  l: !1,
  provider: null,
  m: () => (
    i.p(),
    i.provider ||
      ((i.provider = new e(braze_instance/* default.v */.ZP.v(), braze_instance/* default.g */.ZP.g(), braze_instance/* default.j */.ZP.j(), braze_instance/* default.P */.ZP.P())), braze_instance/* default._ */.ZP._(i.provider)),
    i.provider
  ),
  p: () => {
    i.l || (braze_instance/* default.h */.ZP.h(i), (i.l = !0));
  },
  destroy: () => {
    (i.provider = null), (i.l = !1);
  },
};
/* harmony default export */ var banner_provider_factory = (i);

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/get-banner.js



function getBannerIfNotExpired(n, r) {
  const e = n[r];
  if (!e) return null;
  const t = e.Gt,
    o = new Date().valueOf();
  return -1 !== t && 1e3 * t < o
    ? (logger/* default.info */.Z.info(`Banner with ID: ${e.id} and placement ID: ${r} has expired.`),
      null)
    : e;
}
function getBanner(n) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const e = banner_provider_factory.m();
  if (!e.L()) return null;
  return getBannerIfNotExpired(e.dt(), n);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ui/js/attach-css.js
var attach_css = __webpack_require__(95333);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/ui/js/banner-css.js

function attachBannerCSS(n) {
  (0,attach_css/* attachCSS */.e)(
    n,
    "banner",
    ".ab-html-banner{width:100%;height:100%;border:none}.ab-html-control-banner{width:0;height:0;margin:0;border:none}",
  );
}
function setupBannerUI() {
  attachBannerCSS();
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/dom-utils.js
var dom_utils = __webpack_require__(11507);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/html-display-utils.js
var html_display_utils = __webpack_require__(71177);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/log-banner-click.js





function logBannerClick(n, o) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  if (!(n instanceof Banner))
    return (
      logger/* default.error */.Z.error("Banner argument to logBannerClick must be an Banner object."), !1
    );
  const e = banner_provider_factory.m(),
    t = e.dt();
  return 0 === (0,code_utils/* keys */.XP)(t).length
    ? (logger/* default.info */.Z.info("Not logging banner click. No banners exist."), !1)
    : t[n.placementId]
    ? e.lt(n, o)
    : (logger/* default.info */.Z.info(
        `Not logging banner click for ID ${n.placementId}. The placement ID did not correspond to any banner.`,
      ),
      !1);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/display/banner-to-html.js





const BANNER_PLACEMENT_ID = "data-ab-banner-placement-id";
const BANNER_HTML_CLASS = "ab-html-banner";
const CONTROL_BANNER_HTML_CLASS = "ab-html-control-banner";
function controlBannerToHtml(t) {
  const n = document.createElement("div");
  return (
    (n.id = t.id),
    (n.className = "ab-html-control-banner"),
    n.setAttribute(BANNER_PLACEMENT_ID, t.placementId),
    n
  );
}
function bannerToHtml(t, n) {
  if (t.Jt()) return controlBannerToHtml(t);
  const o = document.createElement("iframe");
  return (
    (o.id = t.id),
    n && o.setAttribute("nonce", n),
    (o.className = "ab-html-banner"),
    o.setAttribute(BANNER_PLACEMENT_ID, t.placementId),
    o.setAttribute("title", "Banner"),
    (0,html_display_utils/* attachHtmlToIframeWithNonce */.Bl)(o, t.html, n),
    (o.onload = () => {
      const n = o.contentWindow,
        e = n.document.getElementsByTagName("title");
      e && e.length > 0 && o.setAttribute("title", e[0].textContent || "");
      const a = Object.assign(
        Object.assign(
          {},
          (0,html_display_utils/* buildBrazeBridge */.NK)(o, () => {
            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 33545)).then((t) => {
              braze_instance/* default._t */.ZP._t() ? t.showFeed() : logger/* default.error */.Z.error(constants/* BRAZE_MUST_BE_INITIALIZED_ERROR */.Go);
            });
          }),
        ),
        {
          logClick: function () {
            logBannerClick(t, ...arguments);
          },
          closeMessage: function () {},
        },
      );
      (n.brazeBridge = a),
        (n.appboyBridge = a),
        n.dispatchEvent(new CustomEvent("ab.BridgeReady"));
    }),
    o
  );
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/display/destroy-banner-html.js


function destroyBannerHtml(o) {
  const n = o.getAttribute(constants/* SUBSCRIPTION_ID_DATA_ATTRIBUTE */.k6);
  null != n && (0,remove_subscription/* removeSubscription */.A)(n),
    o && o.parentNode && o.parentNode.removeChild(o);
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/detect-impression.js
var detect_impression = __webpack_require__(38430);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/log-banner-impressions.js





function logBannerImpressions(o) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  if (!o || o.length <= 0) return !1;
  const n = banner_provider_factory.m(),
    s = n.dt();
  if (0 === (0,code_utils/* keys */.XP)(s).length)
    return logger/* default.info */.Z.info("Not logging banners impression. No banners exist."), !1;
  const e = n.Nt(),
    t = [];
  for (const r of o) {
    const o = s[r];
    o
      ? e[o.placementId]
        ? logger/* default.info */.Z.info(
            `Not logging banners impression for ID ${r}. This ID was already logged this session.`,
          )
        : ((e[o.placementId] = !0), t.push(o.id))
      : logger/* default.info */.Z.info(
          `Not logging banners impression for ID ${r}. The placement ID did not correspond to any banner.`,
        );
  }
  if (0 === t.length) return !1;
  n.xt(e);
  const a = { ids: t };
  return event_logger/* default.ut */.Z.ut(event_types/* EventTypes.ro */.G.ro, a).tt;
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/display/detect-banner-impressions.js




function detectBannerImpressions() {
  const o = document.querySelectorAll(`.${BANNER_HTML_CLASS}, .${CONTROL_BANNER_HTML_CLASS}`),
    t = [];
  for (let n = 0; n < o.length; n++) {
    const s = o[n],
      i = s.getAttribute(BANNER_PLACEMENT_ID);
    if (!i) continue;
    const m = detect_impression/* detectImpression.oo */.mP.oo(s),
      r = detect_impression/* detectImpression.no */.mP.no(s);
    if (m && r) continue;
    const e = (0,dom_utils/* topIsInView */.rJ)(s),
      c = (0,dom_utils/* bottomIsInView */.Fr)(s);
    e && !m && (0,detect_impression/* impressOnTop */.Ji)(s), c && !r && (0,detect_impression/* impressOnBottom */.Zw)(s), detect_impression/* detectImpression.oo */.mP.oo(s) && detect_impression/* detectImpression.no */.mP.no(s) && t.push(i);
  }
  t.length > 0 && logBannerImpressions(t);
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/get-all-banners.js



function getAllBanners() {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const n = {},
    t = braze_instance/* default.v */.ZP.v();
  if (t && !t.Dt()) return n;
  const o = banner_provider_factory.m().dt();
  for (const r in o) n[r] = getBannerIfNotExpired(o, r);
  return n;
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/subscribe-to-banners-updates.js



function subscribeToBannersUpdates(n) {
  var o;
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  const t = banner_provider_factory.m();
  if (t.It()) {
    const r = getAllBanners();
    r && "function" == typeof n && n(r);
  }
  const s = t.qt(n);
  if (!t.Ct()) {
    const n =
      null === (o = braze_instance/* default.nn */.ZP.nn()) || void 0 === o
        ? void 0
        : o.rn(() => {
            const n = t.ht();
            n && n.length > 0 && t.$(n);
          });
    n && t.Tt(n);
  }
  return s;
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/ui/insert-banner.js









function insertBanner(o, e) {
  if (!braze_instance/* default.rr */.ZP.rr()) return;
  if (!o) return void logger/* default.error */.Z.error("Not inserting banner: banner was not provided.");
  if (!e)
    return void logger/* default.error */.Z.error("Not inserting banner: parentNode was not provided.");
  if (!braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.re */.JY.re))
    return void logger/* default.error */.Z.error(
      "Banners are disabled. Use the 'allowUserSuppliedJavascript' option for braze.initialize to enable these messages.",
    );
  setupBannerUI();
  const n = bannerToHtml(o, braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.er */.JY.er)),
    s = subscribeToBannersUpdates((s) => {
      const i = s[o.placementId];
      i ? e.replaceChildren(bannerToHtml(i, braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.er */.JY.er))) : destroyBannerHtml(n);
    });
  s && n.setAttribute(constants/* SUBSCRIPTION_ID_DATA_ATTRIBUTE */.k6, s), e.replaceChildren(n), (0,dom_utils/* addPassiveEventListener */.lj)(window, "scroll", detectBannerImpressions), detectBannerImpressions();
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/request-banners-refresh.js






function requestBannersRefresh(e, n, t) {
  if (!braze_instance/* default.rr */.ZP.rr()) return void logger/* default.warn */.Z.warn(constants/* BRAZE_MUST_BE_INITIALIZED_ERROR */.Go);
  const s = braze_instance/* default.v */.ZP.v();
  if (!s) return;
  if (!(0,code_utils/* isArray */.kJ)(e) || 0 === e.length)
    return void logger/* default.warn */.Z.warn("placementIds should be a non-empty array.");
  if (!braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.re */.JY.re))
    return void logger/* default.error */.Z.error(
      "Banners are disabled. Use the 'allowUserSuppliedJavascript' option for braze.initialize to enable these messages.",
    );
  const o = banner_provider_factory.m();
  if (banner_provider_factory.m().Rt())
    return void logger/* default.warn */.Z.warn(
      "Banners can be refreshed only once per session per user.",
    );
  if (!s || !o.L())
    return void s.A(() => {
      requestBannersRefresh(e, n, t);
    });
  const a = s.ne();
  e.length > a &&
    (logger/* default.warn */.Z.warn(
      `Number of placement IDs requested exceeds the max allowed. Trimming placementIds array from length ${e.length} to ${a} (max allowed).`,
    ),
    (e = e.slice(0, a))),
    0 !==
      (e = e.filter(
        (e) =>
          !!(0,validation_utils/* isValidBannerPlacementId */.Ey)(e) ||
          (logger/* default.warn */.Z.warn(
            `Placement ID should be a valid utf8 string with no whitespaces, filtering out: ${e}`,
          ),
          !1),
      )).length &&
      (logger/* default.info */.Z.info(`Requesting banners for placement IDs: ${JSON.stringify(e)}`),
      banner_provider_factory.m().$(e, n, t));
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/Banner/index.js








// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/window-utils.js
var window_utils = __webpack_require__(75319);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/index.js












/***/ }),

/***/ 8731:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ l10n_manager_factory; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/browser-detector.js + 3 modules
var browser_detector = __webpack_require__(7169);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/common/translations.js
/* harmony default export */ var translations = ({
  en: {
    NO_CARDS_MESSAGE:
      "We have no updates for you at this time.<br/>Please check again later.",
    FEED_TIMEOUT_MESSAGE:
      "Sorry, this refresh timed out.<br/>Please try again later.",
  },
  ar: {
    NO_CARDS_MESSAGE: "ليس لدينا أي تحديث. يرجى التحقق مرة أخرى لاحقاً",
    FEED_TIMEOUT_MESSAGE: "يرجى تكرار المحاولة لاحقا",
  },
  cs: {
    NO_CARDS_MESSAGE:
      "V tuto chvíli pro vás nemáme žádné aktualizace.<br/>Zkontrolujte prosím znovu později.",
    FEED_TIMEOUT_MESSAGE: "Prosím zkuste to znovu později.",
  },
  da: {
    NO_CARDS_MESSAGE: "Vi har ingen updates.<br/>Prøv venligst senere.",
    FEED_TIMEOUT_MESSAGE: "Prøv venligst senere.",
  },
  de: {
    NO_CARDS_MESSAGE:
      "Derzeit sind keine Updates verfügbar.<br/>Bitte später noch einmal versuchen.",
    FEED_TIMEOUT_MESSAGE: "Bitte später noch einmal versuchen.",
  },
  es: {
    NO_CARDS_MESSAGE:
      "No tenemos actualizaciones.<br/>Por favor compruébelo más tarde.",
    FEED_TIMEOUT_MESSAGE: "Por favor inténtelo más tarde.",
  },
  "es-mx": {
    NO_CARDS_MESSAGE:
      "No tenemos ninguna actualización.<br/>Vuelva a verificar más tarde.",
    FEED_TIMEOUT_MESSAGE: "Por favor, vuelva a intentarlo más tarde.",
  },
  et: {
    NO_CARDS_MESSAGE:
      "Uuendusi pole praegu saadaval.<br/>Proovige hiljem uuesti.",
    FEED_TIMEOUT_MESSAGE: "Palun proovige hiljem uuesti.",
  },
  fi: {
    NO_CARDS_MESSAGE:
      "Päivityksiä ei ole saatavilla.<br/>Tarkista myöhemmin uudelleen.",
    FEED_TIMEOUT_MESSAGE: "Yritä myöhemmin uudelleen.",
  },
  fr: {
    NO_CARDS_MESSAGE:
      "Aucune mise à jour disponible.<br/>Veuillez vérifier ultérieurement.",
    FEED_TIMEOUT_MESSAGE: "Veuillez réessayer ultérieurement.",
  },
  he: {
    NO_CARDS_MESSAGE: ".אין לנו עדכונים. בבקשה בדוק שוב בקרוב",
    FEED_TIMEOUT_MESSAGE: ".בבקשה נסה שוב בקרוב",
  },
  hi: {
    NO_CARDS_MESSAGE:
      "हमारे पास कोई अपडेट नहीं हैं। कृपया बाद में फिर से जाँच करें.।",
    FEED_TIMEOUT_MESSAGE: "कृपया बाद में दोबारा प्रयास करें।.",
  },
  id: {
    NO_CARDS_MESSAGE: "Kami tidak memiliki pembaruan. Coba lagi nanti.",
    FEED_TIMEOUT_MESSAGE: "Coba lagi nanti.",
  },
  it: {
    NO_CARDS_MESSAGE: "Non ci sono aggiornamenti.<br/>Ricontrollare più tardi.",
    FEED_TIMEOUT_MESSAGE: "Riprovare più tardi.",
  },
  ja: {
    NO_CARDS_MESSAGE:
      "アップデートはありません。<br/>後でもう一度確認してください。",
    FEED_TIMEOUT_MESSAGE: "後でもう一度試してください。",
  },
  ko: {
    NO_CARDS_MESSAGE: "업데이트가 없습니다. 다음에 다시 확인해 주십시오.",
    FEED_TIMEOUT_MESSAGE: "나중에 다시 시도해 주십시오.",
  },
  ms: {
    NO_CARDS_MESSAGE: "Tiada kemas kini. Sila periksa kemudian.",
    FEED_TIMEOUT_MESSAGE: "Sila cuba kemudian.",
  },
  nl: {
    NO_CARDS_MESSAGE: "Er zijn geen updates.<br/>Probeer het later opnieuw.",
    FEED_TIMEOUT_MESSAGE: "Probeer het later opnieuw.",
  },
  no: {
    NO_CARDS_MESSAGE:
      "Vi har ingen oppdateringer.<br/>Vennligst sjekk igjen senere.",
    FEED_TIMEOUT_MESSAGE: "Vennligst prøv igjen senere.",
  },
  pl: {
    NO_CARDS_MESSAGE:
      "Brak aktualizacji.<br/>Proszę sprawdzić ponownie później.",
    FEED_TIMEOUT_MESSAGE: "Proszę spróbować ponownie później.",
  },
  pt: {
    NO_CARDS_MESSAGE:
      "Não temos atualizações.<br/>Por favor, verifique mais tarde.",
    FEED_TIMEOUT_MESSAGE: "Por favor, tente mais tarde.",
  },
  "pt-br": {
    NO_CARDS_MESSAGE:
      "Não temos nenhuma atualização.<br/>Verifique novamente mais tarde.",
    FEED_TIMEOUT_MESSAGE: "Tente novamente mais tarde.",
  },
  ru: {
    NO_CARDS_MESSAGE:
      "Обновления недоступны.<br/>Пожалуйста, проверьте снова позже.",
    FEED_TIMEOUT_MESSAGE: "Пожалуйста, повторите попытку позже.",
  },
  sv: {
    NO_CARDS_MESSAGE: "Det finns inga uppdateringar.<br/>Försök igen senare.",
    FEED_TIMEOUT_MESSAGE: "Försök igen senare.",
  },
  th: {
    NO_CARDS_MESSAGE: "เราไม่มีการอัพเดต กรุณาตรวจสอบภายหลัง.",
    FEED_TIMEOUT_MESSAGE: "กรุณาลองใหม่ภายหลัง.",
  },
  uk: {
    NO_CARDS_MESSAGE:
      "Оновлення недоступні.<br/>ласка, перевірте знову пізніше.",
    FEED_TIMEOUT_MESSAGE: "Будь ласка, спробуйте ще раз пізніше.",
  },
  vi: {
    NO_CARDS_MESSAGE:
      "Chúng tôi không có cập nhật nào.<br/>Vui lòng kiểm tra lại sau.",
    FEED_TIMEOUT_MESSAGE: "Vui lòng thử lại sau.",
  },
  "zh-hk": {
    NO_CARDS_MESSAGE: "暫時沒有更新.<br/>請稍候再試.",
    FEED_TIMEOUT_MESSAGE: "請稍候再試.",
  },
  "zh-hans": {
    NO_CARDS_MESSAGE: "暂时没有更新.<br/>请稍后再试.",
    FEED_TIMEOUT_MESSAGE: "请稍候再试.",
  },
  "zh-hant": {
    NO_CARDS_MESSAGE: "暫時沒有更新.<br/>請稍候再試.",
    FEED_TIMEOUT_MESSAGE: "請稍候再試.",
  },
  "zh-tw": {
    NO_CARDS_MESSAGE: "暫時沒有更新.<br/>請稍候再試.",
    FEED_TIMEOUT_MESSAGE: "請稍候再試.",
  },
  zh: {
    NO_CARDS_MESSAGE: "暂时没有更新.<br/>请稍后再试.",
    FEED_TIMEOUT_MESSAGE: "请稍候再试.",
  },
});

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/l10n/l10n-manager.js


class lr {
  constructor(t, e = !1) {
    if (
      ((this.language = t),
      null != t && (t = t.toLowerCase()),
      null != t && null == translations[t])
    ) {
      const e = t.indexOf("-");
      e > 0 && (t = t.substring(0, e));
    }
    if (null == translations[t]) {
      const a =
        "Braze does not yet have a localization for language " +
        t +
        ", defaulting to English. Please contact us if you are willing and able to help us translate our SDK into this language.";
      e ? logger/* default.error */.Z.error(a) : logger/* default.info */.Z.info(a), (t = "en");
    }
    this.language = t;
  }
  get(t) {
    return translations[this.language][t];
  }
  Oo() {
    switch (this.language) {
      case "ar":
      case "he":
      case "fa":
        return "rtl";
      default:
        return "ltr";
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/l10n/l10n-manager-factory.js



const ge = {
  l: !1,
  aa: null,
  ea: () => {
    if ((ge.p(), !ge.aa)) {
      let e = browser_detector/* default.language */.Z.language,
        t = !1;
      braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.Xn */.JY.Xn) && ((e = braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.Xn */.JY.Xn)), (t = !0)), (ge.aa = new lr(e, t));
    }
    return ge.aa;
  },
  p: () => {
    ge.l || (braze_instance/* default.h */.ZP.h(ge), (ge.l = !0));
  },
  destroy: () => {
    (ge.aa = null), (ge.l = !1);
  },
};
/* harmony default export */ var l10n_manager_factory = (ge);


/***/ }),

/***/ 88468:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JY": function() { return /* binding */ w; },
  "ZP": function() { return /* binding */ r; }
});

// UNUSED EXPORTS: BrazeSdkInstance

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/subscription-manager.js
var subscription_manager = __webpack_require__(74663);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/indexed-db-adapter.js
var indexed_db_adapter = __webpack_require__(45522);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/managers/auth-manager.js



class kt {
  constructor(t, i, s) {
    (this.C = t),
      (this.Zn = i),
      (this.gh = s),
      (this.C = t),
      (this.Zn = i || !1),
      (this.gh = s),
      (this.Fh = new subscription_manager/* default */.Z()),
      (this.kh = 0),
      (this.fh = 1);
  }
  wh() {
    return this.Zn;
  }
  jh() {
    return this.C.ft(storage_manager/* STORAGE_KEYS.gt.xh */.I.gt.xh);
  }
  setSdkAuthenticationSignature(t) {
    const i = this.jh();
    this.C.Bt(storage_manager/* STORAGE_KEYS.gt.xh */.I.gt.xh, t);
    const e = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs;
    new indexed_db_adapter/* default */.Z(e, logger/* default */.Z).setItem(e.Ms.qh, this.fh, t), i !== t && this.it();
  }
  yh() {
    this.C.Ut(storage_manager/* STORAGE_KEYS.gt.xh */.I.gt.xh);
    const t = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs;
    new indexed_db_adapter/* default */.Z(t, logger/* default */.Z).ge(t.Ms.qh, this.fh);
  }
  subscribeToSdkAuthenticationFailures(t) {
    return this.gh.Ft(t);
  }
  Bh(t) {
    this.gh.X(t);
  }
  Gh() {
    this.Fh.removeAllSubscriptions();
  }
  Hh() {
    this.kh += 1;
  }
  Jh() {
    return this.kh;
  }
  it() {
    this.kh = 0;
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/base-provider.js
var base_provider = __webpack_require__(40158);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/browser-detector.js + 3 modules
var browser_detector = __webpack_require__(7169);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/models/device.js
class Gt {
  constructor(s) {
    (this.id = s), (this.id = s);
  }
  $r() {
    const s = {};
    return (
      null != this.browser && (s.browser = this.browser),
      null != this.Za && (s.browser_version = this.Za),
      null != this.os && (s.os_version = this.os),
      null != this.resolution && (s.resolution = this.resolution),
      null != this.language && (s.locale = this.language),
      null != this.timeZone && (s.time_zone = this.timeZone),
      null != this.userAgent && (s.user_agent = this.userAgent),
      s
    );
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/device-properties.js
var device_properties = __webpack_require__(12017);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/identifier.js
var identifier = __webpack_require__(42308);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/guid.js
var guid = __webpack_require__(57070);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/code-utils.js
var code_utils = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/error-utils.js
var error_utils = __webpack_require__(8031);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/managers/device-manager.js








class Ot {
  constructor(t, e) {
    (this.C = t),
      (this.Qa = e),
      (this.C = t),
      null == e && (e = (0,code_utils/* values */.VO)(device_properties/* default */.Z)),
      (this.Qa = e);
  }
  ve(t = !0) {
    let e = this.C.tu(storage_manager/* STORAGE_KEYS.iu.Ia */.I.iu.Ia);
    null == e && ((e = new identifier/* default */.Z(guid/* default.ce */.Z.ce())), t && this.C.uu(storage_manager/* STORAGE_KEYS.iu.Ia */.I.iu.Ia, e));
    const r = new Gt(e.eu);
    for (let t = 0; t < this.Qa.length; t++) {
      switch (this.Qa[t]) {
        case device_properties/* default.BROWSER */.Z.BROWSER:
          r.browser = browser_detector/* default.browser */.Z.browser;
          break;
        case device_properties/* default.BROWSER_VERSION */.Z.BROWSER_VERSION:
          r.Za = browser_detector/* default.version */.Z.version;
          break;
        case device_properties/* default.OS */.Z.OS:
          r.os = this.tc();
          break;
        case device_properties/* default.RESOLUTION */.Z.RESOLUTION:
          r.ec = screen.width + "x" + screen.height;
          break;
        case device_properties/* default.LANGUAGE */.Z.LANGUAGE:
          r.language = browser_detector/* default.language */.Z.language;
          break;
        case device_properties/* default.TIME_ZONE */.Z.TIME_ZONE:
          r.timeZone = this.rc(new Date());
          break;
        case device_properties/* default.USER_AGENT */.Z.USER_AGENT:
          r.userAgent = browser_detector/* default.userAgent */.Z.userAgent;
      }
    }
    return r;
  }
  tc() {
    if (browser_detector/* default.sc */.Z.sc()) return browser_detector/* default.sc */.Z.sc();
    const t = this.C.ft(storage_manager/* STORAGE_KEYS.gt.ic */.I.gt.ic);
    return t && t.os_version ? t.os_version : browser_detector/* default.tc */.Z.tc();
  }
  rc(t) {
    let e = !1;
    if ("undefined" != typeof Intl && "function" == typeof Intl.DateTimeFormat)
      try {
        if ("function" == typeof Intl.DateTimeFormat().resolvedOptions) {
          const t = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (null != t && "" !== t) return t;
        }
      } catch (t) {
        logger/* default.info */.Z.info(
          "Intl.DateTimeFormat threw an error, cannot detect user's time zone:" +
            (0,error_utils/* getErrorMessage */.e)(t),
        ),
          (e = !0);
      }
    if (e) return "";
    const r = t.getTimezoneOffset();
    return this.oc(r);
  }
  oc(t) {
    const e = Math.trunc(t / 60),
      r = Math.trunc(t % 60);
    let s = "GMT";
    return (
      0 !== t &&
        ((s += t < 0 ? "+" : "-"),
        (s +=
          ("00" + Math.abs(e)).slice(-2) +
          ":" +
          ("00" + Math.abs(r)).slice(-2))),
      s
    );
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/backend-errors.js
var backend_errors = __webpack_require__(63826);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/braze-event.js
var braze_event = __webpack_require__(57559);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/date-utils.js
var date_utils = __webpack_require__(57750);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/event-logger.js
var event_logger = __webpack_require__(39179);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/event-types.js
var event_types = __webpack_require__(12730);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/request-header-utils.js
var request_header_utils = __webpack_require__(76870);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/constants.js
var constants = __webpack_require__(27671);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/utils.js
var utils = __webpack_require__(18982);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/net.js
var net = __webpack_require__(41843);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/managers/network-manager.js











class Pt {
  constructor(t, e, i, s, r, n, o, a, h, u, l, c) {
    (this.an = t),
      (this.C = e),
      (this.Ra = i),
      (this.Cs = s),
      (this.T = r),
      (this.B = n),
      (this.un = o),
      (this.Pa = a),
      (this.Oa = h),
      (this.Ta = u),
      (this.appVersion = l),
      (this.au = c),
      (this.du = (t) => (null == t ? "" : `${t} `)),
      (this.an = t),
      (this.C = e),
      (this.Ra = i),
      (this.Cs = s),
      (this.T = r),
      (this.B = n),
      (this.un = o),
      (this.Pa = a),
      (this.Oa = h),
      (this.Ta = u),
      (this.appVersion = l),
      (this.au = c),
      (this.fu = ["npm"]);
  }
  H(t, e = !1, i = !1) {
    const r = this.an.ve(!i),
      n = r.$r(),
      o = this.C.ft(storage_manager/* STORAGE_KEYS.gt.ic */.I.gt.ic);
    (0,code_utils/* isEqual */.Xy)(o, n) || (t.device = n),
      (t.api_key = this.un),
      (t.time = (0,date_utils/* convertMsToSeconds */.FX)(new Date().valueOf(), !0));
    const a = this.C.ft(storage_manager/* STORAGE_KEYS.gt.vu */.I.gt.vu) || [],
      h = this.C.ft(storage_manager/* STORAGE_KEYS.gt.pu */.I.gt.pu) || "";
    this.fu.length > 0 &&
      (!(0,code_utils/* isEqual */.Xy)(a, this.fu) || h !== this.T.St()) &&
      (t.sdk_metadata = this.fu),
      (t.sdk_version = this.Oa),
      this.Ta && (t.sdk_flavor = this.Ta),
      (t.app_version = this.appVersion),
      (t.app_version_code = this.au),
      (t.device_id = r.id);
    const u = this.Cs.getUserId();
    if ((e && null !== u && (t.user_id = u), !u && !this.Ra.wh())) {
      const e = (0,utils/* getAlias */.q)(this.C);
      e && (t.alias = e);
    }
    return t;
  }
  st(t, e, i) {
    const s = e.auth_error,
      r = e.error;
    if (!s && !r) return !0;
    if (s) {
      let e;
      this.Ra.Hh();
      const r = { errorCode: s.error_code };
      for (const t of i)
        (0,code_utils/* isArray */.kJ)(t) && "X-Braze-Auth-Signature" === t[0] && (r.signature = t[1]);
      t.respond_with && t.respond_with.user_id
        ? (r.userId = t.respond_with.user_id)
        : t.user_id && (r.userId = t.user_id);
      const n = s.reason;
      return (
        n
          ? ((r.reason = n), (e = `due to ${n}`))
          : (e = `with error code ${s.error_code}.`),
        this.Ra.wh() ||
          (e +=
            ' Please use the "enableSdkAuthentication" initialization option to enable authentication.'),
        logger/* default.error */.Z.error(`SDK Authentication failed ${e}`),
        this.Ru(t.events || [], t.attributes || []),
        this.Ra.Bh(r),
        !1
      );
    }
    if (r) {
      let i,
        s = r;
      switch (s) {
        case backend_errors/* default.gu */.Z.gu:
          return (
            (i = "Received successful response with empty body."),
            event_logger/* default.ut */.Z.ut(event_types/* EventTypes.bu */.G.bu, { e: i }),
            logger/* default.info */.Z.info(i),
            !1
          );
        case backend_errors/* default.qu */.Z.qu:
          return (
            (i = "Received successful response with invalid JSON"),
            event_logger/* default.ut */.Z.ut(event_types/* EventTypes.bu */.G.bu, { e: i + ": " + e.response }),
            logger/* default.info */.Z.info(i),
            !1
          );
        case backend_errors/* default.Au */.Z.Au:
          s = `The API key "${t.api_key}" is invalid for the baseUrl ${this.Pa}`;
          break;
        case backend_errors/* default.Du */.Z.Du:
          s =
            "Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.";
          break;
        case backend_errors/* default.ku */.Z.ku:
          s = "No device identifier. Please contact support@braze.com";
      }
      logger/* default.error */.Z.error("Backend error: " + s);
    }
    return !1;
  }
  Tu(t, e, i, s) {
    return !!((t && 0 !== t.length) || (e && 0 !== e.length) || i || s);
  }
  yu(t, e, i, s, r = !1) {
    const n = [],
      o = (t) => t || "",
      a = o(this.Cs.getUserId());
    let u = this.Nr(t, e);
    const l = [],
      c = [];
    let d,
      f = null;
    if (i.length > 0) {
      const t = [];
      for (const e of i) {
        if (((d = e.$r()), this.Ra.wh())) {
          if (a && !d.user_id) {
            f || (f = {}), f.events || (f.events = []), f.events.push(d);
            continue;
          }
          if (o(d.user_id) !== a) {
            c.push(d);
            continue;
          }
        }
        t.push(d);
      }
      t.length > 0 && (u.events = t);
    }
    if (s.length > 0) {
      const t = [];
      for (const e of s)
        e && (this.Ra.wh() && o(e.user_id) !== a ? l.push(e) : t.push(e));
      t.length > 0 && (u.attributes = t);
    }
    if ((this.Ru(c, l), (u = this.H(u, !1, r)), f)) {
      f = this.H(f, !1, r);
      const t = { requestData: f, headers: this.J(f, request_header_utils/* default.O.Nu */.Z.O.Nu) };
      n.push(t);
    }
    if (u && !this.Tu(u.events, u.attributes, t, e)) return f ? n : null;
    const m = { requestData: u, headers: this.J(u, request_header_utils/* default.O.Nu */.Z.O.Nu) };
    return n.push(m), n;
  }
  Ru(t, e) {
    if (t) {
      const e = [];
      for (const i of t) {
        const t = braze_event/* default.fromJson */.Z.fromJson(i);
        (t.time = (0,date_utils/* convertSecondsToMs */.Pn)(t.time)), e.push(t);
      }
      this.C.Vo(e);
    }
    if (e) for (const t of e) this.C.wu(t);
  }
  et(t, e) {
    let i = "HTTP error ";
    null != t && (i += t + " "), (i += e), logger/* default.error */.Z.error(i);
  }
  zr(t) {
    return event_logger/* default.ut */.Z.ut(event_types/* EventTypes.Cu */.G.Cu, { n: t });
  }
  Nr(t, e, i) {
    const s = {};
    t && (s.feed = !0), e && (s.triggers = !0);
    const r = null != i ? i : this.Cs.getUserId();
    if ((r && (s.user_id = r), !s.user_id && !this.Ra.wh())) {
      const t = (0,utils/* getAlias */.q)(this.C);
      t && (s.alias = t);
    }
    return (s.config = { config_time: this.B.Et() }), { respond_with: s };
  }
  Su(t) {
    const e = new Date().valueOf();
    let i = constants/* LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT.toString */.dH.toString();
    const s = request_header_utils/* default.Bu */.Z.Bu(this.C, t);
    if (-1 !== s) {
      i = (e - s).toString();
    }
    return i;
  }
  J(t, e, i = !1) {
    const s = [["X-Braze-Api-Key", this.un]],
      r = this.Su(e);
    s.push(["X-Braze-Last-Req-Ms-Ago", r]);
    const n = request_header_utils/* default.zu */.Z.zu(this.C, e).toString();
    s.push(["X-Braze-Req-Attempt", n]);
    let o = !1;
    if (
      (null != t.respond_with &&
        t.respond_with.triggers &&
        (s.push(["X-Braze-TriggersRequest", "true"]), (o = !0)),
      null != t.respond_with &&
        t.respond_with.feed &&
        (s.push(["X-Braze-FeedRequest", "true"]), (o = !0)),
      e === request_header_utils/* default.O.gi */.Z.O.gi)
    ) {
      s.push(["X-Braze-ContentCardsRequest", "true"]);
      let t = request_header_utils/* default.zu */.Z.zu(this.C, request_header_utils/* default.O.gi */.Z.O.gi);
      (t && !i) || ((t = 1), request_header_utils/* default.ju */.Z.ju(this.C, request_header_utils/* default.O.gi */.Z.O.gi, t));
      const e = Math.max(0, t - 1);
      s.push(["BRAZE-SYNC-RETRY-COUNT", e.toString()]), (o = !0);
    }
    if (
      (e === request_header_utils/* default.O.Le */.Z.O.Le &&
        (s.push(["X-Braze-FeatureFlagsRequest", "true"]), (o = !0)),
      o && s.push(["X-Braze-DataRequest", "true"]),
      this.Ra.wh())
    ) {
      const t = this.Ra.jh();
      null != t && s.push(["X-Braze-Auth-Signature", t]);
    }
    return s;
  }
  Mu(t, e, i, s) {
    window.setTimeout(() => {
      logger/* default.info */.Z.info(`Retrying rate limited ${this.du(s)}SDK request.`),
        this.V(e, i, s);
    }, t);
  }
  V(t, e, i, r) {
    if (!this.Xu(i))
      return (
        logger/* default.info */.Z.info(`${this.du(i)}SDK request being rate limited.`),
        void ("function" == typeof r && r())
      );
    const n = this.$u();
    if (!n.Fu)
      return (
        logger/* default.info */.Z.info(
          `${this.du(
            i,
          )}SDK request being rate limited. Request will be retried in ${Math.trunc(
            n.Lu / 1e3,
          )} seconds.`,
        ),
        void this.Mu(n.Lu, t, e, i)
      );
    this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Eu */.I.gt.Eu, new Date().valueOf());
    const o = t.device;
    o && o.os_version instanceof Promise
      ? o.os_version.then((i) => {
          (t.device.os_version = i), e(n.Ku);
        })
      : e(n.Ku);
  }
  Iu(t) {
    const e = t ? (0,net/* readResponseHeaders */.D)(t) : null;
    if (!e || !e["retry-after"]) return null;
    const i = e["retry-after"];
    if (isNaN(i) && !isNaN(Date.parse(i)))
      return { type: "date", value: Date.parse(i) };
    if (!isNaN(parseFloat(i.toString())))
      return { type: "timestamp", value: 1e3 * parseFloat(i.toString()) };
    {
      const t =
        "Received unexpected value for retry-after header in /sync response";
      event_logger/* default.ut */.Z.ut(event_types/* EventTypes.bu */.G.bu, { e: t + ": " + i });
    }
    return null;
  }
  rt(t, e, i, s, r, n) {
    if (request_header_utils/* default.zu */.Z.zu(this.C, i) >= constants/* MAX_RETRY_COUNT_PER_REQUEST */.mM) return;
    let o;
    n = n || 0;
    const a = this.Iu(t);
    r();
    const u = (t) => {
      const r = window.setTimeout(() => {
        e();
      }, t);
      s(r), request_header_utils/* default.Pu */.Z.Pu(this.C, i);
    };
    if (a && !isNaN(a.value)) {
      switch (a.type) {
        case "date":
          (o = a.value - new Date().getTime() + n), o < 0 && e();
          break;
        case "timestamp":
          o = a.value + n;
      }
      u(o);
    } else n ? u(n) : request_header_utils/* default.wi */.Z.wi(this.C, i);
  }
  Uu(t) {
    var e;
    null === (e = this.C) || void 0 === e || e.Bt(storage_manager/* STORAGE_KEYS.gt.xu */.I.gt.xu, t);
  }
  Hu(t, e) {
    let i = this.Ou();
    null == i && (i = {}), (i[t] = e), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Gu */.I.gt.Gu, i);
  }
  _u() {
    var t;
    return null === (t = this.C) || void 0 === t ? void 0 : t.ft(storage_manager/* STORAGE_KEYS.gt.xu */.I.gt.xu);
  }
  Ou() {
    var t;
    return null === (t = this.C) || void 0 === t ? void 0 : t.ft(storage_manager/* STORAGE_KEYS.gt.Gu */.I.gt.Gu);
  }
  Wu(t, e, i, s, r = "") {
    let n;
    if (r) {
      const t = this.Ou();
      n = null == t || isNaN(t[r]) ? e : t[r];
    } else (n = this._u()), (null == n || isNaN(n)) && (n = e);
    const o = (t - s) / 1e3;
    return (n = Math.min(n + o / i, e)), n;
  }
  Yu(t, e) {
    return Math.max(0, (1 - t) * e * 1e3);
  }
  Ju(t, e = "") {
    var i, r, n, o, a;
    const u = { Fu: !0, Ku: -1, Lu: 0 };
    if ((null == t && (t = !0), !t && !e)) return u;
    let l,
      c,
      d = null;
    if (t) d = null === (i = this.C) || void 0 === i ? void 0 : i.ft(storage_manager/* STORAGE_KEYS.gt.Eu */.I.gt.Eu);
    else {
      const t = request_header_utils/* default.Qu */.Z.Qu(this.C);
      if (null == t || null == t[e]) return u;
      d = t[e];
    }
    if (null == d || isNaN(d)) return u;
    if (
      (t
        ? ((l =
            (null === (r = this.B) || void 0 === r ? void 0 : r.Vu()) || -1),
          (c = (null === (n = this.B) || void 0 === n ? void 0 : n.Zu()) || -1))
        : ((l =
            (null === (o = this.B) || void 0 === o ? void 0 : o.tl(e)) || -1),
          (c =
            (null === (a = this.B) || void 0 === a ? void 0 : a.el(e)) || -1)),
      -1 === l || -1 === c)
    )
      return u;
    const f = new Date().valueOf();
    let m = this.Wu(f, l, c, d, e);
    return m < 1
      ? ((u.Fu = !1), (u.Lu = this.Yu(m, c)), u)
      : ((m = Math.trunc(m) - 1),
        (u.Ku = m),
        t ? this.Uu(m) : this.Hu(e, m),
        u);
  }
  $u() {
    return this.Ju(!0);
  }
  Xu(t) {
    const e = this.Ju(!1, t);
    return !(e && !e.Fu);
  }
  it() {
    this.Ra.it();
  }
  Z() {
    return this.Pa;
  }
  addSdkMetadata(t) {
    for (const e of t) -1 === this.fu.indexOf(e) && this.fu.push(e);
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/math.js
var math = __webpack_require__(96504);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/request-result.js
var request_result = __webpack_require__(24673);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/utils/push-utils.js
var push_utils = __webpack_require__(74556);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/request-controller.js










class Lt {
  constructor(t, i, s, e, h, o, n, r, l, a) {
    (this.un = t),
      (this.baseUrl = i),
      (this.T = s),
      (this.an = e),
      (this.Cs = h),
      (this.B = o),
      (this.C = n),
      (this.$l = r),
      (this.Ra = l),
      (this.S = a),
      (this.un = t),
      (this.baseUrl = i),
      (this.Tl = 0),
      (this.dE = n.IE() || 0),
      (this.Ml = null),
      (this.T = s),
      (this.an = e),
      (this.Cs = h),
      (this.B = o),
      (this.C = n),
      (this.Ra = l),
      (this.S = a),
      (this.$l = r),
      (this.Pl = new subscription_manager/* default */.Z()),
      (this.Ol = null),
      (this.Ul = 50),
      (this._l = !1);
  }
  Jl(t, i) {
    return !t && !i && this.Ra.Jh() >= this.Ul;
  }
  Kl(t) {
    let i = this.T.zl();
    if (t.length > 0) {
      const s = this.Cs.getUserId();
      for (const e of t) {
        const t = (!e.userId && !s) || e.userId === s;
        e.type === event_types/* EventTypes.Bl */.G.Bl && t && (i = !0);
      }
    }
    return i;
  }
  Xl(t = !1, i = !1, e = !0, o, n, r, u = !1, c = !1) {
    e && this.Ql();
    const d = this.C.AE(),
      m = this.C.OE();
    let f = !1;
    const g = (t, i, u = -1) => {
        const c = new Date().valueOf();
        request_header_utils/* default.W */.Z.W(this.C, request_header_utils/* default.O.Nu */.Z.O.Nu, c),
          -1 !== u && i.push(["X-Braze-Req-Tokens-Remaining", u.toString()]);
        let d = !1;
        net/* default.Y */.Z.Y({
          url: this.baseUrl + "/data/",
          data: t,
          headers: i,
          tt: (e) => {
            null != t.respond_with &&
              t.respond_with.triggers &&
              (this.Tl = Math.max(this.Tl - 1, 0)),
              this.S.st(t, e, i)
                ? (this.Ra.it(),
                  this.B.gl(e),
                  (null != t.respond_with &&
                    t.respond_with.user_id != this.Cs.getUserId()) ||
                    (null != t.device && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.ic */.I.gt.ic, t.device),
                    null != t.sdk_metadata &&
                      (this.C.Bt(storage_manager/* STORAGE_KEYS.gt.vu */.I.gt.vu, t.sdk_metadata),
                      this.C.Bt(storage_manager/* STORAGE_KEYS.gt.pu */.I.gt.pu, this.T.St())),
                    this.$l(e),
                    request_header_utils/* default.ju */.Z.ju(this.C, request_header_utils/* default.O.Nu */.Z.O.Nu, 1),
                    "function" == typeof o && o()))
                : e.auth_error && (d = !0);
          },
          error: () => {
            (d = !0),
              null != t.respond_with &&
                t.respond_with.triggers &&
                (this.Tl = Math.max(this.Tl - 1, 0)),
              this.S.Ru(t.events, t.attributes),
              "function" == typeof n && n();
          },
          nt: (t, i) => {
            "function" == typeof r && r(!d);
            const s = this.S.Iu(i);
            let o = 0;
            if (s)
              switch (s.type) {
                case "date":
                  o = Math.max(s.value - new Date().valueOf(), 0);
                  break;
                case "timestamp":
                  o = s.value;
              }
            if (e && !f) {
              if (d) {
                request_header_utils/* default.Pu */.Z.Pu(this.C, request_header_utils/* default.O.Nu */.Z.O.Nu);
                let t = this.Ml;
                (null == t || t < 1e3 * this.dE) && (t = 1e3 * this.dE);
                const i = Math.min(3e5, (0,math/* randomInclusive */.R)(1e3 * this.dE, 3 * t)) + o;
                this.Yl(i);
              } else this.Yl(Math.max(1e3 * this.dE, o));
              f = !0;
            }
          },
        });
      },
      p = this.Kl(d),
      v = i || p;
    if (this.Jl(u, p))
      return void logger/* default.info */.Z.info(
        "Declining to flush data due to 50 consecutive authentication failures",
      );
    if (e && !this.S.Tu(d, m, t, v))
      return this.Yl(), void ("function" == typeof r && r(!0));
    const b = this.S.yu(t, v, d, m, c);
    v && this.Tl++;
    let w = !1;
    if (b)
      for (const t of b)
        this.S.V(
          t.requestData,
          (i) => g(t.requestData, t.headers, i),
          request_header_utils/* default.O.Nu */.Z.O.Nu,
          n,
        ),
          (w = !0);
    this.Ra.wh() && e && !w
      ? this.Yl()
      : p && (logger/* default.info */.Z.info("Invoking new session subscriptions"), this.Pl.X());
  }
  Zl() {
    return this.Tl > 0;
  }
  Yl(t = 1e3 * this.dE) {
    this._l ||
      (this.Ql(),
      (this.Ol = window.setTimeout(() => {
        if (document.hidden) {
          const t = "visibilitychange",
            i = () => {
              document.hidden ||
                (document.removeEventListener(t, i, !1), this.Xl());
            };
          document.addEventListener(t, i, !1);
        } else this.Xl();
      }, t)),
      (this.Ml = t));
  }
  Ql() {
    null != this.Ol && (clearTimeout(this.Ol), (this.Ol = null));
  }
  initialize() {
    (this._l = !1), this.Yl();
  }
  destroy() {
    this.Pl.removeAllSubscriptions(),
      this.Ra.Gh(),
      this.Ql(),
      (this._l = !0),
      this.Xl(void 0, void 0, !1, void 0, void 0, void 0, void 0, !0),
      (this.Ol = null);
  }
  rn(t) {
    return this.Pl.Ft(t);
  }
  openSession() {
    const t = this.T.St() !== this.T.Qo();
    t && (this.C.TE(storage_manager/* STORAGE_KEYS.iu.Ia */.I.iu.Ia), this.C.TE(storage_manager/* STORAGE_KEYS.iu.su */.I.iu.su)),
      this.Xl(void 0, !1, void 0, () => {
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Ge */.I.gt.Ge);
      }),
      this.Jn(),
      t &&
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23966)).then((t) => {
          if (this._l) return;
          const i = t.default.ea();
          if (
            null != i &&
            (push_utils/* default.isPushPermissionGranted */.Z.isPushPermissionGranted() || push_utils/* default.isPushBlocked */.Z.isPushBlocked())
          ) {
            const t = () => {
                i.vn()
                  ? logger/* default.info */.Z.info(
                      "Push token maintenance is disabled, not refreshing token for backend.",
                    )
                  : i.subscribe();
              },
              e = (i, s) => {
                s && t();
              },
              h = () => {
                const i = this.C.ft(storage_manager/* STORAGE_KEYS.gt.qn */.I.gt.qn);
                (null == i || i) && t();
              },
              o = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs;
            new indexed_db_adapter/* default */.Z(o, logger/* default */.Z).cr(o.Ms.cu, e, h);
          }
        });
  }
  hc() {
    this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Xe */.I.gt.Xe), this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Is */.I.gt.Is), this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Lr */.I.gt.Lr);
  }
  changeUser(t, i, e) {
    const h = this.Cs.getUserId();
    if (h !== t) {
      this.T.Fl(),
        this.hc(),
        null != h && this.Xl(void 0, !1, void 0, void 0, void 0),
        this.Cs.ou(t),
        e ? this.Ra.setSdkAuthenticationSignature(e) : this.Ra.yh();
      for (let t = 0; t < i.length; t++) i[t].changeUser(null == h);
      null != h && this.C.Ut(storage_manager/* STORAGE_KEYS.gt.Zt */.I.gt.Zt),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt.ic */.I.gt.ic),
        this.C.Ut(storage_manager/* STORAGE_KEYS.gt._E */.I.gt._E),
        this.openSession(),
        logger/* default.info */.Z.info('Changed user to "' + t + '".');
    } else {
      let i = "Doing nothing.";
      e &&
        this.Ra.jh() !== e &&
        (this.Ra.setSdkAuthenticationSignature(e),
        (i = "Updated SDK authentication signature")),
        logger/* default.info */.Z.info(`Current user is already ${t}. ${i}`);
    }
  }
  requestImmediateDataFlush(t) {
    this.Ql(), this.T.Qo();
    this.Xl(
      void 0,
      void 0,
      void 0,
      void 0,
      () => {
        logger/* default.error */.Z.error("Failed to flush data, request will be retried automatically.");
      },
      t,
      !0,
    );
  }
  requestFeedRefresh() {
    this.T.Qo(), this.Xl(!0);
  }
  br(t, i) {
    this.T.Qo(),
      logger/* default.info */.Z.info("Requesting explicit trigger refresh."),
      this.Xl(void 0, !0, void 0, t, i);
  }
  Cn(t, i) {
    const e = event_types/* EventTypes.dc */.G.dc,
      h = { a: t, l: i },
      o = event_logger/* default.ut */.Z.ut(e, h);
    return (
      o && (logger/* default.info */.Z.info(`Logged alias ${t} with label ${i}`), this.C.Bt(storage_manager/* STORAGE_KEYS.gt._E */.I.gt._E, h)),
      o
    );
  }
  Ln(t, i, s) {
    if (this.B.hu(i))
      return (
        logger/* default.info */.Z.info(`Custom Attribute "${i}" is blocklisted, ignoring.`), new request_result/* default */.Z()
      );
    const e = { key: i, value: s },
      h = event_logger/* default.ut */.Z.ut(t, e);
    if (h) {
      const t = "object" == typeof s ? JSON.stringify(s, null, 2) : s;
      logger/* default.info */.Z.info(`Logged custom attribute: ${i} with value: ${t}`);
    }
    return h;
  }
  setLastKnownLocation(t, i, s, e, h, o) {
    const n = { latitude: i, longitude: s };
    null != e && (n.altitude = e),
      null != h && (n.ll_accuracy = h),
      null != o && (n.alt_accuracy = o);
    const r = event_logger/* default.ut */.Z.ut(event_types/* EventTypes.mc */.G.mc, n, t || void 0);
    return (
      r &&
        logger/* default.info */.Z.info(`Set user last known location as ${JSON.stringify(n, null, 2)}`),
      r
    );
  }
  lr(t, i) {
    const s = this.T.Qo();
    return new braze_event/* default */.Z(this.Cs.getUserId(), event_types/* EventTypes.fc */.G.fc, t, s, { cid: i });
  }
  vc(t, i) {
    return new indexed_db_adapter/* default */.Z(t, i);
  }
  Jn() {
    const t = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs;
    this.vc(t, logger/* default */.Z).setItem(t.Ms.Nu, 1, {
      baseUrl: this.baseUrl,
      data: { api_key: this.un, device_id: this.an.ve().id },
      userId: this.Cs.getUserId(),
      sdkAuthEnabled: this.Ra.wh(),
    });
  }
  vr(t) {
    for (const i of t)
      if (i.api_key === this.un) this.S.Ru(i.events, i.attributes);
      else {
        const t = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs;
        new indexed_db_adapter/* default */.Z(t, logger/* default */.Z).setItem(t.Ms.kr, guid/* default.ce */.Z.ce(), i);
      }
  }
  Hn(t, i, s) {
    if (this.B.hu(t))
      return (
        logger/* default.info */.Z.info(`Custom Attribute "${t}" is blocklisted, ignoring.`), new request_result/* default */.Z()
      );
    let e, h;
    return (
      null === i && null === s
        ? ((e = event_types/* EventTypes.bc */.G.bc), (h = { key: t }))
        : ((e = event_types/* EventTypes.wc */.G.wc), (h = { key: t, latitude: i, longitude: s })),
      event_logger/* default.ut */.Z.ut(e, h)
    );
  }
  Kn(t, i) {
    const s = { group_id: t, status: i };
    return event_logger/* default.ut */.Z.ut(event_types/* EventTypes.kc */.G.kc, s);
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/models/server-config.js

class Jt {
  constructor(
    t = 0,
    i = [],
    s = [],
    h = [],
    e = null,
    l = null,
    r = { enabled: !1 },
    a = { enabled: !1, refresh_rate_limit: void 0 },
    n = { enabled: !0, capacity: constants/* GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT */.Up, refill_rate: constants/* GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT */.Y$, endpoint_overrides: {} },
    o = { enabled: !1, max_placements: 0 },
  ) {
    (this.ml = t),
      (this.Rl = i),
      (this.Cl = s),
      (this.El = h),
      (this.wl = e),
      (this.fl = l),
      (this.dl = r),
      (this.De = a),
      (this.bl = n),
      (this.banners = o),
      (this.ml = t),
      (this.Rl = i),
      (this.Cl = s),
      (this.El = h),
      (this.wl = e),
      (this.fl = l),
      (this.dl = r),
      (this.De = a),
      (this.bl = n),
      (this.banners = o);
  }
  bt() {
    return {
      s: "5.8.1",
      l: this.ml,
      e: this.Rl,
      a: this.Cl,
      p: this.El,
      m: this.wl,
      v: this.fl,
      c: this.dl,
      f: this.De,
      grl: this.bl,
      b: this.banners,
    };
  }
  static En(t) {
    let i = t.l;
    return (
      "5.8.1" !== t.s && (i = 0),
      new Jt(i, t.e, t.a, t.p, t.m, t.v, t.c, t.f, t.grl, t.b)
    );
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/managers/server-config-manager.js





class Mt {
  constructor(t) {
    (this.C = t),
      (this.C = t),
      (this.il = new subscription_manager/* default */.Z()),
      (this.sl = new subscription_manager/* default */.Z()),
      (this.rl = new subscription_manager/* default */.Z()),
      (this.al = new subscription_manager/* default */.Z()),
      (this.hl = null),
      (this.ul = null);
  }
  ol() {
    if (null == this.ul) {
      const t = this.C.ft(storage_manager/* STORAGE_KEYS.gt.cl */.I.gt.cl);
      this.ul = null != t ? Jt.En(t) : new Jt();
    }
    return this.ul;
  }
  Et() {
    return this.ol().ml;
  }
  gl(t) {
    if (null != t && null != t.config) {
      const e = t.config;
      if (e.time > this.ol().ml) {
        const t = (t) => (null == t ? this.ol().bl : t),
          i = new Jt(
            e.time,
            e.events_blacklist,
            e.attributes_blacklist,
            e.purchases_blacklist,
            e.messaging_session_timeout,
            e.vapid_public_key,
            e.content_cards,
            e.feature_flags,
            t(e.global_request_rate_limit),
            e.banners,
          );
        let n = !1;
        null != i.fl && this.Tn() !== i.fl && (n = !0);
        let r = !1;
        null != i.dl.enabled && this.Ri() !== i.dl.enabled && (r = !0);
        let l = !1;
        null != i.De.enabled && this.Be() !== i.De.enabled && (l = !0);
        let a = !1;
        null != i.banners.enabled &&
          this.Dt() !== i.banners.enabled &&
          (a = !0),
          (this.ul = i),
          this.C.Bt(storage_manager/* STORAGE_KEYS.gt.cl */.I.gt.cl, i.bt()),
          n && this.il.X(),
          r && this.sl.X(),
          l && this.rl.X(),
          a && this.al.X();
      }
    }
  }
  In(t) {
    const e = this.il.Ft(t);
    return this.hl && this.il.removeSubscription(this.hl), (this.hl = e), e;
  }
  ji(t) {
    return this.sl.Ft(t);
  }
  Ke(t) {
    return this.rl.Ft(t);
  }
  A(t) {
    return this.al.Ft(t);
  }
  je(t) {
    return -1 !== this.ol().Rl.indexOf(t);
  }
  hu(t) {
    return -1 !== this.ol().Cl.indexOf(t);
  }
  Dr(t) {
    return -1 !== this.ol().El.indexOf(t);
  }
  vl() {
    return this.ol().wl;
  }
  Tn() {
    return this.ol().fl;
  }
  Ri() {
    return this.ol().dl.enabled || !1;
  }
  yl() {
    const t = this.ol().bl;
    return !(!t || null == t.enabled) && t.enabled;
  }
  Vu() {
    if (!this.yl()) return -1;
    const t = this.ol().bl;
    return null == t.capacity || t.capacity < 10 ? -1 : t.capacity;
  }
  Zu() {
    if (!this.yl()) return -1;
    const t = this.ol().bl;
    return null == t.refill_rate || t.refill_rate <= 0 ? -1 : t.refill_rate;
  }
  Ll(t) {
    const e = this.ol().bl.endpoint_overrides;
    return null == e ? null : e[t];
  }
  tl(t) {
    const e = this.Ll(t);
    return null == e || isNaN(e.capacity) || e.capacity <= 0 ? -1 : e.capacity;
  }
  el(t) {
    const e = this.Ll(t);
    return null == e || isNaN(e.refill_rate) || e.refill_rate <= 0
      ? -1
      : e.refill_rate;
  }
  Be() {
    return this.ol().De.enabled && null == this.Oe()
      ? (event_logger/* default.ut */.Z.ut(event_types/* EventTypes.bu */.G.bu, { e: "Missing feature flag refresh_rate_limit." }), !1)
      : this.ol().De.enabled || !1;
  }
  Oe() {
    return this.ol().De.refresh_rate_limit;
  }
  Dt() {
    return this.ol().banners.enabled || !1;
  }
  ne() {
    return this.ol().banners.max_placements || 0;
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/managers/session-manager.js





class Wt {
  constructor(s, t, i, e) {
    (this.C = s),
      (this.Cs = t),
      (this.B = i),
      (this.Sl = e),
      (this.C = s),
      (this.Cs = t),
      (this.B = i),
      (this.jl = 1e3),
      (null == e || isNaN(e)) && (e = 1800),
      e < this.jl / 1e3 &&
        (logger/* default.info */.Z.info(
          "Specified session timeout of " +
            e +
            "s is too small, using the minimum session timeout of " +
            this.jl / 1e3 +
            "s instead.",
        ),
        (e = this.jl / 1e3)),
      (this.Sl = e);
  }
  xl(s, t) {
    return new braze_event/* default */.Z(this.Cs.getUserId(), event_types/* EventTypes.Dl */.G.Dl, s, t.eu, { d: (0,date_utils/* convertMsToSeconds */.FX)(s - t.Gl) });
  }
  St() {
    const t = this.C.tu(storage_manager/* STORAGE_KEYS.iu.Nl */.I.iu.Nl);
    return null == t ? null : t.eu;
  }
  zl() {
    const t = new Date().valueOf(),
      i = this.B.vl();
    if (null == i) return !1;
    const e = this.C.ft(storage_manager/* STORAGE_KEYS.gt.Hl */.I.gt.Hl),
      n = null == e || t - e > 1e3 * i;
    return n && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Hl */.I.gt.Hl, t), n;
  }
  Wl(s, t) {
    return null == t || null == t.kl || (!(s - t.Gl < this.jl) && t.kl < s);
  }
  Qo() {
    const t = new Date().valueOf(),
      i = t + 1e3 * this.Sl,
      e = this.C.tu(storage_manager/* STORAGE_KEYS.iu.Nl */.I.iu.Nl);
    if (this.Wl(t, e)) {
      let n = "Generating session start event with time " + t;
      if (null != e) {
        let s = e.ql;
        s - e.Gl < this.jl && (s = e.Gl + this.jl),
          this.C.Al(this.xl(s, e)),
          (n += " (old session ended " + s + ")");
      }
      (n += ". Will expire " + i.valueOf()), logger/* default.info */.Z.info(n);
      const o = new identifier/* default */.Z(guid/* default.ce */.Z.ce(), i);
      this.C.Al(new braze_event/* default */.Z(this.Cs.getUserId(), event_types/* EventTypes.Bl */.G.Bl, t, o.eu)),
        this.C.uu(storage_manager/* STORAGE_KEYS.iu.Nl */.I.iu.Nl, o);
      return null == this.C.ft(storage_manager/* STORAGE_KEYS.gt.Hl */.I.gt.Hl) && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.Hl */.I.gt.Hl, t), o.eu;
    }
    if (null != e) return (e.ql = t), (e.kl = i), this.C.uu(storage_manager/* STORAGE_KEYS.iu.Nl */.I.iu.Nl, e), e.eu;
  }
  Fl() {
    const t = this.C.tu(storage_manager/* STORAGE_KEYS.iu.Nl */.I.iu.Nl);
    null != t &&
      (this.C.Il(storage_manager/* STORAGE_KEYS.iu.Nl */.I.iu.Nl), this.C.Al(this.xl(new Date().valueOf(), t)));
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager-factory.js


const Bt = {
  Ja: function (e, o = !1) {
    let t = !1;
    try {
      if (localStorage && localStorage.getItem)
        try {
          localStorage.setItem(storage_manager/* STORAGE_KEYS.gt.ac */.I.gt.ac, "true"),
            localStorage.getItem(storage_manager/* STORAGE_KEYS.gt.ac */.I.gt.ac) &&
              (localStorage.removeItem(storage_manager/* STORAGE_KEYS.gt.ac */.I.gt.ac), (t = !0));
        } catch (e) {
          if (
            !(
              e instanceof Error &&
              ("QuotaExceededError" === e.name ||
                "NS_ERROR_DOM_QUOTA_REACHED" === e.name) &&
              localStorage.length > 0
            )
          )
            throw e;
          t = !0;
        }
    } catch (e) {
      logger/* default.info */.Z.info("Local Storage not supported!");
    }
    const r = Bt.nc(),
      a = new storage_manager/* default.cc */.Z.cc(e, r && !o, t);
    let n;
    return (n = t ? new storage_manager/* default.lc */.Z.lc(e) : new storage_manager/* default.gc */.Z.gc()), new storage_manager/* default */.Z(a, n);
  },
  nc: function () {
    return (
      navigator.cookieEnabled ||
      ("cookie" in document &&
        (document.cookie.length > 0 ||
          (document.cookie = "test").indexOf.call(document.cookie, "test") >
            -1))
    );
  },
};
/* harmony default export */ var storage_manager_factory = (Bt);

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/triggers/triggers-provider-factory.js + 2 modules
var triggers_provider_factory = __webpack_require__(85346);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/string-utils.js
var string_utils = __webpack_require__(8548);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/push-token.js
var push_token = __webpack_require__(63552);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/User/user.js
var user = __webpack_require__(17615);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/User/user-manager.js






class bt {
  constructor(t, s) {
    (this.B = t), (this.C = s), (this.B = t), (this.C = s);
  }
  getUserId() {
    const t = this.C.tu(storage_manager/* STORAGE_KEYS.iu.su */.I.iu.su);
    if (null == t) return null;
    let i = t.eu,
      e = (0,string_utils/* getByteLength */.E)(i);
    if (e > user/* default.ur */.Z.ur) {
      for (; e > user/* default.ur */.Z.ur; ) (i = i.slice(0, i.length - 1)), (e = (0,string_utils/* getByteLength */.E)(i));
      (t.eu = i), this.C.uu(storage_manager/* STORAGE_KEYS.iu.su */.I.iu.su, t);
    }
    return i;
  }
  ou(t) {
    const i = null == this.getUserId();
    this.C.uu(storage_manager/* STORAGE_KEYS.iu.su */.I.iu.su, new identifier/* default */.Z(t)), i && this.C.ru(t);
  }
  setCustomUserAttribute(t, s) {
    if (this.B.hu(t))
      return (
        logger/* default.info */.Z.info('Custom Attribute "' + t + '" is blocklisted, ignoring.'), !1
      );
    const i = {};
    return (i[t] = s), this.nu(user/* default.lu */.Z.lu, i, !0);
  }
  nu(t, s, i = !1, e = !1) {
    const u = this.C.mu(this.getUserId(), t, s);
    let o = "",
      r = t,
      h = s;
    return (
      i &&
        ((o = " custom"),
        "object" == typeof s &&
          ((r = Object.keys(s)[0]),
          (h = s[r]),
          "object" == typeof h && (h = JSON.stringify(h, null, 2)))),
      !e && u && logger/* default.info */.Z.info(`Logged${o} attribute ${r} with value ${h}`),
      u
    );
  }
  Sn(t, i, e, u, o) {
    this.nu("push_token", t, !1, !0),
      this.nu("custom_push_public_key", e, !1, !0),
      this.nu("custom_push_user_auth", u, !1, !0),
      this.nu("custom_push_vapid_public_key", o, !1, !0);
    const r = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs,
      h = new indexed_db_adapter/* default */.Z(r, logger/* default */.Z),
      n = new push_token/* default */.Z(t, i, e, u, o);
    this.C.Bt(storage_manager/* STORAGE_KEYS.gt.qn */.I.gt.qn, n.bt()), h.setItem(r.Ms.cu, r.be, !0);
  }
  jn(t) {
    if (
      (this.nu("push_token", null, !1, !0),
      this.nu("custom_push_public_key", null, !1, !0),
      this.nu("custom_push_user_auth", null, !1, !0),
      this.nu("custom_push_vapid_public_key", null, !1, !0),
      t)
    ) {
      const t = indexed_db_adapter/* default.Ls.Fs */.Z.Ls.Fs,
        i = new indexed_db_adapter/* default */.Z(t, logger/* default */.Z);
      this.C.Bt(storage_manager/* STORAGE_KEYS.gt.qn */.I.gt.qn, !1), i.setItem(t.Ms.cu, t.be, !1);
    }
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/url-utils.js
var url_utils = __webpack_require__(1148);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/window-utils.js
var window_utils = __webpack_require__(75319);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/shared-lib/supported-options.js
/* harmony default export */ var supported_options = ({
  Yo: "allowCrawlerActivity",
  Zo: "baseUrl",
  Wh: "noCookies",
  Vh: "devicePropertyAllowlist",
  Da: "disablePushTokenMaintenance",
  Kh: "enableLogging",
  $h: "enableSdkAuthentication",
  Ca: "manageServiceWorkerExternally",
  Yh: "minimumIntervalBetweenTriggerActionsInSeconds",
  Xh: "sessionTimeoutInSeconds",
  Zh: "appVersion",
  Qh: "appVersionNumber",
  _a: "serviceWorkerLocation",
  Ba: "safariWebsitePushId",
  Xn: "localization",
  er: "contentSecurityNonce",
  re: "allowUserSuppliedJavascript",
  No: "inAppMessageZIndex",
  Ko: "openInAppMessagesInNewTab",
  en: "openNewsFeedCardsInNewTab",
  mh: "requireExplicitInAppMessageDismissal",
  Ea: "doNotLoadFontAwesome",
  Ia: "deviceId",
  Aa: "serviceWorkerScope",
  Na: "sdkFlavor",
  tn: "openCardsInNewTab",
});

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js





















const w = {
  Yo: "allowCrawlerActivity",
  Zo: "baseUrl",
  Wh: "noCookies",
  Vh: "devicePropertyAllowlist",
  Da: "disablePushTokenMaintenance",
  Kh: "enableLogging",
  $h: "enableSdkAuthentication",
  Ca: "manageServiceWorkerExternally",
  Yh: "minimumIntervalBetweenTriggerActionsInSeconds",
  Xh: "sessionTimeoutInSeconds",
  Zh: "appVersion",
  Qh: "appVersionNumber",
  _a: "serviceWorkerLocation",
  Ba: "safariWebsitePushId",
  Xn: "localization",
  er: "contentSecurityNonce",
  re: "allowUserSuppliedJavascript",
  No: "inAppMessageZIndex",
  Ko: "openInAppMessagesInNewTab",
  tn: "openCardsInNewTab",
  en: "openNewsFeedCardsInNewTab",
  mh: "requireExplicitInAppMessageDismissal",
  Ea: "doNotLoadFontAwesome",
  Ia: "deviceId",
  Aa: "serviceWorkerScope",
  Na: "sdkFlavor",
};
class Vt {
  constructor() {
    (this.un = ""),
      (this.Oa = ""),
      (this.Ta = void 0),
      (this.Ra = null),
      (this.an = null),
      (this.S = null),
      (this.Fi = null),
      (this.B = null),
      (this.T = null),
      (this.C = null),
      (this.Cs = null),
      (this.Pa = ""),
      (this.isInitialized = !1),
      (this.La = !1),
      (this.Ua = new subscription_manager/* default */.Z()),
      (this.Wa = new subscription_manager/* default */.Z()),
      (this.options = {}),
      (this.Va = []),
      (this.Fa = []),
      (this.Mi = []),
      (this.Oa = "5.8.1");
  }
  Ka(t) {
    this.Ua.Ft(t);
  }
  Nh(t) {
    this.Wa.Ft(t);
  }
  initialize(t, i) {
    if (this._t())
      return logger/* default.info */.Z.info("Braze has already been initialized with an API key."), !0;
    this.options = i || {};
    let e = this.ee(w.Kh);
    const r = (0,url_utils/* parseQueryStringKeyValues */.L)(window_utils/* WindowUtils.Ga */.SD.Ga());
    if (
      (r && "true" === r.brazeLogging && (e = !0),
      logger/* default.init */.Z.init(e),
      logger/* default.info */.Z.info(
        `Initialization Options: ${JSON.stringify(this.options, null, 2)}`,
      ),
      null == t || "" === t || "string" != typeof t)
    )
      return logger/* default.error */.Z.error("Braze requires a valid API key to be initialized."), !1;
    this.un = t;
    let n = this.ee(w.Zo);
    if (null == n || "" === n || "string" != typeof n)
      return logger/* default.error */.Z.error("Braze requires a valid baseUrl to be initialized."), !1;
    !1 === /^https?:/.test(n) && (n = `https://${n}`);
    const o = n;
    if (
      ((n = document.createElement("a")),
      (n.href = o),
      "/" === n.pathname && (n = `${n}api/v3`),
      (this.Pa = n.toString()),
      browser_detector/* default.$a */.Z.$a && !this.ee(w.Yo))
    )
      return (
        logger/* default.info */.Z.info("Ignoring activity from crawler bot " + navigator.userAgent),
        (this.La = !0),
        !1
      );
    const h = this.ee(w.Wh) || !1;
    if (
      ((this.C = storage_manager_factory.Ja(t, h)), h && this.C.Ya(t), new storage_manager/* default.se */.Z.se(null, !0).gr(storage_manager/* STORAGE_KEYS.me */.I.me))
    )
      return (
        logger/* default.info */.Z.info("Ignoring all activity due to previous opt out"),
        (this.La = !0),
        !1
      );
    for (const t of (0,code_utils/* keys */.XP)(this.options))
      -1 === (0,code_utils/* values */.VO)(supported_options).indexOf(t) &&
        logger/* default.warn */.Z.warn(`Ignoring unknown initialization option '${t}'.`);
    const a = ["mparticle", "wordpress", "tealium"];
    if (null != this.ee(w.Na)) {
      const t = this.ee(w.Na);
      -1 !== a.indexOf(t)
        ? (this.Ta = t)
        : logger/* default.error */.Z.error("Invalid sdk flavor passed: " + t);
    }
    let l = this.ee(supported_options.Vh);
    if (null != l)
      if ((0,code_utils/* isArray */.kJ)(l)) {
        const t = [];
        for (let i = 0; i < l.length; i++)
          (0,code_utils/* validateValueIsFromEnum */.fk)(
            device_properties/* default */.Z,
            l[i],
            "devicePropertyAllowlist contained an invalid value.",
            "DeviceProperties",
          ) && t.push(l[i]);
        l = t;
      } else
        logger/* default.error */.Z.error(
          "devicePropertyAllowlist must be an array. Defaulting to all properties.",
        ),
          (l = null);
    const c = this.ee(w.Ia);
    if (c) {
      const t = new identifier/* default */.Z(c);
      this.C.uu(storage_manager/* STORAGE_KEYS.iu.Ia */.I.iu.Ia, t);
    }
    (this.an = new Ot(this.C, l)),
      (this.B = new Mt(this.C)),
      (this.Cs = new bt(this.B, this.C)),
      (this.T = new Wt(this.C, this.Cs, this.B, this.ee(w.Xh)));
    const f = new subscription_manager/* default */.Z();
    return (
      (this.Ra = new kt(this.C, this.ee(w.$h), f)),
      this.N(f),
      (this.S = new Pt(
        this.an,
        this.C,
        this.Ra,
        this.Cs,
        this.T,
        this.B,
        this.un,
        this.Pa,
        this.Oa,
        this.Ta || "",
        this.ee(w.Zh),
        this.ee(w.Qh),
      )),
      (this.Fi = new Lt(
        this.un,
        this.Pa,
        this.T,
        this.an,
        this.Cs,
        this.B,
        this.C,
        (t) => {
          if (this._t()) for (const i of this.ar()) i.U(t);
        },
        this.Ra,
        this.S,
      )),
      this.Fi.initialize(),
      h || this.C.Ha(),
      logger/* default.info */.Z.info(
        `Initialized for the Braze backend at "${this.ee(
          w.Zo,
        )}" with API key "${this.un}".`,
      ),
      triggers_provider_factory/* TriggersProviderFactory.p */.n.p(),
      this.B.Ke(() => {
        var t;
        this.isInitialized &&
          (null === (t = this.B) || void 0 === t ? void 0 : t.Be()) &&
          Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 992)).then((t) => {
            if (!this.isInitialized) return;
            (0, t.default)();
          });
      }),
      this.Fi.rn(() => {
        var t;
        this.isInitialized &&
          (null === (t = this.B) || void 0 === t ? void 0 : t.Be()) &&
          Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 992)).then((t) => {
            if (!this.isInitialized) return;
            (0, t.default)(void 0, void 0, !0);
          });
      }),
      this.Ua.X(this.options),
      (this.isInitialized = !0),
      window.dispatchEvent(new CustomEvent("braze.initialized")),
      !0
    );
  }
  destroy(t) {
    if ((logger/* default.destroy */.Z.destroy(), this._t())) {
      this.Wa.X(), this.Wa.removeAllSubscriptions();
      for (const t of this.Va) t.destroy();
      this.Va = [];
      for (const t of this.Fa) t.clearData(!1);
      (this.Fa = []),
        this.removeAllSubscriptions(),
        (this.Mi = []),
        null != this.Fi && this.Fi.destroy(),
        (this.Fi = null),
        (this.Ra = null),
        (this.an = null),
        (this.S = null),
        (this.B = null),
        (this.T = null),
        (this.Cs = null),
        (this.options = {}),
        (this.Ta = void 0),
        (this.isInitialized = !1),
        (this.La = !1),
        t && (this.C = null);
    }
  }
  rr() {
    return !this.Xa() && (!!this._t() || (console.warn(constants/* BRAZE_MUST_BE_INITIALIZED_ERROR */.Go), !1));
  }
  Ma() {
    return this.un;
  }
  Sr() {
    return this.Ra;
  }
  Z() {
    return this.Pa;
  }
  ue() {
    return this.an;
  }
  g() {
    return this.S;
  }
  ee(t) {
    return this.options[t];
  }
  ar() {
    return this.Fa;
  }
  nn() {
    return this.Fi;
  }
  v() {
    return this.B;
  }
  P() {
    return this.T;
  }
  j() {
    return this.C;
  }
  mr() {
    if (this.Cs && this.Fi) return new user/* default */.Z(this.Cs, this.Fi);
  }
  ir() {
    return this.Cs;
  }
  tr() {
    return !0 === this.ee(w.re);
  }
  h(t) {
    let i = !1;
    for (const s of this.Va) s === t && (i = !0);
    i || this.Va.push(t);
  }
  _(i) {
    let s = !1;
    for (const t of this.Fa) t.constructor === i.constructor && (s = !0);
    i instanceof base_provider/* default */.Z && !s && this.Fa.push(i);
  }
  N(t) {
    t instanceof subscription_manager/* default */.Z && this.Mi.push(t);
  }
  removeAllSubscriptions() {
    if (this.rr()) for (const t of this.Mi) t.removeAllSubscriptions();
  }
  removeSubscription(t) {
    if (this.rr()) for (const i of this.Mi) i.removeSubscription(t);
  }
  fe(t) {
    this.La = t;
  }
  _t() {
    return this.isInitialized;
  }
  Xa() {
    return this.La;
  }
  di() {
    return this.Oa;
  }
}
const r = new Vt();



/***/ }),

/***/ 45966:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ STORAGE_KEYS; },
/* harmony export */   "Z": function() { return /* binding */ ne; }
/* harmony export */ });
/* harmony import */ var _models_braze_event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57559);
/* harmony import */ var _models_identifier_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42308);
/* harmony import */ var _util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72893);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12730);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20335);
/* harmony import */ var _User_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17615);
/* harmony import */ var _util_browser_detector_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7169);
/* harmony import */ var _util_error_utils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8031);







const STORAGE_KEYS = {
  iu: {
    su: "ab.storage.userId",
    Ia: "ab.storage.deviceId",
    Nl: "ab.storage.sessionId",
  },
  gt: {
    ac: "ab.test",
    tE: "ab.storage.events",
    eE: "ab.storage.attributes",
    sE: "ab.storage.attributes.anonymous_user",
    ic: "ab.storage.device",
    vu: "ab.storage.sdk_metadata",
    pu: "ab.storage.session_id_for_cached_metadata",
    qn: "ab.storage.pushToken",
    qi: "ab.storage.newsFeed",
    zi: "ab.storage.lastNewsFeedRefresh",
    Zt: "ab.storage.cardImpressions",
    cl: "ab.storage.serverConfig",
    rE: "ab.storage.triggers",
    oE: "ab.storage.triggers.ts",
    Hl: "ab.storage.messagingSessionStart",
    Is: "ab.storage.cc",
    Qs: "ab.storage.ccLastFullSync",
    Vs: "ab.storage.ccLastCardUpdated",
    xu: "ab.storage.globalRateLimitCurrentTokenCount",
    Gu: "ab.storage.dynamicRateLimitCurrentTokenCount",
    Kt: "ab.storage.ccClicks",
    Yt: "ab.storage.ccImpressions",
    Vt: "ab.storage.ccDismissals",
    nE: "ab.storage.lastDisplayedTriggerTimesById",
    aE: "ab.storage.lastDisplayedTriggerTime",
    iE: "ab.storage.triggerFireInstancesById",
    xh: "ab.storage.signature",
    EE: "ab.storage.brazeSyncRetryCount",
    fi: "ab.storage.sdkVersion",
    Xe: "ab.storage.ff",
    Ge: "ab.storage.ffImpressions",
    Ze: "ab.storage.ffLastRefreshAt",
    Ve: "ab.storage.ff.sessionId",
    lE: "ab.storage.lastReqToEndpoint",
    SE: "ab.storage.requestAttempts",
    Lr: "ab.storage.deferredIam",
    Eu: "ab.storage.lastSdkReq",
    _E: "ab.storage.alias",
    vt: "ab.storage.banners",
    kt: "ab.storage.banners.impressions",
    yt: "ab.storage.banners.sessionId",
  },
  me: "ab.optOut",
};
class ne {
  constructor(t, e) {
    (this.uE = t), (this.cE = e), (this.uE = t), (this.cE = e);
  }
  Ya(t) {
    const e = (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .keys */ .XP)(STORAGE_KEYS.iu),
      s = new ne.se(t);
    for (const t of e) s.remove(STORAGE_KEYS.iu[t]);
  }
  uu(t, e) {
    let s = null;
    null != e && e instanceof _models_identifier_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z && (s = e.bt()), this.uE.store(t, s);
  }
  TE(t) {
    const e = this.tu(t);
    null != e && ((e.ql = new Date().valueOf()), this.uu(t, e));
  }
  tu(t) {
    const e = this.uE.gr(t),
      s = ((t) => {
        let e;
        try {
          e = JSON.parse(t);
        } catch (t) {
          e = null;
        }
        return e;
      })(e);
    let r;
    if (s) (r = _models_identifier_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].En */ .Z.En(s) || null), r && this.uu(t, r);
    else {
      const s = _models_identifier_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].hE */ .Z.hE(e);
      (r = _models_identifier_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].En */ .Z.En(s) || null), s !== e && r && this.uu(t, r);
    }
    return r;
  }
  Il(t) {
    this.uE.remove(t);
  }
  Ha() {
    const t = (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .keys */ .XP)(STORAGE_KEYS.iu);
    let e;
    for (const s of t)
      (e = this.tu(STORAGE_KEYS.iu[s])),
        null != e && this.uu(STORAGE_KEYS.iu[s], e);
  }
  Vo(t) {
    let e;
    if (null == t || 0 === t.length) return !1;
    e = (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .kJ)(t) ? t : [t];
    let s = this.cE.gr(STORAGE_KEYS.gt.tE);
    (null != s && (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .kJ)(s)) || (s = []);
    for (let t = 0; t < e.length; t++) s.push(e[t].bt());
    return this.cE.store(STORAGE_KEYS.gt.tE, s);
  }
  Al(t) {
    return null != t && this.Vo([t]);
  }
  AE() {
    let t = this.cE.gr(STORAGE_KEYS.gt.tE);
    this.cE.remove(STORAGE_KEYS.gt.tE), null == t && (t = []);
    const e = [];
    let s = !1,
      r = null;
    if ((0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .kJ)(t))
      for (let s = 0; s < t.length; s++)
        _models_braze_event_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].RE */ .Z.RE(t[s]) ? e.push(_models_braze_event_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].En */ .Z.En(t[s])) : (r = s);
    else s = !0;
    if (s || null != r) {
      let o = "Stored events could not be deserialized as Events";
      s &&
        (o += ", was " + Object.prototype.toString.call(t) + " not an array"),
        null != r &&
          (o += ", value at index " + r + " does not look like an event"),
        (o +=
          ", serialized values were of type " +
          typeof t +
          ": " +
          JSON.stringify(t)),
        e.push(new _models_braze_event_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(null, _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_3__/* .EventTypes.bu */ .G.bu, new Date().valueOf(), null, { e: o }));
    }
    return e;
  }
  Bt(t, e) {
    return (
      !!(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .validateValueIsFromEnum */ .fk)(
        STORAGE_KEYS.gt,
        t,
        "StorageManager cannot store object.",
        "STORAGE_KEYS.OBJECTS",
      ) && this.cE.store(t, e)
    );
  }
  ft(t) {
    return (
      !!(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .validateValueIsFromEnum */ .fk)(
        STORAGE_KEYS.gt,
        t,
        "StorageManager cannot retrieve object.",
        "STORAGE_KEYS.OBJECTS",
      ) && this.cE.gr(t)
    );
  }
  Ut(t) {
    return (
      !!(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .validateValueIsFromEnum */ .fk)(
        STORAGE_KEYS.gt,
        t,
        "StorageManager cannot remove object.",
        "STORAGE_KEYS.OBJECTS",
      ) && (this.cE.remove(t), !0)
    );
  }
  clearData() {
    const t = (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .keys */ .XP)(STORAGE_KEYS.iu),
      e = (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .keys */ .XP)(STORAGE_KEYS.gt);
    for (let e = 0; e < t.length; e++) {
      const s = t[e];
      this.uE.remove(STORAGE_KEYS.iu[s]);
    }
    for (let t = 0; t < e.length; t++) {
      const s = e[t];
      this.cE.remove(STORAGE_KEYS.gt[s]);
    }
  }
  gE(t) {
    return t || STORAGE_KEYS.gt.sE;
  }
  wu(t) {
    let e = this.cE.gr(STORAGE_KEYS.gt.eE);
    null == e && (e = {});
    const s = this.gE(t[_User_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Qn */ .Z.Qn]),
      r = e[s];
    for (const o in t)
      o !== _User_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Qn */ .Z.Qn &&
        (null == e[s] || (r && null == r[o])) &&
        this.mu(t[_User_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Qn */ .Z.Qn], o, t[o]);
  }
  mu(t, e, s) {
    let r = this.cE.gr(STORAGE_KEYS.gt.eE);
    null == r && (r = {});
    const o = this.gE(t);
    let n = r[o];
    if (
      (null == n && ((n = {}), null != t && (n[_User_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Qn */ .Z.Qn] = t)), e === _User_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lu */ .Z.lu)
    ) {
      null == n[e] && (n[e] = {});
      for (const t in s) n[e][t] = s[t];
    } else n[e] = s;
    return (r[o] = n), this.cE.store(STORAGE_KEYS.gt.eE, r);
  }
  OE() {
    const t = this.cE.gr(STORAGE_KEYS.gt.eE);
    this.cE.remove(STORAGE_KEYS.gt.eE);
    const e = [];
    for (const s in t) null != t[s] && e.push(t[s]);
    return e;
  }
  ru(t) {
    const e = this.cE.gr(STORAGE_KEYS.gt.eE);
    if (null != e) {
      const s = this.gE(null),
        r = e[s];
      null != r &&
        ((e[s] = void 0),
        this.cE.store(STORAGE_KEYS.gt.eE, e),
        (r[_User_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Qn */ .Z.Qn] = t),
        this.wu(r));
    }
    const s = this.tu(STORAGE_KEYS.iu.Nl);
    let r = null;
    null != s && (r = s.eu);
    const o = this.AE();
    if (null != o)
      for (let e = 0; e < o.length; e++) {
        const s = o[e];
        null == s.userId && s.sessionId == r && (s.userId = t), this.Al(s);
      }
  }
  IE() {
    return this.cE.dE;
  }
}
(ne.lc = class {
  constructor(t) {
    (this.un = t), (this.un = t), (this.dE = _util_browser_detector_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].fE */ .Z.fE() ? 3 : 10);
  }
  bE(t) {
    return t + "." + this.un;
  }
  store(t, e) {
    const s = { v: e };
    try {
      return localStorage.setItem(this.bE(t), JSON.stringify(s)), !0;
    } catch (t) {
      return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].info */ .Z.info("Storage failure: " + (0,_util_error_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .getErrorMessage */ .e)(t)), !1;
    }
  }
  gr(t) {
    try {
      let e = null;
      const s = localStorage.getItem(this.bE(t));
      return null != s && (e = JSON.parse(s)), null == e ? null : e.v;
    } catch (t) {
      return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].info */ .Z.info("Storage retrieval failure: " + (0,_util_error_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .getErrorMessage */ .e)(t)), null;
    }
  }
  remove(t) {
    try {
      localStorage.removeItem(this.bE(t));
    } catch (t) {
      return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].info */ .Z.info("Storage removal failure: " + (0,_util_error_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .getErrorMessage */ .e)(t)), !1;
    }
  }
}),
  (ne.gc = class {
    constructor() {
      (this.KE = {}), (this.mE = 5242880), (this.dE = 3);
    }
    store(t, e) {
      const s = { value: e },
        r = this.YE(e);
      return r > this.mE
        ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].info */ .Z.info(
            "Storage failure: object is ≈" +
              r +
              " bytes which is greater than the max of " +
              this.mE,
          ),
          !1)
        : ((this.KE[t] = s), !0);
    }
    YE(t) {
      const e = [],
        s = [t];
      let r = 0;
      for (; s.length; ) {
        const t = s.pop();
        if ("boolean" == typeof t) r += 4;
        else if ("string" == typeof t) r += 2 * t.length;
        else if ("number" == typeof t) r += 8;
        else if ("object" == typeof t && -1 === e.indexOf(t)) {
          let r, o;
          e.push(t);
          for (const e in t) (o = t), (r = e), s.push(o[r]);
        }
      }
      return r;
    }
    gr(t) {
      const e = this.KE[t];
      return null == e ? null : e.value;
    }
    remove(t) {
      this.KE[t] = null;
    }
  }),
  (ne.se = class {
    constructor(t, e) {
      (this.un = t),
        (this.NE = e),
        (this.un = t),
        (this.GE = this.DE()),
        (this.CE = 576e3),
        (this.NE = !!e);
    }
    bE(t) {
      return null != this.un ? t + "." + this.un : t;
    }
    DE() {
      let t = 0,
        e = document.location.hostname;
      const s = e.split("."),
        r = "ab._gd";
      for (; t < s.length - 1 && -1 === document.cookie.indexOf(r + "=" + r); )
        t++,
          (e = "." + s.slice(-1 - t).join(".")),
          (document.cookie = r + "=" + r + ";domain=" + e + ";");
      return (
        (document.cookie =
          r + "=;expires=" + new Date(0).toUTCString() + ";domain=" + e + ";"),
        e
      );
    }
    le() {
      const t = new Date();
      return t.setTime(t.getTime() + 60 * this.CE * 1e3), t.getFullYear();
    }
    ME() {
      const t = (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .values */ .VO)(STORAGE_KEYS.iu),
        e = document.cookie.split(";");
      for (let s = 0; s < e.length; s++) {
        let r = e[s];
        for (; " " === r.charAt(0); ) r = r.substring(1);
        let o = !1;
        for (let e = 0; e < t.length; e++)
          if (0 === r.indexOf(t[e])) {
            o = !0;
            break;
          }
        if (o) {
          const t = r.split("=")[0];
          -1 === t.indexOf("." + this.un) && this.pE(t);
        }
      }
    }
    store(t, e) {
      this.ME();
      const s = new Date();
      s.setTime(s.getTime() + 60 * this.CE * 1e3);
      const r = "expires=" + s.toUTCString(),
        o = "domain=" + this.GE;
      let n;
      n = this.NE ? e : encodeURIComponent(e);
      const a = this.bE(t) + "=" + n + ";" + r + ";" + o + ";path=/";
      return a.length >= 4093
        ? (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].info */ .Z.info(
            "Storage failure: string is " +
              a.length +
              " chars which is too large to store as a cookie.",
          ),
          !1)
        : ((document.cookie = a), !0);
    }
    gr(t) {
      const e = [],
        s = this.bE(t) + "=",
        r = document.cookie.split(";");
      for (let o = 0; o < r.length; o++) {
        let n = r[o];
        for (; " " === n.charAt(0); ) n = n.substring(1);
        if (0 === n.indexOf(s))
          try {
            let t;
            (t = this.NE
              ? n.substring(s.length, n.length)
              : decodeURIComponent(n.substring(s.length, n.length))),
              e.push(t);
          } catch (e) {
            return (
              _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"].info */ .Z.info("Storage retrieval failure: " + (0,_util_error_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .getErrorMessage */ .e)(e)),
              this.remove(t),
              null
            );
          }
      }
      return e.length > 0 ? e[e.length - 1] : null;
    }
    remove(t) {
      this.pE(this.bE(t));
    }
    pE(t) {
      const e = t + "=;expires=" + new Date(0).toUTCString();
      (document.cookie = e), (document.cookie = e + ";path=/");
      const s = e + ";domain=" + this.GE;
      (document.cookie = s), (document.cookie = s + ";path=/");
    }
  }),
  (ne.cc = class {
    constructor(t, e, s) {
      (this.un = t),
        (this.vE = []),
        e && this.vE.push(new ne.se(t)),
        s && this.vE.push(new ne.lc(t)),
        this.vE.push(new ne.gc());
    }
    store(t, e) {
      let s = !0;
      for (let r = 0; r < this.vE.length; r++) s = this.vE[r].store(t, e) && s;
      return s;
    }
    gr(t) {
      for (let e = 0; e < this.vE.length; e++) {
        const s = this.vE[e].gr(t);
        if (null != s) return s;
      }
      return null;
    }
    remove(t) {
      new ne.se(this.un).remove(t);
      for (let e = 0; e < this.vE.length; e++) this.vE[e].remove(t);
    }
  });


/***/ }),

/***/ 74663:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57070);

class u {
  constructor() {
    this.Mi = {};
  }
  Ft(t) {
    if ("function" != typeof t) return null;
    const i = _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ce */ .Z.ce();
    return (this.Mi[i] = t), i;
  }
  removeSubscription(t) {
    delete this.Mi[t];
  }
  removeAllSubscriptions() {
    this.Mi = {};
  }
  uc() {
    return Object.keys(this.Mi).length;
  }
  X(t) {
    const i = [];
    for (const s in this.Mi) {
      const r = this.Mi[s];
      i.push(r(t));
    }
    return i;
  }
}


/***/ }),

/***/ 18982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getAlias; }
/* harmony export */ });
/* harmony import */ var _storage_manager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45966);

function getAlias(e) {
  const t = null == e ? void 0 : e.ft(_storage_manager_js__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEYS.gt._E */ .I.gt._E);
  let n;
  return t && (n = { label: t.l, name: t.a }), n;
}


/***/ }),

/***/ 63826:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
  Au: "invalid_api_key",
  Du: "blacklisted",
  ku: "no_device_identifier",
  qu: "invalid_json_response",
  gu: "empty_response",
  __: "sdk_auth_error",
});


/***/ }),

/***/ 57559:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ve; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88468);
/* harmony import */ var _managers_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18982);
/* harmony import */ var _util_code_utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72893);
/* harmony import */ var _util_date_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57750);




class ve {
  constructor(t, s, i, r, e) {
    (this.userId = t),
      (this.type = s),
      (this.time = i),
      (this.sessionId = r),
      (this.data = e),
      (this.userId = t),
      (this.type = s),
      (this.time = (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .timestampOrNow */ ._0)(i)),
      (this.sessionId = r),
      (this.data = e);
  }
  $r() {
    var t;
    const s = {
      name: this.type,
      time: (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .convertMsToSeconds */ .FX)(this.time),
      data: this.data || {},
      session_id: this.sessionId,
    };
    null != this.userId && (s.user_id = this.userId);
    const i = (null === (t = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Sr */ .ZP.Sr()) || void 0 === t ? void 0 : t.wh()) || !1;
    if (!s.user_id && !i) {
      const t = (0,_managers_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .getAlias */ .q)(_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].j */ .ZP.j());
      t && (s.alias = t);
    }
    return s;
  }
  bt() {
    return {
      u: this.userId,
      t: this.type,
      ts: this.time,
      s: this.sessionId,
      d: this.data,
    };
  }
  static fromJson(t) {
    return new ve(t.user_id, t.name, t.time, t.session_id, t.data);
  }
  static RE(t) {
    return null != t && (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .isObject */ .Kn)(t) && null != t.t && "" !== t.t;
  }
  static En(t) {
    return new ve(t.u, t.t, t.ts, t.s, t.d);
  }
}


/***/ }),

/***/ 42308:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _t; }
/* harmony export */ });
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57070);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20335);
/* harmony import */ var _util_code_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72893);
/* harmony import */ var _util_error_utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8031);



class _t {
  constructor(t, e, i) {
    (this.eu = t),
      null == t && (t = _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ce */ .Z.ce()),
      !i || isNaN(i) ? (this.Gl = new Date().valueOf()) : (this.Gl = i),
      (this.eu = t),
      (this.ql = new Date().valueOf()),
      (this.kl = e);
  }
  bt() {
    return `g:${encodeURIComponent(this.eu)}|e:${this.kl}|c:${this.Gl}|l:${
      this.ql
    }`;
  }
  static hE(t) {
    if ("string" != typeof t) return null;
    const e = t.lastIndexOf("|e:"),
      i = t.substring(0, e),
      r = i.split("g:")[1];
    let n;
    return (
      (n = /[|:]/.test(r) ? encodeURIComponent(r) : r),
      (t = t.replace(i, `g:${n}`))
    );
  }
  static En(t) {
    let e;
    if ("string" == typeof t)
      try {
        const i = t.split("|");
        if (!(0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ)(i) || 4 !== i.length) return null;
        const r = (t) => t.split(":")[1],
          n = (t) => {
            const e = parseInt(r(t));
            if (!isNaN(e)) return e;
          };
        (e = new _t(decodeURIComponent(r(i[0])), n(i[1]), n(i[2]))),
          (e.ql = n(i[3]));
      } catch (e) {
        _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].info */ .Z.info(
          `Unable to parse cookie string ${t}, failed with error: ${(0,_util_error_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .getErrorMessage */ .e)(e)}`,
        );
      }
    else {
      if (null == t || null == t.g) return null;
      (e = new _t(t.g, t.e, t.c)), (e.ql = t.l);
    }
    return e;
  }
}


/***/ }),

/***/ 63552:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ti; }
/* harmony export */ });
/* harmony import */ var _util_date_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57750);

class ti {
  constructor(t, i, s, l, h) {
    (this.endpoint = t),
      (this.zn = i),
      (this.publicKey = s),
      (this.Vl = l),
      (this.fl = h),
      (this.endpoint = t || null),
      (this.zn = i || null),
      (this.publicKey = s || null),
      (this.Vl = l || null),
      (this.fl = h || null);
  }
  bt() {
    return {
      e: this.endpoint,
      c: this.zn,
      p: this.publicKey,
      u: this.Vl,
      v: this.fl,
    };
  }
  static En(t) {
    return new ti(t.e, (0,_util_date_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .rehydrateDateAfterJsonization */ .Rd)(t.c), t.p, t.u, t.v);
  }
}


/***/ }),

/***/ 24673:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ E; }
/* harmony export */ });
class E {
  constructor(t = !1, s = []) {
    (this.tt = t), (this.$e = s), (this.tt = t), (this.$e = s);
  }
  rs(t) {
    (this.tt = this.tt && t.tt), this.$e.push(...t.$e);
  }
}


/***/ }),

/***/ 24365:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
  OPEN: "open",
  Rr: "purchase",
  hr: "push_click",
  Ee: "custom_event",
  Bo: "iam_click",
  Bs: "test",
});


/***/ }),

/***/ 52134:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pt; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/date-utils.js
var date_utils = __webpack_require__(57750);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/custom-event-data.js
class ts {
  constructor(t) {
    (this.xc = t), (this.xc = t);
  }
  yc(t) {
    return null == this.xc || this.xc === t[0];
  }
  static fromJson(t) {
    return new ts(t ? t.event_name : null);
  }
  bt() {
    return this.xc;
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/code-utils.js
var code_utils = __webpack_require__(72893);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/filter.js


class fr {
  constructor(t, s, e, i) {
    (this.yE = t),
      (this.HE = s),
      (this.comparator = e),
      (this.LE = i),
      (this.yE = t),
      (this.HE = s),
      (this.comparator = e),
      (this.LE = i),
      this.HE === fr.QE.UE &&
        this.comparator !== fr.wE.XE &&
        this.comparator !== fr.wE.BE &&
        this.comparator !== fr.wE.jE &&
        this.comparator !== fr.wE.zE &&
        (this.LE = (0,date_utils/* dateFromUnixTimestamp */.X2)(this.LE));
  }
  yc(t) {
    let s = null;
    switch ((null != t && (s = t[this.yE]), this.comparator)) {
      case fr.wE.FE:
        return null != s && s.valueOf() === this.LE.valueOf();
      case fr.wE.kE:
        return null == s || s.valueOf() !== this.LE.valueOf();
      case fr.wE.xE:
        return null != s && typeof s == typeof this.LE && s > this.LE;
      case fr.wE.XE:
        return this.HE === fr.QE.UE
          ? null != s && (0,code_utils/* isDate */.J_)(s) && (0,date_utils/* secondsAgo */.$N)(s) <= this.LE.valueOf()
          : null != s && typeof s == typeof this.LE && s >= this.LE;
      case fr.wE.JE:
        return null != s && typeof s == typeof this.LE && s < this.LE;
      case fr.wE.BE:
        return this.HE === fr.QE.UE
          ? null != s && (0,code_utils/* isDate */.J_)(s) && (0,date_utils/* secondsAgo */.$N)(s) >= this.LE.valueOf()
          : null != s && typeof s == typeof this.LE && s <= this.LE;
      case fr.wE.VE:
        return (
          null != s &&
          "string" == typeof s &&
          typeof s == typeof this.LE &&
          null != s.match(this.LE)
        );
      case fr.wE.qE:
        return null != s;
      case fr.wE.PE:
        return null == s;
      case fr.wE.jE:
        return null != s && (0,code_utils/* isDate */.J_)(s) && (0,date_utils/* secondsInTheFuture */.yo)(s) < this.LE;
      case fr.wE.zE:
        return null != s && (0,code_utils/* isDate */.J_)(s) && (0,date_utils/* secondsInTheFuture */.yo)(s) > this.LE;
      case fr.wE.WE:
        return (
          null == s ||
          typeof s != typeof this.LE ||
          "string" != typeof s ||
          null == s.match(this.LE)
        );
    }
    return !1;
  }
  static fromJson(t) {
    return new fr(
      t.property_key,
      t.property_type,
      t.comparator,
      t.property_value,
    );
  }
  bt() {
    let t = this.LE;
    return (
      (0,code_utils/* isDate */.J_)(this.LE) && (t = (0,date_utils/* convertMsToSeconds */.FX)(t.valueOf())),
      { k: this.yE, t: this.HE, c: this.comparator, v: t }
    );
  }
  static En(t) {
    return new fr(t.k, t.t, t.c, t.v);
  }
}
(fr.QE = { ZE: "boolean", $E: "number", tT: "string", UE: "date" }),
  (fr.wE = {
    FE: 1,
    kE: 2,
    xE: 3,
    XE: 4,
    JE: 5,
    BE: 6,
    VE: 10,
    qE: 11,
    PE: 12,
    jE: 15,
    zE: 16,
    WE: 17,
  });

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/filter-set.js


class is {
  constructor(t) {
    (this.filters = t), (this.filters = t);
  }
  yc(t) {
    let r = !0;
    for (let e = 0; e < this.filters.length; e++) {
      const o = this.filters[e];
      let s = !1;
      for (let r = 0; r < o.length; r++)
        if (o[r].yc(t)) {
          s = !0;
          break;
        }
      if (!s) {
        r = !1;
        break;
      }
    }
    return r;
  }
  static fromJson(t) {
    if (null == t || !(0,code_utils/* isArray */.kJ)(t)) return null;
    const r = [];
    for (let e = 0; e < t.length; e++) {
      const o = [],
        s = t[e];
      for (let t = 0; t < s.length; t++) o.push(fr.fromJson(s[t]));
      r.push(o);
    }
    return new is(r);
  }
  bt() {
    const t = [];
    for (let r = 0; r < this.filters.length; r++) {
      const e = this.filters[r],
        o = [];
      for (let t = 0; t < e.length; t++) o.push(e[t].bt());
      t.push(o);
    }
    return t;
  }
  static En(t) {
    const r = [];
    for (let e = 0; e < t.length; e++) {
      const o = [],
        s = t[e];
      for (let t = 0; t < s.length; t++) o.push(fr.En(s[t]));
      r.push(o);
    }
    return new is(r);
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/custom-event-property-data.js

class rs {
  constructor(t, s) {
    (this.xc = t), (this.tf = s), (this.xc = t), (this.tf = s);
  }
  yc(t) {
    if (null == this.xc || null == this.tf) return !1;
    const s = t[0],
      i = t[1];
    return s === this.xc && this.tf.yc(i);
  }
  static fromJson(t) {
    return new rs(
      t ? t.event_name : null,
      t ? is.fromJson(t.property_filters) : null,
    );
  }
  bt() {
    return { e: this.xc, pf: this.tf ? this.tf.bt() : null };
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/in-app-message-click-data.js

class ni {
  constructor(t, i) {
    (this.if = t), (this.rf = i), (this.if = t), (this.rf = i);
  }
  yc(t) {
    if (null == this.if) return !1;
    const i = ri.sf(t[0], this.if);
    if (!i) return !1;
    let r = null == this.rf || 0 === this.rf.length;
    if (null != this.rf)
      for (let i = 0; i < this.rf.length; i++)
        if (this.rf[i] === t[1]) {
          r = !0;
          break;
        }
    return i && r;
  }
  static fromJson(t) {
    return new ni(t ? t.id : null, t ? t.buttons : null);
  }
  bt() {
    return this.if;
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/purchase-data.js
class ns {
  constructor(t) {
    (this.productId = t), (this.productId = t);
  }
  yc(t) {
    return null == this.productId || t[0] === this.productId;
  }
  static fromJson(t) {
    return new ns(t ? t.product_id : null);
  }
  bt() {
    return this.productId;
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/purchase-property-data.js

class hs {
  constructor(t, s) {
    (this.productId = t), (this.tf = s), (this.productId = t), (this.tf = s);
  }
  yc(t) {
    if (null == this.productId || null == this.tf) return !1;
    const s = t[0],
      i = t[1];
    return s === this.productId && this.tf.yc(i);
  }
  static fromJson(t) {
    return new hs(
      t ? t.product_id : null,
      t ? is.fromJson(t.property_filters) : null,
    );
  }
  bt() {
    return { id: this.productId, pf: this.tf ? this.tf.bt() : null };
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/push-click-data.js

class ur {
  constructor(t) {
    (this.if = t), (this.if = t);
  }
  yc(t) {
    return null == this.if || ri.sf(t[0], this.if);
  }
  static fromJson(t) {
    return new ur(t ? t.campaign_id : null);
  }
  bt() {
    return this.if;
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/trigger-events.js
var trigger_events = __webpack_require__(24365);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/error-utils.js
var error_utils = __webpack_require__(8031);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/trigger-condition.js










class ri {
  constructor(e, t) {
    (this.type = e), (this.data = t), (this.type = e), (this.data = t);
  }
  _c(e, t) {
    return ri.Ec[this.type] === e && (null == this.data || this.data.yc(t));
  }
  static sf(e, t) {
    let r = null;
    try {
      r = window.atob(e);
    } catch (t) {
      return logger/* default.info */.Z.info("Failed to unencode analytics id " + e + ": " + (0,error_utils/* getErrorMessage */.e)(t)), !1;
    }
    return t === r.split("_")[0];
  }
  static fromJson(e) {
    const t = e.type;
    let r = null;
    switch (t) {
      case ri.Xr.OPEN:
      case ri.Xr.Bs:
        break;
      case ri.Xr.Rr:
        r = ns.fromJson(e.data);
        break;
      case ri.Xr.jc:
        r = hs.fromJson(e.data);
        break;
      case ri.Xr.hr:
        r = ur.fromJson(e.data);
        break;
      case ri.Xr.Ee:
        r = ts.fromJson(e.data);
        break;
      case ri.Xr.Cc:
        r = rs.fromJson(e.data);
        break;
      case ri.Xr.Bo:
        r = ni.fromJson(e.data);
    }
    return new ri(t, r);
  }
  bt() {
    return { t: this.type, d: this.data ? this.data.bt() : null };
  }
  static En(e) {
    let t,
      r = null;
    switch (e.t) {
      case ri.Xr.OPEN:
      case ri.Xr.Bs:
        break;
      case ri.Xr.Rr:
        r = new ns(e.d);
        break;
      case ri.Xr.jc:
        (t = e.d || {}), (r = new hs(t.id, is.En(t.pf || [])));
        break;
      case ri.Xr.hr:
        r = new ur(e.d);
        break;
      case ri.Xr.Ee:
        r = new ts(e.d);
        break;
      case ri.Xr.Cc:
        (t = e.d || {}), (r = new rs(t.e, is.En(t.pf || [])));
        break;
      case ri.Xr.Bo:
        r = new ni(e.d);
    }
    return new ri(e.t, r);
  }
}
(ri.Xr = {
  OPEN: "open",
  Rr: "purchase",
  jc: "purchase_property",
  hr: "push_click",
  Ee: "custom_event",
  Cc: "custom_event_property",
  Bo: "iam_click",
  Bs: "test",
}),
  (ri.Ec = {}),
  (ri.Ec[ri.Xr.OPEN] = trigger_events/* default.OPEN */.Z.OPEN),
  (ri.Ec[ri.Xr.Rr] = trigger_events/* default.Rr */.Z.Rr),
  (ri.Ec[ri.Xr.jc] = trigger_events/* default.Rr */.Z.Rr),
  (ri.Ec[ri.Xr.hr] = trigger_events/* default.hr */.Z.hr),
  (ri.Ec[ri.Xr.Ee] = trigger_events/* default.Ee */.Z.Ee),
  (ri.Ec[ri.Xr.Cc] = trigger_events/* default.Ee */.Z.Ee),
  (ri.Ec[ri.Xr.Bo] = trigger_events/* default.Bo */.Z.Bo),
  (ri.Ec[ri.Xr.Bs] = trigger_events/* default.Bs */.Z.Bs);

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/trigger.js




class pt {
  constructor(t, i = [], s, e, r = 0, h, l, o = 0, n = pt.td, a, u, d) {
    (this.id = t),
      (this.sd = i),
      (this.startTime = s),
      (this.endTime = e),
      (this.priority = r),
      (this.type = h),
      (this.data = l),
      (this.ed = o),
      (this.rd = n),
      (this.Kr = a),
      (this.hd = u),
      (this.od = d),
      (this.id = t),
      (this.sd = i || []),
      void 0 === s && (s = null),
      (this.startTime = s),
      void 0 === e && (e = null),
      (this.endTime = e),
      (this.priority = r || 0),
      (this.type = h),
      (this.ed = o || 0),
      null == a && (a = 1e3 * (this.ed + 30)),
      (this.Kr = a),
      (this.data = l),
      null != n && (this.rd = n),
      (this.hd = u),
      (this.od = d || null);
  }
  nd(t) {
    return (
      null == this.od || (this.rd !== pt.td && t - this.od >= 1e3 * this.rd)
    );
  }
  ad(t) {
    this.od = t;
  }
  ud(t) {
    const i = t + 1e3 * this.ed;
    return Math.max(i - new Date().valueOf(), 0);
  }
  dd(t) {
    const i = new Date().valueOf() - t,
      s = null == t || isNaN(i) || null == this.Kr || i < this.Kr;
    return (
      s ||
        logger/* default.info */.Z.info(
          `Trigger action ${this.type} is no longer eligible for display - fired ${i}ms ago and has a timeout of ${this.Kr}ms.`,
        ),
      !s
    );
  }
  static fromJson(t) {
    const i = t.id,
      s = [];
    for (let i = 0; i < t.trigger_condition.length; i++)
      s.push(ri.fromJson(t.trigger_condition[i]));
    const e = (0,date_utils/* dateFromUnixTimestamp */.X2)(t.start_time),
      r = (0,date_utils/* dateFromUnixTimestamp */.X2)(t.end_time),
      h = t.priority,
      l = t.type,
      o = t.delay,
      n = t.re_eligibility,
      a = t.timeout,
      u = t.data,
      d = t.min_seconds_since_last_trigger;
    return (0,code_utils/* validateValueIsFromEnum */.fk)(
      pt.Xr,
      l,
      "Could not construct Trigger from server data",
      "Trigger.Types",
    )
      ? new pt(i, s, e, r, h, l, u, o, n, a, d)
      : null;
  }
  bt() {
    const t = [];
    for (let i = 0; i < this.sd.length; i++) t.push(this.sd[i].bt());
    return {
      i: this.id,
      c: t,
      s: this.startTime,
      e: this.endTime,
      p: this.priority,
      t: this.type,
      da: this.data,
      d: this.ed,
      r: this.rd,
      tm: this.Kr,
      ss: this.hd,
      ld: this.od,
    };
  }
  static En(t) {
    const i = [],
      s = t.c || [];
    for (let t = 0; t < s.length; t++) i.push(ri.En(s[t]));
    return new pt(
      t.i,
      i,
      (0,date_utils/* rehydrateDateAfterJsonization */.Rd)(t.s),
      (0,date_utils/* rehydrateDateAfterJsonization */.Rd)(t.e),
      t.p,
      t.t,
      t.da,
      t.d,
      t.r,
      t.tm,
      t.ss,
      t.ld,
    );
  }
}
(pt.Xr = { Or: "inapp", md: "templated_iam" }), (pt.td = -1);


/***/ }),

/***/ 85346:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ TriggersProviderFactory; }
});

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/in-app-message-manager-factory.js + 1 modules
var in_app_message_manager_factory = __webpack_require__(79602);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/braze-instance.js + 11 modules
var braze_instance = __webpack_require__(88468);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/common/base-provider.js
var base_provider = __webpack_require__(40158);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/in-app-message-factory.js
var in_app_message_factory = __webpack_require__(23340);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/models/braze-event.js
var braze_event = __webpack_require__(57559);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/code-utils.js
var code_utils = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/managers/storage-manager.js
var storage_manager = __webpack_require__(45966);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/templated-in-app-message.js
class wt {
  constructor(t, s, i, h, l) {
    (this.triggerId = t),
      (this.Hr = s),
      (this.Cr = i),
      (this.Jr = h),
      (this.Kr = l),
      (this.triggerId = t),
      (this.Hr = s),
      (this.Cr = i),
      (this.Jr = h),
      (this.Kr = l);
  }
  static fromJson(t, s, i, h, l) {
    return null == t || null == t.trigger_id
      ? null
      : new wt(t.trigger_id, s, i, h, l);
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/trigger.js + 9 modules
var trigger = __webpack_require__(52134);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/triggers/models/trigger-events.js
var trigger_events = __webpack_require__(24365);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/shared-lib/logger.js
var logger = __webpack_require__(20335);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/triggers-provider.js









class gr extends base_provider/* default */.Z {
  constructor(t, i, s, e, r) {
    super(),
      (this.tg = t),
      (this.Ts = i),
      (this.C = s),
      (this.Fi = e),
      (this.ig = r),
      (this.tg = t),
      (this.Ts = i),
      (this.C = s),
      (this.Fi = e),
      (this.ig = r),
      (this.sg = []),
      (this.eg = []),
      (this.hg = null),
      (this.ng = {}),
      (this.og = {}),
      (this.triggers = []),
      (this.lg = 0),
      this.ag(),
      this.gg();
  }
  fg() {
    if (this.C) {
      (this.hg = this.C.ft(storage_manager/* STORAGE_KEYS.gt.aE */.I.gt.aE) || this.hg),
        (this.ng = this.C.ft(storage_manager/* STORAGE_KEYS.gt.iE */.I.gt.iE) || this.ng),
        (this.og = this.C.ft(storage_manager/* STORAGE_KEYS.gt.nE */.I.gt.nE) || this.og);
      for (let t = 0; t < this.triggers.length; t++) {
        const i = this.triggers[t];
        i.id && null != this.og[i.id] && i.ad(this.og[i.id]);
      }
    }
  }
  ag() {
    if (!this.C) return;
    this.lg = this.C.ft(storage_manager/* STORAGE_KEYS.gt.oE */.I.gt.oE) || 0;
    const t = this.C.ft(storage_manager/* STORAGE_KEYS.gt.rE */.I.gt.rE) || [],
      i = [];
    for (let s = 0; s < t.length; s++) i.push(trigger/* default.En */.Z.En(t[s]));
    (this.triggers = i), this.fg();
  }
  gg() {
    const t = this,
      i = function (i, s, e, r, h) {
        return function () {
          t.cg(i, s, e, r, h);
        };
      },
      e = {};
    for (const t of this.triggers) t.id && (e[t.id] = t);
    let r = !1;
    for (let t = 0; t < this.triggers.length; t++) {
      const s = this.triggers[t];
      if (s.id && null != this.ng[s.id]) {
        const t = this.ng[s.id],
          h = [];
        for (let r = 0; r < t.length; r++) {
          const n = t[r],
            o = s.ud(n.Jr || 0);
          if (o > 0) {
            let t, r;
            h.push(n),
              null != n.ug && (t = n.ug),
              null != n.dg && braze_event/* default.RE */.Z.RE(n.dg) && (r = braze_event/* default.En */.Z.En(n.dg));
            const l = [];
            if (n.pg && (0,code_utils/* isArray */.kJ)(n.pg))
              for (let t = 0; t < n.pg.length; t++) {
                const i = e[n.pg[t]];
                null != i && l.push(i);
              }
            this.eg.push(window.setTimeout(i(s, n.Jr || 0, t, r, l), o));
          }
        }
        this.ng[s.id].length > h.length &&
          ((this.ng[s.id] = h),
          (r = !0),
          0 === this.ng[s.id].length && delete this.ng[s.id]);
      }
    }
    r && this.C && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.iE */.I.gt.iE, this.ng);
  }
  mg() {
    if (!this.C) return;
    const t = [];
    for (let i = 0; i < this.triggers.length; i++)
      t.push(this.triggers[i].bt());
    (this.lg = new Date().valueOf()),
      this.C.Bt(storage_manager/* STORAGE_KEYS.gt.rE */.I.gt.rE, t),
      this.C.Bt(storage_manager/* STORAGE_KEYS.gt.oE */.I.gt.oE, this.lg);
  }
  bg() {
    if (!this.C) return;
    (this.C.ft(storage_manager/* STORAGE_KEYS.gt.oE */.I.gt.oE) || 0) > this.lg ? this.ag() : this.fg();
  }
  U(t) {
    let i = !1;
    if (null != t && t.triggers) {
      this.ig.Zr(), this.fg();
      const e = {},
        r = {};
      this.triggers = [];
      for (let s = 0; s < t.triggers.length; s++) {
        const h = trigger/* default.fromJson */.Z.fromJson(t.triggers[s]);
        if (h) {
          h.id &&
            null != this.og[h.id] &&
            (h.ad(this.og[h.id]), (e[h.id] = this.og[h.id])),
            h.id && null != this.ng[h.id] && (r[h.id] = this.ng[h.id]);
          for (let t = 0; t < h.sd.length; t++)
            if (h.sd[t]._c(trigger_events/* default.Bs */.Z.Bs, null)) {
              i = !0;
              break;
            }
          this.triggers.push(h);
        }
      }
      (0,code_utils/* isEqual */.Xy)(this.og, e) || ((this.og = e), this.C && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.nE */.I.gt.nE, this.og)),
        (0,code_utils/* isEqual */.Xy)(this.ng, r) ||
          ((this.ng = r), this.C && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.iE */.I.gt.iE, this.ng)),
        this.mg(),
        i &&
          (logger/* default.info */.Z.info("Trigger with test condition found, firing test."),
          this.Ce(trigger_events/* default.Bs */.Z.Bs)),
        this.Ce(trigger_events/* default.OPEN */.Z.OPEN);
      const h = this.sg;
      let n;
      this.sg = [];
      for (let t = 0; t < h.length; t++)
        (n = Array.prototype.slice.call(h[t])), this.Ce(...n);
    }
  }
  cg(t, i, s, e, r) {
    const h = (e) => {
        this.fg();
        const r = new Date().valueOf();
        t.dd(i) ||
          (!1 === navigator.onLine && t.type === trigger/* default.Xr.Or */.Z.Xr.Or && e.imageUrl
            ? logger/* default.info */.Z.info(
                `Not showing ${t.type} trigger action ${t.id} due to offline state.`,
              )
            : t.nd(r) && this.wg(t, r, s)
            ? 0 === this.Ts.uc()
              ? logger/* default.info */.Z.info(
                  `Not displaying trigger ${t.id} because neither automaticallyShowInAppMessages() nor subscribeToInAppMessage() were called.`,
                )
              : (this.Ts.X([e]), this.yg(t, r))
            : logger/* default.info */.Z.info(
                `Not displaying trigger ${t.id} because display time fell outside of the acceptable time window.`,
              ));
      },
      n = () => {
        this.fg();
        const h = r.pop();
        if (null != h)
          if ((this.Tg(h, i, s, e, r), h.dd(i))) {
            let t = `Server aborted in-app message display, but the timeout on fallback trigger ${h.id} has already elapsed.`;
            r.length > 0 && (t += " Continuing to fall back."), logger/* default.info */.Z.info(t), n();
          } else {
            logger/* default.info */.Z.info(
              `Server aborted in-app message display. Falling back to lower priority ${h.type} trigger action ${t.id}.`,
            );
            const n = 1e3 * h.ed - (new Date().valueOf() - i);
            n > 0
              ? this.eg.push(
                  window.setTimeout(() => {
                    this.cg(h, i, s, e, r);
                  }, n),
                )
              : this.cg(h, i, s, e, r);
          }
      };
    let o, l, a;
    switch (t.type) {
      case trigger/* default.Xr.Or */.Z.Xr.Or:
        if (((o = (0,in_app_message_factory/* newInAppMessageFromJson */.q)(t.data)), null == o)) {
          logger/* default.error */.Z.error(
            `Could not parse trigger data for trigger ${t.id}, ignoring.`,
          );
          break;
        }
        if (((l = this.ig.Mr(o)), l)) {
          logger/* default.error */.Z.error(l), n();
          break;
        }
        h(o);
        break;
      case trigger/* default.Xr.md */.Z.Xr.md:
        if (((a = wt.fromJson(t.data, h, n, i, t.Kr || 0)), null == a)) {
          logger/* default.error */.Z.error(
            `Could not parse trigger data for trigger ${t.id}, ignoring.`,
          );
          break;
        }
        this.ig.Er(a, s, e);
        break;
      default:
        logger/* default.error */.Z.error(`Trigger ${t.id} was of unexpected type ${t.type}, ignoring.`);
    }
  }
  Ce(t, i = null, s) {
    if (!(0,code_utils/* validateValueIsFromEnum */.fk)(trigger_events/* default */.Z, t, "Cannot fire trigger action.", "TriggerEvents")) return;
    if (this.Fi && this.Fi.Zl())
      return (
        logger/* default.info */.Z.info(
          "Trigger sync is currently in progress, awaiting sync completion before firing trigger event.",
        ),
        void this.sg.push(arguments)
      );
    this.bg();
    const e = new Date().valueOf(),
      r = e - (this.hg || 0);
    let h = !0,
      n = !0;
    const o = [];
    for (let s = 0; s < this.triggers.length; s++) {
      const r = this.triggers[s],
        l = e + 1e3 * r.ed;
      if (
        r.nd(l) &&
        (null == r.startTime || r.startTime.valueOf() <= e) &&
        (null == r.endTime || r.endTime.valueOf() >= e)
      ) {
        let s = !1;
        for (let e = 0; e < r.sd.length; e++)
          if (r.sd[e]._c(t, i)) {
            s = !0;
            break;
          }
        s && ((h = !1), this.wg(r, l, t) && ((n = !1), o.push(r)));
      }
    }
    if (h)
      return void logger/* default.info */.Z.info(
        `Trigger event ${t} did not match any trigger conditions.`,
      );
    if (n)
      return void logger/* default.info */.Z.info(
        `Ignoring ${t} trigger event because a trigger was displayed ${
          r / 1e3
        }s ago.`,
      );
    o.sort((t, i) => t.priority - i.priority);
    const l = o.pop();
    null != l &&
      (logger/* default.info */.Z.info(
        `Firing ${l.type} trigger action ${l.id} from trigger event ${t}.`,
      ),
      this.Tg(l, e, t, s, o),
      0 === l.ed
        ? this.cg(l, e, t, s, o)
        : this.eg.push(
            window.setTimeout(() => {
              this.cg(l, e, t, s, o);
            }, 1e3 * l.ed),
          ));
  }
  changeUser(t = !1) {
    if (((this.triggers = []), this.C && this.C.Ut(storage_manager/* STORAGE_KEYS.gt.rE */.I.gt.rE), !t)) {
      (this.sg = []), (this.hg = null), (this.og = {}), (this.ng = {});
      for (let t = 0; t < this.eg.length; t++) clearTimeout(this.eg[t]);
      (this.eg = []),
        this.C && (this.C.Ut(storage_manager/* STORAGE_KEYS.gt.aE */.I.gt.aE), this.C.Ut(storage_manager/* STORAGE_KEYS.gt.nE */.I.gt.nE), this.C.Ut(storage_manager/* STORAGE_KEYS.gt.iE */.I.gt.iE));
    }
  }
  clearData() {
    (this.triggers = []), (this.hg = null), (this.og = {}), (this.ng = {});
    for (let t = 0; t < this.eg.length; t++) clearTimeout(this.eg[t]);
    this.eg = [];
  }
  wg(t, i, s) {
    if (null == this.hg) return !0;
    if (s === trigger_events/* default.Bs */.Z.Bs)
      return (
        logger/* default.info */.Z.info(
          "Ignoring minimum interval between trigger because it is a test type.",
        ),
        !0
      );
    let e = t.hd;
    return null == e && (e = this.tg), i - this.hg >= 1e3 * e;
  }
  Tg(t, i, e, r, h) {
    this.fg(), t.id && (this.ng[t.id] = this.ng[t.id] || []);
    const n = {};
    let o;
    (n.Jr = i), (n.ug = e), null != r && (o = r.bt()), (n.dg = o);
    const l = [];
    for (const t of h) t.id && l.push(t.id);
    (n.pg = l),
      t.id && this.ng[t.id].push(n),
      this.C && this.C.Bt(storage_manager/* STORAGE_KEYS.gt.iE */.I.gt.iE, this.ng);
  }
  yg(t, i) {
    this.fg(),
      t.ad(i),
      (this.hg = i),
      t.id && (this.og[t.id] = i),
      this.C && (this.C.Bt(storage_manager/* STORAGE_KEYS.gt.aE */.I.gt.aE, i), this.C.Bt(storage_manager/* STORAGE_KEYS.gt.nE */.I.gt.nE, this.og));
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/triggers/triggers-provider-factory.js



const TriggersProviderFactory = {
  l: !1,
  provider: null,
  m: () => (
    TriggersProviderFactory.p(),
    TriggersProviderFactory.provider || TriggersProviderFactory.rg(),
    TriggersProviderFactory.provider
  ),
  rg: () => {
    if (!TriggersProviderFactory.provider) {
      const i = braze_instance/* default.ee */.ZP.ee(braze_instance/* OPTIONS.Yh */.JY.Yh);
      (TriggersProviderFactory.provider = new gr(
        null != i ? i : 30,
        in_app_message_manager_factory/* default.ea */.Z.ea().Xi(),
        braze_instance/* default.j */.ZP.j(),
        braze_instance/* default.nn */.ZP.nn(),
        in_app_message_manager_factory/* default.ea */.Z.ea(),
      )),
        braze_instance/* default._ */.ZP._(TriggersProviderFactory.provider);
    }
  },
  p: () => {
    TriggersProviderFactory.l ||
      (TriggersProviderFactory.rg(),
      braze_instance/* default.h */.ZP.h(TriggersProviderFactory),
      (TriggersProviderFactory.l = !0));
  },
  destroy: () => {
    (TriggersProviderFactory.provider = null), (TriggersProviderFactory.l = !1);
  },
};


/***/ }),

/***/ 95333:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ attachCSS; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);

function attachCSS(n, t, o) {
  const c = n || document.querySelector("head"),
    e = `ab-${t}-css-definitions-${"5.8.1".replace(/\./g, "-")}`;
  if (!c) return;
  const s = c.ownerDocument || document;
  if (null == s.getElementById(e)) {
    const n = s.createElement("style");
    (n.innerHTML = o || ""), (n.id = e);
    const t = _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ee */ .ZP.ee(_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* .OPTIONS.er */ .JY.er);
    null != t && n.setAttribute("nonce", t), c.appendChild(n);
  }
}


/***/ }),

/***/ 46959:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ setupFeedUI; }
/* harmony export */ });
/* unused harmony export attachFeedCSS */
/* harmony import */ var _attach_css_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95333);
/* harmony import */ var _load_font_awesome_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16524);


function attachFeedCSS(t) {
  (0,_attach_css_js__WEBPACK_IMPORTED_MODULE_0__/* .attachCSS */ .e)(
    t,
    "feed",
    "body>.ab-feed{position:fixed;top:0;right:0;bottom:0;width:421px;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}body>.ab-feed .ab-feed-body{position:absolute;top:0;left:0;right:0;border:none;border-left:1px solid #d0d0d0;padding-top:70px;min-height:100%}body>.ab-feed .ab-initial-spinner{float:none}body>.ab-feed .ab-no-cards-message{position:absolute;width:100%;margin-left:-20px;top:40%}.ab-feed{-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 1px 7px 1px rgba(66,82,113,.15);-moz-box-shadow:0 1px 7px 1px rgba(66,82,113,.15);box-shadow:0 1px 7px 1px rgba(66,82,113,.15);width:402px;background-color:#eee;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;font-size:13px;line-height:130%;letter-spacing:normal;overflow-y:auto;overflow-x:visible;z-index:9011;-webkit-overflow-scrolling:touch}.ab-feed :focus,.ab-feed:focus{outline:0}.ab-feed .ab-feed-body{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;border:1px solid #d0d0d0;border-top:none;padding:20px 20px 0 20px}.ab-feed.ab-effect-slide{-webkit-transform:translateX(450px);-moz-transform:translateX(450px);-ms-transform:translateX(450px);transform:translateX(450px);-webkit-transition:transform .5s ease-in-out;-moz-transition:transform .5s ease-in-out;-o-transition:transform .5s ease-in-out;transition:transform .5s ease-in-out}.ab-feed.ab-effect-slide.ab-show{-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.ab-feed.ab-effect-slide.ab-hide{-webkit-transform:translateX(450px);-moz-transform:translateX(450px);-ms-transform:translateX(450px);transform:translateX(450px)}.ab-feed .ab-card{position:relative;-webkit-box-shadow:0 2px 3px 0 rgba(178,178,178,.5);-moz-box-shadow:0 2px 3px 0 rgba(178,178,178,.5);box-shadow:0 2px 3px 0 rgba(178,178,178,.5);-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;width:100%;border:1px solid #d0d0d0;margin-bottom:20px;overflow:hidden;background-color:#fff;-webkit-transition:height .4s ease-in-out,margin .4s ease-in-out;-moz-transition:height .4s ease-in-out,margin .4s ease-in-out;-o-transition:height .4s ease-in-out,margin .4s ease-in-out;transition:height .4s ease-in-out,margin .4s ease-in-out}.ab-feed .ab-card .ab-pinned-indicator{position:absolute;right:0;top:0;margin-right:-1px;width:0;height:0;border-style:solid;border-width:0 24px 24px 0;border-color:transparent #1676d0 transparent transparent}.ab-feed .ab-card .ab-pinned-indicator .fa-star{position:absolute;right:-21px;top:2px;font-size:9px;color:#fff}.ab-feed .ab-card.ab-effect-card.ab-hide{-webkit-transition:all .5s ease-in-out;-moz-transition:all .5s ease-in-out;-o-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.ab-feed .ab-card.ab-effect-card.ab-hide.ab-swiped-left{-webkit-transform:translateX(-450px);-moz-transform:translateX(-450px);-ms-transform:translateX(-450px);transform:translateX(-450px)}.ab-feed .ab-card.ab-effect-card.ab-hide.ab-swiped-right{-webkit-transform:translateX(450px);-moz-transform:translateX(450px);-ms-transform:translateX(450px);transform:translateX(450px)}.ab-feed .ab-card.ab-effect-card.ab-hide:not(.ab-swiped-left):not(.ab-swiped-right){opacity:0}.ab-feed .ab-card .ab-close-button{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;background-color:transparent;background-size:15px;border:none;width:15px;min-width:15px;height:15px;cursor:pointer;display:block;font-size:15px;line-height:0;padding-top:15px;padding-right:15px;padding-left:15px;padding-bottom:15px;position:absolute;top:0;z-index:9021;opacity:0;-webkit-transition:.5s;-moz-transition:.5s;-o-transition:.5s;transition:.5s}.ab-feed .ab-card .ab-close-button[dir=rtl]{left:0}.ab-feed .ab-card .ab-close-button[dir=ltr]{right:0}.ab-feed .ab-card .ab-close-button svg{-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease;fill:#9b9b9b;height:auto;width:100%}.ab-feed .ab-card .ab-close-button svg.ab-chevron{display:none}.ab-feed .ab-card .ab-close-button:active{background-color:transparent}.ab-feed .ab-card .ab-close-button:focus{background-color:transparent}.ab-feed .ab-card .ab-close-button:hover{background-color:transparent}.ab-feed .ab-card .ab-close-button:hover svg{fill-opacity:.8}.ab-feed .ab-card .ab-close-button:hover{opacity:1}.ab-feed .ab-card .ab-close-button:focus{opacity:1}.ab-feed .ab-card a{float:none;color:inherit;text-decoration:none}.ab-feed .ab-card a:hover{text-decoration:underline}.ab-feed .ab-card .ab-image-area{float:none;display:inline-block;vertical-align:top;line-height:0;overflow:hidden;width:100%;-webkit-box-sizing:initial;-moz-box-sizing:initial;box-sizing:initial}.ab-feed .ab-card .ab-image-area img{float:none;height:auto;width:100%}.ab-feed .ab-card.ab-image-only .ab-card-body{display:none}.ab-feed .ab-card .ab-card-body{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:inline-block;width:100%;position:relative}.ab-feed .ab-card .ab-unread-indicator{position:absolute;bottom:0;margin-right:-1px;width:100%;height:5px;background-color:#1676d0}.ab-feed .ab-card .ab-unread-indicator.read{background-color:transparent}.ab-feed .ab-card .ab-title{float:none;letter-spacing:0;margin:0;font-weight:700;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;display:block;overflow:hidden;word-wrap:break-word;text-overflow:ellipsis;font-size:18px;line-height:130%;padding:20px 25px 0 25px}.ab-feed .ab-card .ab-description{float:none;color:#545454;padding:15px 25px 20px 25px;word-wrap:break-word;white-space:pre-wrap}.ab-feed .ab-card .ab-description.ab-no-title{padding-top:20px}.ab-feed .ab-card .ab-url-area{float:none;color:#1676d0;margin-top:12px;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif}.ab-feed .ab-card.ab-classic-card .ab-card-body{min-height:40px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}.ab-feed .ab-card.ab-classic-card.with-image .ab-card-body{min-height:100px}.ab-feed .ab-card.ab-classic-card.with-image .ab-card-body[dir=ltr]{padding-left:72px}.ab-feed .ab-card.ab-classic-card.with-image .ab-card-body[dir=rtl]{padding-right:72px}.ab-feed .ab-card.ab-classic-card.with-image .ab-image-area{width:60px;height:60px;padding:20px 0 25px 25px;position:absolute}.ab-feed .ab-card.ab-classic-card.with-image .ab-image-area[dir=rtl]{padding:20px 25px 25px 0}.ab-feed .ab-card.ab-classic-card.with-image .ab-image-area img{-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;max-width:100%;max-height:100%;width:auto;height:auto}.ab-feed .ab-card.ab-classic-card.with-image .ab-title{background-color:transparent;font-size:16px}.ab-feed .ab-card.ab-classic-card.with-image .ab-description{padding-top:10px}.ab-feed .ab-card.ab-control-card{height:0;width:0;margin:0;border:0}.ab-feed .ab-feed-buttons-wrapper{float:none;position:relative;background-color:#282828;height:50px;-webkit-box-shadow:0 2px 3px 0 rgba(178,178,178,.5);-moz-box-shadow:0 2px 3px 0 rgba(178,178,178,.5);box-shadow:0 2px 3px 0 rgba(178,178,178,.5);z-index:1}.ab-feed .ab-feed-buttons-wrapper .ab-close-button,.ab-feed .ab-feed-buttons-wrapper .ab-refresh-button{float:none;cursor:pointer;color:#fff;font-size:18px;padding:16px;-webkit-transition:.2s;-moz-transition:.2s;-o-transition:.2s;transition:.2s}.ab-feed .ab-feed-buttons-wrapper .ab-close-button:hover,.ab-feed .ab-feed-buttons-wrapper .ab-refresh-button:hover{font-size:22px}.ab-feed .ab-feed-buttons-wrapper .ab-close-button{float:right}.ab-feed .ab-feed-buttons-wrapper .ab-close-button:hover{padding-top:12px;padding-right:14px}.ab-feed .ab-feed-buttons-wrapper .ab-refresh-button{padding-left:17px}.ab-feed .ab-feed-buttons-wrapper .ab-refresh-button:hover{padding-top:13px;padding-left:14px}.ab-feed .ab-no-cards-message{text-align:center;margin-bottom:20px}@media (max-width:600px){body>.ab-feed{width:100%}}",
  );
}
function setupFeedUI() {
  attachFeedCSS(), (0,_load_font_awesome_js__WEBPACK_IMPORTED_MODULE_1__/* .loadFontAwesome */ .N)();
}


/***/ }),

/***/ 9135:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ setupInAppMessageUI; }
/* harmony export */ });
/* unused harmony export attachInAppMessageCSS */
/* harmony import */ var _attach_css_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95333);
/* harmony import */ var _load_font_awesome_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16524);


function attachInAppMessageCSS(t) {
  (0,_attach_css_js__WEBPACK_IMPORTED_MODULE_0__/* .attachCSS */ .e)(
    t,
    "iam",
    ".ab-pause-scrolling,body.ab-pause-scrolling,html.ab-pause-scrolling{overflow:hidden;touch-action:none}.ab-iam-root.v3{position:fixed;top:0;right:0;bottom:0;left:0;pointer-events:none;z-index:9011;-webkit-tap-highlight-color:transparent}.ab-iam-root.v3:focus{outline:0}.ab-iam-root.v3.ab-effect-fullscreen,.ab-iam-root.v3.ab-effect-html,.ab-iam-root.v3.ab-effect-modal{opacity:0}.ab-iam-root.v3.ab-effect-fullscreen.ab-show,.ab-iam-root.v3.ab-effect-html.ab-show,.ab-iam-root.v3.ab-effect-modal.ab-show{opacity:1}.ab-iam-root.v3.ab-effect-fullscreen.ab-show.ab-animate-in,.ab-iam-root.v3.ab-effect-html.ab-show.ab-animate-in,.ab-iam-root.v3.ab-effect-modal.ab-show.ab-animate-in{-webkit-transition:opacity .5s;-moz-transition:opacity .5s;-o-transition:opacity .5s;transition:opacity .5s}.ab-iam-root.v3.ab-effect-fullscreen.ab-hide,.ab-iam-root.v3.ab-effect-html.ab-hide,.ab-iam-root.v3.ab-effect-modal.ab-hide{opacity:0}.ab-iam-root.v3.ab-effect-fullscreen.ab-hide.ab-animate-out,.ab-iam-root.v3.ab-effect-html.ab-hide.ab-animate-out,.ab-iam-root.v3.ab-effect-modal.ab-hide.ab-animate-out{-webkit-transition:opacity .5s;-moz-transition:opacity .5s;-o-transition:opacity .5s;transition:opacity .5s}.ab-iam-root.v3.ab-effect-slide .ab-in-app-message{-webkit-transform:translateX(535px);-moz-transform:translateX(535px);-ms-transform:translateX(535px);transform:translateX(535px)}.ab-iam-root.v3.ab-effect-slide.ab-show .ab-in-app-message{-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.ab-iam-root.v3.ab-effect-slide.ab-show.ab-animate-in .ab-in-app-message{-webkit-transition:transform .5s ease-in-out;-moz-transition:transform .5s ease-in-out;-o-transition:transform .5s ease-in-out;transition:transform .5s ease-in-out}.ab-iam-root.v3.ab-effect-slide.ab-hide .ab-in-app-message{-webkit-transform:translateX(535px);-moz-transform:translateX(535px);-ms-transform:translateX(535px);transform:translateX(535px)}.ab-iam-root.v3.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-left{-webkit-transform:translateX(-535px);-moz-transform:translateX(-535px);-ms-transform:translateX(-535px);transform:translateX(-535px)}.ab-iam-root.v3.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-up{-webkit-transform:translateY(-535px);-moz-transform:translateY(-535px);-ms-transform:translateY(-535px);transform:translateY(-535px)}.ab-iam-root.v3.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-down{-webkit-transform:translateY(535px);-moz-transform:translateY(535px);-ms-transform:translateY(535px);transform:translateY(535px)}.ab-iam-root.v3.ab-effect-slide.ab-hide.ab-animate-out .ab-in-app-message{-webkit-transition:transform .5s ease-in-out;-moz-transition:transform .5s ease-in-out;-o-transition:transform .5s ease-in-out;transition:transform .5s ease-in-out}.ab-iam-root.v3 .ab-ios-scroll-wrapper{position:fixed;top:0;right:0;bottom:0;left:0;overflow:auto;pointer-events:all;touch-action:auto;-webkit-overflow-scrolling:touch}.ab-iam-root.v3 .ab-in-app-message{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:fixed;text-align:center;-webkit-box-shadow:0 0 4px rgba(0,0,0,.3);-moz-box-shadow:0 0 4px rgba(0,0,0,.3);box-shadow:0 0 4px rgba(0,0,0,.3);line-height:normal;letter-spacing:normal;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;z-index:9011;max-width:100%;overflow:hidden;display:inline-block;pointer-events:all;color:#333;color-scheme:normal}.ab-iam-root.v3 .ab-in-app-message.ab-no-shadow{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.ab-iam-root.v3 .ab-in-app-message :focus,.ab-iam-root.v3 .ab-in-app-message:focus{outline:0}.ab-iam-root.v3 .ab-in-app-message.ab-clickable{cursor:pointer}.ab-iam-root.v3 .ab-in-app-message.ab-background{background-color:#fff}.ab-iam-root.v3 .ab-in-app-message .ab-close-button{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;background-color:transparent;background-size:15px;border:none;width:15px;min-width:15px;height:15px;cursor:pointer;display:block;font-size:15px;line-height:0;padding-top:15px;padding-right:15px;padding-left:15px;padding-bottom:15px;position:absolute;top:0;z-index:9021}.ab-iam-root.v3 .ab-in-app-message .ab-close-button[dir=rtl]{left:0}.ab-iam-root.v3 .ab-in-app-message .ab-close-button[dir=ltr]{right:0}.ab-iam-root.v3 .ab-in-app-message .ab-close-button svg{-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease;fill:#9b9b9b;height:auto;width:100%}.ab-iam-root.v3 .ab-in-app-message .ab-close-button svg.ab-chevron{display:none}.ab-iam-root.v3 .ab-in-app-message .ab-close-button:active{background-color:transparent}.ab-iam-root.v3 .ab-in-app-message .ab-close-button:focus{background-color:transparent}.ab-iam-root.v3 .ab-in-app-message .ab-close-button:hover{background-color:transparent}.ab-iam-root.v3 .ab-in-app-message .ab-close-button:hover svg{fill-opacity:.8}.ab-iam-root.v3 .ab-in-app-message .ab-message-text{float:none;line-height:1.5;margin:20px 25px;max-width:100%;overflow:hidden;overflow-y:auto;vertical-align:text-bottom;word-wrap:break-word;white-space:pre-wrap;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif}.ab-iam-root.v3 .ab-in-app-message .ab-message-text.start-aligned{text-align:start}.ab-iam-root.v3 .ab-in-app-message .ab-message-text.end-aligned{text-align:end}.ab-iam-root.v3 .ab-in-app-message .ab-message-text.center-aligned{text-align:center}.ab-iam-root.v3 .ab-in-app-message .ab-message-text::-webkit-scrollbar{-webkit-appearance:none;width:14px}.ab-iam-root.v3 .ab-in-app-message .ab-message-text::-webkit-scrollbar-thumb{-webkit-appearance:none;border:4px solid transparent;background-clip:padding-box;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;background-color:rgba(0,0,0,.2)}.ab-iam-root.v3 .ab-in-app-message .ab-message-text::-webkit-scrollbar-button{width:0;height:0;display:none}.ab-iam-root.v3 .ab-in-app-message .ab-message-text::-webkit-scrollbar-corner{background-color:transparent}.ab-iam-root.v3 .ab-in-app-message .ab-message-header{float:none;letter-spacing:0;margin:0;font-weight:700;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;display:block;font-size:20px;margin-bottom:10px;line-height:1.3}.ab-iam-root.v3 .ab-in-app-message .ab-message-header.start-aligned{text-align:start}.ab-iam-root.v3 .ab-in-app-message .ab-message-header.end-aligned{text-align:end}.ab-iam-root.v3 .ab-in-app-message .ab-message-header.center-aligned{text-align:center}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen,.ab-iam-root.v3 .ab-in-app-message.ab-modal,.ab-iam-root.v3 .ab-in-app-message.ab-slideup{-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;cursor:pointer;overflow:hidden;word-wrap:break-word;text-overflow:ellipsis;font-size:14px;font-weight:700;margin:20px;margin-top:calc(constant(safe-area-inset-top,0) + 20px);margin-right:calc(constant(safe-area-inset-right,0) + 20px);margin-bottom:calc(constant(safe-area-inset-bottom,0) + 20px);margin-left:calc(constant(safe-area-inset-left,0) + 20px);margin-top:calc(env(safe-area-inset-top,0) + 20px);margin-right:calc(env(safe-area-inset-right,0) + 20px);margin-bottom:calc(env(safe-area-inset-bottom,0) + 20px);margin-left:calc(env(safe-area-inset-left,0) + 20px);max-height:150px;padding:10px;right:0;background-color:#efefef}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone{max-height:66px;margin:10px;margin-top:calc(constant(safe-area-inset-top,0) + 10px);margin-right:calc(constant(safe-area-inset-right,0) + 10px);margin-bottom:calc(constant(safe-area-inset-bottom,0) + 10px);margin-left:calc(constant(safe-area-inset-left,0) + 10px);margin-top:calc(env(safe-area-inset-top,0) + 10px);margin-right:calc(env(safe-area-inset-right,0) + 10px);margin-bottom:calc(env(safe-area-inset-bottom,0) + 10px);margin-left:calc(env(safe-area-inset-left,0) + 10px);max-width:90%;max-width:calc(100% - 40px);min-width:90%;min-width:calc(100% - 40px)}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-close-button{display:none}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-close-button svg:not(.ab-chevron){display:none}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-close-button{display:block;height:20px;padding:0 20px 0 18px;pointer-events:none;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:12px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-close-button svg.ab-chevron{display:inline}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-close-button svg.ab-chevron.rtl{-webkit-transform:scaleX(-1);-moz-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-message-text{border-right-width:40px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text{max-width:100%;border-right-width:10px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text span{max-height:66px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text.ab-with-image{max-width:80%;max-width:calc(100% - 50px - 5px - 10px - 25px)}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-image-area{width:50px;height:50px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-image-area img{max-width:100%;max-height:100%;width:auto;height:auto}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:active .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:focus .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:hover .ab-message-text{opacity:.8}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:active .ab-close-button svg.ab-chevron,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:focus .ab-close-button svg.ab-chevron,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:hover .ab-close-button svg.ab-chevron{fill-opacity:.8}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:table-cell;border-color:transparent;border-style:solid;border-width:5px 25px 5px 10px;max-width:430px;vertical-align:middle;margin:0}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text[dir=rtl]{border-width:5px 10px 5px 25px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text span{display:block;max-height:150px;overflow:auto}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text.ab-with-image{max-width:365px;border-top:0;border-bottom:0}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;background-color:transparent;background-size:15px;border:none;width:15px;min-width:15px;height:15px;cursor:pointer;display:block;font-size:15px;line-height:0;padding-top:15px;padding-right:15px;padding-left:15px;padding-bottom:15px;position:absolute;top:0;z-index:9021}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button[dir=rtl]{left:0}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button[dir=ltr]{right:0}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button svg{-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease;fill:#9b9b9b;height:auto;width:100%}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button svg.ab-chevron{display:none}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button:active{background-color:transparent}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button:focus{background-color:transparent}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button:hover{background-color:transparent}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button:hover svg{fill-opacity:.8}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area{float:none;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:table-cell;border-color:transparent;border-style:solid;border-width:5px 0 5px 5px;vertical-align:top;width:60px;margin:0}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area.ab-icon-area{width:auto}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area img{float:none;width:100%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen,.ab-iam-root.v3 .ab-in-app-message.ab-modal{font-size:14px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area{float:none;position:relative;display:block;overflow:hidden}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-image-area .ab-center-cropped-img,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area .ab-center-cropped-img{background-size:cover;background-repeat:no-repeat;background-position:50% 50%;position:absolute;top:0;right:0;bottom:0;left:0}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-icon,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-icon{margin-top:20px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic{padding:0}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-message-text{display:none}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-message-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-message-buttons{bottom:0;left:0}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area{float:none;height:auto;margin:0}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area img{display:block;top:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none}.ab-iam-root.v3 .ab-in-app-message.ab-modal{padding-top:20px;width:450px;max-width:450px;max-height:720px}.ab-iam-root.v3 .ab-in-app-message.ab-modal.simulate-phone{max-width:91%;max-width:calc(100% - 30px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal.simulate-phone.graphic .ab-image-area img{max-width:91vw;max-width:calc(100vw - 30px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text{max-height:660px}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-image{max-height:524.82758621px}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-icon{max-height:610px}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons{margin-bottom:93px;max-height:587px}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-image{max-height:451.82758621px}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-icon{max-height:537px}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area{margin-top:-20px;max-height:155.17241379px}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area img{max-width:100%;max-height:155.17241379px}.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area.ab-icon-area{height:auto}.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic{width:auto;overflow:hidden}.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area{display:inline}.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area img{width:auto;max-height:720px;max-width:450px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen{width:450px;max-height:720px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape{width:720px;max-height:450px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape .ab-image-area{height:225px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape.graphic .ab-image-area{height:450px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape .ab-message-text{max-height:112px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-message-text{max-height:247px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-message-text.ab-with-buttons{margin-bottom:93px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-image-area{height:360px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-image-area{height:720px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone{-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone:not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone:not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.graphic{display:block}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message.ab-html-message{background-color:transparent;border:none;height:100%;overflow:auto;position:relative;touch-action:auto;width:100%}.ab-iam-root.v3 .ab-in-app-message .ab-message-buttons{position:absolute;bottom:0;width:100%;padding:17px 25px 30px 25px;z-index:inherit;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.ab-iam-root.v3 .ab-in-app-message .ab-message-button{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;cursor:pointer;display:inline-block;font-size:14px;font-weight:700;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;height:44px;line-height:normal;letter-spacing:normal;margin:0;max-width:100%;min-width:80px;padding:0 12px;position:relative;text-transform:none;width:48%;width:calc(50% - 5px);border:1px solid #1b78cf;-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease;overflow:hidden;word-wrap:break-word;text-overflow:ellipsis;word-wrap:normal;white-space:nowrap}.ab-iam-root.v3 .ab-in-app-message .ab-message-button:first-of-type{float:left;background-color:#fff;color:#1b78cf}.ab-iam-root.v3 .ab-in-app-message .ab-message-button:last-of-type{float:right;background-color:#1b78cf;color:#fff}.ab-iam-root.v3 .ab-in-app-message .ab-message-button:first-of-type:last-of-type{float:none;width:auto}.ab-iam-root.v3 .ab-in-app-message .ab-message-button:after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:transparent}.ab-iam-root.v3 .ab-in-app-message .ab-message-button:after{-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease}.ab-iam-root.v3 .ab-in-app-message .ab-message-button:hover{opacity:.8}.ab-iam-root.v3 .ab-in-app-message .ab-message-button:active:after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.08)}.ab-iam-root.v3 .ab-in-app-message .ab-message-button:focus:after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.15)}.ab-iam-root.v3 .ab-in-app-message .ab-message-button a{color:inherit;text-decoration:inherit}.ab-iam-root.v3 .ab-in-app-message img{float:none;display:inline-block}.ab-iam-root.v3 .ab-in-app-message .ab-icon{float:none;display:inline-block;padding:10px;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px}.ab-iam-root.v3 .ab-in-app-message .ab-icon .fa{float:none;font-size:30px;width:30px}.ab-iam-root.v3 .ab-start-hidden{visibility:hidden}.ab-iam-root.v3 .ab-centered{margin:auto;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.ab-iam-root.v3{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}.ab-iam-root.v3 .ab-page-blocker{position:fixed;top:0;left:0;width:100%;height:100%;z-index:9001;pointer-events:all;background-color:rgba(51,51,51,.75)}@media (max-width:600px){.ab-iam-root.v3 .ab-in-app-message.ab-slideup{max-height:66px;margin:10px;margin-top:calc(constant(safe-area-inset-top,0) + 10px);margin-right:calc(constant(safe-area-inset-right,0) + 10px);margin-bottom:calc(constant(safe-area-inset-bottom,0) + 10px);margin-left:calc(constant(safe-area-inset-left,0) + 10px);margin-top:calc(env(safe-area-inset-top,0) + 10px);margin-right:calc(env(safe-area-inset-right,0) + 10px);margin-bottom:calc(env(safe-area-inset-bottom,0) + 10px);margin-left:calc(env(safe-area-inset-left,0) + 10px);max-width:90%;max-width:calc(100% - 40px);min-width:90%;min-width:calc(100% - 40px)}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button{display:none}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button svg:not(.ab-chevron){display:none}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable .ab-close-button{display:block;height:20px;padding:0 20px 0 18px;pointer-events:none;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:12px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable .ab-close-button svg.ab-chevron{display:inline}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable .ab-close-button svg.ab-chevron.rtl{-webkit-transform:scaleX(-1);-moz-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable .ab-message-text{border-right-width:40px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text{max-width:100%;border-right-width:10px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text span{max-height:66px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text.ab-with-image{max-width:80%;max-width:calc(100% - 50px - 5px - 10px - 25px)}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area{width:50px;height:50px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area img{max-width:100%;max-height:100%;width:auto;height:auto}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape{-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-close-button,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen .ab-image-area,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-image-area,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen .ab-message-text,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape:not(.graphic),.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen:not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape:not(.graphic) .ab-message-buttons,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen:not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.graphic,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.graphic{display:block}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.graphic .ab-message-button,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}}@media (max-width:480px){.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop){max-width:91%;max-width:calc(100% - 30px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop).graphic .ab-image-area img{max-width:91vw;max-width:calc(100vw - 30px)}}@media (max-height:750px){.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop){max-height:91%;max-height:calc(100% - 30px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop).graphic .ab-image-area img{max-height:91vh;max-height:calc(100vh - 30px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop) .ab-message-text{max-height:65vh;max-height:calc(100vh - 30px - 60px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop) .ab-message-text.ab-with-image{max-height:45vh;max-height:calc(100vh - 30px - 155.17241379310346px - 40px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop) .ab-message-text.ab-with-icon{max-height:45vh;max-height:calc(100vh - 30px - 70px - 40px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop) .ab-message-text.ab-with-buttons{max-height:50vh;max-height:calc(100vh - 30px - 93px - 40px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop) .ab-message-text.ab-with-buttons.ab-with-image{max-height:30vh;max-height:calc(100vh - 30px - 155.17241379310346px - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-modal:not(.force-desktop) .ab-message-text.ab-with-buttons.ab-with-icon{max-height:30vh;max-height:calc(100vh - 30px - 70px - 93px - 20px)}}@media (min-width:601px){.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-image-area img{max-height:100%;max-width:100%}}@media (max-height:750px) and (min-width:601px){.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop){-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important;width:450px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop) .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop) .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop) .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop):not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop):not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).graphic{display:block}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}}@media (max-height:480px){.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop){-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop):not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop):not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic{display:block}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}}@media (max-width:750px){.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop){-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop):not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop):not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic{display:block}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}}",
  );
}
function setupInAppMessageUI() {
  attachInAppMessageCSS(), (0,_load_font_awesome_js__WEBPACK_IMPORTED_MODULE_1__/* .loadFontAwesome */ .N)();
}


/***/ }),

/***/ 16524:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ loadFontAwesome; }
/* harmony export */ });
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);

function loadFontAwesome() {
  if (_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ee */ .ZP.ee(_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* .OPTIONS.Ea */ .JY.Ea)) return;
  const e = "https://use.fontawesome.com/7f85a56ba4.css";
  if (
    !(null !== document.querySelector('link[rel=stylesheet][href="' + e + '"]'))
  ) {
    const t = document.createElement("link");
    t.setAttribute("rel", "stylesheet"),
      t.setAttribute("href", e),
      document.getElementsByTagName("head")[0].appendChild(t);
  }
}


/***/ }),

/***/ 73046:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ BRAZE_ACTIONS; },
/* harmony export */   "OL": function() { return /* binding */ getDecodedBrazeAction; },
/* harmony export */   "Tu": function() { return /* binding */ ineligibleBrazeActionURLErrorMessage; },
/* harmony export */   "je": function() { return /* binding */ containsUnknownBrazeAction; },
/* harmony export */   "yi": function() { return /* binding */ INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES; },
/* harmony export */   "zA": function() { return /* binding */ containsPushPrimerBrazeAction; }
/* harmony export */ });
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20335);
/* harmony import */ var _error_utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8031);
/* harmony import */ var _string_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8548);
/* harmony import */ var _validation_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3905);




const BRAZE_ACTIONS = {
  types: {
    io: "container",
    logCustomEvent: "logCustomEvent",
    setEmailNotificationSubscriptionType:
      "setEmailNotificationSubscriptionType",
    setPushNotificationSubscriptionType: "setPushNotificationSubscriptionType",
    setCustomUserAttribute: "setCustomUserAttribute",
    requestPushPermission: "requestPushPermission",
    addToSubscriptionGroup: "addToSubscriptionGroup",
    removeFromSubscriptionGroup: "removeFromSubscriptionGroup",
    addToCustomAttributeArray: "addToCustomAttributeArray",
    removeFromCustomAttributeArray: "removeFromCustomAttributeArray",
    co: "openLink",
    mo: "openLinkInWebView",
  },
  properties: { type: "type", eo: "steps", so: "args" },
};
const INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES = {
  Tr: "unknownBrazeAction",
  Br: "noPushPrompt",
};
const ineligibleBrazeActionURLErrorMessage = (t, o) => {
  switch (t) {
    case INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Tr:
      return `${o} contains an unknown braze action type and will not be displayed.`;
    case INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Br:
      return `${o} contains a push prompt braze action, but is not eligible for a push prompt. Ignoring.`;
    default:
      return "";
  }
};
function getDecodedBrazeAction(t) {
  try {
    const o = t.match(_validation_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .BRAZE_ACTION_URI_REGEX */ .y9),
      r = o ? o[0].length : null,
      n = r ? t.substring(r) : null;
    if (null == r || r > t.length - 1 || !n)
      return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(
        `Did not find base64 encoded brazeAction in url to process : ${t}`,
      );
    const e = (0,_string_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .decodeBrazeActions */ .T)(n);
    return e
      ? JSON.parse(e)
      : void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(`Failed to decode base64 encoded brazeAction: ${n}`);
  } catch (o) {
    return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(`Failed to process brazeAction URL ${t} : ${(0,_error_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .getErrorMessage */ .e)(o)}`);
  }
}
function po(t, o) {
  let r = !1;
  if (o) for (const n of o) if (((r = r || t(n)), r)) return !0;
  return !1;
}
function containsUnknownBrazeAction(t) {
  const o = BRAZE_ACTIONS.properties.type,
    r = BRAZE_ACTIONS.properties.eo;
  try {
    if (null == t) return !0;
    const n = t[o];
    return n === BRAZE_ACTIONS.types.io
      ? po(containsUnknownBrazeAction, t[r])
      : !(0,_validation_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isValidBrazeActionType */ .OM)(n);
  } catch (t) {
    return !0;
  }
}
function containsPushPrimerBrazeAction(t) {
  if (!t || !(0,_validation_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isValidBrazeActionJson */ .zR)(t)) return !1;
  const o = BRAZE_ACTIONS.properties.type,
    r = BRAZE_ACTIONS.properties.eo,
    n = t[o];
  return n === BRAZE_ACTIONS.types.io
    ? po(containsPushPrimerBrazeAction, t[r])
    : n === BRAZE_ACTIONS.types.requestPushPermission;
}


/***/ }),

/***/ 7169:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ro; }
});

// UNUSED EXPORTS: BrowserDetector

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/code-utils.js
var code_utils = __webpack_require__(72893);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/util/base-device-parser.js

class Oe {
  constructor() {}
  ef() {}
  ff() {}
  tc(t) {}
  static nf(t, e) {
    if (t && e)
      if (((t = t.toLowerCase()), (0,code_utils/* isArray */.kJ)(e.cf))) {
        for (let r = 0; r < e.cf.length; r++)
          if (-1 !== t.indexOf(e.cf[r].toLowerCase())) return e.identity;
      } else if (-1 !== t.indexOf(e.cf.toLowerCase())) return e.identity;
  }
}

// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/util/device-constants.js
var device_constants = __webpack_require__(35806);
;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/util/client-hints-parser.js


class ai extends Oe {
  constructor() {
    if (
      (super(),
      (this.userAgentData = navigator.userAgentData),
      (this.browser = null),
      (this.version = null),
      this.userAgentData)
    ) {
      const t = this.Bc();
      (this.browser = t.browser || "Unknown Browser"),
        (this.version = t.version || "Unknown Version");
    }
    this.OS = null;
  }
  ef() {
    return this.browser;
  }
  ff() {
    return this.version;
  }
  tc(t) {
    if (this.OS) return Promise.resolve(this.OS);
    const s = (s) => {
      for (let r = 0; r < t.length; r++) {
        const i = ai.nf(s, t[r]);
        if (i) return (this.OS = i), this.OS;
      }
      return s;
    };
    return this.userAgentData.platform
      ? Promise.resolve(s(this.userAgentData.platform))
      : this.getHighEntropyValues()
          .then((t) => (t.platform ? s(t.platform) : navigator.platform))
          .catch(() => navigator.platform);
  }
  Bc() {
    const t = {},
      s = this.userAgentData.brands;
    if (s && s.length)
      for (const r of s) {
        const s = this.Vc(device_constants/* Browsers */.s),
          i = r.brand.match(s);
        if (i && i.length > 0) {
          (t.browser = i[0]), (t.version = r.version);
          break;
        }
      }
    return t;
  }
  Vc(t) {
    const s = [];
    for (const r in t) {
      const i = r;
      s.push(t[i]);
    }
    return new RegExp("(" + s.join("|") + ")", "i");
  }
  getHighEntropyValues() {
    return this.userAgentData.getHighEntropyValues
      ? this.userAgentData.getHighEntropyValues(["platform"])
      : Promise.reject();
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/util/user-agent-parser.js


class gi extends Oe {
  constructor() {
    super(), (this.fd = gi.Bc(navigator.userAgent || ""));
  }
  ef() {
    return this.fd[0] || "Unknown Browser";
  }
  ff() {
    return this.fd[1] || "Unknown Version";
  }
  tc(r) {
    for (let n = 0; n < r.length; n++) {
      const e = r[n].string;
      let i = gi.nf(e, r[n]);
      if (i)
        return (
          i === device_constants/* OperatingSystems.Pg */.T.Pg && navigator.maxTouchPoints > 1 && (i = device_constants/* OperatingSystems.ao */.T.ao),
          Promise.resolve(i)
        );
    }
    return Promise.resolve(navigator.platform);
  }
  static Bc(r) {
    let n,
      e =
        r.match(
          /(samsungbrowser|tizen|roku|konqueror|icab|crios|opera|ucbrowser|chrome|safari|firefox|camino|msie|trident(?=\/))\/?\s*(\.?\d+(\.\d+)*)/i,
        ) || [];
    if (-1 !== r.indexOf("(Web0S; Linux/SmartTV)"))
      return ["LG Smart TV", null];
    if (-1 !== r.indexOf("CrKey")) return ["Chromecast", null];
    if (
      -1 !== r.indexOf("BRAVIA") ||
      -1 !== r.indexOf("SonyCEBrowser") ||
      -1 !== r.indexOf("SonyDTV")
    )
      return ["Sony Smart TV", null];
    if (-1 !== r.indexOf("PhilipsTV")) return ["Philips Smart TV", null];
    if (r.match(/\b(Roku)\b/)) return ["Roku", null];
    if (r.match(/\bAFTM\b/)) return ["Amazon Fire Stick", null];
    if (
      e[1] === device_constants/* Browsers.rO */.s.rO &&
      ((n = r.match(/\b(OPR|Edge|EdgA|Edg|UCBrowser)\/(\.?\d+(\.\d+)*)/)),
      null != n)
    )
      return (
        (n = n.slice(1)),
        (n[0] = n[0].replace("OPR", device_constants/* Browsers.oO */.s.oO)),
        (n[0] = n[0].replace("EdgA", device_constants/* Browsers.eO */.s.eO)),
        "Edg" === n[0] && (n[0] = device_constants/* Browsers.eO */.s.eO),
        [n[0], n[1]]
      );
    if (
      e[1] === device_constants/* Browsers.Bg */.s.Bg &&
      ((n = r.match(/\b(EdgiOS)\/(\.?\d+(\.\d+)*)/)), null != n)
    )
      return (
        (n = n.slice(1)), (n[0] = n[0].replace("EdgiOS", device_constants/* Browsers.eO */.s.eO)), [n[0], n[1]]
      );
    if (
      ((e = e[2] ? [e[1], e[2]] : [null, null]),
      e[0] === device_constants/* Browsers.Bg */.s.Bg &&
        null != (n = r.match(/version\/(\.?\d+(\.\d+)*)/i)) &&
        e.splice(1, 1, n[1]),
      null != (n = r.match(/\b(UCBrowser)\/(\.?\d+(\.\d+)*)/)) &&
        e.splice(1, 1, n[2]),
      e[0] === device_constants/* Browsers.oO */.s.oO && null != (n = r.match(/mini\/(\.?\d+(\.\d+)*)/i)))
    )
      return ["Opera Mini", n[1] || ""];
    if (e[0]) {
      const r = e[0].toLowerCase();
      "crios" === r && (e[0] = device_constants/* Browsers.rO */.s.rO),
        "tizen" === r && ((e[0] = "Samsung Smart TV"), (e[1] = null)),
        "samsungbrowser" === r && (e[0] = "Samsung Browser");
    }
    return e;
  }
}

;// CONCATENATED MODULE: ./node_modules/@braze/web-sdk/src/util/browser-detector.js



class ui {
  constructor() {
    const t = navigator.userAgentData ? ai : gi;
    (this.Sg = new t()),
      (this.userAgent = navigator.userAgent),
      (this.browser = this.Sg.ef()),
      (this.version = this.Sg.ff()),
      (this.OS = null),
      this.tc().then((t) => (this.OS = t));
    const i = navigator;
    (this.language = (
      i.userLanguage ||
      i.language ||
      i.browserLanguage ||
      i.systemLanguage ||
      ""
    ).toLowerCase()),
      (this.$a = ui.vg(this.userAgent));
  }
  fE() {
    return this.browser === device_constants/* Browsers.Bg */.s.Bg;
  }
  sc() {
    return this.OS || null;
  }
  tc() {
    return this.OS
      ? Promise.resolve(this.OS)
      : this.Sg.tc(ui.kg).then((t) => ((this.OS = t), t));
  }
  static vg(t) {
    t = t.toLowerCase();
    const i = [
      "googlebot",
      "bingbot",
      "slurp",
      "duckduckbot",
      "baiduspider",
      "yandex",
      "facebookexternalhit",
      "sogou",
      "ia_archiver",
      "https://github.com/prerender/prerender",
      "aolbuild",
      "bingpreview",
      "msnbot",
      "adsbot",
      "mediapartners-google",
      "teoma",
      "taiko",
    ];
    for (let n = 0; n < i.length; n++) if (-1 !== t.indexOf(i[n])) return !0;
    return !1;
  }
}
ui.kg = [
  { string: navigator.platform, cf: "Win", identity: device_constants/* OperatingSystems.Og */.T.Og },
  { string: navigator.platform, cf: "Mac", identity: device_constants/* OperatingSystems.Pg */.T.Pg },
  { string: navigator.platform, cf: "BlackBerry", identity: "BlackBerry" },
  { string: navigator.platform, cf: "FreeBSD", identity: "FreeBSD" },
  { string: navigator.platform, cf: "OpenBSD", identity: "OpenBSD" },
  { string: navigator.platform, cf: "Nintendo", identity: "Nintendo" },
  { string: navigator.platform, cf: "SunOS", identity: "SunOS" },
  { string: navigator.platform, cf: "PlayStation", identity: "PlayStation" },
  { string: navigator.platform, cf: "X11", identity: "X11" },
  {
    string: navigator.userAgent,
    cf: ["iPhone", "iPad", "iPod"],
    identity: device_constants/* OperatingSystems.ao */.T.ao,
  },
  { string: navigator.platform, cf: "Pike v", identity: device_constants/* OperatingSystems.ao */.T.ao },
  { string: navigator.userAgent, cf: ["Web0S"], identity: "WebOS" },
  { string: navigator.userAgent, cf: "Tizen", identity: "Tizen" },
  {
    string: navigator.platform,
    cf: ["Linux armv7l", "Android"],
    identity: device_constants/* OperatingSystems.xg */.T.xg,
  },
  { string: navigator.userAgent, cf: ["Android"], identity: device_constants/* OperatingSystems.xg */.T.xg },
  { string: navigator.platform, cf: "Linux", identity: "Linux" },
];
const ro = new ui();



/***/ }),

/***/ 72893:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J_": function() { return /* binding */ isDate; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "VO": function() { return /* binding */ values; },
/* harmony export */   "XP": function() { return /* binding */ keys; },
/* harmony export */   "Xy": function() { return /* binding */ isEqual; },
/* harmony export */   "fk": function() { return /* binding */ validateValueIsFromEnum; },
/* harmony export */   "jV": function() { return /* binding */ intersection; },
/* harmony export */   "kJ": function() { return /* binding */ isArray; }
/* harmony export */ });
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20335);

function values(t) {
  const e = [];
  let r;
  for (const n in t)
    (r = n),
      Object.prototype.hasOwnProperty.call(t, r) &&
        void 0 !== t[r] &&
        e.push(t[r]);
  return e;
}
function validateValueIsFromEnum(t, e, r, n) {
  const o = values(t);
  return (
    -1 !== o.indexOf(e) ||
    (_shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(`${r} Valid values from ${n} are "${o.join('"/"')}".`), !1)
  );
}
function isArray(t) {
  return Array.isArray
    ? Array.isArray(t)
    : "[object Array]" === Object.prototype.toString.call(t);
}
function isDate(t) {
  return "[object Date]" === Object.prototype.toString.call(t);
}
function isObject(t) {
  return "[object Object]" === Object.prototype.toString.call(t);
}
function intersection(t, ...e) {
  null == t && (t = []);
  const r = [],
    n = arguments.length;
  for (let e = 0, o = t.length; e < o; e++) {
    const o = t[e];
    if (-1 !== r.indexOf(o)) continue;
    let c = 1;
    for (c = 1; c < n && -1 !== arguments[c].indexOf(o); c++);
    c === n && r.push(o);
  }
  return r;
}
function keys(t) {
  const e = [];
  for (const r in t) Object.prototype.hasOwnProperty.call(t, r) && e.push(r);
  return e;
}
function isEqual(t, e) {
  if (t === e) return 0 !== t || 1 / t == 1 / e;
  if (null == t || null == e) return t === e;
  const r = t.toString();
  if (r !== e.toString()) return !1;
  switch (r) {
    case "[object RegExp]":
    case "[object String]":
      return "" + t == "" + e;
    case "[object Number]":
      return +t != +t ? +e != +e : 0 == +t ? 1 / +t == 1 / e : +t == +e;
    case "[object Date]":
    case "[object Boolean]":
      return +t == +e;
  }
  const n = "[object Array]" === r;
  if (!n) {
    if ("object" != typeof t || "object" != typeof e) return !1;
    const r = t.constructor,
      n = e.constructor;
    if (
      r !== n &&
      !(
        "function" == typeof r &&
        r instanceof r &&
        "function" == typeof n &&
        n instanceof n
      ) &&
      "constructor" in t &&
      "constructor" in e
    )
      return !1;
  }
  const o = [],
    c = [];
  let i = o.length;
  for (; i--; ) if (o[i] === t) return c[i] === e;
  if ((o.push(t), c.push(e), n)) {
    if (((i = t.length), i !== e.length)) return !1;
    for (; i--; ) if (!isEqual(t[i], e[i])) return !1;
  } else {
    const r = keys(t);
    let n;
    if (((i = r.length), keys(e).length !== i)) return !1;
    for (; i--; )
      if (
        ((n = r[i]),
        !Object.prototype.hasOwnProperty.call(e, n) || !isEqual(t[n], e[n]))
      )
        return !1;
  }
  return o.pop(), c.pop(), !0;
}


/***/ }),

/***/ 5242:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ createCloseButton; }
/* harmony export */ });
/* harmony import */ var _dom_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11507);
/* harmony import */ var _key_codes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7429);


function createCloseButton(t, o, e, n = "ltr") {
  const r = document.createElement("button");
  r.setAttribute("aria-label", t),
    r.setAttribute("tabindex", "0"),
    r.setAttribute("role", "button"),
    (r.dir = n),
    (0,_dom_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .addPassiveEventListener */ .lj)(r, "touchstart"),
    (r.className = "ab-close-button");
  const l = (0,_dom_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .buildSvg */ .MK)(
    "0 0 15 15",
    "M15 1.5L13.5 0l-6 6-6-6L0 1.5l6 6-6 6L1.5 15l6-6 6 6 1.5-1.5-6-6 6-6z",
    o,
  );
  return (
    r.appendChild(l),
    r.addEventListener("keydown", (t) => {
      (t.keyCode !== _key_codes_js__WEBPACK_IMPORTED_MODULE_1__/* .KeyCodes.Wo */ .m.Wo && t.keyCode !== _key_codes_js__WEBPACK_IMPORTED_MODULE_1__/* .KeyCodes.Xo */ .m.Xo) ||
        (e(), t.stopPropagation());
    }),
    (r.onclick = (t) => {
      e(), t.stopPropagation();
    }),
    r
  );
}


/***/ }),

/***/ 57750:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$N": function() { return /* binding */ secondsAgo; },
/* harmony export */   "BT": function() { return /* binding */ toValidBackendTimeString; },
/* harmony export */   "FX": function() { return /* binding */ convertMsToSeconds; },
/* harmony export */   "Pn": function() { return /* binding */ convertSecondsToMs; },
/* harmony export */   "Rd": function() { return /* binding */ rehydrateDateAfterJsonization; },
/* harmony export */   "X2": function() { return /* binding */ dateFromUnixTimestamp; },
/* harmony export */   "_0": function() { return /* binding */ timestampOrNow; },
/* harmony export */   "yo": function() { return /* binding */ secondsInTheFuture; }
/* harmony export */ });
/* harmony import */ var _code_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72893);

function convertMsToSeconds(e, n = !1) {
  let t = e / 1e3;
  return n && (t = Math.floor(t)), t;
}
function convertSecondsToMs(e) {
  return 1e3 * e;
}
function dateFromUnixTimestamp(e) {
  if (null == e) return null;
  const n = parseInt(e.toString());
  return isNaN(n) ? null : new Date(1e3 * n);
}
function toValidBackendTimeString(e) {
  return null != e && (0,_code_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isDate */ .J_)(e) ? e.toISOString().replace(/\.[0-9]{3}Z$/, "") : e;
}
function rehydrateDateAfterJsonization(e) {
  return null == e || "" === e ? null : new Date(e);
}
function timestampOrNow(e) {
  return null == e || "" === e ? new Date().valueOf() : e;
}
function secondsAgo(e) {
  return (new Date().valueOf() - e.valueOf()) / 1e3;
}
function secondsInTheFuture(e) {
  return (e.valueOf() - new Date().valueOf()) / 1e3;
}


/***/ }),

/***/ 35806:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ OperatingSystems; },
/* harmony export */   "s": function() { return /* binding */ Browsers; }
/* harmony export */ });
const Browsers = {
  rO: "Chrome",
  eO: "Edge",
  oO: "Opera",
  Bg: "Safari",
  OO: "Firefox",
};
const OperatingSystems = {
  xg: "Android",
  ao: "iOS",
  Pg: "Mac",
  Og: "Windows",
};


/***/ }),

/***/ 11507:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ clickElement; },
/* harmony export */   "FZ": function() { return /* binding */ detectSwipe; },
/* harmony export */   "Fr": function() { return /* binding */ bottomIsInView; },
/* harmony export */   "MK": function() { return /* binding */ buildSvg; },
/* harmony export */   "QZ": function() { return /* binding */ supportsPassive; },
/* harmony export */   "lP": function() { return /* binding */ DOMUtils; },
/* harmony export */   "lj": function() { return /* binding */ addPassiveEventListener; },
/* harmony export */   "mQ": function() { return /* binding */ DIRECTIONS; },
/* harmony export */   "rJ": function() { return /* binding */ topIsInView; }
/* harmony export */ });
/* unused harmony export _isInView */
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20335);
/* harmony import */ var _error_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8031);


function _isInView(t, n = !1, e = !1, s = !1) {
  if (null == t) return !1;
  (n = n || !1), (e = e || !1);
  const i = t.getBoundingClientRect();
  return (
    null != i &&
    ((i.top >= 0 &&
      i.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
      !n) &&
    (i.left >= 0 || !s) &&
    ((i.bottom >= 0 &&
      i.bottom <=
        (window.innerHeight || document.documentElement.clientHeight)) ||
      !e) &&
    (i.right <= (window.innerWidth || document.documentElement.clientWidth) ||
      !s)
  );
}
const DOMUtils = { Ic: null, Ho: _isInView };
const DIRECTIONS = { To: "up", qo: "down", ie: "left", de: "right" };
function supportsPassive() {
  if (null == DOMUtils.Ic) {
    DOMUtils.Ic = !1;
    try {
      const t = Object.defineProperty({}, "passive", {
        get: () => {
          DOMUtils.Ic = !0;
        },
      });
      window.addEventListener("testPassive", () => {}, t),
        window.removeEventListener("testPassive", () => {}, t);
    } catch (t) {
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error((0,_error_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .getErrorMessage */ .e)(t));
    }
  }
  return DOMUtils.Ic;
}
function addPassiveEventListener(t, n, e = () => {}) {
  t.addEventListener(n, e, !!supportsPassive() && { passive: !0 });
}
function topIsInView(t) {
  return DOMUtils.Ho(t, !0, !1, !1);
}
function bottomIsInView(t) {
  return DOMUtils.Ho(t, !1, !0, !1);
}
function clickElement(t) {
  if (t.onclick) {
    const n = document.createEvent("MouseEvents");
    n.initEvent("click", !0, !0), t.onclick.apply(t, [n]);
  }
}
function detectSwipe(t, n, e) {
  let s = null,
    i = null;
  addPassiveEventListener(t, "touchstart", (t) => {
    (s = t.touches[0].clientX), (i = t.touches[0].clientY);
  }),
    addPassiveEventListener(t, "touchmove", (o) => {
      if (null == s || null == i) return;
      const l = s - o.touches[0].clientX,
        u = i - o.touches[0].clientY;
      Math.abs(l) > Math.abs(u) && Math.abs(l) >= 25
        ? (((l > 0 && n === DIRECTIONS.ie) || (l < 0 && n === DIRECTIONS.de)) &&
            e(o),
          (s = null),
          (i = null))
        : Math.abs(u) >= 25 &&
          (((u > 0 &&
            n === DIRECTIONS.To &&
            t.scrollTop === t.scrollHeight - t.offsetHeight) ||
            (u < 0 && n === DIRECTIONS.qo && 0 === t.scrollTop)) &&
            e(o),
          (s = null),
          (i = null));
    });
}
function buildSvg(t, n, e) {
  const s = "http://www.w3.org/2000/svg",
    i = document.createElementNS(s, "svg");
  i.setAttribute("viewBox", t), i.setAttribute("xmlns", s);
  const o = document.createElementNS(s, "path");
  return (
    o.setAttribute("d", n),
    null != e && o.setAttribute("fill", e),
    i.appendChild(o),
    i
  );
}


/***/ }),

/***/ 8031:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getErrorMessage; }
/* harmony export */ });
const getErrorMessage = (r) =>
  r instanceof Error ? r.message : String(r);


/***/ }),

/***/ 71177:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bl": function() { return /* binding */ attachHtmlToIframeWithNonce; },
/* harmony export */   "NK": function() { return /* binding */ buildBrazeBridge; }
/* harmony export */ });
/* unused harmony export applyNonceToDynamicallyCreatedTags */
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20335);
/* harmony import */ var _Core_get_user_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46243);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27671);
/* harmony import */ var _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88468);
/* harmony import */ var _util_code_utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72893);





const buildBrazeBridge = (t, e, o) => {
  const n = { display: {}, web: {} },
    requestPushPermission = function () {
      return function () {
        const t = arguments;
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 12261)).then((e) => {
          _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"]._t */ .ZP._t()
            ? e.requestPushPermission(...Array.prototype.slice.call(t))
            : _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_MUST_BE_INITIALIZED_ERROR */ .Go);
        });
      };
    },
    s = {
      requestImmediateDataFlush: function () {
        const t = arguments;
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64650)).then(
          ({ requestImmediateDataFlush: requestImmediateDataFlush }) => {
            _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"]._t */ .ZP._t()
              ? requestImmediateDataFlush(...Array.prototype.slice.call(t))
              : _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_MUST_BE_INITIALIZED_ERROR */ .Go);
          },
        );
      },
      logCustomEvent: function () {
        const t = arguments;
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61454)).then(
          ({ logCustomEvent: logCustomEvent }) => {
            if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"]._t */ .ZP._t()) return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_MUST_BE_INITIALIZED_ERROR */ .Go);
            logCustomEvent(...Array.prototype.slice.call(t));
          },
        );
      },
      logPurchase: function () {
        const t = arguments;
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61364)).then(
          ({ logPurchase: logPurchase }) => {
            if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"]._t */ .ZP._t()) return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_MUST_BE_INITIALIZED_ERROR */ .Go);
            logPurchase(...Array.prototype.slice.call(t));
          },
        );
      },
      unregisterPush: function () {
        const t = arguments;
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 77824)).then(
          ({ unregisterPush: unregisterPush }) => {
            _managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"]._t */ .ZP._t()
              ? unregisterPush(...Array.prototype.slice.call(t))
              : _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_MUST_BE_INITIALIZED_ERROR */ .Go);
          },
        );
      },
      requestPushPermission: requestPushPermission(),
      changeUser: function () {
        const t = arguments;
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34790)).then(({ changeUser: changeUser }) => {
          if (!_managers_braze_instance_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"]._t */ .ZP._t()) return void _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(_common_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .BRAZE_MUST_BE_INITIALIZED_ERROR */ .Go);
          changeUser(...Array.prototype.slice.call(t));
        });
      },
    },
    i = function (t) {
      return function () {
        s[t](...Array.prototype.slice.call(arguments));
      };
    };
  for (const t of (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .keys */ .XP)(s)) n[t] = i(t);
  const u = [
      "setFirstName",
      "setLastName",
      "setEmail",
      "setGender",
      "setDateOfBirth",
      "setCountry",
      "setHomeCity",
      "setEmailNotificationSubscriptionType",
      "setLanguage",
      "addAlias",
      "setPushNotificationSubscriptionType",
      "setPhoneNumber",
      "setCustomUserAttribute",
      "addToCustomAttributeArray",
      "removeFromCustomAttributeArray",
      "incrementCustomUserAttribute",
      "setCustomLocationAttribute",
      "addToSubscriptionGroup",
      "removeFromSubscriptionGroup",
      "setLineId",
    ],
    c = function (t) {
      return function () {
        const e = (0,_Core_get_user_js__WEBPACK_IMPORTED_MODULE_4__/* .getUser */ .P)();
        e && e[t](...Array.prototype.slice.call(arguments));
      };
    },
    a = {};
  for (let t = 0; t < u.length; t++) a[u[t]] = c(u[t]);
  n.getUser = function () {
    return a;
  };
  const m = { showFeed: e },
    f = function (e) {
      return function () {
        const r = arguments;
        "function" != typeof o
          ? m[e](...Array.prototype.slice.call(r))
          : o(t, function () {
              m[e](...Array.prototype.slice.call(r));
            });
      };
    },
    l = n.display;
  for (const t of (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .keys */ .XP)(m)) l[t] = f(t);
  const d = { registerAppboyPushMessages: requestPushPermission() },
    h = function (t) {
      return function () {
        d[t](...Array.prototype.slice.call(arguments));
      };
    },
    g = n.web;
  for (const t of (0,_util_code_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .keys */ .XP)(d)) g[t] = h(t);
  return n;
};
const applyNonceToDynamicallyCreatedTags = (t, e, r) => {
  const o = `([\\w]+)\\s*=\\s*document.createElement\\(['"]${r}['"]\\)`,
    n = t.match(new RegExp(o));
  if (n) {
    const r = `${n[1]}.setAttribute("nonce", "${e}")`;
    return `${t.slice(0, n.index + n[0].length)};${r};${t.slice(
      n.index + n[0].length,
    )}`;
  }
  return null;
};
const attachHtmlToIframeWithNonce = (t, e, r) => {
  let o = null;
  if (null != r) {
    (o = document.createElement("html")), (o.innerHTML = e || "");
    const t = o.getElementsByTagName("style");
    for (let e = 0; e < t.length; e++) t[e].setAttribute("nonce", r);
    const n = o.getElementsByTagName("script");
    for (let t = 0; t < n.length; t++) {
      n[t].setAttribute("nonce", r),
        (n[t].innerHTML = n[t].innerHTML.replace(
          /<style>/g,
          `<style nonce='${r}'>`,
        ));
      const e = applyNonceToDynamicallyCreatedTags(n[t].innerHTML, r, "script");
      e && (n[t].innerHTML = e);
      const o = applyNonceToDynamicallyCreatedTags(n[t].innerHTML, r, "style");
      o && (n[t].innerHTML = o);
    }
  }
  t.srcdoc = o ? o.innerHTML : e || "";
};


/***/ }),

/***/ 7429:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ KeyCodes; }
/* harmony export */ });
const KeyCodes = { Wo: 32, yo: 9, Xo: 13, _h: 27 };


/***/ }),

/***/ 96504:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ randomInclusive; }
/* harmony export */ });
const randomInclusive = (t, a) => (
  (t = Math.ceil(t)),
  (a = Math.floor(a)),
  Math.floor(Math.random() * (a - t + 1)) + t
);


/***/ }),

/***/ 41843:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ readResponseHeaders; }
/* harmony export */ });
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20335);
/* harmony import */ var _models_backend_errors_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63826);
/* harmony import */ var _error_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8031);



const l = {
  Y: (t) => {
    let e, o;
    try {
      const r = () => {
        _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error("This browser does not have any supported ajax options!");
      };
      let n = !1;
      if ((window.XMLHttpRequest && (n = !0), !n)) return void r();
      e = new XMLHttpRequest();
      const s = (o) => {
        "function" == typeof t.error && t.error(e.status),
          "function" == typeof t.nt && t.nt(!1, o);
      };
      (e.onload = () => {
        let o = !1;
        if (4 !== e.readyState) return;
        o = (e.status >= 200 && e.status < 300) || 304 === e.status;
        const r = e.getAllResponseHeaders();
        if (o) {
          if ("function" == typeof t.tt) {
            let o;
            try {
              o = JSON.parse(e.responseText);
            } catch (o) {
              const n = {
                error: "" === e.responseText ? _models_backend_errors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gu */ .Z.gu : _models_backend_errors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].qu */ .Z.qu,
                response: e.responseText,
              };
              (0, t.tt)(n, r);
            }
            o && t.tt(o, r);
          }
          "function" == typeof t.nt && t.nt(!0, r);
        } else s(r);
      }),
        (e.onerror = () => {
          s(e.getAllResponseHeaders());
        }),
        (e.ontimeout = () => {
          s();
        }),
        (o = JSON.stringify(t.data)),
        e.open("POST", t.url, !0),
        e.setRequestHeader("Content-type", "application/json"),
        e.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      const i = t.headers || [];
      for (const t of i) e.setRequestHeader(t[0], t[1]);
      e.send(o);
    } catch (t) {
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(`Network request error: ${(0,_error_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .getErrorMessage */ .e)(t)}`);
    }
  },
};
const readResponseHeaders = (t) => {
  const e = {},
    o = t.toString().split("\r\n");
  if (!o) return e;
  let r, n;
  for (const t of o)
    t &&
      ((r = t.slice(0, t.indexOf(":")).toLowerCase().trim()),
      (n = t.slice(t.indexOf(":") + 1).trim()),
      (e[r] = n));
  return e;
};
/* harmony default export */ __webpack_exports__["Z"] = (l);


/***/ }),

/***/ 76870:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27671);
/* harmony import */ var _managers_storage_manager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45966);


const h = {
  O: {
    Nu: "data",
    gi: "content_cards/sync",
    Le: "feature_flags/sync",
    Gr: "template",
    K: "banners/sync",
  },
  Qu: (t) => (null == t ? void 0 : t.ft(_managers_storage_manager_js__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEYS.gt.lE */ .I.gt.lE)),
  sm: (t) => (null == t ? void 0 : t.ft(_managers_storage_manager_js__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEYS.gt.SE */ .I.gt.SE)),
  nm: (t, e) => {
    null == t || t.Bt(_managers_storage_manager_js__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEYS.gt.lE */ .I.gt.lE, e);
  },
  rm: (t, e) => {
    null == t || t.Bt(_managers_storage_manager_js__WEBPACK_IMPORTED_MODULE_0__/* .STORAGE_KEYS.gt.SE */ .I.gt.SE, e);
  },
  Bu: (t, e) => {
    if (!t || !e) return -1;
    const s = h.Qu(t);
    if (null == s) return -1;
    const n = s[e];
    return null == n || isNaN(n) ? -1 : n;
  },
  zu: (t, e) => {
    let s = _common_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .REQUEST_ATTEMPT_DEFAULT */ .S6;
    if (!t || !e) return s;
    const n = h.sm(t);
    return null == n ? s : ((s = n[e]), null == s || isNaN(s) ? _common_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .REQUEST_ATTEMPT_DEFAULT */ .S6 : s);
  },
  W: (t, e, s) => {
    if (!t || !e) return;
    let n = h.Qu(t);
    null == n && (n = {}), (n[e] = s), h.nm(t, n);
  },
  ju: (t, e, s) => {
    if (!t || !e) return;
    let n = h.sm(t);
    null == n && (n = {}), (n[e] = s), h.rm(t, n);
  },
  wi: (t, e) => {
    t && e && h.ju(t, e, _common_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .REQUEST_ATTEMPT_DEFAULT */ .S6);
  },
  Pu: (t, e) => {
    if (!t || !e) return;
    const s = h.zu(t, e);
    h.ju(t, e, s + 1);
  },
};
/* harmony default export */ __webpack_exports__["Z"] = (h);


/***/ }),

/***/ 8548:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getByteLength; },
/* harmony export */   "T": function() { return /* binding */ decodeBrazeActions; }
/* harmony export */ });
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20335);

function getByteLength(t) {
  let e = t.length;
  for (let n = t.length - 1; n >= 0; n--) {
    const r = t.charCodeAt(n);
    r > 127 && r <= 2047 ? e++ : r > 2047 && r <= 65535 && (e += 2),
      r >= 56320 && r <= 57343 && n--;
  }
  return e;
}
function decodeBrazeActions(t) {
  try {
    t = t.replace(/-/g, "+").replace(/_/g, "/");
    const e = window.atob(t),
      n = new Uint8Array(e.length);
    for (let t = 0; t < e.length; t++) n[t] = e.charCodeAt(t);
    const r = new Uint16Array(n.buffer);
    return String.fromCharCode(...r);
  } catch (t) {
    return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error("Unable to decode Base64: " + t), null;
  }
}


/***/ }),

/***/ 1148:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ parseQueryStringKeyValues; },
/* harmony export */   "o": function() { return /* binding */ isURIJavascriptOrData; }
/* harmony export */ });
function parseQueryStringKeyValues(t) {
  null == t && (t = "");
  const r = t.split("?").slice(1).join("?"),
    n = {};
  if (null != r) {
    const t = r.split("&");
    for (let r = 0; r < t.length; r++) {
      const a = t[r].split("=");
      "" !== a[0] && (n[a[0]] = a[1]);
    }
  }
  return n;
}
function isURIJavascriptOrData(t) {
  return !(
    !t ||
    (0 !== (t = t.toString().toLowerCase()).lastIndexOf("javascript:", 0) &&
      0 !== t.lastIndexOf("data:", 0))
  );
}


/***/ }),

/***/ 3905:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$g": function() { return /* binding */ validateCustomAttributeArrayType; },
/* harmony export */   "Ey": function() { return /* binding */ isValidBannerPlacementId; },
/* harmony export */   "OM": function() { return /* binding */ isValidBrazeActionType; },
/* harmony export */   "UO": function() { return /* binding */ validatePropertyType; },
/* harmony export */   "bj": function() { return /* binding */ validateCustomAttributeKey; },
/* harmony export */   "lg": function() { return /* binding */ validateCustomProperties; },
/* harmony export */   "ro": function() { return /* binding */ validateStandardString; },
/* harmony export */   "vV": function() { return /* binding */ isValidEmail; },
/* harmony export */   "y9": function() { return /* binding */ BRAZE_ACTION_URI_REGEX; },
/* harmony export */   "zM": function() { return /* binding */ validateCustomString; },
/* harmony export */   "zR": function() { return /* binding */ isValidBrazeActionJson; }
/* harmony export */ });
/* unused harmony exports CUSTOM_DATA_REGEX, CUSTOM_ATTRIBUTE_SPECIAL_CHARS_REGEX, CUSTOM_ATTRIBUTE_RESERVED_OPERATORS, EMAIL_ADDRESS_REGEX, CUSTOM_PROPERTIES_MAX_SIZE_BYTES, CUSTOM_PROPERTIES_MAX_SIZE_STRING, CUSTOM_ATTRIBUTES_MAX_SIZE_BYTES, CUSTOM_ATTRIBUTES_MAX_SIZE_STRING, CUSTOM_ATTRIBUTE_MAX_DEPTH, VALID_UTF8_STRING_NO_WHITESPACES_REGEX, _validateNestedProperties, _validateEventPropertyValue */
/* harmony import */ var _code_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72893);
/* harmony import */ var _string_utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8548);
/* harmony import */ var _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20335);
/* harmony import */ var _date_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57750);
/* harmony import */ var _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73046);
/* harmony import */ var _common_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27671);






const CUSTOM_DATA_REGEX = /^[^\x00-\x1F\x22]+$/;
const CUSTOM_ATTRIBUTE_SPECIAL_CHARS_REGEX = /[$.]/;
const CUSTOM_ATTRIBUTE_RESERVED_OPERATORS = [
  "$add",
  "$update",
  "$remove",
  "$identifier_key",
  "$identifier_value",
  "$new_object",
  "$time",
  "$google_ad_personalization",
  "$google_ad_user_data",
];
const EMAIL_ADDRESS_REGEX = new RegExp(/^.+@.+\..+$/);
const CUSTOM_PROPERTIES_MAX_SIZE_BYTES = 51200;
const CUSTOM_PROPERTIES_MAX_SIZE_STRING = "50KB";
const CUSTOM_ATTRIBUTES_MAX_SIZE_BYTES = 76800;
const CUSTOM_ATTRIBUTES_MAX_SIZE_STRING = "75KB";
const CUSTOM_ATTRIBUTE_MAX_DEPTH = 50;
const BRAZE_ACTION_URI_REGEX = /^brazeActions:\/\/v\d+\//;
const VALID_UTF8_STRING_NO_WHITESPACES_REGEX = /^[^\s]+$/;
function validateCustomString(t, e, r) {
  const n =
    null != t &&
    "string" == typeof t &&
    ("" === t || null != t.match(CUSTOM_DATA_REGEX));
  return n || _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(`Cannot ${e} because ${r} "${t}" is invalid.`), n;
}
function validateCustomAttributeKey(t) {
  return (
    null != t &&
      t.match(CUSTOM_ATTRIBUTE_SPECIAL_CHARS_REGEX) &&
      -1 === CUSTOM_ATTRIBUTE_RESERVED_OPERATORS.indexOf(t) &&
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].warn */ .Z.warn("Custom attribute keys cannot contain '$' or '.'"),
    validateCustomString(t, "set custom user attribute", "the given key")
  );
}
function validatePropertyType(t) {
  const e = typeof t;
  return (
    null == t || "number" === e || "boolean" === e || (0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isDate */ .J_)(t) || "string" === e
  );
}
function _validateNestedProperties(t, e, r) {
  const n = -1 !== r;
  if (n && r > 50)
    return _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error("Nested attributes cannot be more than 50 levels deep."), !1;
  const o = n ? r + 1 : -1;
  if ((0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ)(t) && (0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ)(e)) {
    for (let r = 0; r < t.length && r < e.length; r++)
      if (
        ((0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isDate */ .J_)(t[r]) && (e[r] = (0,_date_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .toValidBackendTimeString */ .BT)(t[r])),
        !_validateNestedProperties(t[r], e[r], o))
      )
        return !1;
  } else {
    if (!(0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn)(t)) return validatePropertyType(t);
    for (const r of (0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .keys */ .XP)(t)) {
      const i = t[r];
      if (n && !validateCustomAttributeKey(r)) return !1;
      if ((0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isDate */ .J_)(i)) {
        e[r] = (0,_date_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .toValidBackendTimeString */ .BT)(i);
      }
      if (!_validateNestedProperties(i, e[r], o)) return !1;
    }
  }
  return !0;
}
function _validateEventPropertyValue(t, e, r, n, o) {
  let i;
  return (
    (i =
      (0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn)(t) || (0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ)(t)
        ? _validateNestedProperties(t, e, o ? 1 : -1)
        : validatePropertyType(t)),
    i || _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(`Cannot ${r} because ${n} "${t}" is invalid.`),
    i
  );
}
function validateStandardString(t, e, r, n = !1) {
  const o = "string" == typeof t || (null === t && n);
  return o || _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(`Cannot ${e} because ${r} "${t}" is invalid.`), o;
}
function validateCustomProperties(t, e, r, n, o) {
  if ((null == t && (t = {}), "object" != typeof t || (0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ)(t)))
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(`${e} requires that ${r} be an object. Ignoring ${o}.`),
      [!1, null]
    );
  let i, a;
  e === _common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .SET_CUSTOM_USER_ATTRIBUTE_STRING */ .db ? ((i = 76800), (a = "75KB")) : ((i = 51200), (a = "50KB"));
  const s = JSON.stringify(t);
  if ((0,_string_utils_js__WEBPACK_IMPORTED_MODULE_4__/* .getByteLength */ .E)(s) > i)
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
        `Could not ${n} because ${r} was greater than the max size of ${a}.`,
      ),
      [!1, null]
    );
  let u;
  try {
    u = JSON.parse(s);
  } catch (t) {
    return (
      _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(`Could not ${n} because ${r} did not contain valid JSON.`),
      [!1, null]
    );
  }
  for (const r in t) {
    if (e === _common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .SET_CUSTOM_USER_ATTRIBUTE_STRING */ .db && !validateCustomAttributeKey(r)) return [!1, null];
    if (!validateCustomString(r, n, `the ${o} property name`))
      return [!1, null];
    const i = t[r];
    if (e !== _common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .SET_CUSTOM_USER_ATTRIBUTE_STRING */ .db && null == i) {
      delete t[r], delete u[r];
      continue;
    }
    (0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isDate */ .J_)(i) && (u[r] = (0,_date_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .toValidBackendTimeString */ .BT)(i));
    if (
      !_validateEventPropertyValue(
        i,
        u[r],
        n,
        `the ${o} property "${r}"`,
        e === _common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .SET_CUSTOM_USER_ATTRIBUTE_STRING */ .db,
      )
    )
      return [!1, null];
  }
  return [!0, u];
}
function validateCustomAttributeArrayType(t, e) {
  let r = !1,
    n = !1;
  const o = () => {
    _shared_lib_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(
      "Custom attribute arrays must be either string arrays or object arrays.",
    );
  };
  for (const i of e)
    if ("string" == typeof i) {
      if (n) return o(), [!1, !1];
      if (
        !validateCustomString(
          i,
          `set custom user attribute "${t}"`,
          "the element in the given array",
        )
      )
        return [!1, !1];
      r = !0;
    } else {
      if (!(0,_code_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn)(i)) return o(), [!1, !1];
      if (r) return o(), [!1, !1];
      if (
        !validateCustomProperties(
          i,
          _common_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .SET_CUSTOM_USER_ATTRIBUTE_STRING */ .db,
          "attribute value",
          `set custom user attribute "${t}"`,
          "custom user attribute",
        )
      )
        return [!1, !1];
      n = !0;
    }
  return [r, n];
}
function isValidEmail(t) {
  return (
    "string" == typeof t && null != t.toLowerCase().match(EMAIL_ADDRESS_REGEX)
  );
}
function isValidBrazeActionJson(t) {
  if (!(_braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.properties.type */ .A9.properties.type in t)) return !1;
  switch (t[_braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.properties.type */ .A9.properties.type]) {
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.io */ .A9.types.io:
      if (_braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.properties.eo */ .A9.properties.eo in t) return !0;
      break;
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.logCustomEvent */ .A9.types.logCustomEvent:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.setEmailNotificationSubscriptionType */ .A9.types.setEmailNotificationSubscriptionType:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.setPushNotificationSubscriptionType */ .A9.types.setPushNotificationSubscriptionType:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.setCustomUserAttribute */ .A9.types.setCustomUserAttribute:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.addToSubscriptionGroup */ .A9.types.addToSubscriptionGroup:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.removeFromSubscriptionGroup */ .A9.types.removeFromSubscriptionGroup:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.addToCustomAttributeArray */ .A9.types.addToCustomAttributeArray:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.removeFromCustomAttributeArray */ .A9.types.removeFromCustomAttributeArray:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.co */ .A9.types.co:
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.mo */ .A9.types.mo:
      if (_braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.properties.so */ .A9.properties.so in t) return !0;
      break;
    case _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types.requestPushPermission */ .A9.types.requestPushPermission:
      return !0;
    default:
      return !1;
  }
  return !1;
}
function isValidBrazeActionType(t) {
  let e = !1;
  return (
    Object.keys(_braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types */ .A9.types).forEach((r) => {
      _braze_actions_js__WEBPACK_IMPORTED_MODULE_5__/* .BRAZE_ACTIONS.types */ .A9.types[r] !== t.toString() || (e = !0);
    }),
    e
  );
}
function isValidBannerPlacementId(t) {
  return VALID_UTF8_STRING_NO_WHITESPACES_REGEX.test(t);
}


/***/ }),

/***/ 75319:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SD": function() { return /* binding */ WindowUtils; },
/* harmony export */   "eh": function() { return /* binding */ ORIENTATION; }
/* harmony export */ });
/* unused harmony exports _isPhone, _getOrientation, _openUri, _getCurrentUrl */
const ORIENTATION = { PORTRAIT: 0, LANDSCAPE: 1 };
function _isPhone() {
  return screen.width <= 600;
}
function _getOrientation() {
  if ("orientation" in window)
    return 90 === Math.abs(window.orientation) || 270 === window.orientation
      ? ORIENTATION.LANDSCAPE
      : ORIENTATION.PORTRAIT;
  const n = window;
  if ("screen" in n) {
    let e =
      n.screen.orientation || screen.mozOrientation || screen.msOrientation;
    return (
      null != e && "object" == typeof e && (e = e.type),
      "landscape-primary" === e || "landscape-secondary" === e
        ? ORIENTATION.LANDSCAPE
        : ORIENTATION.PORTRAIT
    );
  }
  return ORIENTATION.PORTRAIT;
}
function _openUri(n, e, t) {
  n && (e || (null != t && t.metaKey) ? window.open(n) : (window.location = n));
}
function _getCurrentUrl() {
  return window.location.href;
}
const WindowUtils = {
  openUri: _openUri,
  Uo: _isPhone,
  Jo: _getOrientation,
  Ga: _getCurrentUrl,
};


/***/ })

}]);